
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire9d46"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire9d46"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("1DXtE", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $132791eca83f52bf$export$ffb0004e005737fa; }, function (v) { return $132791eca83f52bf$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $132791eca83f52bf$export$34b9dba7ce09269b; }, function (v) { return $132791eca83f52bf$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $132791eca83f52bf$export$25062201e9e25d76; }, function (v) { return $132791eca83f52bf$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $132791eca83f52bf$export$ffb0004e005737fa;
var $132791eca83f52bf$export$34b9dba7ce09269b;
var $132791eca83f52bf$export$25062201e9e25d76;
'use strict';

var $6SWiB = parcelRequire("6SWiB");
var $132791eca83f52bf$var$k = Symbol.for("react.element"), $132791eca83f52bf$var$l = Symbol.for("react.fragment"), $132791eca83f52bf$var$m = Object.prototype.hasOwnProperty, $132791eca83f52bf$var$n = $6SWiB.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, $132791eca83f52bf$var$p = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $132791eca83f52bf$var$q(c, a, g) {
    var b, d = {}, e = null, h = null;
    void 0 !== g && (e = "" + g);
    void 0 !== a.key && (e = "" + a.key);
    void 0 !== a.ref && (h = a.ref);
    for(b in a)$132791eca83f52bf$var$m.call(a, b) && !$132791eca83f52bf$var$p.hasOwnProperty(b) && (d[b] = a[b]);
    if (c && c.defaultProps) for(b in a = c.defaultProps, a)void 0 === d[b] && (d[b] = a[b]);
    return {
        $$typeof: $132791eca83f52bf$var$k,
        type: c,
        key: e,
        ref: h,
        props: d,
        _owner: $132791eca83f52bf$var$n.current
    };
}
$132791eca83f52bf$export$ffb0004e005737fa = $132791eca83f52bf$var$l;
$132791eca83f52bf$export$34b9dba7ce09269b = $132791eca83f52bf$var$q;
$132791eca83f52bf$export$25062201e9e25d76 = $132791eca83f52bf$var$q;

});
parcelRegister("6SWiB", function(module, exports) {
'use strict';

module.exports = (parcelRequire("pKzN4"));

});
parcelRegister("pKzN4", function(module, exports) {

$parcel$export(module.exports, "Children", function () { return $04d676fd7cff0b54$export$dca3b0875bd9a954; }, function (v) { return $04d676fd7cff0b54$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $04d676fd7cff0b54$export$16fa2f45be04daa8; }, function (v) { return $04d676fd7cff0b54$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $04d676fd7cff0b54$export$ffb0004e005737fa; }, function (v) { return $04d676fd7cff0b54$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $04d676fd7cff0b54$export$e2c29f18771995cb; }, function (v) { return $04d676fd7cff0b54$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $04d676fd7cff0b54$export$221d75b3f55bb0bd; }, function (v) { return $04d676fd7cff0b54$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $04d676fd7cff0b54$export$5f8d39834fd61797; }, function (v) { return $04d676fd7cff0b54$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $04d676fd7cff0b54$export$74bf444e3cd11ea5; }, function (v) { return $04d676fd7cff0b54$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $04d676fd7cff0b54$export$ae55be85d98224ed; }, function (v) { return $04d676fd7cff0b54$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "act", function () { return $04d676fd7cff0b54$export$3ba232387fd5d6dd; }, function (v) { return $04d676fd7cff0b54$export$3ba232387fd5d6dd = v; });
$parcel$export(module.exports, "cloneElement", function () { return $04d676fd7cff0b54$export$e530037191fcd5d7; }, function (v) { return $04d676fd7cff0b54$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $04d676fd7cff0b54$export$fd42f52fd3ae1109; }, function (v) { return $04d676fd7cff0b54$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $04d676fd7cff0b54$export$c8a8987d4410bf2d; }, function (v) { return $04d676fd7cff0b54$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createFactory", function () { return $04d676fd7cff0b54$export$d38cd72104c1f0e9; }, function (v) { return $04d676fd7cff0b54$export$d38cd72104c1f0e9 = v; });
$parcel$export(module.exports, "createRef", function () { return $04d676fd7cff0b54$export$7d1e3a5e95ceca43; }, function (v) { return $04d676fd7cff0b54$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $04d676fd7cff0b54$export$257a8862b851cb5b; }, function (v) { return $04d676fd7cff0b54$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $04d676fd7cff0b54$export$a8257692ac88316c; }, function (v) { return $04d676fd7cff0b54$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $04d676fd7cff0b54$export$488013bae63b21da; }, function (v) { return $04d676fd7cff0b54$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $04d676fd7cff0b54$export$7c73462e0d25e514; }, function (v) { return $04d676fd7cff0b54$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $04d676fd7cff0b54$export$7568632d0d33d16d; }, function (v) { return $04d676fd7cff0b54$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_act", function () { return $04d676fd7cff0b54$export$88948ce120ea2619; }, function (v) { return $04d676fd7cff0b54$export$88948ce120ea2619 = v; });
$parcel$export(module.exports, "useCallback", function () { return $04d676fd7cff0b54$export$35808ee640e87ca7; }, function (v) { return $04d676fd7cff0b54$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $04d676fd7cff0b54$export$fae74005e78b1a27; }, function (v) { return $04d676fd7cff0b54$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $04d676fd7cff0b54$export$dc8fbce3eb94dc1e; }, function (v) { return $04d676fd7cff0b54$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $04d676fd7cff0b54$export$6a7bc4e911dc01cf; }, function (v) { return $04d676fd7cff0b54$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $04d676fd7cff0b54$export$6d9c69b0de29b591; }, function (v) { return $04d676fd7cff0b54$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useId", function () { return $04d676fd7cff0b54$export$f680877a34711e37; }, function (v) { return $04d676fd7cff0b54$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $04d676fd7cff0b54$export$d5a552a76deda3c2; }, function (v) { return $04d676fd7cff0b54$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $04d676fd7cff0b54$export$aaabe4eda9ed9969; }, function (v) { return $04d676fd7cff0b54$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $04d676fd7cff0b54$export$e5c5a5f917a5871c; }, function (v) { return $04d676fd7cff0b54$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $04d676fd7cff0b54$export$1538c33de8887b59; }, function (v) { return $04d676fd7cff0b54$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useReducer", function () { return $04d676fd7cff0b54$export$13e3392192263954; }, function (v) { return $04d676fd7cff0b54$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $04d676fd7cff0b54$export$b8f5890fc79d6aca; }, function (v) { return $04d676fd7cff0b54$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $04d676fd7cff0b54$export$60241385465d0a34; }, function (v) { return $04d676fd7cff0b54$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $04d676fd7cff0b54$export$306c0aa65ff9ec16; }, function (v) { return $04d676fd7cff0b54$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $04d676fd7cff0b54$export$7b286972b8d8ccbf; }, function (v) { return $04d676fd7cff0b54$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $04d676fd7cff0b54$export$83d89fbfd8236492; }, function (v) { return $04d676fd7cff0b54$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $04d676fd7cff0b54$export$dca3b0875bd9a954;
var $04d676fd7cff0b54$export$16fa2f45be04daa8;
var $04d676fd7cff0b54$export$ffb0004e005737fa;
var $04d676fd7cff0b54$export$e2c29f18771995cb;
var $04d676fd7cff0b54$export$221d75b3f55bb0bd;
var $04d676fd7cff0b54$export$5f8d39834fd61797;
var $04d676fd7cff0b54$export$74bf444e3cd11ea5;
var $04d676fd7cff0b54$export$ae55be85d98224ed;
var $04d676fd7cff0b54$export$3ba232387fd5d6dd;
var $04d676fd7cff0b54$export$e530037191fcd5d7;
var $04d676fd7cff0b54$export$fd42f52fd3ae1109;
var $04d676fd7cff0b54$export$c8a8987d4410bf2d;
var $04d676fd7cff0b54$export$d38cd72104c1f0e9;
var $04d676fd7cff0b54$export$7d1e3a5e95ceca43;
var $04d676fd7cff0b54$export$257a8862b851cb5b;
var $04d676fd7cff0b54$export$a8257692ac88316c;
var $04d676fd7cff0b54$export$488013bae63b21da;
var $04d676fd7cff0b54$export$7c73462e0d25e514;
var $04d676fd7cff0b54$export$7568632d0d33d16d;
var $04d676fd7cff0b54$export$88948ce120ea2619;
var $04d676fd7cff0b54$export$35808ee640e87ca7;
var $04d676fd7cff0b54$export$fae74005e78b1a27;
var $04d676fd7cff0b54$export$dc8fbce3eb94dc1e;
var $04d676fd7cff0b54$export$6a7bc4e911dc01cf;
var $04d676fd7cff0b54$export$6d9c69b0de29b591;
var $04d676fd7cff0b54$export$f680877a34711e37;
var $04d676fd7cff0b54$export$d5a552a76deda3c2;
var $04d676fd7cff0b54$export$aaabe4eda9ed9969;
var $04d676fd7cff0b54$export$e5c5a5f917a5871c;
var $04d676fd7cff0b54$export$1538c33de8887b59;
var $04d676fd7cff0b54$export$13e3392192263954;
var $04d676fd7cff0b54$export$b8f5890fc79d6aca;
var $04d676fd7cff0b54$export$60241385465d0a34;
var $04d676fd7cff0b54$export$306c0aa65ff9ec16;
var $04d676fd7cff0b54$export$7b286972b8d8ccbf;
var $04d676fd7cff0b54$export$83d89fbfd8236492;
'use strict';
var $04d676fd7cff0b54$var$l = Symbol.for("react.element"), $04d676fd7cff0b54$var$n = Symbol.for("react.portal"), $04d676fd7cff0b54$var$p = Symbol.for("react.fragment"), $04d676fd7cff0b54$var$q = Symbol.for("react.strict_mode"), $04d676fd7cff0b54$var$r = Symbol.for("react.profiler"), $04d676fd7cff0b54$var$t = Symbol.for("react.provider"), $04d676fd7cff0b54$var$u = Symbol.for("react.context"), $04d676fd7cff0b54$var$v = Symbol.for("react.forward_ref"), $04d676fd7cff0b54$var$w = Symbol.for("react.suspense"), $04d676fd7cff0b54$var$x = Symbol.for("react.memo"), $04d676fd7cff0b54$var$y = Symbol.for("react.lazy"), $04d676fd7cff0b54$var$z = Symbol.iterator;
function $04d676fd7cff0b54$var$A(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $04d676fd7cff0b54$var$z && a[$04d676fd7cff0b54$var$z] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $04d676fd7cff0b54$var$B = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $04d676fd7cff0b54$var$C = Object.assign, $04d676fd7cff0b54$var$D = {};
function $04d676fd7cff0b54$var$E(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $04d676fd7cff0b54$var$D;
    this.updater = e || $04d676fd7cff0b54$var$B;
}
$04d676fd7cff0b54$var$E.prototype.isReactComponent = {};
$04d676fd7cff0b54$var$E.prototype.setState = function(a, b) {
    if ("object" !== typeof a && "function" !== typeof a && null != a) throw Error("setState(...): takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, a, b, "setState");
};
$04d676fd7cff0b54$var$E.prototype.forceUpdate = function(a) {
    this.updater.enqueueForceUpdate(this, a, "forceUpdate");
};
function $04d676fd7cff0b54$var$F() {}
$04d676fd7cff0b54$var$F.prototype = $04d676fd7cff0b54$var$E.prototype;
function $04d676fd7cff0b54$var$G(a, b, e) {
    this.props = a;
    this.context = b;
    this.refs = $04d676fd7cff0b54$var$D;
    this.updater = e || $04d676fd7cff0b54$var$B;
}
var $04d676fd7cff0b54$var$H = $04d676fd7cff0b54$var$G.prototype = new $04d676fd7cff0b54$var$F;
$04d676fd7cff0b54$var$H.constructor = $04d676fd7cff0b54$var$G;
$04d676fd7cff0b54$var$C($04d676fd7cff0b54$var$H, $04d676fd7cff0b54$var$E.prototype);
$04d676fd7cff0b54$var$H.isPureReactComponent = !0;
var $04d676fd7cff0b54$var$I = Array.isArray, $04d676fd7cff0b54$var$J = Object.prototype.hasOwnProperty, $04d676fd7cff0b54$var$K = {
    current: null
}, $04d676fd7cff0b54$var$L = {
    key: !0,
    ref: !0,
    __self: !0,
    __source: !0
};
function $04d676fd7cff0b54$var$M(a, b, e) {
    var d, c = {}, k = null, h = null;
    if (null != b) for(d in void 0 !== b.ref && (h = b.ref), void 0 !== b.key && (k = "" + b.key), b)$04d676fd7cff0b54$var$J.call(b, d) && !$04d676fd7cff0b54$var$L.hasOwnProperty(d) && (c[d] = b[d]);
    var g = arguments.length - 2;
    if (1 === g) c.children = e;
    else if (1 < g) {
        for(var f = Array(g), m = 0; m < g; m++)f[m] = arguments[m + 2];
        c.children = f;
    }
    if (a && a.defaultProps) for(d in g = a.defaultProps, g)void 0 === c[d] && (c[d] = g[d]);
    return {
        $$typeof: $04d676fd7cff0b54$var$l,
        type: a,
        key: k,
        ref: h,
        props: c,
        _owner: $04d676fd7cff0b54$var$K.current
    };
}
function $04d676fd7cff0b54$var$N(a, b) {
    return {
        $$typeof: $04d676fd7cff0b54$var$l,
        type: a.type,
        key: b,
        ref: a.ref,
        props: a.props,
        _owner: a._owner
    };
}
function $04d676fd7cff0b54$var$O(a) {
    return "object" === typeof a && null !== a && a.$$typeof === $04d676fd7cff0b54$var$l;
}
function $04d676fd7cff0b54$var$escape(a) {
    var b = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + a.replace(/[=:]/g, function(a) {
        return b[a];
    });
}
var $04d676fd7cff0b54$var$P = /\/+/g;
function $04d676fd7cff0b54$var$Q(a, b) {
    return "object" === typeof a && null !== a && null != a.key ? $04d676fd7cff0b54$var$escape("" + a.key) : b.toString(36);
}
function $04d676fd7cff0b54$var$R(a, b, e, d, c) {
    var k = typeof a;
    if ("undefined" === k || "boolean" === k) a = null;
    var h = !1;
    if (null === a) h = !0;
    else switch(k){
        case "string":
        case "number":
            h = !0;
            break;
        case "object":
            switch(a.$$typeof){
                case $04d676fd7cff0b54$var$l:
                case $04d676fd7cff0b54$var$n:
                    h = !0;
            }
    }
    if (h) return h = a, c = c(h), a = "" === d ? "." + $04d676fd7cff0b54$var$Q(h, 0) : d, $04d676fd7cff0b54$var$I(c) ? (e = "", null != a && (e = a.replace($04d676fd7cff0b54$var$P, "$&/") + "/"), $04d676fd7cff0b54$var$R(c, b, e, "", function(a) {
        return a;
    })) : null != c && ($04d676fd7cff0b54$var$O(c) && (c = $04d676fd7cff0b54$var$N(c, e + (!c.key || h && h.key === c.key ? "" : ("" + c.key).replace($04d676fd7cff0b54$var$P, "$&/") + "/") + a)), b.push(c)), 1;
    h = 0;
    d = "" === d ? "." : d + ":";
    if ($04d676fd7cff0b54$var$I(a)) for(var g = 0; g < a.length; g++){
        k = a[g];
        var f = d + $04d676fd7cff0b54$var$Q(k, g);
        h += $04d676fd7cff0b54$var$R(k, b, e, f, c);
    }
    else if (f = $04d676fd7cff0b54$var$A(a), "function" === typeof f) for(a = f.call(a), g = 0; !(k = a.next()).done;)k = k.value, f = d + $04d676fd7cff0b54$var$Q(k, g++), h += $04d676fd7cff0b54$var$R(k, b, e, f, c);
    else if ("object" === k) throw b = String(a), Error("Objects are not valid as a React child (found: " + ("[object Object]" === b ? "object with keys {" + Object.keys(a).join(", ") + "}" : b) + "). If you meant to render a collection of children, use an array instead.");
    return h;
}
function $04d676fd7cff0b54$var$S(a, b, e) {
    if (null == a) return a;
    var d = [], c = 0;
    $04d676fd7cff0b54$var$R(a, d, "", "", function(a) {
        return b.call(e, a, c++);
    });
    return d;
}
function $04d676fd7cff0b54$var$T(a) {
    if (-1 === a._status) {
        var b = a._result;
        b = b();
        b.then(function(b) {
            if (0 === a._status || -1 === a._status) a._status = 1, a._result = b;
        }, function(b) {
            if (0 === a._status || -1 === a._status) a._status = 2, a._result = b;
        });
        -1 === a._status && (a._status = 0, a._result = b);
    }
    if (1 === a._status) return a._result.default;
    throw a._result;
}
var $04d676fd7cff0b54$var$U = {
    current: null
}, $04d676fd7cff0b54$var$V = {
    transition: null
}, $04d676fd7cff0b54$var$W = {
    ReactCurrentDispatcher: $04d676fd7cff0b54$var$U,
    ReactCurrentBatchConfig: $04d676fd7cff0b54$var$V,
    ReactCurrentOwner: $04d676fd7cff0b54$var$K
};
function $04d676fd7cff0b54$var$X() {
    throw Error("act(...) is not supported in production builds of React.");
}
$04d676fd7cff0b54$export$dca3b0875bd9a954 = {
    map: $04d676fd7cff0b54$var$S,
    forEach: function(a, b, e) {
        $04d676fd7cff0b54$var$S(a, function() {
            b.apply(this, arguments);
        }, e);
    },
    count: function(a) {
        var b = 0;
        $04d676fd7cff0b54$var$S(a, function() {
            b++;
        });
        return b;
    },
    toArray: function(a) {
        return $04d676fd7cff0b54$var$S(a, function(a) {
            return a;
        }) || [];
    },
    only: function(a) {
        if (!$04d676fd7cff0b54$var$O(a)) throw Error("React.Children.only expected to receive a single React element child.");
        return a;
    }
};
$04d676fd7cff0b54$export$16fa2f45be04daa8 = $04d676fd7cff0b54$var$E;
$04d676fd7cff0b54$export$ffb0004e005737fa = $04d676fd7cff0b54$var$p;
$04d676fd7cff0b54$export$e2c29f18771995cb = $04d676fd7cff0b54$var$r;
$04d676fd7cff0b54$export$221d75b3f55bb0bd = $04d676fd7cff0b54$var$G;
$04d676fd7cff0b54$export$5f8d39834fd61797 = $04d676fd7cff0b54$var$q;
$04d676fd7cff0b54$export$74bf444e3cd11ea5 = $04d676fd7cff0b54$var$w;
$04d676fd7cff0b54$export$ae55be85d98224ed = $04d676fd7cff0b54$var$W;
$04d676fd7cff0b54$export$3ba232387fd5d6dd = $04d676fd7cff0b54$var$X;
$04d676fd7cff0b54$export$e530037191fcd5d7 = function(a, b, e) {
    if (null === a || void 0 === a) throw Error("React.cloneElement(...): The argument must be a React element, but you passed " + a + ".");
    var d = $04d676fd7cff0b54$var$C({}, a.props), c = a.key, k = a.ref, h = a._owner;
    if (null != b) {
        void 0 !== b.ref && (k = b.ref, h = $04d676fd7cff0b54$var$K.current);
        void 0 !== b.key && (c = "" + b.key);
        if (a.type && a.type.defaultProps) var g = a.type.defaultProps;
        for(f in b)$04d676fd7cff0b54$var$J.call(b, f) && !$04d676fd7cff0b54$var$L.hasOwnProperty(f) && (d[f] = void 0 === b[f] && void 0 !== g ? g[f] : b[f]);
    }
    var f = arguments.length - 2;
    if (1 === f) d.children = e;
    else if (1 < f) {
        g = Array(f);
        for(var m = 0; m < f; m++)g[m] = arguments[m + 2];
        d.children = g;
    }
    return {
        $$typeof: $04d676fd7cff0b54$var$l,
        type: a.type,
        key: c,
        ref: k,
        props: d,
        _owner: h
    };
};
$04d676fd7cff0b54$export$fd42f52fd3ae1109 = function(a) {
    a = {
        $$typeof: $04d676fd7cff0b54$var$u,
        _currentValue: a,
        _currentValue2: a,
        _threadCount: 0,
        Provider: null,
        Consumer: null,
        _defaultValue: null,
        _globalName: null
    };
    a.Provider = {
        $$typeof: $04d676fd7cff0b54$var$t,
        _context: a
    };
    return a.Consumer = a;
};
$04d676fd7cff0b54$export$c8a8987d4410bf2d = $04d676fd7cff0b54$var$M;
$04d676fd7cff0b54$export$d38cd72104c1f0e9 = function(a) {
    var b = $04d676fd7cff0b54$var$M.bind(null, a);
    b.type = a;
    return b;
};
$04d676fd7cff0b54$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$04d676fd7cff0b54$export$257a8862b851cb5b = function(a) {
    return {
        $$typeof: $04d676fd7cff0b54$var$v,
        render: a
    };
};
$04d676fd7cff0b54$export$a8257692ac88316c = $04d676fd7cff0b54$var$O;
$04d676fd7cff0b54$export$488013bae63b21da = function(a) {
    return {
        $$typeof: $04d676fd7cff0b54$var$y,
        _payload: {
            _status: -1,
            _result: a
        },
        _init: $04d676fd7cff0b54$var$T
    };
};
$04d676fd7cff0b54$export$7c73462e0d25e514 = function(a, b) {
    return {
        $$typeof: $04d676fd7cff0b54$var$x,
        type: a,
        compare: void 0 === b ? null : b
    };
};
$04d676fd7cff0b54$export$7568632d0d33d16d = function(a) {
    var b = $04d676fd7cff0b54$var$V.transition;
    $04d676fd7cff0b54$var$V.transition = {};
    try {
        a();
    } finally{
        $04d676fd7cff0b54$var$V.transition = b;
    }
};
$04d676fd7cff0b54$export$88948ce120ea2619 = $04d676fd7cff0b54$var$X;
$04d676fd7cff0b54$export$35808ee640e87ca7 = function(a, b) {
    return $04d676fd7cff0b54$var$U.current.useCallback(a, b);
};
$04d676fd7cff0b54$export$fae74005e78b1a27 = function(a) {
    return $04d676fd7cff0b54$var$U.current.useContext(a);
};
$04d676fd7cff0b54$export$dc8fbce3eb94dc1e = function() {};
$04d676fd7cff0b54$export$6a7bc4e911dc01cf = function(a) {
    return $04d676fd7cff0b54$var$U.current.useDeferredValue(a);
};
$04d676fd7cff0b54$export$6d9c69b0de29b591 = function(a, b) {
    return $04d676fd7cff0b54$var$U.current.useEffect(a, b);
};
$04d676fd7cff0b54$export$f680877a34711e37 = function() {
    return $04d676fd7cff0b54$var$U.current.useId();
};
$04d676fd7cff0b54$export$d5a552a76deda3c2 = function(a, b, e) {
    return $04d676fd7cff0b54$var$U.current.useImperativeHandle(a, b, e);
};
$04d676fd7cff0b54$export$aaabe4eda9ed9969 = function(a, b) {
    return $04d676fd7cff0b54$var$U.current.useInsertionEffect(a, b);
};
$04d676fd7cff0b54$export$e5c5a5f917a5871c = function(a, b) {
    return $04d676fd7cff0b54$var$U.current.useLayoutEffect(a, b);
};
$04d676fd7cff0b54$export$1538c33de8887b59 = function(a, b) {
    return $04d676fd7cff0b54$var$U.current.useMemo(a, b);
};
$04d676fd7cff0b54$export$13e3392192263954 = function(a, b, e) {
    return $04d676fd7cff0b54$var$U.current.useReducer(a, b, e);
};
$04d676fd7cff0b54$export$b8f5890fc79d6aca = function(a) {
    return $04d676fd7cff0b54$var$U.current.useRef(a);
};
$04d676fd7cff0b54$export$60241385465d0a34 = function(a) {
    return $04d676fd7cff0b54$var$U.current.useState(a);
};
$04d676fd7cff0b54$export$306c0aa65ff9ec16 = function(a, b, e) {
    return $04d676fd7cff0b54$var$U.current.useSyncExternalStore(a, b, e);
};
$04d676fd7cff0b54$export$7b286972b8d8ccbf = function() {
    return $04d676fd7cff0b54$var$U.current.useTransition();
};
$04d676fd7cff0b54$export$83d89fbfd8236492 = "18.3.1";

});



parcelRegister("5xGGd", function(module, exports) {

$parcel$export(module.exports, "__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED", function () { return $409124218b1e663f$export$ae55be85d98224ed; }, function (v) { return $409124218b1e663f$export$ae55be85d98224ed = v; });
$parcel$export(module.exports, "createPortal", function () { return $409124218b1e663f$export$d39a5bbd09211389; }, function (v) { return $409124218b1e663f$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "createRoot", function () { return $409124218b1e663f$export$882461b6382ed46c; }, function (v) { return $409124218b1e663f$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "findDOMNode", function () { return $409124218b1e663f$export$466bfc07425424d5; }, function (v) { return $409124218b1e663f$export$466bfc07425424d5 = v; });
$parcel$export(module.exports, "flushSync", function () { return $409124218b1e663f$export$cd75ccfd720a3cd4; }, function (v) { return $409124218b1e663f$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "hydrate", function () { return $409124218b1e663f$export$fa8d919ba61d84db; }, function (v) { return $409124218b1e663f$export$fa8d919ba61d84db = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $409124218b1e663f$export$757ceba2d55c277e; }, function (v) { return $409124218b1e663f$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "render", function () { return $409124218b1e663f$export$b3890eb0ae9dca99; }, function (v) { return $409124218b1e663f$export$b3890eb0ae9dca99 = v; });
$parcel$export(module.exports, "unmountComponentAtNode", function () { return $409124218b1e663f$export$502457920280e6be; }, function (v) { return $409124218b1e663f$export$502457920280e6be = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $409124218b1e663f$export$c78a37762a8d58e1; }, function (v) { return $409124218b1e663f$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "unstable_renderSubtreeIntoContainer", function () { return $409124218b1e663f$export$dc54d992c10e8a18; }, function (v) { return $409124218b1e663f$export$dc54d992c10e8a18 = v; });
$parcel$export(module.exports, "version", function () { return $409124218b1e663f$export$83d89fbfd8236492; }, function (v) { return $409124218b1e663f$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $409124218b1e663f$export$ae55be85d98224ed;
var $409124218b1e663f$export$d39a5bbd09211389;
var $409124218b1e663f$export$882461b6382ed46c;
var $409124218b1e663f$export$466bfc07425424d5;
var $409124218b1e663f$export$cd75ccfd720a3cd4;
var $409124218b1e663f$export$fa8d919ba61d84db;
var $409124218b1e663f$export$757ceba2d55c277e;
var $409124218b1e663f$export$b3890eb0ae9dca99;
var $409124218b1e663f$export$502457920280e6be;
var $409124218b1e663f$export$c78a37762a8d58e1;
var $409124218b1e663f$export$dc54d992c10e8a18;
var $409124218b1e663f$export$83d89fbfd8236492;
'use strict';

var $6SWiB = parcelRequire("6SWiB");

var $bUepA = parcelRequire("bUepA");
function $409124218b1e663f$var$p(a) {
    for(var b = "https://reactjs.org/docs/error-decoder.html?invariant=" + a, c = 1; c < arguments.length; c++)b += "&args[]=" + encodeURIComponent(arguments[c]);
    return "Minified React error #" + a + "; visit " + b + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
var $409124218b1e663f$var$da = new Set, $409124218b1e663f$var$ea = {};
function $409124218b1e663f$var$fa(a, b) {
    $409124218b1e663f$var$ha(a, b);
    $409124218b1e663f$var$ha(a + "Capture", b);
}
function $409124218b1e663f$var$ha(a, b) {
    $409124218b1e663f$var$ea[a] = b;
    for(a = 0; a < b.length; a++)$409124218b1e663f$var$da.add(b[a]);
}
var $409124218b1e663f$var$ia = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $409124218b1e663f$var$ja = Object.prototype.hasOwnProperty, $409124218b1e663f$var$ka = /^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/, $409124218b1e663f$var$la = {}, $409124218b1e663f$var$ma = {};
function $409124218b1e663f$var$oa(a) {
    if ($409124218b1e663f$var$ja.call($409124218b1e663f$var$ma, a)) return !0;
    if ($409124218b1e663f$var$ja.call($409124218b1e663f$var$la, a)) return !1;
    if ($409124218b1e663f$var$ka.test(a)) return $409124218b1e663f$var$ma[a] = !0;
    $409124218b1e663f$var$la[a] = !0;
    return !1;
}
function $409124218b1e663f$var$pa(a, b, c, d) {
    if (null !== c && 0 === c.type) return !1;
    switch(typeof b){
        case "function":
        case "symbol":
            return !0;
        case "boolean":
            if (d) return !1;
            if (null !== c) return !c.acceptsBooleans;
            a = a.toLowerCase().slice(0, 5);
            return "data-" !== a && "aria-" !== a;
        default:
            return !1;
    }
}
function $409124218b1e663f$var$qa(a, b, c, d) {
    if (null === b || "undefined" === typeof b || $409124218b1e663f$var$pa(a, b, c, d)) return !0;
    if (d) return !1;
    if (null !== c) switch(c.type){
        case 3:
            return !b;
        case 4:
            return !1 === b;
        case 5:
            return isNaN(b);
        case 6:
            return isNaN(b) || 1 > b;
    }
    return !1;
}
function $409124218b1e663f$var$v(a, b, c, d, e, f, g) {
    this.acceptsBooleans = 2 === b || 3 === b || 4 === b;
    this.attributeName = d;
    this.attributeNamespace = e;
    this.mustUseProperty = c;
    this.propertyName = a;
    this.type = b;
    this.sanitizeURL = f;
    this.removeEmptyString = g;
}
var $409124218b1e663f$var$z = {};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a) {
    $409124218b1e663f$var$z[a] = new $409124218b1e663f$var$v(a, 0, !1, a, null, !1, !1);
});
[
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "className",
        "class"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ]
].forEach(function(a) {
    var b = a[0];
    $409124218b1e663f$var$z[b] = new $409124218b1e663f$var$v(b, 1, !1, a[1], null, !1, !1);
});
[
    "contentEditable",
    "draggable",
    "spellCheck",
    "value"
].forEach(function(a) {
    $409124218b1e663f$var$z[a] = new $409124218b1e663f$var$v(a, 2, !1, a.toLowerCase(), null, !1, !1);
});
[
    "autoReverse",
    "externalResourcesRequired",
    "focusable",
    "preserveAlpha"
].forEach(function(a) {
    $409124218b1e663f$var$z[a] = new $409124218b1e663f$var$v(a, 2, !1, a, null, !1, !1);
});
"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture disableRemotePlayback formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a) {
    $409124218b1e663f$var$z[a] = new $409124218b1e663f$var$v(a, 3, !1, a.toLowerCase(), null, !1, !1);
});
[
    "checked",
    "multiple",
    "muted",
    "selected"
].forEach(function(a) {
    $409124218b1e663f$var$z[a] = new $409124218b1e663f$var$v(a, 3, !0, a, null, !1, !1);
});
[
    "capture",
    "download"
].forEach(function(a) {
    $409124218b1e663f$var$z[a] = new $409124218b1e663f$var$v(a, 4, !1, a, null, !1, !1);
});
[
    "cols",
    "rows",
    "size",
    "span"
].forEach(function(a) {
    $409124218b1e663f$var$z[a] = new $409124218b1e663f$var$v(a, 6, !1, a, null, !1, !1);
});
[
    "rowSpan",
    "start"
].forEach(function(a) {
    $409124218b1e663f$var$z[a] = new $409124218b1e663f$var$v(a, 5, !1, a.toLowerCase(), null, !1, !1);
});
var $409124218b1e663f$var$ra = /[\-:]([a-z])/g;
function $409124218b1e663f$var$sa(a) {
    return a[1].toUpperCase();
}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a) {
    var b = a.replace($409124218b1e663f$var$ra, $409124218b1e663f$var$sa);
    $409124218b1e663f$var$z[b] = new $409124218b1e663f$var$v(b, 1, !1, a, null, !1, !1);
});
"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a) {
    var b = a.replace($409124218b1e663f$var$ra, $409124218b1e663f$var$sa);
    $409124218b1e663f$var$z[b] = new $409124218b1e663f$var$v(b, 1, !1, a, "http://www.w3.org/1999/xlink", !1, !1);
});
[
    "xml:base",
    "xml:lang",
    "xml:space"
].forEach(function(a) {
    var b = a.replace($409124218b1e663f$var$ra, $409124218b1e663f$var$sa);
    $409124218b1e663f$var$z[b] = new $409124218b1e663f$var$v(b, 1, !1, a, "http://www.w3.org/XML/1998/namespace", !1, !1);
});
[
    "tabIndex",
    "crossOrigin"
].forEach(function(a) {
    $409124218b1e663f$var$z[a] = new $409124218b1e663f$var$v(a, 1, !1, a.toLowerCase(), null, !1, !1);
});
$409124218b1e663f$var$z.xlinkHref = new $409124218b1e663f$var$v("xlinkHref", 1, !1, "xlink:href", "http://www.w3.org/1999/xlink", !0, !1);
[
    "src",
    "href",
    "action",
    "formAction"
].forEach(function(a) {
    $409124218b1e663f$var$z[a] = new $409124218b1e663f$var$v(a, 1, !1, a.toLowerCase(), null, !0, !0);
});
function $409124218b1e663f$var$ta(a, b, c, d) {
    var e = $409124218b1e663f$var$z.hasOwnProperty(b) ? $409124218b1e663f$var$z[b] : null;
    if (null !== e ? 0 !== e.type : d || !(2 < b.length) || "o" !== b[0] && "O" !== b[0] || "n" !== b[1] && "N" !== b[1]) $409124218b1e663f$var$qa(b, c, e, d) && (c = null), d || null === e ? $409124218b1e663f$var$oa(b) && (null === c ? a.removeAttribute(b) : a.setAttribute(b, "" + c)) : e.mustUseProperty ? a[e.propertyName] = null === c ? 3 === e.type ? !1 : "" : c : (b = e.attributeName, d = e.attributeNamespace, null === c ? a.removeAttribute(b) : (e = e.type, c = 3 === e || 4 === e && !0 === c ? "" : "" + c, d ? a.setAttributeNS(d, b, c) : a.setAttribute(b, c)));
}
var $409124218b1e663f$var$ua = $6SWiB.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED, $409124218b1e663f$var$va = Symbol.for("react.element"), $409124218b1e663f$var$wa = Symbol.for("react.portal"), $409124218b1e663f$var$ya = Symbol.for("react.fragment"), $409124218b1e663f$var$za = Symbol.for("react.strict_mode"), $409124218b1e663f$var$Aa = Symbol.for("react.profiler"), $409124218b1e663f$var$Ba = Symbol.for("react.provider"), $409124218b1e663f$var$Ca = Symbol.for("react.context"), $409124218b1e663f$var$Da = Symbol.for("react.forward_ref"), $409124218b1e663f$var$Ea = Symbol.for("react.suspense"), $409124218b1e663f$var$Fa = Symbol.for("react.suspense_list"), $409124218b1e663f$var$Ga = Symbol.for("react.memo"), $409124218b1e663f$var$Ha = Symbol.for("react.lazy");
Symbol.for("react.scope");
Symbol.for("react.debug_trace_mode");
var $409124218b1e663f$var$Ia = Symbol.for("react.offscreen");
Symbol.for("react.legacy_hidden");
Symbol.for("react.cache");
Symbol.for("react.tracing_marker");
var $409124218b1e663f$var$Ja = Symbol.iterator;
function $409124218b1e663f$var$Ka(a) {
    if (null === a || "object" !== typeof a) return null;
    a = $409124218b1e663f$var$Ja && a[$409124218b1e663f$var$Ja] || a["@@iterator"];
    return "function" === typeof a ? a : null;
}
var $409124218b1e663f$var$A = Object.assign, $409124218b1e663f$var$La;
function $409124218b1e663f$var$Ma(a) {
    if (void 0 === $409124218b1e663f$var$La) try {
        throw Error();
    } catch (c) {
        var b = c.stack.trim().match(/\n( *(at )?)/);
        $409124218b1e663f$var$La = b && b[1] || "";
    }
    return "\n" + $409124218b1e663f$var$La + a;
}
var $409124218b1e663f$var$Na = !1;
function $409124218b1e663f$var$Oa(a, b) {
    if (!a || $409124218b1e663f$var$Na) return "";
    $409124218b1e663f$var$Na = !0;
    var c = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        if (b) {
            if (b = function() {
                throw Error();
            }, Object.defineProperty(b.prototype, "props", {
                set: function() {
                    throw Error();
                }
            }), "object" === typeof Reflect && Reflect.construct) {
                try {
                    Reflect.construct(b, []);
                } catch (l) {
                    var d = l;
                }
                Reflect.construct(a, [], b);
            } else {
                try {
                    b.call();
                } catch (l) {
                    d = l;
                }
                a.call(b.prototype);
            }
        } else {
            try {
                throw Error();
            } catch (l) {
                d = l;
            }
            a();
        }
    } catch (l) {
        if (l && d && "string" === typeof l.stack) {
            for(var e = l.stack.split("\n"), f = d.stack.split("\n"), g = e.length - 1, h = f.length - 1; 1 <= g && 0 <= h && e[g] !== f[h];)h--;
            for(; 1 <= g && 0 <= h; g--, h--)if (e[g] !== f[h]) {
                if (1 !== g || 1 !== h) {
                    do if (g--, h--, 0 > h || e[g] !== f[h]) {
                        var k = "\n" + e[g].replace(" at new ", " at ");
                        a.displayName && k.includes("<anonymous>") && (k = k.replace("<anonymous>", a.displayName));
                        return k;
                    }
                    while (1 <= g && 0 <= h);
                }
                break;
            }
        }
    } finally{
        $409124218b1e663f$var$Na = !1, Error.prepareStackTrace = c;
    }
    return (a = a ? a.displayName || a.name : "") ? $409124218b1e663f$var$Ma(a) : "";
}
function $409124218b1e663f$var$Pa(a) {
    switch(a.tag){
        case 5:
            return $409124218b1e663f$var$Ma(a.type);
        case 16:
            return $409124218b1e663f$var$Ma("Lazy");
        case 13:
            return $409124218b1e663f$var$Ma("Suspense");
        case 19:
            return $409124218b1e663f$var$Ma("SuspenseList");
        case 0:
        case 2:
        case 15:
            return a = $409124218b1e663f$var$Oa(a.type, !1), a;
        case 11:
            return a = $409124218b1e663f$var$Oa(a.type.render, !1), a;
        case 1:
            return a = $409124218b1e663f$var$Oa(a.type, !0), a;
        default:
            return "";
    }
}
function $409124218b1e663f$var$Qa(a) {
    if (null == a) return null;
    if ("function" === typeof a) return a.displayName || a.name || null;
    if ("string" === typeof a) return a;
    switch(a){
        case $409124218b1e663f$var$ya:
            return "Fragment";
        case $409124218b1e663f$var$wa:
            return "Portal";
        case $409124218b1e663f$var$Aa:
            return "Profiler";
        case $409124218b1e663f$var$za:
            return "StrictMode";
        case $409124218b1e663f$var$Ea:
            return "Suspense";
        case $409124218b1e663f$var$Fa:
            return "SuspenseList";
    }
    if ("object" === typeof a) switch(a.$$typeof){
        case $409124218b1e663f$var$Ca:
            return (a.displayName || "Context") + ".Consumer";
        case $409124218b1e663f$var$Ba:
            return (a._context.displayName || "Context") + ".Provider";
        case $409124218b1e663f$var$Da:
            var b = a.render;
            a = a.displayName;
            a || (a = b.displayName || b.name || "", a = "" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
            return a;
        case $409124218b1e663f$var$Ga:
            return b = a.displayName || null, null !== b ? b : $409124218b1e663f$var$Qa(a.type) || "Memo";
        case $409124218b1e663f$var$Ha:
            b = a._payload;
            a = a._init;
            try {
                return $409124218b1e663f$var$Qa(a(b));
            } catch (c) {}
    }
    return null;
}
function $409124218b1e663f$var$Ra(a) {
    var b = a.type;
    switch(a.tag){
        case 24:
            return "Cache";
        case 9:
            return (b.displayName || "Context") + ".Consumer";
        case 10:
            return (b._context.displayName || "Context") + ".Provider";
        case 18:
            return "DehydratedFragment";
        case 11:
            return a = b.render, a = a.displayName || a.name || "", b.displayName || ("" !== a ? "ForwardRef(" + a + ")" : "ForwardRef");
        case 7:
            return "Fragment";
        case 5:
            return b;
        case 4:
            return "Portal";
        case 3:
            return "Root";
        case 6:
            return "Text";
        case 16:
            return $409124218b1e663f$var$Qa(b);
        case 8:
            return b === $409124218b1e663f$var$za ? "StrictMode" : "Mode";
        case 22:
            return "Offscreen";
        case 12:
            return "Profiler";
        case 21:
            return "Scope";
        case 13:
            return "Suspense";
        case 19:
            return "SuspenseList";
        case 25:
            return "TracingMarker";
        case 1:
        case 0:
        case 17:
        case 2:
        case 14:
        case 15:
            if ("function" === typeof b) return b.displayName || b.name || null;
            if ("string" === typeof b) return b;
    }
    return null;
}
function $409124218b1e663f$var$Sa(a) {
    switch(typeof a){
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return a;
        case "object":
            return a;
        default:
            return "";
    }
}
function $409124218b1e663f$var$Ta(a) {
    var b = a.type;
    return (a = a.nodeName) && "input" === a.toLowerCase() && ("checkbox" === b || "radio" === b);
}
function $409124218b1e663f$var$Ua(a) {
    var b = $409124218b1e663f$var$Ta(a) ? "checked" : "value", c = Object.getOwnPropertyDescriptor(a.constructor.prototype, b), d = "" + a[b];
    if (!a.hasOwnProperty(b) && "undefined" !== typeof c && "function" === typeof c.get && "function" === typeof c.set) {
        var e = c.get, f = c.set;
        Object.defineProperty(a, b, {
            configurable: !0,
            get: function() {
                return e.call(this);
            },
            set: function(a) {
                d = "" + a;
                f.call(this, a);
            }
        });
        Object.defineProperty(a, b, {
            enumerable: c.enumerable
        });
        return {
            getValue: function() {
                return d;
            },
            setValue: function(a) {
                d = "" + a;
            },
            stopTracking: function() {
                a._valueTracker = null;
                delete a[b];
            }
        };
    }
}
function $409124218b1e663f$var$Va(a) {
    a._valueTracker || (a._valueTracker = $409124218b1e663f$var$Ua(a));
}
function $409124218b1e663f$var$Wa(a) {
    if (!a) return !1;
    var b = a._valueTracker;
    if (!b) return !0;
    var c = b.getValue();
    var d = "";
    a && (d = $409124218b1e663f$var$Ta(a) ? a.checked ? "true" : "false" : a.value);
    a = d;
    return a !== c ? (b.setValue(a), !0) : !1;
}
function $409124218b1e663f$var$Xa(a) {
    a = a || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof a) return null;
    try {
        return a.activeElement || a.body;
    } catch (b) {
        return a.body;
    }
}
function $409124218b1e663f$var$Ya(a, b) {
    var c = b.checked;
    return $409124218b1e663f$var$A({}, b, {
        defaultChecked: void 0,
        defaultValue: void 0,
        value: void 0,
        checked: null != c ? c : a._wrapperState.initialChecked
    });
}
function $409124218b1e663f$var$Za(a, b) {
    var c = null == b.defaultValue ? "" : b.defaultValue, d = null != b.checked ? b.checked : b.defaultChecked;
    c = $409124218b1e663f$var$Sa(null != b.value ? b.value : c);
    a._wrapperState = {
        initialChecked: d,
        initialValue: c,
        controlled: "checkbox" === b.type || "radio" === b.type ? null != b.checked : null != b.value
    };
}
function $409124218b1e663f$var$ab(a, b) {
    b = b.checked;
    null != b && $409124218b1e663f$var$ta(a, "checked", b, !1);
}
function $409124218b1e663f$var$bb(a, b) {
    $409124218b1e663f$var$ab(a, b);
    var c = $409124218b1e663f$var$Sa(b.value), d = b.type;
    if (null != c) {
        if ("number" === d) {
            if (0 === c && "" === a.value || a.value != c) a.value = "" + c;
        } else a.value !== "" + c && (a.value = "" + c);
    } else if ("submit" === d || "reset" === d) {
        a.removeAttribute("value");
        return;
    }
    b.hasOwnProperty("value") ? $409124218b1e663f$var$cb(a, b.type, c) : b.hasOwnProperty("defaultValue") && $409124218b1e663f$var$cb(a, b.type, $409124218b1e663f$var$Sa(b.defaultValue));
    null == b.checked && null != b.defaultChecked && (a.defaultChecked = !!b.defaultChecked);
}
function $409124218b1e663f$var$db(a, b, c) {
    if (b.hasOwnProperty("value") || b.hasOwnProperty("defaultValue")) {
        var d = b.type;
        if (!("submit" !== d && "reset" !== d || void 0 !== b.value && null !== b.value)) return;
        b = "" + a._wrapperState.initialValue;
        c || b === a.value || (a.value = b);
        a.defaultValue = b;
    }
    c = a.name;
    "" !== c && (a.name = "");
    a.defaultChecked = !!a._wrapperState.initialChecked;
    "" !== c && (a.name = c);
}
function $409124218b1e663f$var$cb(a, b, c) {
    if ("number" !== b || $409124218b1e663f$var$Xa(a.ownerDocument) !== a) null == c ? a.defaultValue = "" + a._wrapperState.initialValue : a.defaultValue !== "" + c && (a.defaultValue = "" + c);
}
var $409124218b1e663f$var$eb = Array.isArray;
function $409124218b1e663f$var$fb(a, b, c, d) {
    a = a.options;
    if (b) {
        b = {};
        for(var e = 0; e < c.length; e++)b["$" + c[e]] = !0;
        for(c = 0; c < a.length; c++)e = b.hasOwnProperty("$" + a[c].value), a[c].selected !== e && (a[c].selected = e), e && d && (a[c].defaultSelected = !0);
    } else {
        c = "" + $409124218b1e663f$var$Sa(c);
        b = null;
        for(e = 0; e < a.length; e++){
            if (a[e].value === c) {
                a[e].selected = !0;
                d && (a[e].defaultSelected = !0);
                return;
            }
            null !== b || a[e].disabled || (b = a[e]);
        }
        null !== b && (b.selected = !0);
    }
}
function $409124218b1e663f$var$gb(a, b) {
    if (null != b.dangerouslySetInnerHTML) throw Error($409124218b1e663f$var$p(91));
    return $409124218b1e663f$var$A({}, b, {
        value: void 0,
        defaultValue: void 0,
        children: "" + a._wrapperState.initialValue
    });
}
function $409124218b1e663f$var$hb(a, b) {
    var c = b.value;
    if (null == c) {
        c = b.children;
        b = b.defaultValue;
        if (null != c) {
            if (null != b) throw Error($409124218b1e663f$var$p(92));
            if ($409124218b1e663f$var$eb(c)) {
                if (1 < c.length) throw Error($409124218b1e663f$var$p(93));
                c = c[0];
            }
            b = c;
        }
        null == b && (b = "");
        c = b;
    }
    a._wrapperState = {
        initialValue: $409124218b1e663f$var$Sa(c)
    };
}
function $409124218b1e663f$var$ib(a, b) {
    var c = $409124218b1e663f$var$Sa(b.value), d = $409124218b1e663f$var$Sa(b.defaultValue);
    null != c && (c = "" + c, c !== a.value && (a.value = c), null == b.defaultValue && a.defaultValue !== c && (a.defaultValue = c));
    null != d && (a.defaultValue = "" + d);
}
function $409124218b1e663f$var$jb(a) {
    var b = a.textContent;
    b === a._wrapperState.initialValue && "" !== b && null !== b && (a.value = b);
}
function $409124218b1e663f$var$kb(a) {
    switch(a){
        case "svg":
            return "http://www.w3.org/2000/svg";
        case "math":
            return "http://www.w3.org/1998/Math/MathML";
        default:
            return "http://www.w3.org/1999/xhtml";
    }
}
function $409124218b1e663f$var$lb(a, b) {
    return null == a || "http://www.w3.org/1999/xhtml" === a ? $409124218b1e663f$var$kb(b) : "http://www.w3.org/2000/svg" === a && "foreignObject" === b ? "http://www.w3.org/1999/xhtml" : a;
}
var $409124218b1e663f$var$mb, $409124218b1e663f$var$nb = function(a) {
    return "undefined" !== typeof MSApp && MSApp.execUnsafeLocalFunction ? function(b, c, d, e) {
        MSApp.execUnsafeLocalFunction(function() {
            return a(b, c, d, e);
        });
    } : a;
}(function(a, b) {
    if ("http://www.w3.org/2000/svg" !== a.namespaceURI || "innerHTML" in a) a.innerHTML = b;
    else {
        $409124218b1e663f$var$mb = $409124218b1e663f$var$mb || document.createElement("div");
        $409124218b1e663f$var$mb.innerHTML = "<svg>" + b.valueOf().toString() + "</svg>";
        for(b = $409124218b1e663f$var$mb.firstChild; a.firstChild;)a.removeChild(a.firstChild);
        for(; b.firstChild;)a.appendChild(b.firstChild);
    }
});
function $409124218b1e663f$var$ob(a, b) {
    if (b) {
        var c = a.firstChild;
        if (c && c === a.lastChild && 3 === c.nodeType) {
            c.nodeValue = b;
            return;
        }
    }
    a.textContent = b;
}
var $409124218b1e663f$var$pb = {
    animationIterationCount: !0,
    aspectRatio: !0,
    borderImageOutset: !0,
    borderImageSlice: !0,
    borderImageWidth: !0,
    boxFlex: !0,
    boxFlexGroup: !0,
    boxOrdinalGroup: !0,
    columnCount: !0,
    columns: !0,
    flex: !0,
    flexGrow: !0,
    flexPositive: !0,
    flexShrink: !0,
    flexNegative: !0,
    flexOrder: !0,
    gridArea: !0,
    gridRow: !0,
    gridRowEnd: !0,
    gridRowSpan: !0,
    gridRowStart: !0,
    gridColumn: !0,
    gridColumnEnd: !0,
    gridColumnSpan: !0,
    gridColumnStart: !0,
    fontWeight: !0,
    lineClamp: !0,
    lineHeight: !0,
    opacity: !0,
    order: !0,
    orphans: !0,
    tabSize: !0,
    widows: !0,
    zIndex: !0,
    zoom: !0,
    fillOpacity: !0,
    floodOpacity: !0,
    stopOpacity: !0,
    strokeDasharray: !0,
    strokeDashoffset: !0,
    strokeMiterlimit: !0,
    strokeOpacity: !0,
    strokeWidth: !0
}, $409124218b1e663f$var$qb = [
    "Webkit",
    "ms",
    "Moz",
    "O"
];
Object.keys($409124218b1e663f$var$pb).forEach(function(a) {
    $409124218b1e663f$var$qb.forEach(function(b) {
        b = b + a.charAt(0).toUpperCase() + a.substring(1);
        $409124218b1e663f$var$pb[b] = $409124218b1e663f$var$pb[a];
    });
});
function $409124218b1e663f$var$rb(a, b, c) {
    return null == b || "boolean" === typeof b || "" === b ? "" : c || "number" !== typeof b || 0 === b || $409124218b1e663f$var$pb.hasOwnProperty(a) && $409124218b1e663f$var$pb[a] ? ("" + b).trim() : b + "px";
}
function $409124218b1e663f$var$sb(a, b) {
    a = a.style;
    for(var c in b)if (b.hasOwnProperty(c)) {
        var d = 0 === c.indexOf("--"), e = $409124218b1e663f$var$rb(c, b[c], d);
        "float" === c && (c = "cssFloat");
        d ? a.setProperty(c, e) : a[c] = e;
    }
}
var $409124218b1e663f$var$tb = $409124218b1e663f$var$A({
    menuitem: !0
}, {
    area: !0,
    base: !0,
    br: !0,
    col: !0,
    embed: !0,
    hr: !0,
    img: !0,
    input: !0,
    keygen: !0,
    link: !0,
    meta: !0,
    param: !0,
    source: !0,
    track: !0,
    wbr: !0
});
function $409124218b1e663f$var$ub(a, b) {
    if (b) {
        if ($409124218b1e663f$var$tb[a] && (null != b.children || null != b.dangerouslySetInnerHTML)) throw Error($409124218b1e663f$var$p(137, a));
        if (null != b.dangerouslySetInnerHTML) {
            if (null != b.children) throw Error($409124218b1e663f$var$p(60));
            if ("object" !== typeof b.dangerouslySetInnerHTML || !("__html" in b.dangerouslySetInnerHTML)) throw Error($409124218b1e663f$var$p(61));
        }
        if (null != b.style && "object" !== typeof b.style) throw Error($409124218b1e663f$var$p(62));
    }
}
function $409124218b1e663f$var$vb(a, b) {
    if (-1 === a.indexOf("-")) return "string" === typeof b.is;
    switch(a){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $409124218b1e663f$var$wb = null;
function $409124218b1e663f$var$xb(a) {
    a = a.target || a.srcElement || window;
    a.correspondingUseElement && (a = a.correspondingUseElement);
    return 3 === a.nodeType ? a.parentNode : a;
}
var $409124218b1e663f$var$yb = null, $409124218b1e663f$var$zb = null, $409124218b1e663f$var$Ab = null;
function $409124218b1e663f$var$Bb(a) {
    if (a = $409124218b1e663f$var$Cb(a)) {
        if ("function" !== typeof $409124218b1e663f$var$yb) throw Error($409124218b1e663f$var$p(280));
        var b = a.stateNode;
        b && (b = $409124218b1e663f$var$Db(b), $409124218b1e663f$var$yb(a.stateNode, a.type, b));
    }
}
function $409124218b1e663f$var$Eb(a) {
    $409124218b1e663f$var$zb ? $409124218b1e663f$var$Ab ? $409124218b1e663f$var$Ab.push(a) : $409124218b1e663f$var$Ab = [
        a
    ] : $409124218b1e663f$var$zb = a;
}
function $409124218b1e663f$var$Fb() {
    if ($409124218b1e663f$var$zb) {
        var a = $409124218b1e663f$var$zb, b = $409124218b1e663f$var$Ab;
        $409124218b1e663f$var$Ab = $409124218b1e663f$var$zb = null;
        $409124218b1e663f$var$Bb(a);
        if (b) for(a = 0; a < b.length; a++)$409124218b1e663f$var$Bb(b[a]);
    }
}
function $409124218b1e663f$var$Gb(a, b) {
    return a(b);
}
function $409124218b1e663f$var$Hb() {}
var $409124218b1e663f$var$Ib = !1;
function $409124218b1e663f$var$Jb(a, b, c) {
    if ($409124218b1e663f$var$Ib) return a(b, c);
    $409124218b1e663f$var$Ib = !0;
    try {
        return $409124218b1e663f$var$Gb(a, b, c);
    } finally{
        if ($409124218b1e663f$var$Ib = !1, null !== $409124218b1e663f$var$zb || null !== $409124218b1e663f$var$Ab) $409124218b1e663f$var$Hb(), $409124218b1e663f$var$Fb();
    }
}
function $409124218b1e663f$var$Kb(a, b) {
    var c = a.stateNode;
    if (null === c) return null;
    var d = $409124218b1e663f$var$Db(c);
    if (null === d) return null;
    c = d[b];
    a: switch(b){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (d = !d.disabled) || (a = a.type, d = !("button" === a || "input" === a || "select" === a || "textarea" === a));
            a = !d;
            break a;
        default:
            a = !1;
    }
    if (a) return null;
    if (c && "function" !== typeof c) throw Error($409124218b1e663f$var$p(231, b, typeof c));
    return c;
}
var $409124218b1e663f$var$Lb = !1;
if ($409124218b1e663f$var$ia) try {
    var $409124218b1e663f$var$Mb = {};
    Object.defineProperty($409124218b1e663f$var$Mb, "passive", {
        get: function() {
            $409124218b1e663f$var$Lb = !0;
        }
    });
    window.addEventListener("test", $409124218b1e663f$var$Mb, $409124218b1e663f$var$Mb);
    window.removeEventListener("test", $409124218b1e663f$var$Mb, $409124218b1e663f$var$Mb);
} catch (a) {
    $409124218b1e663f$var$Lb = !1;
}
function $409124218b1e663f$var$Nb(a, b, c, d, e, f, g, h, k) {
    var l = Array.prototype.slice.call(arguments, 3);
    try {
        b.apply(c, l);
    } catch (m) {
        this.onError(m);
    }
}
var $409124218b1e663f$var$Ob = !1, $409124218b1e663f$var$Pb = null, $409124218b1e663f$var$Qb = !1, $409124218b1e663f$var$Rb = null, $409124218b1e663f$var$Sb = {
    onError: function(a) {
        $409124218b1e663f$var$Ob = !0;
        $409124218b1e663f$var$Pb = a;
    }
};
function $409124218b1e663f$var$Tb(a, b, c, d, e, f, g, h, k) {
    $409124218b1e663f$var$Ob = !1;
    $409124218b1e663f$var$Pb = null;
    $409124218b1e663f$var$Nb.apply($409124218b1e663f$var$Sb, arguments);
}
function $409124218b1e663f$var$Ub(a, b, c, d, e, f, g, h, k) {
    $409124218b1e663f$var$Tb.apply(this, arguments);
    if ($409124218b1e663f$var$Ob) {
        if ($409124218b1e663f$var$Ob) {
            var l = $409124218b1e663f$var$Pb;
            $409124218b1e663f$var$Ob = !1;
            $409124218b1e663f$var$Pb = null;
        } else throw Error($409124218b1e663f$var$p(198));
        $409124218b1e663f$var$Qb || ($409124218b1e663f$var$Qb = !0, $409124218b1e663f$var$Rb = l);
    }
}
function $409124218b1e663f$var$Vb(a) {
    var b = a, c = a;
    if (a.alternate) for(; b.return;)b = b.return;
    else {
        a = b;
        do b = a, 0 !== (b.flags & 4098) && (c = b.return), a = b.return;
        while (a);
    }
    return 3 === b.tag ? c : null;
}
function $409124218b1e663f$var$Wb(a) {
    if (13 === a.tag) {
        var b = a.memoizedState;
        null === b && (a = a.alternate, null !== a && (b = a.memoizedState));
        if (null !== b) return b.dehydrated;
    }
    return null;
}
function $409124218b1e663f$var$Xb(a) {
    if ($409124218b1e663f$var$Vb(a) !== a) throw Error($409124218b1e663f$var$p(188));
}
function $409124218b1e663f$var$Yb(a) {
    var b = a.alternate;
    if (!b) {
        b = $409124218b1e663f$var$Vb(a);
        if (null === b) throw Error($409124218b1e663f$var$p(188));
        return b !== a ? null : a;
    }
    for(var c = a, d = b;;){
        var e = c.return;
        if (null === e) break;
        var f = e.alternate;
        if (null === f) {
            d = e.return;
            if (null !== d) {
                c = d;
                continue;
            }
            break;
        }
        if (e.child === f.child) {
            for(f = e.child; f;){
                if (f === c) return $409124218b1e663f$var$Xb(e), a;
                if (f === d) return $409124218b1e663f$var$Xb(e), b;
                f = f.sibling;
            }
            throw Error($409124218b1e663f$var$p(188));
        }
        if (c.return !== d.return) c = e, d = f;
        else {
            for(var g = !1, h = e.child; h;){
                if (h === c) {
                    g = !0;
                    c = e;
                    d = f;
                    break;
                }
                if (h === d) {
                    g = !0;
                    d = e;
                    c = f;
                    break;
                }
                h = h.sibling;
            }
            if (!g) {
                for(h = f.child; h;){
                    if (h === c) {
                        g = !0;
                        c = f;
                        d = e;
                        break;
                    }
                    if (h === d) {
                        g = !0;
                        d = f;
                        c = e;
                        break;
                    }
                    h = h.sibling;
                }
                if (!g) throw Error($409124218b1e663f$var$p(189));
            }
        }
        if (c.alternate !== d) throw Error($409124218b1e663f$var$p(190));
    }
    if (3 !== c.tag) throw Error($409124218b1e663f$var$p(188));
    return c.stateNode.current === c ? a : b;
}
function $409124218b1e663f$var$Zb(a) {
    a = $409124218b1e663f$var$Yb(a);
    return null !== a ? $409124218b1e663f$var$$b(a) : null;
}
function $409124218b1e663f$var$$b(a) {
    if (5 === a.tag || 6 === a.tag) return a;
    for(a = a.child; null !== a;){
        var b = $409124218b1e663f$var$$b(a);
        if (null !== b) return b;
        a = a.sibling;
    }
    return null;
}
var $409124218b1e663f$var$ac = $bUepA.unstable_scheduleCallback, $409124218b1e663f$var$bc = $bUepA.unstable_cancelCallback, $409124218b1e663f$var$cc = $bUepA.unstable_shouldYield, $409124218b1e663f$var$dc = $bUepA.unstable_requestPaint, $409124218b1e663f$var$B = $bUepA.unstable_now, $409124218b1e663f$var$ec = $bUepA.unstable_getCurrentPriorityLevel, $409124218b1e663f$var$fc = $bUepA.unstable_ImmediatePriority, $409124218b1e663f$var$gc = $bUepA.unstable_UserBlockingPriority, $409124218b1e663f$var$hc = $bUepA.unstable_NormalPriority, $409124218b1e663f$var$ic = $bUepA.unstable_LowPriority, $409124218b1e663f$var$jc = $bUepA.unstable_IdlePriority, $409124218b1e663f$var$kc = null, $409124218b1e663f$var$lc = null;
function $409124218b1e663f$var$mc(a) {
    if ($409124218b1e663f$var$lc && "function" === typeof $409124218b1e663f$var$lc.onCommitFiberRoot) try {
        $409124218b1e663f$var$lc.onCommitFiberRoot($409124218b1e663f$var$kc, a, void 0, 128 === (a.current.flags & 128));
    } catch (b) {}
}
var $409124218b1e663f$var$oc = Math.clz32 ? Math.clz32 : $409124218b1e663f$var$nc, $409124218b1e663f$var$pc = Math.log, $409124218b1e663f$var$qc = Math.LN2;
function $409124218b1e663f$var$nc(a) {
    a >>>= 0;
    return 0 === a ? 32 : 31 - ($409124218b1e663f$var$pc(a) / $409124218b1e663f$var$qc | 0) | 0;
}
var $409124218b1e663f$var$rc = 64, $409124218b1e663f$var$sc = 4194304;
function $409124218b1e663f$var$tc(a) {
    switch(a & -a){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return a & 4194240;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return a & 130023424;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 1073741824;
        default:
            return a;
    }
}
function $409124218b1e663f$var$uc(a, b) {
    var c = a.pendingLanes;
    if (0 === c) return 0;
    var d = 0, e = a.suspendedLanes, f = a.pingedLanes, g = c & 268435455;
    if (0 !== g) {
        var h = g & ~e;
        0 !== h ? d = $409124218b1e663f$var$tc(h) : (f &= g, 0 !== f && (d = $409124218b1e663f$var$tc(f)));
    } else g = c & ~e, 0 !== g ? d = $409124218b1e663f$var$tc(g) : 0 !== f && (d = $409124218b1e663f$var$tc(f));
    if (0 === d) return 0;
    if (0 !== b && b !== d && 0 === (b & e) && (e = d & -d, f = b & -b, e >= f || 16 === e && 0 !== (f & 4194240))) return b;
    0 !== (d & 4) && (d |= c & 16);
    b = a.entangledLanes;
    if (0 !== b) for(a = a.entanglements, b &= d; 0 < b;)c = 31 - $409124218b1e663f$var$oc(b), e = 1 << c, d |= a[c], b &= ~e;
    return d;
}
function $409124218b1e663f$var$vc(a, b) {
    switch(a){
        case 1:
        case 2:
        case 4:
            return b + 250;
        case 8:
        case 16:
        case 32:
        case 64:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return b + 5E3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
        case 67108864:
            return -1;
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $409124218b1e663f$var$wc(a, b) {
    for(var c = a.suspendedLanes, d = a.pingedLanes, e = a.expirationTimes, f = a.pendingLanes; 0 < f;){
        var g = 31 - $409124218b1e663f$var$oc(f), h = 1 << g, k = e[g];
        if (-1 === k) {
            if (0 === (h & c) || 0 !== (h & d)) e[g] = $409124218b1e663f$var$vc(h, b);
        } else k <= b && (a.expiredLanes |= h);
        f &= ~h;
    }
}
function $409124218b1e663f$var$xc(a) {
    a = a.pendingLanes & -1073741825;
    return 0 !== a ? a : a & 1073741824 ? 1073741824 : 0;
}
function $409124218b1e663f$var$yc() {
    var a = $409124218b1e663f$var$rc;
    $409124218b1e663f$var$rc <<= 1;
    0 === ($409124218b1e663f$var$rc & 4194240) && ($409124218b1e663f$var$rc = 64);
    return a;
}
function $409124218b1e663f$var$zc(a) {
    for(var b = [], c = 0; 31 > c; c++)b.push(a);
    return b;
}
function $409124218b1e663f$var$Ac(a, b, c) {
    a.pendingLanes |= b;
    536870912 !== b && (a.suspendedLanes = 0, a.pingedLanes = 0);
    a = a.eventTimes;
    b = 31 - $409124218b1e663f$var$oc(b);
    a[b] = c;
}
function $409124218b1e663f$var$Bc(a, b) {
    var c = a.pendingLanes & ~b;
    a.pendingLanes = b;
    a.suspendedLanes = 0;
    a.pingedLanes = 0;
    a.expiredLanes &= b;
    a.mutableReadLanes &= b;
    a.entangledLanes &= b;
    b = a.entanglements;
    var d = a.eventTimes;
    for(a = a.expirationTimes; 0 < c;){
        var e = 31 - $409124218b1e663f$var$oc(c), f = 1 << e;
        b[e] = 0;
        d[e] = -1;
        a[e] = -1;
        c &= ~f;
    }
}
function $409124218b1e663f$var$Cc(a, b) {
    var c = a.entangledLanes |= b;
    for(a = a.entanglements; c;){
        var d = 31 - $409124218b1e663f$var$oc(c), e = 1 << d;
        e & b | a[d] & b && (a[d] |= b);
        c &= ~e;
    }
}
var $409124218b1e663f$var$C = 0;
function $409124218b1e663f$var$Dc(a) {
    a &= -a;
    return 1 < a ? 4 < a ? 0 !== (a & 268435455) ? 16 : 536870912 : 4 : 1;
}
var $409124218b1e663f$var$Ec, $409124218b1e663f$var$Fc, $409124218b1e663f$var$Gc, $409124218b1e663f$var$Hc, $409124218b1e663f$var$Ic, $409124218b1e663f$var$Jc = !1, $409124218b1e663f$var$Kc = [], $409124218b1e663f$var$Lc = null, $409124218b1e663f$var$Mc = null, $409124218b1e663f$var$Nc = null, $409124218b1e663f$var$Oc = new Map, $409124218b1e663f$var$Pc = new Map, $409124218b1e663f$var$Qc = [], $409124218b1e663f$var$Rc = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset submit".split(" ");
function $409124218b1e663f$var$Sc(a, b) {
    switch(a){
        case "focusin":
        case "focusout":
            $409124218b1e663f$var$Lc = null;
            break;
        case "dragenter":
        case "dragleave":
            $409124218b1e663f$var$Mc = null;
            break;
        case "mouseover":
        case "mouseout":
            $409124218b1e663f$var$Nc = null;
            break;
        case "pointerover":
        case "pointerout":
            $409124218b1e663f$var$Oc.delete(b.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $409124218b1e663f$var$Pc.delete(b.pointerId);
    }
}
function $409124218b1e663f$var$Tc(a, b, c, d, e, f) {
    if (null === a || a.nativeEvent !== f) return a = {
        blockedOn: b,
        domEventName: c,
        eventSystemFlags: d,
        nativeEvent: f,
        targetContainers: [
            e
        ]
    }, null !== b && (b = $409124218b1e663f$var$Cb(b), null !== b && $409124218b1e663f$var$Fc(b)), a;
    a.eventSystemFlags |= d;
    b = a.targetContainers;
    null !== e && -1 === b.indexOf(e) && b.push(e);
    return a;
}
function $409124218b1e663f$var$Uc(a, b, c, d, e) {
    switch(b){
        case "focusin":
            return $409124218b1e663f$var$Lc = $409124218b1e663f$var$Tc($409124218b1e663f$var$Lc, a, b, c, d, e), !0;
        case "dragenter":
            return $409124218b1e663f$var$Mc = $409124218b1e663f$var$Tc($409124218b1e663f$var$Mc, a, b, c, d, e), !0;
        case "mouseover":
            return $409124218b1e663f$var$Nc = $409124218b1e663f$var$Tc($409124218b1e663f$var$Nc, a, b, c, d, e), !0;
        case "pointerover":
            var f = e.pointerId;
            $409124218b1e663f$var$Oc.set(f, $409124218b1e663f$var$Tc($409124218b1e663f$var$Oc.get(f) || null, a, b, c, d, e));
            return !0;
        case "gotpointercapture":
            return f = e.pointerId, $409124218b1e663f$var$Pc.set(f, $409124218b1e663f$var$Tc($409124218b1e663f$var$Pc.get(f) || null, a, b, c, d, e)), !0;
    }
    return !1;
}
function $409124218b1e663f$var$Vc(a) {
    var b = $409124218b1e663f$var$Wc(a.target);
    if (null !== b) {
        var c = $409124218b1e663f$var$Vb(b);
        if (null !== c) {
            if (b = c.tag, 13 === b) {
                if (b = $409124218b1e663f$var$Wb(c), null !== b) {
                    a.blockedOn = b;
                    $409124218b1e663f$var$Ic(a.priority, function() {
                        $409124218b1e663f$var$Gc(c);
                    });
                    return;
                }
            } else if (3 === b && c.stateNode.current.memoizedState.isDehydrated) {
                a.blockedOn = 3 === c.tag ? c.stateNode.containerInfo : null;
                return;
            }
        }
    }
    a.blockedOn = null;
}
function $409124218b1e663f$var$Xc(a) {
    if (null !== a.blockedOn) return !1;
    for(var b = a.targetContainers; 0 < b.length;){
        var c = $409124218b1e663f$var$Yc(a.domEventName, a.eventSystemFlags, b[0], a.nativeEvent);
        if (null === c) {
            c = a.nativeEvent;
            var d = new c.constructor(c.type, c);
            $409124218b1e663f$var$wb = d;
            c.target.dispatchEvent(d);
            $409124218b1e663f$var$wb = null;
        } else return b = $409124218b1e663f$var$Cb(c), null !== b && $409124218b1e663f$var$Fc(b), a.blockedOn = c, !1;
        b.shift();
    }
    return !0;
}
function $409124218b1e663f$var$Zc(a, b, c) {
    $409124218b1e663f$var$Xc(a) && c.delete(b);
}
function $409124218b1e663f$var$$c() {
    $409124218b1e663f$var$Jc = !1;
    null !== $409124218b1e663f$var$Lc && $409124218b1e663f$var$Xc($409124218b1e663f$var$Lc) && ($409124218b1e663f$var$Lc = null);
    null !== $409124218b1e663f$var$Mc && $409124218b1e663f$var$Xc($409124218b1e663f$var$Mc) && ($409124218b1e663f$var$Mc = null);
    null !== $409124218b1e663f$var$Nc && $409124218b1e663f$var$Xc($409124218b1e663f$var$Nc) && ($409124218b1e663f$var$Nc = null);
    $409124218b1e663f$var$Oc.forEach($409124218b1e663f$var$Zc);
    $409124218b1e663f$var$Pc.forEach($409124218b1e663f$var$Zc);
}
function $409124218b1e663f$var$ad(a, b) {
    a.blockedOn === b && (a.blockedOn = null, $409124218b1e663f$var$Jc || ($409124218b1e663f$var$Jc = !0, $bUepA.unstable_scheduleCallback($bUepA.unstable_NormalPriority, $409124218b1e663f$var$$c)));
}
function $409124218b1e663f$var$bd(a) {
    function b(b) {
        return $409124218b1e663f$var$ad(b, a);
    }
    if (0 < $409124218b1e663f$var$Kc.length) {
        $409124218b1e663f$var$ad($409124218b1e663f$var$Kc[0], a);
        for(var c = 1; c < $409124218b1e663f$var$Kc.length; c++){
            var d = $409124218b1e663f$var$Kc[c];
            d.blockedOn === a && (d.blockedOn = null);
        }
    }
    null !== $409124218b1e663f$var$Lc && $409124218b1e663f$var$ad($409124218b1e663f$var$Lc, a);
    null !== $409124218b1e663f$var$Mc && $409124218b1e663f$var$ad($409124218b1e663f$var$Mc, a);
    null !== $409124218b1e663f$var$Nc && $409124218b1e663f$var$ad($409124218b1e663f$var$Nc, a);
    $409124218b1e663f$var$Oc.forEach(b);
    $409124218b1e663f$var$Pc.forEach(b);
    for(c = 0; c < $409124218b1e663f$var$Qc.length; c++)d = $409124218b1e663f$var$Qc[c], d.blockedOn === a && (d.blockedOn = null);
    for(; 0 < $409124218b1e663f$var$Qc.length && (c = $409124218b1e663f$var$Qc[0], null === c.blockedOn);)$409124218b1e663f$var$Vc(c), null === c.blockedOn && $409124218b1e663f$var$Qc.shift();
}
var $409124218b1e663f$var$cd = $409124218b1e663f$var$ua.ReactCurrentBatchConfig, $409124218b1e663f$var$dd = !0;
function $409124218b1e663f$var$ed(a, b, c, d) {
    var e = $409124218b1e663f$var$C, f = $409124218b1e663f$var$cd.transition;
    $409124218b1e663f$var$cd.transition = null;
    try {
        $409124218b1e663f$var$C = 1, $409124218b1e663f$var$fd(a, b, c, d);
    } finally{
        $409124218b1e663f$var$C = e, $409124218b1e663f$var$cd.transition = f;
    }
}
function $409124218b1e663f$var$gd(a, b, c, d) {
    var e = $409124218b1e663f$var$C, f = $409124218b1e663f$var$cd.transition;
    $409124218b1e663f$var$cd.transition = null;
    try {
        $409124218b1e663f$var$C = 4, $409124218b1e663f$var$fd(a, b, c, d);
    } finally{
        $409124218b1e663f$var$C = e, $409124218b1e663f$var$cd.transition = f;
    }
}
function $409124218b1e663f$var$fd(a, b, c, d) {
    if ($409124218b1e663f$var$dd) {
        var e = $409124218b1e663f$var$Yc(a, b, c, d);
        if (null === e) $409124218b1e663f$var$hd(a, b, d, $409124218b1e663f$var$id, c), $409124218b1e663f$var$Sc(a, d);
        else if ($409124218b1e663f$var$Uc(e, a, b, c, d)) d.stopPropagation();
        else if ($409124218b1e663f$var$Sc(a, d), b & 4 && -1 < $409124218b1e663f$var$Rc.indexOf(a)) {
            for(; null !== e;){
                var f = $409124218b1e663f$var$Cb(e);
                null !== f && $409124218b1e663f$var$Ec(f);
                f = $409124218b1e663f$var$Yc(a, b, c, d);
                null === f && $409124218b1e663f$var$hd(a, b, d, $409124218b1e663f$var$id, c);
                if (f === e) break;
                e = f;
            }
            null !== e && d.stopPropagation();
        } else $409124218b1e663f$var$hd(a, b, d, null, c);
    }
}
var $409124218b1e663f$var$id = null;
function $409124218b1e663f$var$Yc(a, b, c, d) {
    $409124218b1e663f$var$id = null;
    a = $409124218b1e663f$var$xb(d);
    a = $409124218b1e663f$var$Wc(a);
    if (null !== a) {
        if (b = $409124218b1e663f$var$Vb(a), null === b) a = null;
        else if (c = b.tag, 13 === c) {
            a = $409124218b1e663f$var$Wb(b);
            if (null !== a) return a;
            a = null;
        } else if (3 === c) {
            if (b.stateNode.current.memoizedState.isDehydrated) return 3 === b.tag ? b.stateNode.containerInfo : null;
            a = null;
        } else b !== a && (a = null);
    }
    $409124218b1e663f$var$id = a;
    return null;
}
function $409124218b1e663f$var$jd(a) {
    switch(a){
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 1;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "toggle":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 4;
        case "message":
            switch($409124218b1e663f$var$ec()){
                case $409124218b1e663f$var$fc:
                    return 1;
                case $409124218b1e663f$var$gc:
                    return 4;
                case $409124218b1e663f$var$hc:
                case $409124218b1e663f$var$ic:
                    return 16;
                case $409124218b1e663f$var$jc:
                    return 536870912;
                default:
                    return 16;
            }
        default:
            return 16;
    }
}
var $409124218b1e663f$var$kd = null, $409124218b1e663f$var$ld = null, $409124218b1e663f$var$md = null;
function $409124218b1e663f$var$nd() {
    if ($409124218b1e663f$var$md) return $409124218b1e663f$var$md;
    var a, b = $409124218b1e663f$var$ld, c = b.length, d, e = "value" in $409124218b1e663f$var$kd ? $409124218b1e663f$var$kd.value : $409124218b1e663f$var$kd.textContent, f = e.length;
    for(a = 0; a < c && b[a] === e[a]; a++);
    var g = c - a;
    for(d = 1; d <= g && b[c - d] === e[f - d]; d++);
    return $409124218b1e663f$var$md = e.slice(a, 1 < d ? 1 - d : void 0);
}
function $409124218b1e663f$var$od(a) {
    var b = a.keyCode;
    "charCode" in a ? (a = a.charCode, 0 === a && 13 === b && (a = 13)) : a = b;
    10 === a && (a = 13);
    return 32 <= a || 13 === a ? a : 0;
}
function $409124218b1e663f$var$pd() {
    return !0;
}
function $409124218b1e663f$var$qd() {
    return !1;
}
function $409124218b1e663f$var$rd(a) {
    function b(b, d, e, f, g) {
        this._reactName = b;
        this._targetInst = e;
        this.type = d;
        this.nativeEvent = f;
        this.target = g;
        this.currentTarget = null;
        for(var c in a)a.hasOwnProperty(c) && (b = a[c], this[c] = b ? b(f) : f[c]);
        this.isDefaultPrevented = (null != f.defaultPrevented ? f.defaultPrevented : !1 === f.returnValue) ? $409124218b1e663f$var$pd : $409124218b1e663f$var$qd;
        this.isPropagationStopped = $409124218b1e663f$var$qd;
        return this;
    }
    $409124218b1e663f$var$A(b.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var a = this.nativeEvent;
            a && (a.preventDefault ? a.preventDefault() : "unknown" !== typeof a.returnValue && (a.returnValue = !1), this.isDefaultPrevented = $409124218b1e663f$var$pd);
        },
        stopPropagation: function() {
            var a = this.nativeEvent;
            a && (a.stopPropagation ? a.stopPropagation() : "unknown" !== typeof a.cancelBubble && (a.cancelBubble = !0), this.isPropagationStopped = $409124218b1e663f$var$pd);
        },
        persist: function() {},
        isPersistent: $409124218b1e663f$var$pd
    });
    return b;
}
var $409124218b1e663f$var$sd = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(a) {
        return a.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $409124218b1e663f$var$td = $409124218b1e663f$var$rd($409124218b1e663f$var$sd), $409124218b1e663f$var$ud = $409124218b1e663f$var$A({}, $409124218b1e663f$var$sd, {
    view: 0,
    detail: 0
}), $409124218b1e663f$var$vd = $409124218b1e663f$var$rd($409124218b1e663f$var$ud), $409124218b1e663f$var$wd, $409124218b1e663f$var$xd, $409124218b1e663f$var$yd, $409124218b1e663f$var$Ad = $409124218b1e663f$var$A({}, $409124218b1e663f$var$ud, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $409124218b1e663f$var$zd,
    button: 0,
    buttons: 0,
    relatedTarget: function(a) {
        return void 0 === a.relatedTarget ? a.fromElement === a.srcElement ? a.toElement : a.fromElement : a.relatedTarget;
    },
    movementX: function(a) {
        if ("movementX" in a) return a.movementX;
        a !== $409124218b1e663f$var$yd && ($409124218b1e663f$var$yd && "mousemove" === a.type ? ($409124218b1e663f$var$wd = a.screenX - $409124218b1e663f$var$yd.screenX, $409124218b1e663f$var$xd = a.screenY - $409124218b1e663f$var$yd.screenY) : $409124218b1e663f$var$xd = $409124218b1e663f$var$wd = 0, $409124218b1e663f$var$yd = a);
        return $409124218b1e663f$var$wd;
    },
    movementY: function(a) {
        return "movementY" in a ? a.movementY : $409124218b1e663f$var$xd;
    }
}), $409124218b1e663f$var$Bd = $409124218b1e663f$var$rd($409124218b1e663f$var$Ad), $409124218b1e663f$var$Cd = $409124218b1e663f$var$A({}, $409124218b1e663f$var$Ad, {
    dataTransfer: 0
}), $409124218b1e663f$var$Dd = $409124218b1e663f$var$rd($409124218b1e663f$var$Cd), $409124218b1e663f$var$Ed = $409124218b1e663f$var$A({}, $409124218b1e663f$var$ud, {
    relatedTarget: 0
}), $409124218b1e663f$var$Fd = $409124218b1e663f$var$rd($409124218b1e663f$var$Ed), $409124218b1e663f$var$Gd = $409124218b1e663f$var$A({}, $409124218b1e663f$var$sd, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $409124218b1e663f$var$Hd = $409124218b1e663f$var$rd($409124218b1e663f$var$Gd), $409124218b1e663f$var$Id = $409124218b1e663f$var$A({}, $409124218b1e663f$var$sd, {
    clipboardData: function(a) {
        return "clipboardData" in a ? a.clipboardData : window.clipboardData;
    }
}), $409124218b1e663f$var$Jd = $409124218b1e663f$var$rd($409124218b1e663f$var$Id), $409124218b1e663f$var$Kd = $409124218b1e663f$var$A({}, $409124218b1e663f$var$sd, {
    data: 0
}), $409124218b1e663f$var$Ld = $409124218b1e663f$var$rd($409124218b1e663f$var$Kd), $409124218b1e663f$var$Md = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $409124218b1e663f$var$Nd = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $409124218b1e663f$var$Od = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $409124218b1e663f$var$Pd(a) {
    var b = this.nativeEvent;
    return b.getModifierState ? b.getModifierState(a) : (a = $409124218b1e663f$var$Od[a]) ? !!b[a] : !1;
}
function $409124218b1e663f$var$zd() {
    return $409124218b1e663f$var$Pd;
}
var $409124218b1e663f$var$Qd = $409124218b1e663f$var$A({}, $409124218b1e663f$var$ud, {
    key: function(a) {
        if (a.key) {
            var b = $409124218b1e663f$var$Md[a.key] || a.key;
            if ("Unidentified" !== b) return b;
        }
        return "keypress" === a.type ? (a = $409124218b1e663f$var$od(a), 13 === a ? "Enter" : String.fromCharCode(a)) : "keydown" === a.type || "keyup" === a.type ? $409124218b1e663f$var$Nd[a.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $409124218b1e663f$var$zd,
    charCode: function(a) {
        return "keypress" === a.type ? $409124218b1e663f$var$od(a) : 0;
    },
    keyCode: function(a) {
        return "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    },
    which: function(a) {
        return "keypress" === a.type ? $409124218b1e663f$var$od(a) : "keydown" === a.type || "keyup" === a.type ? a.keyCode : 0;
    }
}), $409124218b1e663f$var$Rd = $409124218b1e663f$var$rd($409124218b1e663f$var$Qd), $409124218b1e663f$var$Sd = $409124218b1e663f$var$A({}, $409124218b1e663f$var$Ad, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $409124218b1e663f$var$Td = $409124218b1e663f$var$rd($409124218b1e663f$var$Sd), $409124218b1e663f$var$Ud = $409124218b1e663f$var$A({}, $409124218b1e663f$var$ud, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $409124218b1e663f$var$zd
}), $409124218b1e663f$var$Vd = $409124218b1e663f$var$rd($409124218b1e663f$var$Ud), $409124218b1e663f$var$Wd = $409124218b1e663f$var$A({}, $409124218b1e663f$var$sd, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $409124218b1e663f$var$Xd = $409124218b1e663f$var$rd($409124218b1e663f$var$Wd), $409124218b1e663f$var$Yd = $409124218b1e663f$var$A({}, $409124218b1e663f$var$Ad, {
    deltaX: function(a) {
        return "deltaX" in a ? a.deltaX : "wheelDeltaX" in a ? -a.wheelDeltaX : 0;
    },
    deltaY: function(a) {
        return "deltaY" in a ? a.deltaY : "wheelDeltaY" in a ? -a.wheelDeltaY : "wheelDelta" in a ? -a.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $409124218b1e663f$var$Zd = $409124218b1e663f$var$rd($409124218b1e663f$var$Yd), $409124218b1e663f$var$$d = [
    9,
    13,
    27,
    32
], $409124218b1e663f$var$ae = $409124218b1e663f$var$ia && "CompositionEvent" in window, $409124218b1e663f$var$be = null;
$409124218b1e663f$var$ia && "documentMode" in document && ($409124218b1e663f$var$be = document.documentMode);
var $409124218b1e663f$var$ce = $409124218b1e663f$var$ia && "TextEvent" in window && !$409124218b1e663f$var$be, $409124218b1e663f$var$de = $409124218b1e663f$var$ia && (!$409124218b1e663f$var$ae || $409124218b1e663f$var$be && 8 < $409124218b1e663f$var$be && 11 >= $409124218b1e663f$var$be), $409124218b1e663f$var$ee = String.fromCharCode(32), $409124218b1e663f$var$fe = !1;
function $409124218b1e663f$var$ge(a, b) {
    switch(a){
        case "keyup":
            return -1 !== $409124218b1e663f$var$$d.indexOf(b.keyCode);
        case "keydown":
            return 229 !== b.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $409124218b1e663f$var$he(a) {
    a = a.detail;
    return "object" === typeof a && "data" in a ? a.data : null;
}
var $409124218b1e663f$var$ie = !1;
function $409124218b1e663f$var$je(a, b) {
    switch(a){
        case "compositionend":
            return $409124218b1e663f$var$he(b);
        case "keypress":
            if (32 !== b.which) return null;
            $409124218b1e663f$var$fe = !0;
            return $409124218b1e663f$var$ee;
        case "textInput":
            return a = b.data, a === $409124218b1e663f$var$ee && $409124218b1e663f$var$fe ? null : a;
        default:
            return null;
    }
}
function $409124218b1e663f$var$ke(a, b) {
    if ($409124218b1e663f$var$ie) return "compositionend" === a || !$409124218b1e663f$var$ae && $409124218b1e663f$var$ge(a, b) ? (a = $409124218b1e663f$var$nd(), $409124218b1e663f$var$md = $409124218b1e663f$var$ld = $409124218b1e663f$var$kd = null, $409124218b1e663f$var$ie = !1, a) : null;
    switch(a){
        case "paste":
            return null;
        case "keypress":
            if (!(b.ctrlKey || b.altKey || b.metaKey) || b.ctrlKey && b.altKey) {
                if (b.char && 1 < b.char.length) return b.char;
                if (b.which) return String.fromCharCode(b.which);
            }
            return null;
        case "compositionend":
            return $409124218b1e663f$var$de && "ko" !== b.locale ? null : b.data;
        default:
            return null;
    }
}
var $409124218b1e663f$var$le = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $409124218b1e663f$var$me(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return "input" === b ? !!$409124218b1e663f$var$le[a.type] : "textarea" === b ? !0 : !1;
}
function $409124218b1e663f$var$ne(a, b, c, d) {
    $409124218b1e663f$var$Eb(d);
    b = $409124218b1e663f$var$oe(b, "onChange");
    0 < b.length && (c = new $409124218b1e663f$var$td("onChange", "change", null, c, d), a.push({
        event: c,
        listeners: b
    }));
}
var $409124218b1e663f$var$pe = null, $409124218b1e663f$var$qe = null;
function $409124218b1e663f$var$re(a) {
    $409124218b1e663f$var$se(a, 0);
}
function $409124218b1e663f$var$te(a) {
    var b = $409124218b1e663f$var$ue(a);
    if ($409124218b1e663f$var$Wa(b)) return a;
}
function $409124218b1e663f$var$ve(a, b) {
    if ("change" === a) return b;
}
var $409124218b1e663f$var$we = !1;
if ($409124218b1e663f$var$ia) {
    var $409124218b1e663f$var$xe;
    if ($409124218b1e663f$var$ia) {
        var $409124218b1e663f$var$ye = "oninput" in document;
        if (!$409124218b1e663f$var$ye) {
            var $409124218b1e663f$var$ze = document.createElement("div");
            $409124218b1e663f$var$ze.setAttribute("oninput", "return;");
            $409124218b1e663f$var$ye = "function" === typeof $409124218b1e663f$var$ze.oninput;
        }
        $409124218b1e663f$var$xe = $409124218b1e663f$var$ye;
    } else $409124218b1e663f$var$xe = !1;
    $409124218b1e663f$var$we = $409124218b1e663f$var$xe && (!document.documentMode || 9 < document.documentMode);
}
function $409124218b1e663f$var$Ae() {
    $409124218b1e663f$var$pe && ($409124218b1e663f$var$pe.detachEvent("onpropertychange", $409124218b1e663f$var$Be), $409124218b1e663f$var$qe = $409124218b1e663f$var$pe = null);
}
function $409124218b1e663f$var$Be(a) {
    if ("value" === a.propertyName && $409124218b1e663f$var$te($409124218b1e663f$var$qe)) {
        var b = [];
        $409124218b1e663f$var$ne(b, $409124218b1e663f$var$qe, a, $409124218b1e663f$var$xb(a));
        $409124218b1e663f$var$Jb($409124218b1e663f$var$re, b);
    }
}
function $409124218b1e663f$var$Ce(a, b, c) {
    "focusin" === a ? ($409124218b1e663f$var$Ae(), $409124218b1e663f$var$pe = b, $409124218b1e663f$var$qe = c, $409124218b1e663f$var$pe.attachEvent("onpropertychange", $409124218b1e663f$var$Be)) : "focusout" === a && $409124218b1e663f$var$Ae();
}
function $409124218b1e663f$var$De(a) {
    if ("selectionchange" === a || "keyup" === a || "keydown" === a) return $409124218b1e663f$var$te($409124218b1e663f$var$qe);
}
function $409124218b1e663f$var$Ee(a, b) {
    if ("click" === a) return $409124218b1e663f$var$te(b);
}
function $409124218b1e663f$var$Fe(a, b) {
    if ("input" === a || "change" === a) return $409124218b1e663f$var$te(b);
}
function $409124218b1e663f$var$Ge(a, b) {
    return a === b && (0 !== a || 1 / a === 1 / b) || a !== a && b !== b;
}
var $409124218b1e663f$var$He = "function" === typeof Object.is ? Object.is : $409124218b1e663f$var$Ge;
function $409124218b1e663f$var$Ie(a, b) {
    if ($409124218b1e663f$var$He(a, b)) return !0;
    if ("object" !== typeof a || null === a || "object" !== typeof b || null === b) return !1;
    var c = Object.keys(a), d = Object.keys(b);
    if (c.length !== d.length) return !1;
    for(d = 0; d < c.length; d++){
        var e = c[d];
        if (!$409124218b1e663f$var$ja.call(b, e) || !$409124218b1e663f$var$He(a[e], b[e])) return !1;
    }
    return !0;
}
function $409124218b1e663f$var$Je(a) {
    for(; a && a.firstChild;)a = a.firstChild;
    return a;
}
function $409124218b1e663f$var$Ke(a, b) {
    var c = $409124218b1e663f$var$Je(a);
    a = 0;
    for(var d; c;){
        if (3 === c.nodeType) {
            d = a + c.textContent.length;
            if (a <= b && d >= b) return {
                node: c,
                offset: b - a
            };
            a = d;
        }
        a: {
            for(; c;){
                if (c.nextSibling) {
                    c = c.nextSibling;
                    break a;
                }
                c = c.parentNode;
            }
            c = void 0;
        }
        c = $409124218b1e663f$var$Je(c);
    }
}
function $409124218b1e663f$var$Le(a, b) {
    return a && b ? a === b ? !0 : a && 3 === a.nodeType ? !1 : b && 3 === b.nodeType ? $409124218b1e663f$var$Le(a, b.parentNode) : "contains" in a ? a.contains(b) : a.compareDocumentPosition ? !!(a.compareDocumentPosition(b) & 16) : !1 : !1;
}
function $409124218b1e663f$var$Me() {
    for(var a = window, b = $409124218b1e663f$var$Xa(); b instanceof a.HTMLIFrameElement;){
        try {
            var c = "string" === typeof b.contentWindow.location.href;
        } catch (d) {
            c = !1;
        }
        if (c) a = b.contentWindow;
        else break;
        b = $409124218b1e663f$var$Xa(a.document);
    }
    return b;
}
function $409124218b1e663f$var$Ne(a) {
    var b = a && a.nodeName && a.nodeName.toLowerCase();
    return b && ("input" === b && ("text" === a.type || "search" === a.type || "tel" === a.type || "url" === a.type || "password" === a.type) || "textarea" === b || "true" === a.contentEditable);
}
function $409124218b1e663f$var$Oe(a) {
    var b = $409124218b1e663f$var$Me(), c = a.focusedElem, d = a.selectionRange;
    if (b !== c && c && c.ownerDocument && $409124218b1e663f$var$Le(c.ownerDocument.documentElement, c)) {
        if (null !== d && $409124218b1e663f$var$Ne(c)) {
            if (b = d.start, a = d.end, void 0 === a && (a = b), "selectionStart" in c) c.selectionStart = b, c.selectionEnd = Math.min(a, c.value.length);
            else if (a = (b = c.ownerDocument || document) && b.defaultView || window, a.getSelection) {
                a = a.getSelection();
                var e = c.textContent.length, f = Math.min(d.start, e);
                d = void 0 === d.end ? f : Math.min(d.end, e);
                !a.extend && f > d && (e = d, d = f, f = e);
                e = $409124218b1e663f$var$Ke(c, f);
                var g = $409124218b1e663f$var$Ke(c, d);
                e && g && (1 !== a.rangeCount || a.anchorNode !== e.node || a.anchorOffset !== e.offset || a.focusNode !== g.node || a.focusOffset !== g.offset) && (b = b.createRange(), b.setStart(e.node, e.offset), a.removeAllRanges(), f > d ? (a.addRange(b), a.extend(g.node, g.offset)) : (b.setEnd(g.node, g.offset), a.addRange(b)));
            }
        }
        b = [];
        for(a = c; a = a.parentNode;)1 === a.nodeType && b.push({
            element: a,
            left: a.scrollLeft,
            top: a.scrollTop
        });
        "function" === typeof c.focus && c.focus();
        for(c = 0; c < b.length; c++)a = b[c], a.element.scrollLeft = a.left, a.element.scrollTop = a.top;
    }
}
var $409124218b1e663f$var$Pe = $409124218b1e663f$var$ia && "documentMode" in document && 11 >= document.documentMode, $409124218b1e663f$var$Qe = null, $409124218b1e663f$var$Re = null, $409124218b1e663f$var$Se = null, $409124218b1e663f$var$Te = !1;
function $409124218b1e663f$var$Ue(a, b, c) {
    var d = c.window === c ? c.document : 9 === c.nodeType ? c : c.ownerDocument;
    $409124218b1e663f$var$Te || null == $409124218b1e663f$var$Qe || $409124218b1e663f$var$Qe !== $409124218b1e663f$var$Xa(d) || (d = $409124218b1e663f$var$Qe, "selectionStart" in d && $409124218b1e663f$var$Ne(d) ? d = {
        start: d.selectionStart,
        end: d.selectionEnd
    } : (d = (d.ownerDocument && d.ownerDocument.defaultView || window).getSelection(), d = {
        anchorNode: d.anchorNode,
        anchorOffset: d.anchorOffset,
        focusNode: d.focusNode,
        focusOffset: d.focusOffset
    }), $409124218b1e663f$var$Se && $409124218b1e663f$var$Ie($409124218b1e663f$var$Se, d) || ($409124218b1e663f$var$Se = d, d = $409124218b1e663f$var$oe($409124218b1e663f$var$Re, "onSelect"), 0 < d.length && (b = new $409124218b1e663f$var$td("onSelect", "select", null, b, c), a.push({
        event: b,
        listeners: d
    }), b.target = $409124218b1e663f$var$Qe)));
}
function $409124218b1e663f$var$Ve(a, b) {
    var c = {};
    c[a.toLowerCase()] = b.toLowerCase();
    c["Webkit" + a] = "webkit" + b;
    c["Moz" + a] = "moz" + b;
    return c;
}
var $409124218b1e663f$var$We = {
    animationend: $409124218b1e663f$var$Ve("Animation", "AnimationEnd"),
    animationiteration: $409124218b1e663f$var$Ve("Animation", "AnimationIteration"),
    animationstart: $409124218b1e663f$var$Ve("Animation", "AnimationStart"),
    transitionend: $409124218b1e663f$var$Ve("Transition", "TransitionEnd")
}, $409124218b1e663f$var$Xe = {}, $409124218b1e663f$var$Ye = {};
$409124218b1e663f$var$ia && ($409124218b1e663f$var$Ye = document.createElement("div").style, "AnimationEvent" in window || (delete $409124218b1e663f$var$We.animationend.animation, delete $409124218b1e663f$var$We.animationiteration.animation, delete $409124218b1e663f$var$We.animationstart.animation), "TransitionEvent" in window || delete $409124218b1e663f$var$We.transitionend.transition);
function $409124218b1e663f$var$Ze(a) {
    if ($409124218b1e663f$var$Xe[a]) return $409124218b1e663f$var$Xe[a];
    if (!$409124218b1e663f$var$We[a]) return a;
    var b = $409124218b1e663f$var$We[a], c;
    for(c in b)if (b.hasOwnProperty(c) && c in $409124218b1e663f$var$Ye) return $409124218b1e663f$var$Xe[a] = b[c];
    return a;
}
var $409124218b1e663f$var$$e = $409124218b1e663f$var$Ze("animationend"), $409124218b1e663f$var$af = $409124218b1e663f$var$Ze("animationiteration"), $409124218b1e663f$var$bf = $409124218b1e663f$var$Ze("animationstart"), $409124218b1e663f$var$cf = $409124218b1e663f$var$Ze("transitionend"), $409124218b1e663f$var$df = new Map, $409124218b1e663f$var$ef = "abort auxClick cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
function $409124218b1e663f$var$ff(a, b) {
    $409124218b1e663f$var$df.set(a, b);
    $409124218b1e663f$var$fa(b, [
        a
    ]);
}
for(var $409124218b1e663f$var$gf = 0; $409124218b1e663f$var$gf < $409124218b1e663f$var$ef.length; $409124218b1e663f$var$gf++){
    var $409124218b1e663f$var$hf = $409124218b1e663f$var$ef[$409124218b1e663f$var$gf], $409124218b1e663f$var$jf = $409124218b1e663f$var$hf.toLowerCase(), $409124218b1e663f$var$kf = $409124218b1e663f$var$hf[0].toUpperCase() + $409124218b1e663f$var$hf.slice(1);
    $409124218b1e663f$var$ff($409124218b1e663f$var$jf, "on" + $409124218b1e663f$var$kf);
}
$409124218b1e663f$var$ff($409124218b1e663f$var$$e, "onAnimationEnd");
$409124218b1e663f$var$ff($409124218b1e663f$var$af, "onAnimationIteration");
$409124218b1e663f$var$ff($409124218b1e663f$var$bf, "onAnimationStart");
$409124218b1e663f$var$ff("dblclick", "onDoubleClick");
$409124218b1e663f$var$ff("focusin", "onFocus");
$409124218b1e663f$var$ff("focusout", "onBlur");
$409124218b1e663f$var$ff($409124218b1e663f$var$cf, "onTransitionEnd");
$409124218b1e663f$var$ha("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$409124218b1e663f$var$ha("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$409124218b1e663f$var$ha("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$409124218b1e663f$var$ha("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$409124218b1e663f$var$fa("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$409124218b1e663f$var$fa("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$409124218b1e663f$var$fa("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$409124218b1e663f$var$fa("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$409124218b1e663f$var$fa("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$409124218b1e663f$var$fa("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $409124218b1e663f$var$lf = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $409124218b1e663f$var$mf = new Set("cancel close invalid load scroll toggle".split(" ").concat($409124218b1e663f$var$lf));
function $409124218b1e663f$var$nf(a, b, c) {
    var d = a.type || "unknown-event";
    a.currentTarget = c;
    $409124218b1e663f$var$Ub(d, b, void 0, a);
    a.currentTarget = null;
}
function $409124218b1e663f$var$se(a, b) {
    b = 0 !== (b & 4);
    for(var c = 0; c < a.length; c++){
        var d = a[c], e = d.event;
        d = d.listeners;
        a: {
            var f = void 0;
            if (b) for(var g = d.length - 1; 0 <= g; g--){
                var h = d[g], k = h.instance, l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $409124218b1e663f$var$nf(e, h, l);
                f = k;
            }
            else for(g = 0; g < d.length; g++){
                h = d[g];
                k = h.instance;
                l = h.currentTarget;
                h = h.listener;
                if (k !== f && e.isPropagationStopped()) break a;
                $409124218b1e663f$var$nf(e, h, l);
                f = k;
            }
        }
    }
    if ($409124218b1e663f$var$Qb) throw a = $409124218b1e663f$var$Rb, $409124218b1e663f$var$Qb = !1, $409124218b1e663f$var$Rb = null, a;
}
function $409124218b1e663f$var$D(a, b) {
    var c = b[$409124218b1e663f$var$of];
    void 0 === c && (c = b[$409124218b1e663f$var$of] = new Set);
    var d = a + "__bubble";
    c.has(d) || ($409124218b1e663f$var$pf(b, a, 2, !1), c.add(d));
}
function $409124218b1e663f$var$qf(a, b, c) {
    var d = 0;
    b && (d |= 4);
    $409124218b1e663f$var$pf(c, a, d, b);
}
var $409124218b1e663f$var$rf = "_reactListening" + Math.random().toString(36).slice(2);
function $409124218b1e663f$var$sf(a) {
    if (!a[$409124218b1e663f$var$rf]) {
        a[$409124218b1e663f$var$rf] = !0;
        $409124218b1e663f$var$da.forEach(function(b) {
            "selectionchange" !== b && ($409124218b1e663f$var$mf.has(b) || $409124218b1e663f$var$qf(b, !1, a), $409124218b1e663f$var$qf(b, !0, a));
        });
        var b = 9 === a.nodeType ? a : a.ownerDocument;
        null === b || b[$409124218b1e663f$var$rf] || (b[$409124218b1e663f$var$rf] = !0, $409124218b1e663f$var$qf("selectionchange", !1, b));
    }
}
function $409124218b1e663f$var$pf(a, b, c, d) {
    switch($409124218b1e663f$var$jd(b)){
        case 1:
            var e = $409124218b1e663f$var$ed;
            break;
        case 4:
            e = $409124218b1e663f$var$gd;
            break;
        default:
            e = $409124218b1e663f$var$fd;
    }
    c = e.bind(null, b, c, a);
    e = void 0;
    !$409124218b1e663f$var$Lb || "touchstart" !== b && "touchmove" !== b && "wheel" !== b || (e = !0);
    d ? void 0 !== e ? a.addEventListener(b, c, {
        capture: !0,
        passive: e
    }) : a.addEventListener(b, c, !0) : void 0 !== e ? a.addEventListener(b, c, {
        passive: e
    }) : a.addEventListener(b, c, !1);
}
function $409124218b1e663f$var$hd(a, b, c, d, e) {
    var f = d;
    if (0 === (b & 1) && 0 === (b & 2) && null !== d) a: for(;;){
        if (null === d) return;
        var g = d.tag;
        if (3 === g || 4 === g) {
            var h = d.stateNode.containerInfo;
            if (h === e || 8 === h.nodeType && h.parentNode === e) break;
            if (4 === g) for(g = d.return; null !== g;){
                var k = g.tag;
                if (3 === k || 4 === k) {
                    if (k = g.stateNode.containerInfo, k === e || 8 === k.nodeType && k.parentNode === e) return;
                }
                g = g.return;
            }
            for(; null !== h;){
                g = $409124218b1e663f$var$Wc(h);
                if (null === g) return;
                k = g.tag;
                if (5 === k || 6 === k) {
                    d = f = g;
                    continue a;
                }
                h = h.parentNode;
            }
        }
        d = d.return;
    }
    $409124218b1e663f$var$Jb(function() {
        var d = f, e = $409124218b1e663f$var$xb(c), g = [];
        a: {
            var h = $409124218b1e663f$var$df.get(a);
            if (void 0 !== h) {
                var k = $409124218b1e663f$var$td, n = a;
                switch(a){
                    case "keypress":
                        if (0 === $409124218b1e663f$var$od(c)) break a;
                    case "keydown":
                    case "keyup":
                        k = $409124218b1e663f$var$Rd;
                        break;
                    case "focusin":
                        n = "focus";
                        k = $409124218b1e663f$var$Fd;
                        break;
                    case "focusout":
                        n = "blur";
                        k = $409124218b1e663f$var$Fd;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        k = $409124218b1e663f$var$Fd;
                        break;
                    case "click":
                        if (2 === c.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        k = $409124218b1e663f$var$Bd;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        k = $409124218b1e663f$var$Dd;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        k = $409124218b1e663f$var$Vd;
                        break;
                    case $409124218b1e663f$var$$e:
                    case $409124218b1e663f$var$af:
                    case $409124218b1e663f$var$bf:
                        k = $409124218b1e663f$var$Hd;
                        break;
                    case $409124218b1e663f$var$cf:
                        k = $409124218b1e663f$var$Xd;
                        break;
                    case "scroll":
                        k = $409124218b1e663f$var$vd;
                        break;
                    case "wheel":
                        k = $409124218b1e663f$var$Zd;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        k = $409124218b1e663f$var$Jd;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        k = $409124218b1e663f$var$Td;
                }
                var t = 0 !== (b & 4), J = !t && "scroll" === a, x = t ? null !== h ? h + "Capture" : null : h;
                t = [];
                for(var w = d, u; null !== w;){
                    u = w;
                    var F = u.stateNode;
                    5 === u.tag && null !== F && (u = F, null !== x && (F = $409124218b1e663f$var$Kb(w, x), null != F && t.push($409124218b1e663f$var$tf(w, F, u))));
                    if (J) break;
                    w = w.return;
                }
                0 < t.length && (h = new k(h, n, null, c, e), g.push({
                    event: h,
                    listeners: t
                }));
            }
        }
        if (0 === (b & 7)) {
            a: {
                h = "mouseover" === a || "pointerover" === a;
                k = "mouseout" === a || "pointerout" === a;
                if (h && c !== $409124218b1e663f$var$wb && (n = c.relatedTarget || c.fromElement) && ($409124218b1e663f$var$Wc(n) || n[$409124218b1e663f$var$uf])) break a;
                if (k || h) {
                    h = e.window === e ? e : (h = e.ownerDocument) ? h.defaultView || h.parentWindow : window;
                    if (k) {
                        if (n = c.relatedTarget || c.toElement, k = d, n = n ? $409124218b1e663f$var$Wc(n) : null, null !== n && (J = $409124218b1e663f$var$Vb(n), n !== J || 5 !== n.tag && 6 !== n.tag)) n = null;
                    } else k = null, n = d;
                    if (k !== n) {
                        t = $409124218b1e663f$var$Bd;
                        F = "onMouseLeave";
                        x = "onMouseEnter";
                        w = "mouse";
                        if ("pointerout" === a || "pointerover" === a) t = $409124218b1e663f$var$Td, F = "onPointerLeave", x = "onPointerEnter", w = "pointer";
                        J = null == k ? h : $409124218b1e663f$var$ue(k);
                        u = null == n ? h : $409124218b1e663f$var$ue(n);
                        h = new t(F, w + "leave", k, c, e);
                        h.target = J;
                        h.relatedTarget = u;
                        F = null;
                        $409124218b1e663f$var$Wc(e) === d && (t = new t(x, w + "enter", n, c, e), t.target = u, t.relatedTarget = J, F = t);
                        J = F;
                        if (k && n) b: {
                            t = k;
                            x = n;
                            w = 0;
                            for(u = t; u; u = $409124218b1e663f$var$vf(u))w++;
                            u = 0;
                            for(F = x; F; F = $409124218b1e663f$var$vf(F))u++;
                            for(; 0 < w - u;)t = $409124218b1e663f$var$vf(t), w--;
                            for(; 0 < u - w;)x = $409124218b1e663f$var$vf(x), u--;
                            for(; w--;){
                                if (t === x || null !== x && t === x.alternate) break b;
                                t = $409124218b1e663f$var$vf(t);
                                x = $409124218b1e663f$var$vf(x);
                            }
                            t = null;
                        }
                        else t = null;
                        null !== k && $409124218b1e663f$var$wf(g, h, k, t, !1);
                        null !== n && null !== J && $409124218b1e663f$var$wf(g, J, n, t, !0);
                    }
                }
            }
            a: {
                h = d ? $409124218b1e663f$var$ue(d) : window;
                k = h.nodeName && h.nodeName.toLowerCase();
                if ("select" === k || "input" === k && "file" === h.type) var na = $409124218b1e663f$var$ve;
                else if ($409124218b1e663f$var$me(h)) {
                    if ($409124218b1e663f$var$we) na = $409124218b1e663f$var$Fe;
                    else {
                        na = $409124218b1e663f$var$De;
                        var xa = $409124218b1e663f$var$Ce;
                    }
                } else (k = h.nodeName) && "input" === k.toLowerCase() && ("checkbox" === h.type || "radio" === h.type) && (na = $409124218b1e663f$var$Ee);
                if (na && (na = na(a, d))) {
                    $409124218b1e663f$var$ne(g, na, c, e);
                    break a;
                }
                xa && xa(a, h, d);
                "focusout" === a && (xa = h._wrapperState) && xa.controlled && "number" === h.type && $409124218b1e663f$var$cb(h, "number", h.value);
            }
            xa = d ? $409124218b1e663f$var$ue(d) : window;
            switch(a){
                case "focusin":
                    if ($409124218b1e663f$var$me(xa) || "true" === xa.contentEditable) $409124218b1e663f$var$Qe = xa, $409124218b1e663f$var$Re = d, $409124218b1e663f$var$Se = null;
                    break;
                case "focusout":
                    $409124218b1e663f$var$Se = $409124218b1e663f$var$Re = $409124218b1e663f$var$Qe = null;
                    break;
                case "mousedown":
                    $409124218b1e663f$var$Te = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $409124218b1e663f$var$Te = !1;
                    $409124218b1e663f$var$Ue(g, c, e);
                    break;
                case "selectionchange":
                    if ($409124218b1e663f$var$Pe) break;
                case "keydown":
                case "keyup":
                    $409124218b1e663f$var$Ue(g, c, e);
            }
            var $a;
            if ($409124218b1e663f$var$ae) b: {
                switch(a){
                    case "compositionstart":
                        var ba = "onCompositionStart";
                        break b;
                    case "compositionend":
                        ba = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        ba = "onCompositionUpdate";
                        break b;
                }
                ba = void 0;
            }
            else $409124218b1e663f$var$ie ? $409124218b1e663f$var$ge(a, c) && (ba = "onCompositionEnd") : "keydown" === a && 229 === c.keyCode && (ba = "onCompositionStart");
            ba && ($409124218b1e663f$var$de && "ko" !== c.locale && ($409124218b1e663f$var$ie || "onCompositionStart" !== ba ? "onCompositionEnd" === ba && $409124218b1e663f$var$ie && ($a = $409124218b1e663f$var$nd()) : ($409124218b1e663f$var$kd = e, $409124218b1e663f$var$ld = "value" in $409124218b1e663f$var$kd ? $409124218b1e663f$var$kd.value : $409124218b1e663f$var$kd.textContent, $409124218b1e663f$var$ie = !0)), xa = $409124218b1e663f$var$oe(d, ba), 0 < xa.length && (ba = new $409124218b1e663f$var$Ld(ba, a, null, c, e), g.push({
                event: ba,
                listeners: xa
            }), $a ? ba.data = $a : ($a = $409124218b1e663f$var$he(c), null !== $a && (ba.data = $a))));
            if ($a = $409124218b1e663f$var$ce ? $409124218b1e663f$var$je(a, c) : $409124218b1e663f$var$ke(a, c)) d = $409124218b1e663f$var$oe(d, "onBeforeInput"), 0 < d.length && (e = new $409124218b1e663f$var$Ld("onBeforeInput", "beforeinput", null, c, e), g.push({
                event: e,
                listeners: d
            }), e.data = $a);
        }
        $409124218b1e663f$var$se(g, b);
    });
}
function $409124218b1e663f$var$tf(a, b, c) {
    return {
        instance: a,
        listener: b,
        currentTarget: c
    };
}
function $409124218b1e663f$var$oe(a, b) {
    for(var c = b + "Capture", d = []; null !== a;){
        var e = a, f = e.stateNode;
        5 === e.tag && null !== f && (e = f, f = $409124218b1e663f$var$Kb(a, c), null != f && d.unshift($409124218b1e663f$var$tf(a, f, e)), f = $409124218b1e663f$var$Kb(a, b), null != f && d.push($409124218b1e663f$var$tf(a, f, e)));
        a = a.return;
    }
    return d;
}
function $409124218b1e663f$var$vf(a) {
    if (null === a) return null;
    do a = a.return;
    while (a && 5 !== a.tag);
    return a ? a : null;
}
function $409124218b1e663f$var$wf(a, b, c, d, e) {
    for(var f = b._reactName, g = []; null !== c && c !== d;){
        var h = c, k = h.alternate, l = h.stateNode;
        if (null !== k && k === d) break;
        5 === h.tag && null !== l && (h = l, e ? (k = $409124218b1e663f$var$Kb(c, f), null != k && g.unshift($409124218b1e663f$var$tf(c, k, h))) : e || (k = $409124218b1e663f$var$Kb(c, f), null != k && g.push($409124218b1e663f$var$tf(c, k, h))));
        c = c.return;
    }
    0 !== g.length && a.push({
        event: b,
        listeners: g
    });
}
var $409124218b1e663f$var$xf = /\r\n?/g, $409124218b1e663f$var$yf = /\u0000|\uFFFD/g;
function $409124218b1e663f$var$zf(a) {
    return ("string" === typeof a ? a : "" + a).replace($409124218b1e663f$var$xf, "\n").replace($409124218b1e663f$var$yf, "");
}
function $409124218b1e663f$var$Af(a, b, c) {
    b = $409124218b1e663f$var$zf(b);
    if ($409124218b1e663f$var$zf(a) !== b && c) throw Error($409124218b1e663f$var$p(425));
}
function $409124218b1e663f$var$Bf() {}
var $409124218b1e663f$var$Cf = null, $409124218b1e663f$var$Df = null;
function $409124218b1e663f$var$Ef(a, b) {
    return "textarea" === a || "noscript" === a || "string" === typeof b.children || "number" === typeof b.children || "object" === typeof b.dangerouslySetInnerHTML && null !== b.dangerouslySetInnerHTML && null != b.dangerouslySetInnerHTML.__html;
}
var $409124218b1e663f$var$Ff = "function" === typeof setTimeout ? setTimeout : void 0, $409124218b1e663f$var$Gf = "function" === typeof clearTimeout ? clearTimeout : void 0, $409124218b1e663f$var$Hf = "function" === typeof Promise ? Promise : void 0, $409124218b1e663f$var$Jf = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $409124218b1e663f$var$Hf ? function(a) {
    return $409124218b1e663f$var$Hf.resolve(null).then(a).catch($409124218b1e663f$var$If);
} : $409124218b1e663f$var$Ff;
function $409124218b1e663f$var$If(a) {
    setTimeout(function() {
        throw a;
    });
}
function $409124218b1e663f$var$Kf(a, b) {
    var c = b, d = 0;
    do {
        var e = c.nextSibling;
        a.removeChild(c);
        if (e && 8 === e.nodeType) {
            if (c = e.data, "/$" === c) {
                if (0 === d) {
                    a.removeChild(e);
                    $409124218b1e663f$var$bd(b);
                    return;
                }
                d--;
            } else "$" !== c && "$?" !== c && "$!" !== c || d++;
        }
        c = e;
    }while (c);
    $409124218b1e663f$var$bd(b);
}
function $409124218b1e663f$var$Lf(a) {
    for(; null != a; a = a.nextSibling){
        var b = a.nodeType;
        if (1 === b || 3 === b) break;
        if (8 === b) {
            b = a.data;
            if ("$" === b || "$!" === b || "$?" === b) break;
            if ("/$" === b) return null;
        }
    }
    return a;
}
function $409124218b1e663f$var$Mf(a) {
    a = a.previousSibling;
    for(var b = 0; a;){
        if (8 === a.nodeType) {
            var c = a.data;
            if ("$" === c || "$!" === c || "$?" === c) {
                if (0 === b) return a;
                b--;
            } else "/$" === c && b++;
        }
        a = a.previousSibling;
    }
    return null;
}
var $409124218b1e663f$var$Nf = Math.random().toString(36).slice(2), $409124218b1e663f$var$Of = "__reactFiber$" + $409124218b1e663f$var$Nf, $409124218b1e663f$var$Pf = "__reactProps$" + $409124218b1e663f$var$Nf, $409124218b1e663f$var$uf = "__reactContainer$" + $409124218b1e663f$var$Nf, $409124218b1e663f$var$of = "__reactEvents$" + $409124218b1e663f$var$Nf, $409124218b1e663f$var$Qf = "__reactListeners$" + $409124218b1e663f$var$Nf, $409124218b1e663f$var$Rf = "__reactHandles$" + $409124218b1e663f$var$Nf;
function $409124218b1e663f$var$Wc(a) {
    var b = a[$409124218b1e663f$var$Of];
    if (b) return b;
    for(var c = a.parentNode; c;){
        if (b = c[$409124218b1e663f$var$uf] || c[$409124218b1e663f$var$Of]) {
            c = b.alternate;
            if (null !== b.child || null !== c && null !== c.child) for(a = $409124218b1e663f$var$Mf(a); null !== a;){
                if (c = a[$409124218b1e663f$var$Of]) return c;
                a = $409124218b1e663f$var$Mf(a);
            }
            return b;
        }
        a = c;
        c = a.parentNode;
    }
    return null;
}
function $409124218b1e663f$var$Cb(a) {
    a = a[$409124218b1e663f$var$Of] || a[$409124218b1e663f$var$uf];
    return !a || 5 !== a.tag && 6 !== a.tag && 13 !== a.tag && 3 !== a.tag ? null : a;
}
function $409124218b1e663f$var$ue(a) {
    if (5 === a.tag || 6 === a.tag) return a.stateNode;
    throw Error($409124218b1e663f$var$p(33));
}
function $409124218b1e663f$var$Db(a) {
    return a[$409124218b1e663f$var$Pf] || null;
}
var $409124218b1e663f$var$Sf = [], $409124218b1e663f$var$Tf = -1;
function $409124218b1e663f$var$Uf(a) {
    return {
        current: a
    };
}
function $409124218b1e663f$var$E(a) {
    0 > $409124218b1e663f$var$Tf || (a.current = $409124218b1e663f$var$Sf[$409124218b1e663f$var$Tf], $409124218b1e663f$var$Sf[$409124218b1e663f$var$Tf] = null, $409124218b1e663f$var$Tf--);
}
function $409124218b1e663f$var$G(a, b) {
    $409124218b1e663f$var$Tf++;
    $409124218b1e663f$var$Sf[$409124218b1e663f$var$Tf] = a.current;
    a.current = b;
}
var $409124218b1e663f$var$Vf = {}, $409124218b1e663f$var$H = $409124218b1e663f$var$Uf($409124218b1e663f$var$Vf), $409124218b1e663f$var$Wf = $409124218b1e663f$var$Uf(!1), $409124218b1e663f$var$Xf = $409124218b1e663f$var$Vf;
function $409124218b1e663f$var$Yf(a, b) {
    var c = a.type.contextTypes;
    if (!c) return $409124218b1e663f$var$Vf;
    var d = a.stateNode;
    if (d && d.__reactInternalMemoizedUnmaskedChildContext === b) return d.__reactInternalMemoizedMaskedChildContext;
    var e = {}, f;
    for(f in c)e[f] = b[f];
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = b, a.__reactInternalMemoizedMaskedChildContext = e);
    return e;
}
function $409124218b1e663f$var$Zf(a) {
    a = a.childContextTypes;
    return null !== a && void 0 !== a;
}
function $409124218b1e663f$var$$f() {
    $409124218b1e663f$var$E($409124218b1e663f$var$Wf);
    $409124218b1e663f$var$E($409124218b1e663f$var$H);
}
function $409124218b1e663f$var$ag(a, b, c) {
    if ($409124218b1e663f$var$H.current !== $409124218b1e663f$var$Vf) throw Error($409124218b1e663f$var$p(168));
    $409124218b1e663f$var$G($409124218b1e663f$var$H, b);
    $409124218b1e663f$var$G($409124218b1e663f$var$Wf, c);
}
function $409124218b1e663f$var$bg(a, b, c) {
    var d = a.stateNode;
    b = b.childContextTypes;
    if ("function" !== typeof d.getChildContext) return c;
    d = d.getChildContext();
    for(var e in d)if (!(e in b)) throw Error($409124218b1e663f$var$p(108, $409124218b1e663f$var$Ra(a) || "Unknown", e));
    return $409124218b1e663f$var$A({}, c, d);
}
function $409124218b1e663f$var$cg(a) {
    a = (a = a.stateNode) && a.__reactInternalMemoizedMergedChildContext || $409124218b1e663f$var$Vf;
    $409124218b1e663f$var$Xf = $409124218b1e663f$var$H.current;
    $409124218b1e663f$var$G($409124218b1e663f$var$H, a);
    $409124218b1e663f$var$G($409124218b1e663f$var$Wf, $409124218b1e663f$var$Wf.current);
    return !0;
}
function $409124218b1e663f$var$dg(a, b, c) {
    var d = a.stateNode;
    if (!d) throw Error($409124218b1e663f$var$p(169));
    c ? (a = $409124218b1e663f$var$bg(a, b, $409124218b1e663f$var$Xf), d.__reactInternalMemoizedMergedChildContext = a, $409124218b1e663f$var$E($409124218b1e663f$var$Wf), $409124218b1e663f$var$E($409124218b1e663f$var$H), $409124218b1e663f$var$G($409124218b1e663f$var$H, a)) : $409124218b1e663f$var$E($409124218b1e663f$var$Wf);
    $409124218b1e663f$var$G($409124218b1e663f$var$Wf, c);
}
var $409124218b1e663f$var$eg = null, $409124218b1e663f$var$fg = !1, $409124218b1e663f$var$gg = !1;
function $409124218b1e663f$var$hg(a) {
    null === $409124218b1e663f$var$eg ? $409124218b1e663f$var$eg = [
        a
    ] : $409124218b1e663f$var$eg.push(a);
}
function $409124218b1e663f$var$ig(a) {
    $409124218b1e663f$var$fg = !0;
    $409124218b1e663f$var$hg(a);
}
function $409124218b1e663f$var$jg() {
    if (!$409124218b1e663f$var$gg && null !== $409124218b1e663f$var$eg) {
        $409124218b1e663f$var$gg = !0;
        var a = 0, b = $409124218b1e663f$var$C;
        try {
            var c = $409124218b1e663f$var$eg;
            for($409124218b1e663f$var$C = 1; a < c.length; a++){
                var d = c[a];
                do d = d(!0);
                while (null !== d);
            }
            $409124218b1e663f$var$eg = null;
            $409124218b1e663f$var$fg = !1;
        } catch (e) {
            throw null !== $409124218b1e663f$var$eg && ($409124218b1e663f$var$eg = $409124218b1e663f$var$eg.slice(a + 1)), $409124218b1e663f$var$ac($409124218b1e663f$var$fc, $409124218b1e663f$var$jg), e;
        } finally{
            $409124218b1e663f$var$C = b, $409124218b1e663f$var$gg = !1;
        }
    }
    return null;
}
var $409124218b1e663f$var$kg = [], $409124218b1e663f$var$lg = 0, $409124218b1e663f$var$mg = null, $409124218b1e663f$var$ng = 0, $409124218b1e663f$var$og = [], $409124218b1e663f$var$pg = 0, $409124218b1e663f$var$qg = null, $409124218b1e663f$var$rg = 1, $409124218b1e663f$var$sg = "";
function $409124218b1e663f$var$tg(a, b) {
    $409124218b1e663f$var$kg[$409124218b1e663f$var$lg++] = $409124218b1e663f$var$ng;
    $409124218b1e663f$var$kg[$409124218b1e663f$var$lg++] = $409124218b1e663f$var$mg;
    $409124218b1e663f$var$mg = a;
    $409124218b1e663f$var$ng = b;
}
function $409124218b1e663f$var$ug(a, b, c) {
    $409124218b1e663f$var$og[$409124218b1e663f$var$pg++] = $409124218b1e663f$var$rg;
    $409124218b1e663f$var$og[$409124218b1e663f$var$pg++] = $409124218b1e663f$var$sg;
    $409124218b1e663f$var$og[$409124218b1e663f$var$pg++] = $409124218b1e663f$var$qg;
    $409124218b1e663f$var$qg = a;
    var d = $409124218b1e663f$var$rg;
    a = $409124218b1e663f$var$sg;
    var e = 32 - $409124218b1e663f$var$oc(d) - 1;
    d &= ~(1 << e);
    c += 1;
    var f = 32 - $409124218b1e663f$var$oc(b) + e;
    if (30 < f) {
        var g = e - e % 5;
        f = (d & (1 << g) - 1).toString(32);
        d >>= g;
        e -= g;
        $409124218b1e663f$var$rg = 1 << 32 - $409124218b1e663f$var$oc(b) + e | c << e | d;
        $409124218b1e663f$var$sg = f + a;
    } else $409124218b1e663f$var$rg = 1 << f | c << e | d, $409124218b1e663f$var$sg = a;
}
function $409124218b1e663f$var$vg(a) {
    null !== a.return && ($409124218b1e663f$var$tg(a, 1), $409124218b1e663f$var$ug(a, 1, 0));
}
function $409124218b1e663f$var$wg(a) {
    for(; a === $409124218b1e663f$var$mg;)$409124218b1e663f$var$mg = $409124218b1e663f$var$kg[--$409124218b1e663f$var$lg], $409124218b1e663f$var$kg[$409124218b1e663f$var$lg] = null, $409124218b1e663f$var$ng = $409124218b1e663f$var$kg[--$409124218b1e663f$var$lg], $409124218b1e663f$var$kg[$409124218b1e663f$var$lg] = null;
    for(; a === $409124218b1e663f$var$qg;)$409124218b1e663f$var$qg = $409124218b1e663f$var$og[--$409124218b1e663f$var$pg], $409124218b1e663f$var$og[$409124218b1e663f$var$pg] = null, $409124218b1e663f$var$sg = $409124218b1e663f$var$og[--$409124218b1e663f$var$pg], $409124218b1e663f$var$og[$409124218b1e663f$var$pg] = null, $409124218b1e663f$var$rg = $409124218b1e663f$var$og[--$409124218b1e663f$var$pg], $409124218b1e663f$var$og[$409124218b1e663f$var$pg] = null;
}
var $409124218b1e663f$var$xg = null, $409124218b1e663f$var$yg = null, $409124218b1e663f$var$I = !1, $409124218b1e663f$var$zg = null;
function $409124218b1e663f$var$Ag(a, b) {
    var c = $409124218b1e663f$var$Bg(5, null, null, 0);
    c.elementType = "DELETED";
    c.stateNode = b;
    c.return = a;
    b = a.deletions;
    null === b ? (a.deletions = [
        c
    ], a.flags |= 16) : b.push(c);
}
function $409124218b1e663f$var$Cg(a, b) {
    switch(a.tag){
        case 5:
            var c = a.type;
            b = 1 !== b.nodeType || c.toLowerCase() !== b.nodeName.toLowerCase() ? null : b;
            return null !== b ? (a.stateNode = b, $409124218b1e663f$var$xg = a, $409124218b1e663f$var$yg = $409124218b1e663f$var$Lf(b.firstChild), !0) : !1;
        case 6:
            return b = "" === a.pendingProps || 3 !== b.nodeType ? null : b, null !== b ? (a.stateNode = b, $409124218b1e663f$var$xg = a, $409124218b1e663f$var$yg = null, !0) : !1;
        case 13:
            return b = 8 !== b.nodeType ? null : b, null !== b ? (c = null !== $409124218b1e663f$var$qg ? {
                id: $409124218b1e663f$var$rg,
                overflow: $409124218b1e663f$var$sg
            } : null, a.memoizedState = {
                dehydrated: b,
                treeContext: c,
                retryLane: 1073741824
            }, c = $409124218b1e663f$var$Bg(18, null, null, 0), c.stateNode = b, c.return = a, a.child = c, $409124218b1e663f$var$xg = a, $409124218b1e663f$var$yg = null, !0) : !1;
        default:
            return !1;
    }
}
function $409124218b1e663f$var$Dg(a) {
    return 0 !== (a.mode & 1) && 0 === (a.flags & 128);
}
function $409124218b1e663f$var$Eg(a) {
    if ($409124218b1e663f$var$I) {
        var b = $409124218b1e663f$var$yg;
        if (b) {
            var c = b;
            if (!$409124218b1e663f$var$Cg(a, b)) {
                if ($409124218b1e663f$var$Dg(a)) throw Error($409124218b1e663f$var$p(418));
                b = $409124218b1e663f$var$Lf(c.nextSibling);
                var d = $409124218b1e663f$var$xg;
                b && $409124218b1e663f$var$Cg(a, b) ? $409124218b1e663f$var$Ag(d, c) : (a.flags = a.flags & -4097 | 2, $409124218b1e663f$var$I = !1, $409124218b1e663f$var$xg = a);
            }
        } else {
            if ($409124218b1e663f$var$Dg(a)) throw Error($409124218b1e663f$var$p(418));
            a.flags = a.flags & -4097 | 2;
            $409124218b1e663f$var$I = !1;
            $409124218b1e663f$var$xg = a;
        }
    }
}
function $409124218b1e663f$var$Fg(a) {
    for(a = a.return; null !== a && 5 !== a.tag && 3 !== a.tag && 13 !== a.tag;)a = a.return;
    $409124218b1e663f$var$xg = a;
}
function $409124218b1e663f$var$Gg(a) {
    if (a !== $409124218b1e663f$var$xg) return !1;
    if (!$409124218b1e663f$var$I) return $409124218b1e663f$var$Fg(a), $409124218b1e663f$var$I = !0, !1;
    var b;
    (b = 3 !== a.tag) && !(b = 5 !== a.tag) && (b = a.type, b = "head" !== b && "body" !== b && !$409124218b1e663f$var$Ef(a.type, a.memoizedProps));
    if (b && (b = $409124218b1e663f$var$yg)) {
        if ($409124218b1e663f$var$Dg(a)) throw $409124218b1e663f$var$Hg(), Error($409124218b1e663f$var$p(418));
        for(; b;)$409124218b1e663f$var$Ag(a, b), b = $409124218b1e663f$var$Lf(b.nextSibling);
    }
    $409124218b1e663f$var$Fg(a);
    if (13 === a.tag) {
        a = a.memoizedState;
        a = null !== a ? a.dehydrated : null;
        if (!a) throw Error($409124218b1e663f$var$p(317));
        a: {
            a = a.nextSibling;
            for(b = 0; a;){
                if (8 === a.nodeType) {
                    var c = a.data;
                    if ("/$" === c) {
                        if (0 === b) {
                            $409124218b1e663f$var$yg = $409124218b1e663f$var$Lf(a.nextSibling);
                            break a;
                        }
                        b--;
                    } else "$" !== c && "$!" !== c && "$?" !== c || b++;
                }
                a = a.nextSibling;
            }
            $409124218b1e663f$var$yg = null;
        }
    } else $409124218b1e663f$var$yg = $409124218b1e663f$var$xg ? $409124218b1e663f$var$Lf(a.stateNode.nextSibling) : null;
    return !0;
}
function $409124218b1e663f$var$Hg() {
    for(var a = $409124218b1e663f$var$yg; a;)a = $409124218b1e663f$var$Lf(a.nextSibling);
}
function $409124218b1e663f$var$Ig() {
    $409124218b1e663f$var$yg = $409124218b1e663f$var$xg = null;
    $409124218b1e663f$var$I = !1;
}
function $409124218b1e663f$var$Jg(a) {
    null === $409124218b1e663f$var$zg ? $409124218b1e663f$var$zg = [
        a
    ] : $409124218b1e663f$var$zg.push(a);
}
var $409124218b1e663f$var$Kg = $409124218b1e663f$var$ua.ReactCurrentBatchConfig;
function $409124218b1e663f$var$Lg(a, b, c) {
    a = c.ref;
    if (null !== a && "function" !== typeof a && "object" !== typeof a) {
        if (c._owner) {
            c = c._owner;
            if (c) {
                if (1 !== c.tag) throw Error($409124218b1e663f$var$p(309));
                var d = c.stateNode;
            }
            if (!d) throw Error($409124218b1e663f$var$p(147, a));
            var e = d, f = "" + a;
            if (null !== b && null !== b.ref && "function" === typeof b.ref && b.ref._stringRef === f) return b.ref;
            b = function(a) {
                var b = e.refs;
                null === a ? delete b[f] : b[f] = a;
            };
            b._stringRef = f;
            return b;
        }
        if ("string" !== typeof a) throw Error($409124218b1e663f$var$p(284));
        if (!c._owner) throw Error($409124218b1e663f$var$p(290, a));
    }
    return a;
}
function $409124218b1e663f$var$Mg(a, b) {
    a = Object.prototype.toString.call(b);
    throw Error($409124218b1e663f$var$p(31, "[object Object]" === a ? "object with keys {" + Object.keys(b).join(", ") + "}" : a));
}
function $409124218b1e663f$var$Ng(a) {
    var b = a._init;
    return b(a._payload);
}
function $409124218b1e663f$var$Og(a) {
    function b(b, c) {
        if (a) {
            var d = b.deletions;
            null === d ? (b.deletions = [
                c
            ], b.flags |= 16) : d.push(c);
        }
    }
    function c(c, d) {
        if (!a) return null;
        for(; null !== d;)b(c, d), d = d.sibling;
        return null;
    }
    function d(a, b) {
        for(a = new Map; null !== b;)null !== b.key ? a.set(b.key, b) : a.set(b.index, b), b = b.sibling;
        return a;
    }
    function e(a, b) {
        a = $409124218b1e663f$var$Pg(a, b);
        a.index = 0;
        a.sibling = null;
        return a;
    }
    function f(b, c, d) {
        b.index = d;
        if (!a) return b.flags |= 1048576, c;
        d = b.alternate;
        if (null !== d) return d = d.index, d < c ? (b.flags |= 2, c) : d;
        b.flags |= 2;
        return c;
    }
    function g(b) {
        a && null === b.alternate && (b.flags |= 2);
        return b;
    }
    function h(a, b, c, d) {
        if (null === b || 6 !== b.tag) return b = $409124218b1e663f$var$Qg(c, a.mode, d), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function k(a, b, c, d) {
        var f = c.type;
        if (f === $409124218b1e663f$var$ya) return m(a, b, c.props.children, d, c.key);
        if (null !== b && (b.elementType === f || "object" === typeof f && null !== f && f.$$typeof === $409124218b1e663f$var$Ha && $409124218b1e663f$var$Ng(f) === b.type)) return d = e(b, c.props), d.ref = $409124218b1e663f$var$Lg(a, b, c), d.return = a, d;
        d = $409124218b1e663f$var$Rg(c.type, c.key, c.props, null, a.mode, d);
        d.ref = $409124218b1e663f$var$Lg(a, b, c);
        d.return = a;
        return d;
    }
    function l(a, b, c, d) {
        if (null === b || 4 !== b.tag || b.stateNode.containerInfo !== c.containerInfo || b.stateNode.implementation !== c.implementation) return b = $409124218b1e663f$var$Sg(c, a.mode, d), b.return = a, b;
        b = e(b, c.children || []);
        b.return = a;
        return b;
    }
    function m(a, b, c, d, f) {
        if (null === b || 7 !== b.tag) return b = $409124218b1e663f$var$Tg(c, a.mode, d, f), b.return = a, b;
        b = e(b, c);
        b.return = a;
        return b;
    }
    function q(a, b, c) {
        if ("string" === typeof b && "" !== b || "number" === typeof b) return b = $409124218b1e663f$var$Qg("" + b, a.mode, c), b.return = a, b;
        if ("object" === typeof b && null !== b) {
            switch(b.$$typeof){
                case $409124218b1e663f$var$va:
                    return c = $409124218b1e663f$var$Rg(b.type, b.key, b.props, null, a.mode, c), c.ref = $409124218b1e663f$var$Lg(a, null, b), c.return = a, c;
                case $409124218b1e663f$var$wa:
                    return b = $409124218b1e663f$var$Sg(b, a.mode, c), b.return = a, b;
                case $409124218b1e663f$var$Ha:
                    var d = b._init;
                    return q(a, d(b._payload), c);
            }
            if ($409124218b1e663f$var$eb(b) || $409124218b1e663f$var$Ka(b)) return b = $409124218b1e663f$var$Tg(b, a.mode, c, null), b.return = a, b;
            $409124218b1e663f$var$Mg(a, b);
        }
        return null;
    }
    function r(a, b, c, d) {
        var e = null !== b ? b.key : null;
        if ("string" === typeof c && "" !== c || "number" === typeof c) return null !== e ? null : h(a, b, "" + c, d);
        if ("object" === typeof c && null !== c) {
            switch(c.$$typeof){
                case $409124218b1e663f$var$va:
                    return c.key === e ? k(a, b, c, d) : null;
                case $409124218b1e663f$var$wa:
                    return c.key === e ? l(a, b, c, d) : null;
                case $409124218b1e663f$var$Ha:
                    return e = c._init, r(a, b, e(c._payload), d);
            }
            if ($409124218b1e663f$var$eb(c) || $409124218b1e663f$var$Ka(c)) return null !== e ? null : m(a, b, c, d, null);
            $409124218b1e663f$var$Mg(a, c);
        }
        return null;
    }
    function y(a, b, c, d, e) {
        if ("string" === typeof d && "" !== d || "number" === typeof d) return a = a.get(c) || null, h(b, a, "" + d, e);
        if ("object" === typeof d && null !== d) {
            switch(d.$$typeof){
                case $409124218b1e663f$var$va:
                    return a = a.get(null === d.key ? c : d.key) || null, k(b, a, d, e);
                case $409124218b1e663f$var$wa:
                    return a = a.get(null === d.key ? c : d.key) || null, l(b, a, d, e);
                case $409124218b1e663f$var$Ha:
                    var f = d._init;
                    return y(a, b, c, f(d._payload), e);
            }
            if ($409124218b1e663f$var$eb(d) || $409124218b1e663f$var$Ka(d)) return a = a.get(c) || null, m(b, a, d, e, null);
            $409124218b1e663f$var$Mg(b, d);
        }
        return null;
    }
    function n(e, g, h, k) {
        for(var l = null, m = null, u = g, w = g = 0, x = null; null !== u && w < h.length; w++){
            u.index > w ? (x = u, u = null) : x = u.sibling;
            var n = r(e, u, h[w], k);
            if (null === n) {
                null === u && (u = x);
                break;
            }
            a && u && null === n.alternate && b(e, u);
            g = f(n, g, w);
            null === m ? l = n : m.sibling = n;
            m = n;
            u = x;
        }
        if (w === h.length) return c(e, u), $409124218b1e663f$var$I && $409124218b1e663f$var$tg(e, w), l;
        if (null === u) {
            for(; w < h.length; w++)u = q(e, h[w], k), null !== u && (g = f(u, g, w), null === m ? l = u : m.sibling = u, m = u);
            $409124218b1e663f$var$I && $409124218b1e663f$var$tg(e, w);
            return l;
        }
        for(u = d(e, u); w < h.length; w++)x = y(u, e, w, h[w], k), null !== x && (a && null !== x.alternate && u.delete(null === x.key ? w : x.key), g = f(x, g, w), null === m ? l = x : m.sibling = x, m = x);
        a && u.forEach(function(a) {
            return b(e, a);
        });
        $409124218b1e663f$var$I && $409124218b1e663f$var$tg(e, w);
        return l;
    }
    function t(e, g, h, k) {
        var l = $409124218b1e663f$var$Ka(h);
        if ("function" !== typeof l) throw Error($409124218b1e663f$var$p(150));
        h = l.call(h);
        if (null == h) throw Error($409124218b1e663f$var$p(151));
        for(var u = l = null, m = g, w = g = 0, x = null, n = h.next(); null !== m && !n.done; w++, n = h.next()){
            m.index > w ? (x = m, m = null) : x = m.sibling;
            var t = r(e, m, n.value, k);
            if (null === t) {
                null === m && (m = x);
                break;
            }
            a && m && null === t.alternate && b(e, m);
            g = f(t, g, w);
            null === u ? l = t : u.sibling = t;
            u = t;
            m = x;
        }
        if (n.done) return c(e, m), $409124218b1e663f$var$I && $409124218b1e663f$var$tg(e, w), l;
        if (null === m) {
            for(; !n.done; w++, n = h.next())n = q(e, n.value, k), null !== n && (g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
            $409124218b1e663f$var$I && $409124218b1e663f$var$tg(e, w);
            return l;
        }
        for(m = d(e, m); !n.done; w++, n = h.next())n = y(m, e, w, n.value, k), null !== n && (a && null !== n.alternate && m.delete(null === n.key ? w : n.key), g = f(n, g, w), null === u ? l = n : u.sibling = n, u = n);
        a && m.forEach(function(a) {
            return b(e, a);
        });
        $409124218b1e663f$var$I && $409124218b1e663f$var$tg(e, w);
        return l;
    }
    function J(a, d, f, h) {
        "object" === typeof f && null !== f && f.type === $409124218b1e663f$var$ya && null === f.key && (f = f.props.children);
        if ("object" === typeof f && null !== f) {
            switch(f.$$typeof){
                case $409124218b1e663f$var$va:
                    a: {
                        for(var k = f.key, l = d; null !== l;){
                            if (l.key === k) {
                                k = f.type;
                                if (k === $409124218b1e663f$var$ya) {
                                    if (7 === l.tag) {
                                        c(a, l.sibling);
                                        d = e(l, f.props.children);
                                        d.return = a;
                                        a = d;
                                        break a;
                                    }
                                } else if (l.elementType === k || "object" === typeof k && null !== k && k.$$typeof === $409124218b1e663f$var$Ha && $409124218b1e663f$var$Ng(k) === l.type) {
                                    c(a, l.sibling);
                                    d = e(l, f.props);
                                    d.ref = $409124218b1e663f$var$Lg(a, l, f);
                                    d.return = a;
                                    a = d;
                                    break a;
                                }
                                c(a, l);
                                break;
                            } else b(a, l);
                            l = l.sibling;
                        }
                        f.type === $409124218b1e663f$var$ya ? (d = $409124218b1e663f$var$Tg(f.props.children, a.mode, h, f.key), d.return = a, a = d) : (h = $409124218b1e663f$var$Rg(f.type, f.key, f.props, null, a.mode, h), h.ref = $409124218b1e663f$var$Lg(a, d, f), h.return = a, a = h);
                    }
                    return g(a);
                case $409124218b1e663f$var$wa:
                    a: {
                        for(l = f.key; null !== d;){
                            if (d.key === l) {
                                if (4 === d.tag && d.stateNode.containerInfo === f.containerInfo && d.stateNode.implementation === f.implementation) {
                                    c(a, d.sibling);
                                    d = e(d, f.children || []);
                                    d.return = a;
                                    a = d;
                                    break a;
                                } else {
                                    c(a, d);
                                    break;
                                }
                            } else b(a, d);
                            d = d.sibling;
                        }
                        d = $409124218b1e663f$var$Sg(f, a.mode, h);
                        d.return = a;
                        a = d;
                    }
                    return g(a);
                case $409124218b1e663f$var$Ha:
                    return l = f._init, J(a, d, l(f._payload), h);
            }
            if ($409124218b1e663f$var$eb(f)) return n(a, d, f, h);
            if ($409124218b1e663f$var$Ka(f)) return t(a, d, f, h);
            $409124218b1e663f$var$Mg(a, f);
        }
        return "string" === typeof f && "" !== f || "number" === typeof f ? (f = "" + f, null !== d && 6 === d.tag ? (c(a, d.sibling), d = e(d, f), d.return = a, a = d) : (c(a, d), d = $409124218b1e663f$var$Qg(f, a.mode, h), d.return = a, a = d), g(a)) : c(a, d);
    }
    return J;
}
var $409124218b1e663f$var$Ug = $409124218b1e663f$var$Og(!0), $409124218b1e663f$var$Vg = $409124218b1e663f$var$Og(!1), $409124218b1e663f$var$Wg = $409124218b1e663f$var$Uf(null), $409124218b1e663f$var$Xg = null, $409124218b1e663f$var$Yg = null, $409124218b1e663f$var$Zg = null;
function $409124218b1e663f$var$$g() {
    $409124218b1e663f$var$Zg = $409124218b1e663f$var$Yg = $409124218b1e663f$var$Xg = null;
}
function $409124218b1e663f$var$ah(a) {
    var b = $409124218b1e663f$var$Wg.current;
    $409124218b1e663f$var$E($409124218b1e663f$var$Wg);
    a._currentValue = b;
}
function $409124218b1e663f$var$bh(a, b, c) {
    for(; null !== a;){
        var d = a.alternate;
        (a.childLanes & b) !== b ? (a.childLanes |= b, null !== d && (d.childLanes |= b)) : null !== d && (d.childLanes & b) !== b && (d.childLanes |= b);
        if (a === c) break;
        a = a.return;
    }
}
function $409124218b1e663f$var$ch(a, b) {
    $409124218b1e663f$var$Xg = a;
    $409124218b1e663f$var$Zg = $409124218b1e663f$var$Yg = null;
    a = a.dependencies;
    null !== a && null !== a.firstContext && (0 !== (a.lanes & b) && ($409124218b1e663f$var$dh = !0), a.firstContext = null);
}
function $409124218b1e663f$var$eh(a) {
    var b = a._currentValue;
    if ($409124218b1e663f$var$Zg !== a) {
        if (a = {
            context: a,
            memoizedValue: b,
            next: null
        }, null === $409124218b1e663f$var$Yg) {
            if (null === $409124218b1e663f$var$Xg) throw Error($409124218b1e663f$var$p(308));
            $409124218b1e663f$var$Yg = a;
            $409124218b1e663f$var$Xg.dependencies = {
                lanes: 0,
                firstContext: a
            };
        } else $409124218b1e663f$var$Yg = $409124218b1e663f$var$Yg.next = a;
    }
    return b;
}
var $409124218b1e663f$var$fh = null;
function $409124218b1e663f$var$gh(a) {
    null === $409124218b1e663f$var$fh ? $409124218b1e663f$var$fh = [
        a
    ] : $409124218b1e663f$var$fh.push(a);
}
function $409124218b1e663f$var$hh(a, b, c, d) {
    var e = b.interleaved;
    null === e ? (c.next = c, $409124218b1e663f$var$gh(b)) : (c.next = e.next, e.next = c);
    b.interleaved = c;
    return $409124218b1e663f$var$ih(a, d);
}
function $409124218b1e663f$var$ih(a, b) {
    a.lanes |= b;
    var c = a.alternate;
    null !== c && (c.lanes |= b);
    c = a;
    for(a = a.return; null !== a;)a.childLanes |= b, c = a.alternate, null !== c && (c.childLanes |= b), c = a, a = a.return;
    return 3 === c.tag ? c.stateNode : null;
}
var $409124218b1e663f$var$jh = !1;
function $409124218b1e663f$var$kh(a) {
    a.updateQueue = {
        baseState: a.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            interleaved: null,
            lanes: 0
        },
        effects: null
    };
}
function $409124218b1e663f$var$lh(a, b) {
    a = a.updateQueue;
    b.updateQueue === a && (b.updateQueue = {
        baseState: a.baseState,
        firstBaseUpdate: a.firstBaseUpdate,
        lastBaseUpdate: a.lastBaseUpdate,
        shared: a.shared,
        effects: a.effects
    });
}
function $409124218b1e663f$var$mh(a, b) {
    return {
        eventTime: a,
        lane: b,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $409124218b1e663f$var$nh(a, b, c) {
    var d = a.updateQueue;
    if (null === d) return null;
    d = d.shared;
    if (0 !== ($409124218b1e663f$var$K & 2)) {
        var e = d.pending;
        null === e ? b.next = b : (b.next = e.next, e.next = b);
        d.pending = b;
        return $409124218b1e663f$var$ih(a, c);
    }
    e = d.interleaved;
    null === e ? (b.next = b, $409124218b1e663f$var$gh(d)) : (b.next = e.next, e.next = b);
    d.interleaved = b;
    return $409124218b1e663f$var$ih(a, c);
}
function $409124218b1e663f$var$oh(a, b, c) {
    b = b.updateQueue;
    if (null !== b && (b = b.shared, 0 !== (c & 4194240))) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $409124218b1e663f$var$Cc(a, c);
    }
}
function $409124218b1e663f$var$ph(a, b) {
    var c = a.updateQueue, d = a.alternate;
    if (null !== d && (d = d.updateQueue, c === d)) {
        var e = null, f = null;
        c = c.firstBaseUpdate;
        if (null !== c) {
            do {
                var g = {
                    eventTime: c.eventTime,
                    lane: c.lane,
                    tag: c.tag,
                    payload: c.payload,
                    callback: c.callback,
                    next: null
                };
                null === f ? e = f = g : f = f.next = g;
                c = c.next;
            }while (null !== c);
            null === f ? e = f = b : f = f.next = b;
        } else e = f = b;
        c = {
            baseState: d.baseState,
            firstBaseUpdate: e,
            lastBaseUpdate: f,
            shared: d.shared,
            effects: d.effects
        };
        a.updateQueue = c;
        return;
    }
    a = c.lastBaseUpdate;
    null === a ? c.firstBaseUpdate = b : a.next = b;
    c.lastBaseUpdate = b;
}
function $409124218b1e663f$var$qh(a, b, c, d) {
    var e = a.updateQueue;
    $409124218b1e663f$var$jh = !1;
    var f = e.firstBaseUpdate, g = e.lastBaseUpdate, h = e.shared.pending;
    if (null !== h) {
        e.shared.pending = null;
        var k = h, l = k.next;
        k.next = null;
        null === g ? f = l : g.next = l;
        g = k;
        var m = a.alternate;
        null !== m && (m = m.updateQueue, h = m.lastBaseUpdate, h !== g && (null === h ? m.firstBaseUpdate = l : h.next = l, m.lastBaseUpdate = k));
    }
    if (null !== f) {
        var q = e.baseState;
        g = 0;
        m = l = k = null;
        h = f;
        do {
            var r = h.lane, y = h.eventTime;
            if ((d & r) === r) {
                null !== m && (m = m.next = {
                    eventTime: y,
                    lane: 0,
                    tag: h.tag,
                    payload: h.payload,
                    callback: h.callback,
                    next: null
                });
                a: {
                    var n = a, t = h;
                    r = b;
                    y = c;
                    switch(t.tag){
                        case 1:
                            n = t.payload;
                            if ("function" === typeof n) {
                                q = n.call(y, q, r);
                                break a;
                            }
                            q = n;
                            break a;
                        case 3:
                            n.flags = n.flags & -65537 | 128;
                        case 0:
                            n = t.payload;
                            r = "function" === typeof n ? n.call(y, q, r) : n;
                            if (null === r || void 0 === r) break a;
                            q = $409124218b1e663f$var$A({}, q, r);
                            break a;
                        case 2:
                            $409124218b1e663f$var$jh = !0;
                    }
                }
                null !== h.callback && 0 !== h.lane && (a.flags |= 64, r = e.effects, null === r ? e.effects = [
                    h
                ] : r.push(h));
            } else y = {
                eventTime: y,
                lane: r,
                tag: h.tag,
                payload: h.payload,
                callback: h.callback,
                next: null
            }, null === m ? (l = m = y, k = q) : m = m.next = y, g |= r;
            h = h.next;
            if (null === h) {
                if (h = e.shared.pending, null === h) break;
                else r = h, h = r.next, r.next = null, e.lastBaseUpdate = r, e.shared.pending = null;
            }
        }while (1);
        null === m && (k = q);
        e.baseState = k;
        e.firstBaseUpdate = l;
        e.lastBaseUpdate = m;
        b = e.shared.interleaved;
        if (null !== b) {
            e = b;
            do g |= e.lane, e = e.next;
            while (e !== b);
        } else null === f && (e.shared.lanes = 0);
        $409124218b1e663f$var$rh |= g;
        a.lanes = g;
        a.memoizedState = q;
    }
}
function $409124218b1e663f$var$sh(a, b, c) {
    a = b.effects;
    b.effects = null;
    if (null !== a) for(b = 0; b < a.length; b++){
        var d = a[b], e = d.callback;
        if (null !== e) {
            d.callback = null;
            d = c;
            if ("function" !== typeof e) throw Error($409124218b1e663f$var$p(191, e));
            e.call(d);
        }
    }
}
var $409124218b1e663f$var$th = {}, $409124218b1e663f$var$uh = $409124218b1e663f$var$Uf($409124218b1e663f$var$th), $409124218b1e663f$var$vh = $409124218b1e663f$var$Uf($409124218b1e663f$var$th), $409124218b1e663f$var$wh = $409124218b1e663f$var$Uf($409124218b1e663f$var$th);
function $409124218b1e663f$var$xh(a) {
    if (a === $409124218b1e663f$var$th) throw Error($409124218b1e663f$var$p(174));
    return a;
}
function $409124218b1e663f$var$yh(a, b) {
    $409124218b1e663f$var$G($409124218b1e663f$var$wh, b);
    $409124218b1e663f$var$G($409124218b1e663f$var$vh, a);
    $409124218b1e663f$var$G($409124218b1e663f$var$uh, $409124218b1e663f$var$th);
    a = b.nodeType;
    switch(a){
        case 9:
        case 11:
            b = (b = b.documentElement) ? b.namespaceURI : $409124218b1e663f$var$lb(null, "");
            break;
        default:
            a = 8 === a ? b.parentNode : b, b = a.namespaceURI || null, a = a.tagName, b = $409124218b1e663f$var$lb(b, a);
    }
    $409124218b1e663f$var$E($409124218b1e663f$var$uh);
    $409124218b1e663f$var$G($409124218b1e663f$var$uh, b);
}
function $409124218b1e663f$var$zh() {
    $409124218b1e663f$var$E($409124218b1e663f$var$uh);
    $409124218b1e663f$var$E($409124218b1e663f$var$vh);
    $409124218b1e663f$var$E($409124218b1e663f$var$wh);
}
function $409124218b1e663f$var$Ah(a) {
    $409124218b1e663f$var$xh($409124218b1e663f$var$wh.current);
    var b = $409124218b1e663f$var$xh($409124218b1e663f$var$uh.current);
    var c = $409124218b1e663f$var$lb(b, a.type);
    b !== c && ($409124218b1e663f$var$G($409124218b1e663f$var$vh, a), $409124218b1e663f$var$G($409124218b1e663f$var$uh, c));
}
function $409124218b1e663f$var$Bh(a) {
    $409124218b1e663f$var$vh.current === a && ($409124218b1e663f$var$E($409124218b1e663f$var$uh), $409124218b1e663f$var$E($409124218b1e663f$var$vh));
}
var $409124218b1e663f$var$L = $409124218b1e663f$var$Uf(0);
function $409124218b1e663f$var$Ch(a) {
    for(var b = a; null !== b;){
        if (13 === b.tag) {
            var c = b.memoizedState;
            if (null !== c && (c = c.dehydrated, null === c || "$?" === c.data || "$!" === c.data)) return b;
        } else if (19 === b.tag && void 0 !== b.memoizedProps.revealOrder) {
            if (0 !== (b.flags & 128)) return b;
        } else if (null !== b.child) {
            b.child.return = b;
            b = b.child;
            continue;
        }
        if (b === a) break;
        for(; null === b.sibling;){
            if (null === b.return || b.return === a) return null;
            b = b.return;
        }
        b.sibling.return = b.return;
        b = b.sibling;
    }
    return null;
}
var $409124218b1e663f$var$Dh = [];
function $409124218b1e663f$var$Eh() {
    for(var a = 0; a < $409124218b1e663f$var$Dh.length; a++)$409124218b1e663f$var$Dh[a]._workInProgressVersionPrimary = null;
    $409124218b1e663f$var$Dh.length = 0;
}
var $409124218b1e663f$var$Fh = $409124218b1e663f$var$ua.ReactCurrentDispatcher, $409124218b1e663f$var$Gh = $409124218b1e663f$var$ua.ReactCurrentBatchConfig, $409124218b1e663f$var$Hh = 0, $409124218b1e663f$var$M = null, $409124218b1e663f$var$N = null, $409124218b1e663f$var$O = null, $409124218b1e663f$var$Ih = !1, $409124218b1e663f$var$Jh = !1, $409124218b1e663f$var$Kh = 0, $409124218b1e663f$var$Lh = 0;
function $409124218b1e663f$var$P() {
    throw Error($409124218b1e663f$var$p(321));
}
function $409124218b1e663f$var$Mh(a, b) {
    if (null === b) return !1;
    for(var c = 0; c < b.length && c < a.length; c++)if (!$409124218b1e663f$var$He(a[c], b[c])) return !1;
    return !0;
}
function $409124218b1e663f$var$Nh(a, b, c, d, e, f) {
    $409124218b1e663f$var$Hh = f;
    $409124218b1e663f$var$M = b;
    b.memoizedState = null;
    b.updateQueue = null;
    b.lanes = 0;
    $409124218b1e663f$var$Fh.current = null === a || null === a.memoizedState ? $409124218b1e663f$var$Oh : $409124218b1e663f$var$Ph;
    a = c(d, e);
    if ($409124218b1e663f$var$Jh) {
        f = 0;
        do {
            $409124218b1e663f$var$Jh = !1;
            $409124218b1e663f$var$Kh = 0;
            if (25 <= f) throw Error($409124218b1e663f$var$p(301));
            f += 1;
            $409124218b1e663f$var$O = $409124218b1e663f$var$N = null;
            b.updateQueue = null;
            $409124218b1e663f$var$Fh.current = $409124218b1e663f$var$Qh;
            a = c(d, e);
        }while ($409124218b1e663f$var$Jh);
    }
    $409124218b1e663f$var$Fh.current = $409124218b1e663f$var$Rh;
    b = null !== $409124218b1e663f$var$N && null !== $409124218b1e663f$var$N.next;
    $409124218b1e663f$var$Hh = 0;
    $409124218b1e663f$var$O = $409124218b1e663f$var$N = $409124218b1e663f$var$M = null;
    $409124218b1e663f$var$Ih = !1;
    if (b) throw Error($409124218b1e663f$var$p(300));
    return a;
}
function $409124218b1e663f$var$Sh() {
    var a = 0 !== $409124218b1e663f$var$Kh;
    $409124218b1e663f$var$Kh = 0;
    return a;
}
function $409124218b1e663f$var$Th() {
    var a = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $409124218b1e663f$var$O ? $409124218b1e663f$var$M.memoizedState = $409124218b1e663f$var$O = a : $409124218b1e663f$var$O = $409124218b1e663f$var$O.next = a;
    return $409124218b1e663f$var$O;
}
function $409124218b1e663f$var$Uh() {
    if (null === $409124218b1e663f$var$N) {
        var a = $409124218b1e663f$var$M.alternate;
        a = null !== a ? a.memoizedState : null;
    } else a = $409124218b1e663f$var$N.next;
    var b = null === $409124218b1e663f$var$O ? $409124218b1e663f$var$M.memoizedState : $409124218b1e663f$var$O.next;
    if (null !== b) $409124218b1e663f$var$O = b, $409124218b1e663f$var$N = a;
    else {
        if (null === a) throw Error($409124218b1e663f$var$p(310));
        $409124218b1e663f$var$N = a;
        a = {
            memoizedState: $409124218b1e663f$var$N.memoizedState,
            baseState: $409124218b1e663f$var$N.baseState,
            baseQueue: $409124218b1e663f$var$N.baseQueue,
            queue: $409124218b1e663f$var$N.queue,
            next: null
        };
        null === $409124218b1e663f$var$O ? $409124218b1e663f$var$M.memoizedState = $409124218b1e663f$var$O = a : $409124218b1e663f$var$O = $409124218b1e663f$var$O.next = a;
    }
    return $409124218b1e663f$var$O;
}
function $409124218b1e663f$var$Vh(a, b) {
    return "function" === typeof b ? b(a) : b;
}
function $409124218b1e663f$var$Wh(a) {
    var b = $409124218b1e663f$var$Uh(), c = b.queue;
    if (null === c) throw Error($409124218b1e663f$var$p(311));
    c.lastRenderedReducer = a;
    var d = $409124218b1e663f$var$N, e = d.baseQueue, f = c.pending;
    if (null !== f) {
        if (null !== e) {
            var g = e.next;
            e.next = f.next;
            f.next = g;
        }
        d.baseQueue = e = f;
        c.pending = null;
    }
    if (null !== e) {
        f = e.next;
        d = d.baseState;
        var h = g = null, k = null, l = f;
        do {
            var m = l.lane;
            if (($409124218b1e663f$var$Hh & m) === m) null !== k && (k = k.next = {
                lane: 0,
                action: l.action,
                hasEagerState: l.hasEagerState,
                eagerState: l.eagerState,
                next: null
            }), d = l.hasEagerState ? l.eagerState : a(d, l.action);
            else {
                var q = {
                    lane: m,
                    action: l.action,
                    hasEagerState: l.hasEagerState,
                    eagerState: l.eagerState,
                    next: null
                };
                null === k ? (h = k = q, g = d) : k = k.next = q;
                $409124218b1e663f$var$M.lanes |= m;
                $409124218b1e663f$var$rh |= m;
            }
            l = l.next;
        }while (null !== l && l !== f);
        null === k ? g = d : k.next = h;
        $409124218b1e663f$var$He(d, b.memoizedState) || ($409124218b1e663f$var$dh = !0);
        b.memoizedState = d;
        b.baseState = g;
        b.baseQueue = k;
        c.lastRenderedState = d;
    }
    a = c.interleaved;
    if (null !== a) {
        e = a;
        do f = e.lane, $409124218b1e663f$var$M.lanes |= f, $409124218b1e663f$var$rh |= f, e = e.next;
        while (e !== a);
    } else null === e && (c.lanes = 0);
    return [
        b.memoizedState,
        c.dispatch
    ];
}
function $409124218b1e663f$var$Xh(a) {
    var b = $409124218b1e663f$var$Uh(), c = b.queue;
    if (null === c) throw Error($409124218b1e663f$var$p(311));
    c.lastRenderedReducer = a;
    var d = c.dispatch, e = c.pending, f = b.memoizedState;
    if (null !== e) {
        c.pending = null;
        var g = e = e.next;
        do f = a(f, g.action), g = g.next;
        while (g !== e);
        $409124218b1e663f$var$He(f, b.memoizedState) || ($409124218b1e663f$var$dh = !0);
        b.memoizedState = f;
        null === b.baseQueue && (b.baseState = f);
        c.lastRenderedState = f;
    }
    return [
        f,
        d
    ];
}
function $409124218b1e663f$var$Yh() {}
function $409124218b1e663f$var$Zh(a, b) {
    var c = $409124218b1e663f$var$M, d = $409124218b1e663f$var$Uh(), e = b(), f = !$409124218b1e663f$var$He(d.memoizedState, e);
    f && (d.memoizedState = e, $409124218b1e663f$var$dh = !0);
    d = d.queue;
    $409124218b1e663f$var$$h($409124218b1e663f$var$ai.bind(null, c, d, a), [
        a
    ]);
    if (d.getSnapshot !== b || f || null !== $409124218b1e663f$var$O && $409124218b1e663f$var$O.memoizedState.tag & 1) {
        c.flags |= 2048;
        $409124218b1e663f$var$bi(9, $409124218b1e663f$var$ci.bind(null, c, d, e, b), void 0, null);
        if (null === $409124218b1e663f$var$Q) throw Error($409124218b1e663f$var$p(349));
        0 !== ($409124218b1e663f$var$Hh & 30) || $409124218b1e663f$var$di(c, b, e);
    }
    return e;
}
function $409124218b1e663f$var$di(a, b, c) {
    a.flags |= 16384;
    a = {
        getSnapshot: b,
        value: c
    };
    b = $409124218b1e663f$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $409124218b1e663f$var$M.updateQueue = b, b.stores = [
        a
    ]) : (c = b.stores, null === c ? b.stores = [
        a
    ] : c.push(a));
}
function $409124218b1e663f$var$ci(a, b, c, d) {
    b.value = c;
    b.getSnapshot = d;
    $409124218b1e663f$var$ei(b) && $409124218b1e663f$var$fi(a);
}
function $409124218b1e663f$var$ai(a, b, c) {
    return c(function() {
        $409124218b1e663f$var$ei(b) && $409124218b1e663f$var$fi(a);
    });
}
function $409124218b1e663f$var$ei(a) {
    var b = a.getSnapshot;
    a = a.value;
    try {
        var c = b();
        return !$409124218b1e663f$var$He(a, c);
    } catch (d) {
        return !0;
    }
}
function $409124218b1e663f$var$fi(a) {
    var b = $409124218b1e663f$var$ih(a, 1);
    null !== b && $409124218b1e663f$var$gi(b, a, 1, -1);
}
function $409124218b1e663f$var$hi(a) {
    var b = $409124218b1e663f$var$Th();
    "function" === typeof a && (a = a());
    b.memoizedState = b.baseState = a;
    a = {
        pending: null,
        interleaved: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $409124218b1e663f$var$Vh,
        lastRenderedState: a
    };
    b.queue = a;
    a = a.dispatch = $409124218b1e663f$var$ii.bind(null, $409124218b1e663f$var$M, a);
    return [
        b.memoizedState,
        a
    ];
}
function $409124218b1e663f$var$bi(a, b, c, d) {
    a = {
        tag: a,
        create: b,
        destroy: c,
        deps: d,
        next: null
    };
    b = $409124218b1e663f$var$M.updateQueue;
    null === b ? (b = {
        lastEffect: null,
        stores: null
    }, $409124218b1e663f$var$M.updateQueue = b, b.lastEffect = a.next = a) : (c = b.lastEffect, null === c ? b.lastEffect = a.next = a : (d = c.next, c.next = a, a.next = d, b.lastEffect = a));
    return a;
}
function $409124218b1e663f$var$ji() {
    return $409124218b1e663f$var$Uh().memoizedState;
}
function $409124218b1e663f$var$ki(a, b, c, d) {
    var e = $409124218b1e663f$var$Th();
    $409124218b1e663f$var$M.flags |= a;
    e.memoizedState = $409124218b1e663f$var$bi(1 | b, c, void 0, void 0 === d ? null : d);
}
function $409124218b1e663f$var$li(a, b, c, d) {
    var e = $409124218b1e663f$var$Uh();
    d = void 0 === d ? null : d;
    var f = void 0;
    if (null !== $409124218b1e663f$var$N) {
        var g = $409124218b1e663f$var$N.memoizedState;
        f = g.destroy;
        if (null !== d && $409124218b1e663f$var$Mh(d, g.deps)) {
            e.memoizedState = $409124218b1e663f$var$bi(b, c, f, d);
            return;
        }
    }
    $409124218b1e663f$var$M.flags |= a;
    e.memoizedState = $409124218b1e663f$var$bi(1 | b, c, f, d);
}
function $409124218b1e663f$var$mi(a, b) {
    return $409124218b1e663f$var$ki(8390656, 8, a, b);
}
function $409124218b1e663f$var$$h(a, b) {
    return $409124218b1e663f$var$li(2048, 8, a, b);
}
function $409124218b1e663f$var$ni(a, b) {
    return $409124218b1e663f$var$li(4, 2, a, b);
}
function $409124218b1e663f$var$oi(a, b) {
    return $409124218b1e663f$var$li(4, 4, a, b);
}
function $409124218b1e663f$var$pi(a, b) {
    if ("function" === typeof b) return a = a(), b(a), function() {
        b(null);
    };
    if (null !== b && void 0 !== b) return a = a(), b.current = a, function() {
        b.current = null;
    };
}
function $409124218b1e663f$var$qi(a, b, c) {
    c = null !== c && void 0 !== c ? c.concat([
        a
    ]) : null;
    return $409124218b1e663f$var$li(4, 4, $409124218b1e663f$var$pi.bind(null, b, a), c);
}
function $409124218b1e663f$var$ri() {}
function $409124218b1e663f$var$si(a, b) {
    var c = $409124218b1e663f$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $409124218b1e663f$var$Mh(b, d[1])) return d[0];
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $409124218b1e663f$var$ti(a, b) {
    var c = $409124218b1e663f$var$Uh();
    b = void 0 === b ? null : b;
    var d = c.memoizedState;
    if (null !== d && null !== b && $409124218b1e663f$var$Mh(b, d[1])) return d[0];
    a = a();
    c.memoizedState = [
        a,
        b
    ];
    return a;
}
function $409124218b1e663f$var$ui(a, b, c) {
    if (0 === ($409124218b1e663f$var$Hh & 21)) return a.baseState && (a.baseState = !1, $409124218b1e663f$var$dh = !0), a.memoizedState = c;
    $409124218b1e663f$var$He(c, b) || (c = $409124218b1e663f$var$yc(), $409124218b1e663f$var$M.lanes |= c, $409124218b1e663f$var$rh |= c, a.baseState = !0);
    return b;
}
function $409124218b1e663f$var$vi(a, b) {
    var c = $409124218b1e663f$var$C;
    $409124218b1e663f$var$C = 0 !== c && 4 > c ? c : 4;
    a(!0);
    var d = $409124218b1e663f$var$Gh.transition;
    $409124218b1e663f$var$Gh.transition = {};
    try {
        a(!1), b();
    } finally{
        $409124218b1e663f$var$C = c, $409124218b1e663f$var$Gh.transition = d;
    }
}
function $409124218b1e663f$var$wi() {
    return $409124218b1e663f$var$Uh().memoizedState;
}
function $409124218b1e663f$var$xi(a, b, c) {
    var d = $409124218b1e663f$var$yi(a);
    c = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($409124218b1e663f$var$zi(a)) $409124218b1e663f$var$Ai(b, c);
    else if (c = $409124218b1e663f$var$hh(a, b, c, d), null !== c) {
        var e = $409124218b1e663f$var$R();
        $409124218b1e663f$var$gi(c, a, d, e);
        $409124218b1e663f$var$Bi(c, b, d);
    }
}
function $409124218b1e663f$var$ii(a, b, c) {
    var d = $409124218b1e663f$var$yi(a), e = {
        lane: d,
        action: c,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($409124218b1e663f$var$zi(a)) $409124218b1e663f$var$Ai(b, e);
    else {
        var f = a.alternate;
        if (0 === a.lanes && (null === f || 0 === f.lanes) && (f = b.lastRenderedReducer, null !== f)) try {
            var g = b.lastRenderedState, h = f(g, c);
            e.hasEagerState = !0;
            e.eagerState = h;
            if ($409124218b1e663f$var$He(h, g)) {
                var k = b.interleaved;
                null === k ? (e.next = e, $409124218b1e663f$var$gh(b)) : (e.next = k.next, k.next = e);
                b.interleaved = e;
                return;
            }
        } catch (l) {} finally{}
        c = $409124218b1e663f$var$hh(a, b, e, d);
        null !== c && (e = $409124218b1e663f$var$R(), $409124218b1e663f$var$gi(c, a, d, e), $409124218b1e663f$var$Bi(c, b, d));
    }
}
function $409124218b1e663f$var$zi(a) {
    var b = a.alternate;
    return a === $409124218b1e663f$var$M || null !== b && b === $409124218b1e663f$var$M;
}
function $409124218b1e663f$var$Ai(a, b) {
    $409124218b1e663f$var$Jh = $409124218b1e663f$var$Ih = !0;
    var c = a.pending;
    null === c ? b.next = b : (b.next = c.next, c.next = b);
    a.pending = b;
}
function $409124218b1e663f$var$Bi(a, b, c) {
    if (0 !== (c & 4194240)) {
        var d = b.lanes;
        d &= a.pendingLanes;
        c |= d;
        b.lanes = c;
        $409124218b1e663f$var$Cc(a, c);
    }
}
var $409124218b1e663f$var$Rh = {
    readContext: $409124218b1e663f$var$eh,
    useCallback: $409124218b1e663f$var$P,
    useContext: $409124218b1e663f$var$P,
    useEffect: $409124218b1e663f$var$P,
    useImperativeHandle: $409124218b1e663f$var$P,
    useInsertionEffect: $409124218b1e663f$var$P,
    useLayoutEffect: $409124218b1e663f$var$P,
    useMemo: $409124218b1e663f$var$P,
    useReducer: $409124218b1e663f$var$P,
    useRef: $409124218b1e663f$var$P,
    useState: $409124218b1e663f$var$P,
    useDebugValue: $409124218b1e663f$var$P,
    useDeferredValue: $409124218b1e663f$var$P,
    useTransition: $409124218b1e663f$var$P,
    useMutableSource: $409124218b1e663f$var$P,
    useSyncExternalStore: $409124218b1e663f$var$P,
    useId: $409124218b1e663f$var$P,
    unstable_isNewReconciler: !1
}, $409124218b1e663f$var$Oh = {
    readContext: $409124218b1e663f$var$eh,
    useCallback: function(a, b) {
        $409124218b1e663f$var$Th().memoizedState = [
            a,
            void 0 === b ? null : b
        ];
        return a;
    },
    useContext: $409124218b1e663f$var$eh,
    useEffect: $409124218b1e663f$var$mi,
    useImperativeHandle: function(a, b, c) {
        c = null !== c && void 0 !== c ? c.concat([
            a
        ]) : null;
        return $409124218b1e663f$var$ki(4194308, 4, $409124218b1e663f$var$pi.bind(null, b, a), c);
    },
    useLayoutEffect: function(a, b) {
        return $409124218b1e663f$var$ki(4194308, 4, a, b);
    },
    useInsertionEffect: function(a, b) {
        return $409124218b1e663f$var$ki(4, 2, a, b);
    },
    useMemo: function(a, b) {
        var c = $409124218b1e663f$var$Th();
        b = void 0 === b ? null : b;
        a = a();
        c.memoizedState = [
            a,
            b
        ];
        return a;
    },
    useReducer: function(a, b, c) {
        var d = $409124218b1e663f$var$Th();
        b = void 0 !== c ? c(b) : b;
        d.memoizedState = d.baseState = b;
        a = {
            pending: null,
            interleaved: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: a,
            lastRenderedState: b
        };
        d.queue = a;
        a = a.dispatch = $409124218b1e663f$var$xi.bind(null, $409124218b1e663f$var$M, a);
        return [
            d.memoizedState,
            a
        ];
    },
    useRef: function(a) {
        var b = $409124218b1e663f$var$Th();
        a = {
            current: a
        };
        return b.memoizedState = a;
    },
    useState: $409124218b1e663f$var$hi,
    useDebugValue: $409124218b1e663f$var$ri,
    useDeferredValue: function(a) {
        return $409124218b1e663f$var$Th().memoizedState = a;
    },
    useTransition: function() {
        var a = $409124218b1e663f$var$hi(!1), b = a[0];
        a = $409124218b1e663f$var$vi.bind(null, a[1]);
        $409124218b1e663f$var$Th().memoizedState = a;
        return [
            b,
            a
        ];
    },
    useMutableSource: function() {},
    useSyncExternalStore: function(a, b, c) {
        var d = $409124218b1e663f$var$M, e = $409124218b1e663f$var$Th();
        if ($409124218b1e663f$var$I) {
            if (void 0 === c) throw Error($409124218b1e663f$var$p(407));
            c = c();
        } else {
            c = b();
            if (null === $409124218b1e663f$var$Q) throw Error($409124218b1e663f$var$p(349));
            0 !== ($409124218b1e663f$var$Hh & 30) || $409124218b1e663f$var$di(d, b, c);
        }
        e.memoizedState = c;
        var f = {
            value: c,
            getSnapshot: b
        };
        e.queue = f;
        $409124218b1e663f$var$mi($409124218b1e663f$var$ai.bind(null, d, f, a), [
            a
        ]);
        d.flags |= 2048;
        $409124218b1e663f$var$bi(9, $409124218b1e663f$var$ci.bind(null, d, f, c, b), void 0, null);
        return c;
    },
    useId: function() {
        var a = $409124218b1e663f$var$Th(), b = $409124218b1e663f$var$Q.identifierPrefix;
        if ($409124218b1e663f$var$I) {
            var c = $409124218b1e663f$var$sg;
            var d = $409124218b1e663f$var$rg;
            c = (d & ~(1 << 32 - $409124218b1e663f$var$oc(d) - 1)).toString(32) + c;
            b = ":" + b + "R" + c;
            c = $409124218b1e663f$var$Kh++;
            0 < c && (b += "H" + c.toString(32));
            b += ":";
        } else c = $409124218b1e663f$var$Lh++, b = ":" + b + "r" + c.toString(32) + ":";
        return a.memoizedState = b;
    },
    unstable_isNewReconciler: !1
}, $409124218b1e663f$var$Ph = {
    readContext: $409124218b1e663f$var$eh,
    useCallback: $409124218b1e663f$var$si,
    useContext: $409124218b1e663f$var$eh,
    useEffect: $409124218b1e663f$var$$h,
    useImperativeHandle: $409124218b1e663f$var$qi,
    useInsertionEffect: $409124218b1e663f$var$ni,
    useLayoutEffect: $409124218b1e663f$var$oi,
    useMemo: $409124218b1e663f$var$ti,
    useReducer: $409124218b1e663f$var$Wh,
    useRef: $409124218b1e663f$var$ji,
    useState: function() {
        return $409124218b1e663f$var$Wh($409124218b1e663f$var$Vh);
    },
    useDebugValue: $409124218b1e663f$var$ri,
    useDeferredValue: function(a) {
        var b = $409124218b1e663f$var$Uh();
        return $409124218b1e663f$var$ui(b, $409124218b1e663f$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $409124218b1e663f$var$Wh($409124218b1e663f$var$Vh)[0], b = $409124218b1e663f$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $409124218b1e663f$var$Yh,
    useSyncExternalStore: $409124218b1e663f$var$Zh,
    useId: $409124218b1e663f$var$wi,
    unstable_isNewReconciler: !1
}, $409124218b1e663f$var$Qh = {
    readContext: $409124218b1e663f$var$eh,
    useCallback: $409124218b1e663f$var$si,
    useContext: $409124218b1e663f$var$eh,
    useEffect: $409124218b1e663f$var$$h,
    useImperativeHandle: $409124218b1e663f$var$qi,
    useInsertionEffect: $409124218b1e663f$var$ni,
    useLayoutEffect: $409124218b1e663f$var$oi,
    useMemo: $409124218b1e663f$var$ti,
    useReducer: $409124218b1e663f$var$Xh,
    useRef: $409124218b1e663f$var$ji,
    useState: function() {
        return $409124218b1e663f$var$Xh($409124218b1e663f$var$Vh);
    },
    useDebugValue: $409124218b1e663f$var$ri,
    useDeferredValue: function(a) {
        var b = $409124218b1e663f$var$Uh();
        return null === $409124218b1e663f$var$N ? b.memoizedState = a : $409124218b1e663f$var$ui(b, $409124218b1e663f$var$N.memoizedState, a);
    },
    useTransition: function() {
        var a = $409124218b1e663f$var$Xh($409124218b1e663f$var$Vh)[0], b = $409124218b1e663f$var$Uh().memoizedState;
        return [
            a,
            b
        ];
    },
    useMutableSource: $409124218b1e663f$var$Yh,
    useSyncExternalStore: $409124218b1e663f$var$Zh,
    useId: $409124218b1e663f$var$wi,
    unstable_isNewReconciler: !1
};
function $409124218b1e663f$var$Ci(a, b) {
    if (a && a.defaultProps) {
        b = $409124218b1e663f$var$A({}, b);
        a = a.defaultProps;
        for(var c in a)void 0 === b[c] && (b[c] = a[c]);
        return b;
    }
    return b;
}
function $409124218b1e663f$var$Di(a, b, c, d) {
    b = a.memoizedState;
    c = c(d, b);
    c = null === c || void 0 === c ? b : $409124218b1e663f$var$A({}, b, c);
    a.memoizedState = c;
    0 === a.lanes && (a.updateQueue.baseState = c);
}
var $409124218b1e663f$var$Ei = {
    isMounted: function(a) {
        return (a = a._reactInternals) ? $409124218b1e663f$var$Vb(a) === a : !1;
    },
    enqueueSetState: function(a, b, c) {
        a = a._reactInternals;
        var d = $409124218b1e663f$var$R(), e = $409124218b1e663f$var$yi(a), f = $409124218b1e663f$var$mh(d, e);
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $409124218b1e663f$var$nh(a, f, e);
        null !== b && ($409124218b1e663f$var$gi(b, a, e, d), $409124218b1e663f$var$oh(b, a, e));
    },
    enqueueReplaceState: function(a, b, c) {
        a = a._reactInternals;
        var d = $409124218b1e663f$var$R(), e = $409124218b1e663f$var$yi(a), f = $409124218b1e663f$var$mh(d, e);
        f.tag = 1;
        f.payload = b;
        void 0 !== c && null !== c && (f.callback = c);
        b = $409124218b1e663f$var$nh(a, f, e);
        null !== b && ($409124218b1e663f$var$gi(b, a, e, d), $409124218b1e663f$var$oh(b, a, e));
    },
    enqueueForceUpdate: function(a, b) {
        a = a._reactInternals;
        var c = $409124218b1e663f$var$R(), d = $409124218b1e663f$var$yi(a), e = $409124218b1e663f$var$mh(c, d);
        e.tag = 2;
        void 0 !== b && null !== b && (e.callback = b);
        b = $409124218b1e663f$var$nh(a, e, d);
        null !== b && ($409124218b1e663f$var$gi(b, a, d, c), $409124218b1e663f$var$oh(b, a, d));
    }
};
function $409124218b1e663f$var$Fi(a, b, c, d, e, f, g) {
    a = a.stateNode;
    return "function" === typeof a.shouldComponentUpdate ? a.shouldComponentUpdate(d, f, g) : b.prototype && b.prototype.isPureReactComponent ? !$409124218b1e663f$var$Ie(c, d) || !$409124218b1e663f$var$Ie(e, f) : !0;
}
function $409124218b1e663f$var$Gi(a, b, c) {
    var d = !1, e = $409124218b1e663f$var$Vf;
    var f = b.contextType;
    "object" === typeof f && null !== f ? f = $409124218b1e663f$var$eh(f) : (e = $409124218b1e663f$var$Zf(b) ? $409124218b1e663f$var$Xf : $409124218b1e663f$var$H.current, d = b.contextTypes, f = (d = null !== d && void 0 !== d) ? $409124218b1e663f$var$Yf(a, e) : $409124218b1e663f$var$Vf);
    b = new b(c, f);
    a.memoizedState = null !== b.state && void 0 !== b.state ? b.state : null;
    b.updater = $409124218b1e663f$var$Ei;
    a.stateNode = b;
    b._reactInternals = a;
    d && (a = a.stateNode, a.__reactInternalMemoizedUnmaskedChildContext = e, a.__reactInternalMemoizedMaskedChildContext = f);
    return b;
}
function $409124218b1e663f$var$Hi(a, b, c, d) {
    a = b.state;
    "function" === typeof b.componentWillReceiveProps && b.componentWillReceiveProps(c, d);
    "function" === typeof b.UNSAFE_componentWillReceiveProps && b.UNSAFE_componentWillReceiveProps(c, d);
    b.state !== a && $409124218b1e663f$var$Ei.enqueueReplaceState(b, b.state, null);
}
function $409124218b1e663f$var$Ii(a, b, c, d) {
    var e = a.stateNode;
    e.props = c;
    e.state = a.memoizedState;
    e.refs = {};
    $409124218b1e663f$var$kh(a);
    var f = b.contextType;
    "object" === typeof f && null !== f ? e.context = $409124218b1e663f$var$eh(f) : (f = $409124218b1e663f$var$Zf(b) ? $409124218b1e663f$var$Xf : $409124218b1e663f$var$H.current, e.context = $409124218b1e663f$var$Yf(a, f));
    e.state = a.memoizedState;
    f = b.getDerivedStateFromProps;
    "function" === typeof f && ($409124218b1e663f$var$Di(a, b, f, c), e.state = a.memoizedState);
    "function" === typeof b.getDerivedStateFromProps || "function" === typeof e.getSnapshotBeforeUpdate || "function" !== typeof e.UNSAFE_componentWillMount && "function" !== typeof e.componentWillMount || (b = e.state, "function" === typeof e.componentWillMount && e.componentWillMount(), "function" === typeof e.UNSAFE_componentWillMount && e.UNSAFE_componentWillMount(), b !== e.state && $409124218b1e663f$var$Ei.enqueueReplaceState(e, e.state, null), $409124218b1e663f$var$qh(a, c, e, d), e.state = a.memoizedState);
    "function" === typeof e.componentDidMount && (a.flags |= 4194308);
}
function $409124218b1e663f$var$Ji(a, b) {
    try {
        var c = "", d = b;
        do c += $409124218b1e663f$var$Pa(d), d = d.return;
        while (d);
        var e = c;
    } catch (f) {
        e = "\nError generating stack: " + f.message + "\n" + f.stack;
    }
    return {
        value: a,
        source: b,
        stack: e,
        digest: null
    };
}
function $409124218b1e663f$var$Ki(a, b, c) {
    return {
        value: a,
        source: null,
        stack: null != c ? c : null,
        digest: null != b ? b : null
    };
}
function $409124218b1e663f$var$Li(a, b) {
    try {
        console.error(b.value);
    } catch (c) {
        setTimeout(function() {
            throw c;
        });
    }
}
var $409124218b1e663f$var$Mi = "function" === typeof WeakMap ? WeakMap : Map;
function $409124218b1e663f$var$Ni(a, b, c) {
    c = $409124218b1e663f$var$mh(-1, c);
    c.tag = 3;
    c.payload = {
        element: null
    };
    var d = b.value;
    c.callback = function() {
        $409124218b1e663f$var$Oi || ($409124218b1e663f$var$Oi = !0, $409124218b1e663f$var$Pi = d);
        $409124218b1e663f$var$Li(a, b);
    };
    return c;
}
function $409124218b1e663f$var$Qi(a, b, c) {
    c = $409124218b1e663f$var$mh(-1, c);
    c.tag = 3;
    var d = a.type.getDerivedStateFromError;
    if ("function" === typeof d) {
        var e = b.value;
        c.payload = function() {
            return d(e);
        };
        c.callback = function() {
            $409124218b1e663f$var$Li(a, b);
        };
    }
    var f = a.stateNode;
    null !== f && "function" === typeof f.componentDidCatch && (c.callback = function() {
        $409124218b1e663f$var$Li(a, b);
        "function" !== typeof d && (null === $409124218b1e663f$var$Ri ? $409124218b1e663f$var$Ri = new Set([
            this
        ]) : $409124218b1e663f$var$Ri.add(this));
        var c = b.stack;
        this.componentDidCatch(b.value, {
            componentStack: null !== c ? c : ""
        });
    });
    return c;
}
function $409124218b1e663f$var$Si(a, b, c) {
    var d = a.pingCache;
    if (null === d) {
        d = a.pingCache = new $409124218b1e663f$var$Mi;
        var e = new Set;
        d.set(b, e);
    } else e = d.get(b), void 0 === e && (e = new Set, d.set(b, e));
    e.has(c) || (e.add(c), a = $409124218b1e663f$var$Ti.bind(null, a, b, c), b.then(a, a));
}
function $409124218b1e663f$var$Ui(a) {
    do {
        var b;
        if (b = 13 === a.tag) b = a.memoizedState, b = null !== b ? null !== b.dehydrated ? !0 : !1 : !0;
        if (b) return a;
        a = a.return;
    }while (null !== a);
    return null;
}
function $409124218b1e663f$var$Vi(a, b, c, d, e) {
    if (0 === (a.mode & 1)) return a === b ? a.flags |= 65536 : (a.flags |= 128, c.flags |= 131072, c.flags &= -52805, 1 === c.tag && (null === c.alternate ? c.tag = 17 : (b = $409124218b1e663f$var$mh(-1, 1), b.tag = 2, $409124218b1e663f$var$nh(c, b, 1))), c.lanes |= 1), a;
    a.flags |= 65536;
    a.lanes = e;
    return a;
}
var $409124218b1e663f$var$Wi = $409124218b1e663f$var$ua.ReactCurrentOwner, $409124218b1e663f$var$dh = !1;
function $409124218b1e663f$var$Xi(a, b, c, d) {
    b.child = null === a ? $409124218b1e663f$var$Vg(b, null, c, d) : $409124218b1e663f$var$Ug(b, a.child, c, d);
}
function $409124218b1e663f$var$Yi(a, b, c, d, e) {
    c = c.render;
    var f = b.ref;
    $409124218b1e663f$var$ch(b, e);
    d = $409124218b1e663f$var$Nh(a, b, c, d, f, e);
    c = $409124218b1e663f$var$Sh();
    if (null !== a && !$409124218b1e663f$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $409124218b1e663f$var$Zi(a, b, e);
    $409124218b1e663f$var$I && c && $409124218b1e663f$var$vg(b);
    b.flags |= 1;
    $409124218b1e663f$var$Xi(a, b, d, e);
    return b.child;
}
function $409124218b1e663f$var$$i(a, b, c, d, e) {
    if (null === a) {
        var f = c.type;
        if ("function" === typeof f && !$409124218b1e663f$var$aj(f) && void 0 === f.defaultProps && null === c.compare && void 0 === c.defaultProps) return b.tag = 15, b.type = f, $409124218b1e663f$var$bj(a, b, f, d, e);
        a = $409124218b1e663f$var$Rg(c.type, null, d, b, b.mode, e);
        a.ref = b.ref;
        a.return = b;
        return b.child = a;
    }
    f = a.child;
    if (0 === (a.lanes & e)) {
        var g = f.memoizedProps;
        c = c.compare;
        c = null !== c ? c : $409124218b1e663f$var$Ie;
        if (c(g, d) && a.ref === b.ref) return $409124218b1e663f$var$Zi(a, b, e);
    }
    b.flags |= 1;
    a = $409124218b1e663f$var$Pg(f, d);
    a.ref = b.ref;
    a.return = b;
    return b.child = a;
}
function $409124218b1e663f$var$bj(a, b, c, d, e) {
    if (null !== a) {
        var f = a.memoizedProps;
        if ($409124218b1e663f$var$Ie(f, d) && a.ref === b.ref) {
            if ($409124218b1e663f$var$dh = !1, b.pendingProps = d = f, 0 !== (a.lanes & e)) 0 !== (a.flags & 131072) && ($409124218b1e663f$var$dh = !0);
            else return b.lanes = a.lanes, $409124218b1e663f$var$Zi(a, b, e);
        }
    }
    return $409124218b1e663f$var$cj(a, b, c, d, e);
}
function $409124218b1e663f$var$dj(a, b, c) {
    var d = b.pendingProps, e = d.children, f = null !== a ? a.memoizedState : null;
    if ("hidden" === d.mode) {
        if (0 === (b.mode & 1)) b.memoizedState = {
            baseLanes: 0,
            cachePool: null,
            transitions: null
        }, $409124218b1e663f$var$G($409124218b1e663f$var$ej, $409124218b1e663f$var$fj), $409124218b1e663f$var$fj |= c;
        else {
            if (0 === (c & 1073741824)) return a = null !== f ? f.baseLanes | c : c, b.lanes = b.childLanes = 1073741824, b.memoizedState = {
                baseLanes: a,
                cachePool: null,
                transitions: null
            }, b.updateQueue = null, $409124218b1e663f$var$G($409124218b1e663f$var$ej, $409124218b1e663f$var$fj), $409124218b1e663f$var$fj |= a, null;
            b.memoizedState = {
                baseLanes: 0,
                cachePool: null,
                transitions: null
            };
            d = null !== f ? f.baseLanes : c;
            $409124218b1e663f$var$G($409124218b1e663f$var$ej, $409124218b1e663f$var$fj);
            $409124218b1e663f$var$fj |= d;
        }
    } else null !== f ? (d = f.baseLanes | c, b.memoizedState = null) : d = c, $409124218b1e663f$var$G($409124218b1e663f$var$ej, $409124218b1e663f$var$fj), $409124218b1e663f$var$fj |= d;
    $409124218b1e663f$var$Xi(a, b, e, c);
    return b.child;
}
function $409124218b1e663f$var$gj(a, b) {
    var c = b.ref;
    if (null === a && null !== c || null !== a && a.ref !== c) b.flags |= 512, b.flags |= 2097152;
}
function $409124218b1e663f$var$cj(a, b, c, d, e) {
    var f = $409124218b1e663f$var$Zf(c) ? $409124218b1e663f$var$Xf : $409124218b1e663f$var$H.current;
    f = $409124218b1e663f$var$Yf(b, f);
    $409124218b1e663f$var$ch(b, e);
    c = $409124218b1e663f$var$Nh(a, b, c, d, f, e);
    d = $409124218b1e663f$var$Sh();
    if (null !== a && !$409124218b1e663f$var$dh) return b.updateQueue = a.updateQueue, b.flags &= -2053, a.lanes &= ~e, $409124218b1e663f$var$Zi(a, b, e);
    $409124218b1e663f$var$I && d && $409124218b1e663f$var$vg(b);
    b.flags |= 1;
    $409124218b1e663f$var$Xi(a, b, c, e);
    return b.child;
}
function $409124218b1e663f$var$hj(a, b, c, d, e) {
    if ($409124218b1e663f$var$Zf(c)) {
        var f = !0;
        $409124218b1e663f$var$cg(b);
    } else f = !1;
    $409124218b1e663f$var$ch(b, e);
    if (null === b.stateNode) $409124218b1e663f$var$ij(a, b), $409124218b1e663f$var$Gi(b, c, d), $409124218b1e663f$var$Ii(b, c, d, e), d = !0;
    else if (null === a) {
        var g = b.stateNode, h = b.memoizedProps;
        g.props = h;
        var k = g.context, l = c.contextType;
        "object" === typeof l && null !== l ? l = $409124218b1e663f$var$eh(l) : (l = $409124218b1e663f$var$Zf(c) ? $409124218b1e663f$var$Xf : $409124218b1e663f$var$H.current, l = $409124218b1e663f$var$Yf(b, l));
        var m = c.getDerivedStateFromProps, q = "function" === typeof m || "function" === typeof g.getSnapshotBeforeUpdate;
        q || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== d || k !== l) && $409124218b1e663f$var$Hi(b, g, d, l);
        $409124218b1e663f$var$jh = !1;
        var r = b.memoizedState;
        g.state = r;
        $409124218b1e663f$var$qh(b, d, g, e);
        k = b.memoizedState;
        h !== d || r !== k || $409124218b1e663f$var$Wf.current || $409124218b1e663f$var$jh ? ("function" === typeof m && ($409124218b1e663f$var$Di(b, c, m, d), k = b.memoizedState), (h = $409124218b1e663f$var$jh || $409124218b1e663f$var$Fi(b, c, h, d, r, k, l)) ? (q || "function" !== typeof g.UNSAFE_componentWillMount && "function" !== typeof g.componentWillMount || ("function" === typeof g.componentWillMount && g.componentWillMount(), "function" === typeof g.UNSAFE_componentWillMount && g.UNSAFE_componentWillMount()), "function" === typeof g.componentDidMount && (b.flags |= 4194308)) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), b.memoizedProps = d, b.memoizedState = k), g.props = d, g.state = k, g.context = l, d = h) : ("function" === typeof g.componentDidMount && (b.flags |= 4194308), d = !1);
    } else {
        g = b.stateNode;
        $409124218b1e663f$var$lh(a, b);
        h = b.memoizedProps;
        l = b.type === b.elementType ? h : $409124218b1e663f$var$Ci(b.type, h);
        g.props = l;
        q = b.pendingProps;
        r = g.context;
        k = c.contextType;
        "object" === typeof k && null !== k ? k = $409124218b1e663f$var$eh(k) : (k = $409124218b1e663f$var$Zf(c) ? $409124218b1e663f$var$Xf : $409124218b1e663f$var$H.current, k = $409124218b1e663f$var$Yf(b, k));
        var y = c.getDerivedStateFromProps;
        (m = "function" === typeof y || "function" === typeof g.getSnapshotBeforeUpdate) || "function" !== typeof g.UNSAFE_componentWillReceiveProps && "function" !== typeof g.componentWillReceiveProps || (h !== q || r !== k) && $409124218b1e663f$var$Hi(b, g, d, k);
        $409124218b1e663f$var$jh = !1;
        r = b.memoizedState;
        g.state = r;
        $409124218b1e663f$var$qh(b, d, g, e);
        var n = b.memoizedState;
        h !== q || r !== n || $409124218b1e663f$var$Wf.current || $409124218b1e663f$var$jh ? ("function" === typeof y && ($409124218b1e663f$var$Di(b, c, y, d), n = b.memoizedState), (l = $409124218b1e663f$var$jh || $409124218b1e663f$var$Fi(b, c, l, d, r, n, k) || !1) ? (m || "function" !== typeof g.UNSAFE_componentWillUpdate && "function" !== typeof g.componentWillUpdate || ("function" === typeof g.componentWillUpdate && g.componentWillUpdate(d, n, k), "function" === typeof g.UNSAFE_componentWillUpdate && g.UNSAFE_componentWillUpdate(d, n, k)), "function" === typeof g.componentDidUpdate && (b.flags |= 4), "function" === typeof g.getSnapshotBeforeUpdate && (b.flags |= 1024)) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), b.memoizedProps = d, b.memoizedState = n), g.props = d, g.state = n, g.context = k, d = l) : ("function" !== typeof g.componentDidUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 4), "function" !== typeof g.getSnapshotBeforeUpdate || h === a.memoizedProps && r === a.memoizedState || (b.flags |= 1024), d = !1);
    }
    return $409124218b1e663f$var$jj(a, b, c, d, f, e);
}
function $409124218b1e663f$var$jj(a, b, c, d, e, f) {
    $409124218b1e663f$var$gj(a, b);
    var g = 0 !== (b.flags & 128);
    if (!d && !g) return e && $409124218b1e663f$var$dg(b, c, !1), $409124218b1e663f$var$Zi(a, b, f);
    d = b.stateNode;
    $409124218b1e663f$var$Wi.current = b;
    var h = g && "function" !== typeof c.getDerivedStateFromError ? null : d.render();
    b.flags |= 1;
    null !== a && g ? (b.child = $409124218b1e663f$var$Ug(b, a.child, null, f), b.child = $409124218b1e663f$var$Ug(b, null, h, f)) : $409124218b1e663f$var$Xi(a, b, h, f);
    b.memoizedState = d.state;
    e && $409124218b1e663f$var$dg(b, c, !0);
    return b.child;
}
function $409124218b1e663f$var$kj(a) {
    var b = a.stateNode;
    b.pendingContext ? $409124218b1e663f$var$ag(a, b.pendingContext, b.pendingContext !== b.context) : b.context && $409124218b1e663f$var$ag(a, b.context, !1);
    $409124218b1e663f$var$yh(a, b.containerInfo);
}
function $409124218b1e663f$var$lj(a, b, c, d, e) {
    $409124218b1e663f$var$Ig();
    $409124218b1e663f$var$Jg(e);
    b.flags |= 256;
    $409124218b1e663f$var$Xi(a, b, c, d);
    return b.child;
}
var $409124218b1e663f$var$mj = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0
};
function $409124218b1e663f$var$nj(a) {
    return {
        baseLanes: a,
        cachePool: null,
        transitions: null
    };
}
function $409124218b1e663f$var$oj(a, b, c) {
    var d = b.pendingProps, e = $409124218b1e663f$var$L.current, f = !1, g = 0 !== (b.flags & 128), h;
    (h = g) || (h = null !== a && null === a.memoizedState ? !1 : 0 !== (e & 2));
    if (h) f = !0, b.flags &= -129;
    else if (null === a || null !== a.memoizedState) e |= 1;
    $409124218b1e663f$var$G($409124218b1e663f$var$L, e & 1);
    if (null === a) {
        $409124218b1e663f$var$Eg(b);
        a = b.memoizedState;
        if (null !== a && (a = a.dehydrated, null !== a)) return 0 === (b.mode & 1) ? b.lanes = 1 : "$!" === a.data ? b.lanes = 8 : b.lanes = 1073741824, null;
        g = d.children;
        a = d.fallback;
        return f ? (d = b.mode, f = b.child, g = {
            mode: "hidden",
            children: g
        }, 0 === (d & 1) && null !== f ? (f.childLanes = 0, f.pendingProps = g) : f = $409124218b1e663f$var$pj(g, d, 0, null), a = $409124218b1e663f$var$Tg(a, d, c, null), f.return = b, a.return = b, f.sibling = a, b.child = f, b.child.memoizedState = $409124218b1e663f$var$nj(c), b.memoizedState = $409124218b1e663f$var$mj, a) : $409124218b1e663f$var$qj(b, g);
    }
    e = a.memoizedState;
    if (null !== e && (h = e.dehydrated, null !== h)) return $409124218b1e663f$var$rj(a, b, g, d, h, e, c);
    if (f) {
        f = d.fallback;
        g = b.mode;
        e = a.child;
        h = e.sibling;
        var k = {
            mode: "hidden",
            children: d.children
        };
        0 === (g & 1) && b.child !== e ? (d = b.child, d.childLanes = 0, d.pendingProps = k, b.deletions = null) : (d = $409124218b1e663f$var$Pg(e, k), d.subtreeFlags = e.subtreeFlags & 14680064);
        null !== h ? f = $409124218b1e663f$var$Pg(h, f) : (f = $409124218b1e663f$var$Tg(f, g, c, null), f.flags |= 2);
        f.return = b;
        d.return = b;
        d.sibling = f;
        b.child = d;
        d = f;
        f = b.child;
        g = a.child.memoizedState;
        g = null === g ? $409124218b1e663f$var$nj(c) : {
            baseLanes: g.baseLanes | c,
            cachePool: null,
            transitions: g.transitions
        };
        f.memoizedState = g;
        f.childLanes = a.childLanes & ~c;
        b.memoizedState = $409124218b1e663f$var$mj;
        return d;
    }
    f = a.child;
    a = f.sibling;
    d = $409124218b1e663f$var$Pg(f, {
        mode: "visible",
        children: d.children
    });
    0 === (b.mode & 1) && (d.lanes = c);
    d.return = b;
    d.sibling = null;
    null !== a && (c = b.deletions, null === c ? (b.deletions = [
        a
    ], b.flags |= 16) : c.push(a));
    b.child = d;
    b.memoizedState = null;
    return d;
}
function $409124218b1e663f$var$qj(a, b) {
    b = $409124218b1e663f$var$pj({
        mode: "visible",
        children: b
    }, a.mode, 0, null);
    b.return = a;
    return a.child = b;
}
function $409124218b1e663f$var$sj(a, b, c, d) {
    null !== d && $409124218b1e663f$var$Jg(d);
    $409124218b1e663f$var$Ug(b, a.child, null, c);
    a = $409124218b1e663f$var$qj(b, b.pendingProps.children);
    a.flags |= 2;
    b.memoizedState = null;
    return a;
}
function $409124218b1e663f$var$rj(a, b, c, d, e, f, g) {
    if (c) {
        if (b.flags & 256) return b.flags &= -257, d = $409124218b1e663f$var$Ki(Error($409124218b1e663f$var$p(422))), $409124218b1e663f$var$sj(a, b, g, d);
        if (null !== b.memoizedState) return b.child = a.child, b.flags |= 128, null;
        f = d.fallback;
        e = b.mode;
        d = $409124218b1e663f$var$pj({
            mode: "visible",
            children: d.children
        }, e, 0, null);
        f = $409124218b1e663f$var$Tg(f, e, g, null);
        f.flags |= 2;
        d.return = b;
        f.return = b;
        d.sibling = f;
        b.child = d;
        0 !== (b.mode & 1) && $409124218b1e663f$var$Ug(b, a.child, null, g);
        b.child.memoizedState = $409124218b1e663f$var$nj(g);
        b.memoizedState = $409124218b1e663f$var$mj;
        return f;
    }
    if (0 === (b.mode & 1)) return $409124218b1e663f$var$sj(a, b, g, null);
    if ("$!" === e.data) {
        d = e.nextSibling && e.nextSibling.dataset;
        if (d) var h = d.dgst;
        d = h;
        f = Error($409124218b1e663f$var$p(419));
        d = $409124218b1e663f$var$Ki(f, d, void 0);
        return $409124218b1e663f$var$sj(a, b, g, d);
    }
    h = 0 !== (g & a.childLanes);
    if ($409124218b1e663f$var$dh || h) {
        d = $409124218b1e663f$var$Q;
        if (null !== d) {
            switch(g & -g){
                case 4:
                    e = 2;
                    break;
                case 16:
                    e = 8;
                    break;
                case 64:
                case 128:
                case 256:
                case 512:
                case 1024:
                case 2048:
                case 4096:
                case 8192:
                case 16384:
                case 32768:
                case 65536:
                case 131072:
                case 262144:
                case 524288:
                case 1048576:
                case 2097152:
                case 4194304:
                case 8388608:
                case 16777216:
                case 33554432:
                case 67108864:
                    e = 32;
                    break;
                case 536870912:
                    e = 268435456;
                    break;
                default:
                    e = 0;
            }
            e = 0 !== (e & (d.suspendedLanes | g)) ? 0 : e;
            0 !== e && e !== f.retryLane && (f.retryLane = e, $409124218b1e663f$var$ih(a, e), $409124218b1e663f$var$gi(d, a, e, -1));
        }
        $409124218b1e663f$var$tj();
        d = $409124218b1e663f$var$Ki(Error($409124218b1e663f$var$p(421)));
        return $409124218b1e663f$var$sj(a, b, g, d);
    }
    if ("$?" === e.data) return b.flags |= 128, b.child = a.child, b = $409124218b1e663f$var$uj.bind(null, a), e._reactRetry = b, null;
    a = f.treeContext;
    $409124218b1e663f$var$yg = $409124218b1e663f$var$Lf(e.nextSibling);
    $409124218b1e663f$var$xg = b;
    $409124218b1e663f$var$I = !0;
    $409124218b1e663f$var$zg = null;
    null !== a && ($409124218b1e663f$var$og[$409124218b1e663f$var$pg++] = $409124218b1e663f$var$rg, $409124218b1e663f$var$og[$409124218b1e663f$var$pg++] = $409124218b1e663f$var$sg, $409124218b1e663f$var$og[$409124218b1e663f$var$pg++] = $409124218b1e663f$var$qg, $409124218b1e663f$var$rg = a.id, $409124218b1e663f$var$sg = a.overflow, $409124218b1e663f$var$qg = b);
    b = $409124218b1e663f$var$qj(b, d.children);
    b.flags |= 4096;
    return b;
}
function $409124218b1e663f$var$vj(a, b, c) {
    a.lanes |= b;
    var d = a.alternate;
    null !== d && (d.lanes |= b);
    $409124218b1e663f$var$bh(a.return, b, c);
}
function $409124218b1e663f$var$wj(a, b, c, d, e) {
    var f = a.memoizedState;
    null === f ? a.memoizedState = {
        isBackwards: b,
        rendering: null,
        renderingStartTime: 0,
        last: d,
        tail: c,
        tailMode: e
    } : (f.isBackwards = b, f.rendering = null, f.renderingStartTime = 0, f.last = d, f.tail = c, f.tailMode = e);
}
function $409124218b1e663f$var$xj(a, b, c) {
    var d = b.pendingProps, e = d.revealOrder, f = d.tail;
    $409124218b1e663f$var$Xi(a, b, d.children, c);
    d = $409124218b1e663f$var$L.current;
    if (0 !== (d & 2)) d = d & 1 | 2, b.flags |= 128;
    else {
        if (null !== a && 0 !== (a.flags & 128)) a: for(a = b.child; null !== a;){
            if (13 === a.tag) null !== a.memoizedState && $409124218b1e663f$var$vj(a, c, b);
            else if (19 === a.tag) $409124218b1e663f$var$vj(a, c, b);
            else if (null !== a.child) {
                a.child.return = a;
                a = a.child;
                continue;
            }
            if (a === b) break a;
            for(; null === a.sibling;){
                if (null === a.return || a.return === b) break a;
                a = a.return;
            }
            a.sibling.return = a.return;
            a = a.sibling;
        }
        d &= 1;
    }
    $409124218b1e663f$var$G($409124218b1e663f$var$L, d);
    if (0 === (b.mode & 1)) b.memoizedState = null;
    else switch(e){
        case "forwards":
            c = b.child;
            for(e = null; null !== c;)a = c.alternate, null !== a && null === $409124218b1e663f$var$Ch(a) && (e = c), c = c.sibling;
            c = e;
            null === c ? (e = b.child, b.child = null) : (e = c.sibling, c.sibling = null);
            $409124218b1e663f$var$wj(b, !1, e, c, f);
            break;
        case "backwards":
            c = null;
            e = b.child;
            for(b.child = null; null !== e;){
                a = e.alternate;
                if (null !== a && null === $409124218b1e663f$var$Ch(a)) {
                    b.child = e;
                    break;
                }
                a = e.sibling;
                e.sibling = c;
                c = e;
                e = a;
            }
            $409124218b1e663f$var$wj(b, !0, c, null, f);
            break;
        case "together":
            $409124218b1e663f$var$wj(b, !1, null, null, void 0);
            break;
        default:
            b.memoizedState = null;
    }
    return b.child;
}
function $409124218b1e663f$var$ij(a, b) {
    0 === (b.mode & 1) && null !== a && (a.alternate = null, b.alternate = null, b.flags |= 2);
}
function $409124218b1e663f$var$Zi(a, b, c) {
    null !== a && (b.dependencies = a.dependencies);
    $409124218b1e663f$var$rh |= b.lanes;
    if (0 === (c & b.childLanes)) return null;
    if (null !== a && b.child !== a.child) throw Error($409124218b1e663f$var$p(153));
    if (null !== b.child) {
        a = b.child;
        c = $409124218b1e663f$var$Pg(a, a.pendingProps);
        b.child = c;
        for(c.return = b; null !== a.sibling;)a = a.sibling, c = c.sibling = $409124218b1e663f$var$Pg(a, a.pendingProps), c.return = b;
        c.sibling = null;
    }
    return b.child;
}
function $409124218b1e663f$var$yj(a, b, c) {
    switch(b.tag){
        case 3:
            $409124218b1e663f$var$kj(b);
            $409124218b1e663f$var$Ig();
            break;
        case 5:
            $409124218b1e663f$var$Ah(b);
            break;
        case 1:
            $409124218b1e663f$var$Zf(b.type) && $409124218b1e663f$var$cg(b);
            break;
        case 4:
            $409124218b1e663f$var$yh(b, b.stateNode.containerInfo);
            break;
        case 10:
            var d = b.type._context, e = b.memoizedProps.value;
            $409124218b1e663f$var$G($409124218b1e663f$var$Wg, d._currentValue);
            d._currentValue = e;
            break;
        case 13:
            d = b.memoizedState;
            if (null !== d) {
                if (null !== d.dehydrated) return $409124218b1e663f$var$G($409124218b1e663f$var$L, $409124218b1e663f$var$L.current & 1), b.flags |= 128, null;
                if (0 !== (c & b.child.childLanes)) return $409124218b1e663f$var$oj(a, b, c);
                $409124218b1e663f$var$G($409124218b1e663f$var$L, $409124218b1e663f$var$L.current & 1);
                a = $409124218b1e663f$var$Zi(a, b, c);
                return null !== a ? a.sibling : null;
            }
            $409124218b1e663f$var$G($409124218b1e663f$var$L, $409124218b1e663f$var$L.current & 1);
            break;
        case 19:
            d = 0 !== (c & b.childLanes);
            if (0 !== (a.flags & 128)) {
                if (d) return $409124218b1e663f$var$xj(a, b, c);
                b.flags |= 128;
            }
            e = b.memoizedState;
            null !== e && (e.rendering = null, e.tail = null, e.lastEffect = null);
            $409124218b1e663f$var$G($409124218b1e663f$var$L, $409124218b1e663f$var$L.current);
            if (d) break;
            else return null;
        case 22:
        case 23:
            return b.lanes = 0, $409124218b1e663f$var$dj(a, b, c);
    }
    return $409124218b1e663f$var$Zi(a, b, c);
}
var $409124218b1e663f$var$zj, $409124218b1e663f$var$Aj, $409124218b1e663f$var$Bj, $409124218b1e663f$var$Cj;
$409124218b1e663f$var$zj = function(a, b) {
    for(var c = b.child; null !== c;){
        if (5 === c.tag || 6 === c.tag) a.appendChild(c.stateNode);
        else if (4 !== c.tag && null !== c.child) {
            c.child.return = c;
            c = c.child;
            continue;
        }
        if (c === b) break;
        for(; null === c.sibling;){
            if (null === c.return || c.return === b) return;
            c = c.return;
        }
        c.sibling.return = c.return;
        c = c.sibling;
    }
};
$409124218b1e663f$var$Aj = function() {};
$409124218b1e663f$var$Bj = function(a, b, c, d) {
    var e = a.memoizedProps;
    if (e !== d) {
        a = b.stateNode;
        $409124218b1e663f$var$xh($409124218b1e663f$var$uh.current);
        var f = null;
        switch(c){
            case "input":
                e = $409124218b1e663f$var$Ya(a, e);
                d = $409124218b1e663f$var$Ya(a, d);
                f = [];
                break;
            case "select":
                e = $409124218b1e663f$var$A({}, e, {
                    value: void 0
                });
                d = $409124218b1e663f$var$A({}, d, {
                    value: void 0
                });
                f = [];
                break;
            case "textarea":
                e = $409124218b1e663f$var$gb(a, e);
                d = $409124218b1e663f$var$gb(a, d);
                f = [];
                break;
            default:
                "function" !== typeof e.onClick && "function" === typeof d.onClick && (a.onclick = $409124218b1e663f$var$Bf);
        }
        $409124218b1e663f$var$ub(c, d);
        var g;
        c = null;
        for(l in e)if (!d.hasOwnProperty(l) && e.hasOwnProperty(l) && null != e[l]) {
            if ("style" === l) {
                var h = e[l];
                for(g in h)h.hasOwnProperty(g) && (c || (c = {}), c[g] = "");
            } else "dangerouslySetInnerHTML" !== l && "children" !== l && "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && "autoFocus" !== l && ($409124218b1e663f$var$ea.hasOwnProperty(l) ? f || (f = []) : (f = f || []).push(l, null));
        }
        for(l in d){
            var k = d[l];
            h = null != e ? e[l] : void 0;
            if (d.hasOwnProperty(l) && k !== h && (null != k || null != h)) {
                if ("style" === l) {
                    if (h) {
                        for(g in h)!h.hasOwnProperty(g) || k && k.hasOwnProperty(g) || (c || (c = {}), c[g] = "");
                        for(g in k)k.hasOwnProperty(g) && h[g] !== k[g] && (c || (c = {}), c[g] = k[g]);
                    } else c || (f || (f = []), f.push(l, c)), c = k;
                } else "dangerouslySetInnerHTML" === l ? (k = k ? k.__html : void 0, h = h ? h.__html : void 0, null != k && h !== k && (f = f || []).push(l, k)) : "children" === l ? "string" !== typeof k && "number" !== typeof k || (f = f || []).push(l, "" + k) : "suppressContentEditableWarning" !== l && "suppressHydrationWarning" !== l && ($409124218b1e663f$var$ea.hasOwnProperty(l) ? (null != k && "onScroll" === l && $409124218b1e663f$var$D("scroll", a), f || h === k || (f = [])) : (f = f || []).push(l, k));
            }
        }
        c && (f = f || []).push("style", c);
        var l = f;
        if (b.updateQueue = l) b.flags |= 4;
    }
};
$409124218b1e663f$var$Cj = function(a, b, c, d) {
    c !== d && (b.flags |= 4);
};
function $409124218b1e663f$var$Dj(a, b) {
    if (!$409124218b1e663f$var$I) switch(a.tailMode){
        case "hidden":
            b = a.tail;
            for(var c = null; null !== b;)null !== b.alternate && (c = b), b = b.sibling;
            null === c ? a.tail = null : c.sibling = null;
            break;
        case "collapsed":
            c = a.tail;
            for(var d = null; null !== c;)null !== c.alternate && (d = c), c = c.sibling;
            null === d ? b || null === a.tail ? a.tail = null : a.tail.sibling = null : d.sibling = null;
    }
}
function $409124218b1e663f$var$S(a) {
    var b = null !== a.alternate && a.alternate.child === a.child, c = 0, d = 0;
    if (b) for(var e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags & 14680064, d |= e.flags & 14680064, e.return = a, e = e.sibling;
    else for(e = a.child; null !== e;)c |= e.lanes | e.childLanes, d |= e.subtreeFlags, d |= e.flags, e.return = a, e = e.sibling;
    a.subtreeFlags |= d;
    a.childLanes = c;
    return b;
}
function $409124218b1e663f$var$Ej(a, b, c) {
    var d = b.pendingProps;
    $409124218b1e663f$var$wg(b);
    switch(b.tag){
        case 2:
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $409124218b1e663f$var$S(b), null;
        case 1:
            return $409124218b1e663f$var$Zf(b.type) && $409124218b1e663f$var$$f(), $409124218b1e663f$var$S(b), null;
        case 3:
            d = b.stateNode;
            $409124218b1e663f$var$zh();
            $409124218b1e663f$var$E($409124218b1e663f$var$Wf);
            $409124218b1e663f$var$E($409124218b1e663f$var$H);
            $409124218b1e663f$var$Eh();
            d.pendingContext && (d.context = d.pendingContext, d.pendingContext = null);
            if (null === a || null === a.child) $409124218b1e663f$var$Gg(b) ? b.flags |= 4 : null === a || a.memoizedState.isDehydrated && 0 === (b.flags & 256) || (b.flags |= 1024, null !== $409124218b1e663f$var$zg && ($409124218b1e663f$var$Fj($409124218b1e663f$var$zg), $409124218b1e663f$var$zg = null));
            $409124218b1e663f$var$Aj(a, b);
            $409124218b1e663f$var$S(b);
            return null;
        case 5:
            $409124218b1e663f$var$Bh(b);
            var e = $409124218b1e663f$var$xh($409124218b1e663f$var$wh.current);
            c = b.type;
            if (null !== a && null != b.stateNode) $409124218b1e663f$var$Bj(a, b, c, d, e), a.ref !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            else {
                if (!d) {
                    if (null === b.stateNode) throw Error($409124218b1e663f$var$p(166));
                    $409124218b1e663f$var$S(b);
                    return null;
                }
                a = $409124218b1e663f$var$xh($409124218b1e663f$var$uh.current);
                if ($409124218b1e663f$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.type;
                    var f = b.memoizedProps;
                    d[$409124218b1e663f$var$Of] = b;
                    d[$409124218b1e663f$var$Pf] = f;
                    a = 0 !== (b.mode & 1);
                    switch(c){
                        case "dialog":
                            $409124218b1e663f$var$D("cancel", d);
                            $409124218b1e663f$var$D("close", d);
                            break;
                        case "iframe":
                        case "object":
                        case "embed":
                            $409124218b1e663f$var$D("load", d);
                            break;
                        case "video":
                        case "audio":
                            for(e = 0; e < $409124218b1e663f$var$lf.length; e++)$409124218b1e663f$var$D($409124218b1e663f$var$lf[e], d);
                            break;
                        case "source":
                            $409124218b1e663f$var$D("error", d);
                            break;
                        case "img":
                        case "image":
                        case "link":
                            $409124218b1e663f$var$D("error", d);
                            $409124218b1e663f$var$D("load", d);
                            break;
                        case "details":
                            $409124218b1e663f$var$D("toggle", d);
                            break;
                        case "input":
                            $409124218b1e663f$var$Za(d, f);
                            $409124218b1e663f$var$D("invalid", d);
                            break;
                        case "select":
                            d._wrapperState = {
                                wasMultiple: !!f.multiple
                            };
                            $409124218b1e663f$var$D("invalid", d);
                            break;
                        case "textarea":
                            $409124218b1e663f$var$hb(d, f), $409124218b1e663f$var$D("invalid", d);
                    }
                    $409124218b1e663f$var$ub(c, f);
                    e = null;
                    for(var g in f)if (f.hasOwnProperty(g)) {
                        var h = f[g];
                        "children" === g ? "string" === typeof h ? d.textContent !== h && (!0 !== f.suppressHydrationWarning && $409124218b1e663f$var$Af(d.textContent, h, a), e = [
                            "children",
                            h
                        ]) : "number" === typeof h && d.textContent !== "" + h && (!0 !== f.suppressHydrationWarning && $409124218b1e663f$var$Af(d.textContent, h, a), e = [
                            "children",
                            "" + h
                        ]) : $409124218b1e663f$var$ea.hasOwnProperty(g) && null != h && "onScroll" === g && $409124218b1e663f$var$D("scroll", d);
                    }
                    switch(c){
                        case "input":
                            $409124218b1e663f$var$Va(d);
                            $409124218b1e663f$var$db(d, f, !0);
                            break;
                        case "textarea":
                            $409124218b1e663f$var$Va(d);
                            $409124218b1e663f$var$jb(d);
                            break;
                        case "select":
                        case "option":
                            break;
                        default:
                            "function" === typeof f.onClick && (d.onclick = $409124218b1e663f$var$Bf);
                    }
                    d = e;
                    b.updateQueue = d;
                    null !== d && (b.flags |= 4);
                } else {
                    g = 9 === e.nodeType ? e : e.ownerDocument;
                    "http://www.w3.org/1999/xhtml" === a && (a = $409124218b1e663f$var$kb(c));
                    "http://www.w3.org/1999/xhtml" === a ? "script" === c ? (a = g.createElement("div"), a.innerHTML = "<script>\x3c/script>", a = a.removeChild(a.firstChild)) : "string" === typeof d.is ? a = g.createElement(c, {
                        is: d.is
                    }) : (a = g.createElement(c), "select" === c && (g = a, d.multiple ? g.multiple = !0 : d.size && (g.size = d.size))) : a = g.createElementNS(a, c);
                    a[$409124218b1e663f$var$Of] = b;
                    a[$409124218b1e663f$var$Pf] = d;
                    $409124218b1e663f$var$zj(a, b, !1, !1);
                    b.stateNode = a;
                    a: {
                        g = $409124218b1e663f$var$vb(c, d);
                        switch(c){
                            case "dialog":
                                $409124218b1e663f$var$D("cancel", a);
                                $409124218b1e663f$var$D("close", a);
                                e = d;
                                break;
                            case "iframe":
                            case "object":
                            case "embed":
                                $409124218b1e663f$var$D("load", a);
                                e = d;
                                break;
                            case "video":
                            case "audio":
                                for(e = 0; e < $409124218b1e663f$var$lf.length; e++)$409124218b1e663f$var$D($409124218b1e663f$var$lf[e], a);
                                e = d;
                                break;
                            case "source":
                                $409124218b1e663f$var$D("error", a);
                                e = d;
                                break;
                            case "img":
                            case "image":
                            case "link":
                                $409124218b1e663f$var$D("error", a);
                                $409124218b1e663f$var$D("load", a);
                                e = d;
                                break;
                            case "details":
                                $409124218b1e663f$var$D("toggle", a);
                                e = d;
                                break;
                            case "input":
                                $409124218b1e663f$var$Za(a, d);
                                e = $409124218b1e663f$var$Ya(a, d);
                                $409124218b1e663f$var$D("invalid", a);
                                break;
                            case "option":
                                e = d;
                                break;
                            case "select":
                                a._wrapperState = {
                                    wasMultiple: !!d.multiple
                                };
                                e = $409124218b1e663f$var$A({}, d, {
                                    value: void 0
                                });
                                $409124218b1e663f$var$D("invalid", a);
                                break;
                            case "textarea":
                                $409124218b1e663f$var$hb(a, d);
                                e = $409124218b1e663f$var$gb(a, d);
                                $409124218b1e663f$var$D("invalid", a);
                                break;
                            default:
                                e = d;
                        }
                        $409124218b1e663f$var$ub(c, e);
                        h = e;
                        for(f in h)if (h.hasOwnProperty(f)) {
                            var k = h[f];
                            "style" === f ? $409124218b1e663f$var$sb(a, k) : "dangerouslySetInnerHTML" === f ? (k = k ? k.__html : void 0, null != k && $409124218b1e663f$var$nb(a, k)) : "children" === f ? "string" === typeof k ? ("textarea" !== c || "" !== k) && $409124218b1e663f$var$ob(a, k) : "number" === typeof k && $409124218b1e663f$var$ob(a, "" + k) : "suppressContentEditableWarning" !== f && "suppressHydrationWarning" !== f && "autoFocus" !== f && ($409124218b1e663f$var$ea.hasOwnProperty(f) ? null != k && "onScroll" === f && $409124218b1e663f$var$D("scroll", a) : null != k && $409124218b1e663f$var$ta(a, f, k, g));
                        }
                        switch(c){
                            case "input":
                                $409124218b1e663f$var$Va(a);
                                $409124218b1e663f$var$db(a, d, !1);
                                break;
                            case "textarea":
                                $409124218b1e663f$var$Va(a);
                                $409124218b1e663f$var$jb(a);
                                break;
                            case "option":
                                null != d.value && a.setAttribute("value", "" + $409124218b1e663f$var$Sa(d.value));
                                break;
                            case "select":
                                a.multiple = !!d.multiple;
                                f = d.value;
                                null != f ? $409124218b1e663f$var$fb(a, !!d.multiple, f, !1) : null != d.defaultValue && $409124218b1e663f$var$fb(a, !!d.multiple, d.defaultValue, !0);
                                break;
                            default:
                                "function" === typeof e.onClick && (a.onclick = $409124218b1e663f$var$Bf);
                        }
                        switch(c){
                            case "button":
                            case "input":
                            case "select":
                            case "textarea":
                                d = !!d.autoFocus;
                                break a;
                            case "img":
                                d = !0;
                                break a;
                            default:
                                d = !1;
                        }
                    }
                    d && (b.flags |= 4);
                }
                null !== b.ref && (b.flags |= 512, b.flags |= 2097152);
            }
            $409124218b1e663f$var$S(b);
            return null;
        case 6:
            if (a && null != b.stateNode) $409124218b1e663f$var$Cj(a, b, a.memoizedProps, d);
            else {
                if ("string" !== typeof d && null === b.stateNode) throw Error($409124218b1e663f$var$p(166));
                c = $409124218b1e663f$var$xh($409124218b1e663f$var$wh.current);
                $409124218b1e663f$var$xh($409124218b1e663f$var$uh.current);
                if ($409124218b1e663f$var$Gg(b)) {
                    d = b.stateNode;
                    c = b.memoizedProps;
                    d[$409124218b1e663f$var$Of] = b;
                    if (f = d.nodeValue !== c) {
                        if (a = $409124218b1e663f$var$xg, null !== a) switch(a.tag){
                            case 3:
                                $409124218b1e663f$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                                break;
                            case 5:
                                !0 !== a.memoizedProps.suppressHydrationWarning && $409124218b1e663f$var$Af(d.nodeValue, c, 0 !== (a.mode & 1));
                        }
                    }
                    f && (b.flags |= 4);
                } else d = (9 === c.nodeType ? c : c.ownerDocument).createTextNode(d), d[$409124218b1e663f$var$Of] = b, b.stateNode = d;
            }
            $409124218b1e663f$var$S(b);
            return null;
        case 13:
            $409124218b1e663f$var$E($409124218b1e663f$var$L);
            d = b.memoizedState;
            if (null === a || null !== a.memoizedState && null !== a.memoizedState.dehydrated) {
                if ($409124218b1e663f$var$I && null !== $409124218b1e663f$var$yg && 0 !== (b.mode & 1) && 0 === (b.flags & 128)) $409124218b1e663f$var$Hg(), $409124218b1e663f$var$Ig(), b.flags |= 98560, f = !1;
                else if (f = $409124218b1e663f$var$Gg(b), null !== d && null !== d.dehydrated) {
                    if (null === a) {
                        if (!f) throw Error($409124218b1e663f$var$p(318));
                        f = b.memoizedState;
                        f = null !== f ? f.dehydrated : null;
                        if (!f) throw Error($409124218b1e663f$var$p(317));
                        f[$409124218b1e663f$var$Of] = b;
                    } else $409124218b1e663f$var$Ig(), 0 === (b.flags & 128) && (b.memoizedState = null), b.flags |= 4;
                    $409124218b1e663f$var$S(b);
                    f = !1;
                } else null !== $409124218b1e663f$var$zg && ($409124218b1e663f$var$Fj($409124218b1e663f$var$zg), $409124218b1e663f$var$zg = null), f = !0;
                if (!f) return b.flags & 65536 ? b : null;
            }
            if (0 !== (b.flags & 128)) return b.lanes = c, b;
            d = null !== d;
            d !== (null !== a && null !== a.memoizedState) && d && (b.child.flags |= 8192, 0 !== (b.mode & 1) && (null === a || 0 !== ($409124218b1e663f$var$L.current & 1) ? 0 === $409124218b1e663f$var$T && ($409124218b1e663f$var$T = 3) : $409124218b1e663f$var$tj()));
            null !== b.updateQueue && (b.flags |= 4);
            $409124218b1e663f$var$S(b);
            return null;
        case 4:
            return $409124218b1e663f$var$zh(), $409124218b1e663f$var$Aj(a, b), null === a && $409124218b1e663f$var$sf(b.stateNode.containerInfo), $409124218b1e663f$var$S(b), null;
        case 10:
            return $409124218b1e663f$var$ah(b.type._context), $409124218b1e663f$var$S(b), null;
        case 17:
            return $409124218b1e663f$var$Zf(b.type) && $409124218b1e663f$var$$f(), $409124218b1e663f$var$S(b), null;
        case 19:
            $409124218b1e663f$var$E($409124218b1e663f$var$L);
            f = b.memoizedState;
            if (null === f) return $409124218b1e663f$var$S(b), null;
            d = 0 !== (b.flags & 128);
            g = f.rendering;
            if (null === g) {
                if (d) $409124218b1e663f$var$Dj(f, !1);
                else {
                    if (0 !== $409124218b1e663f$var$T || null !== a && 0 !== (a.flags & 128)) for(a = b.child; null !== a;){
                        g = $409124218b1e663f$var$Ch(a);
                        if (null !== g) {
                            b.flags |= 128;
                            $409124218b1e663f$var$Dj(f, !1);
                            d = g.updateQueue;
                            null !== d && (b.updateQueue = d, b.flags |= 4);
                            b.subtreeFlags = 0;
                            d = c;
                            for(c = b.child; null !== c;)f = c, a = d, f.flags &= 14680066, g = f.alternate, null === g ? (f.childLanes = 0, f.lanes = a, f.child = null, f.subtreeFlags = 0, f.memoizedProps = null, f.memoizedState = null, f.updateQueue = null, f.dependencies = null, f.stateNode = null) : (f.childLanes = g.childLanes, f.lanes = g.lanes, f.child = g.child, f.subtreeFlags = 0, f.deletions = null, f.memoizedProps = g.memoizedProps, f.memoizedState = g.memoizedState, f.updateQueue = g.updateQueue, f.type = g.type, a = g.dependencies, f.dependencies = null === a ? null : {
                                lanes: a.lanes,
                                firstContext: a.firstContext
                            }), c = c.sibling;
                            $409124218b1e663f$var$G($409124218b1e663f$var$L, $409124218b1e663f$var$L.current & 1 | 2);
                            return b.child;
                        }
                        a = a.sibling;
                    }
                    null !== f.tail && $409124218b1e663f$var$B() > $409124218b1e663f$var$Gj && (b.flags |= 128, d = !0, $409124218b1e663f$var$Dj(f, !1), b.lanes = 4194304);
                }
            } else {
                if (!d) {
                    if (a = $409124218b1e663f$var$Ch(g), null !== a) {
                        if (b.flags |= 128, d = !0, c = a.updateQueue, null !== c && (b.updateQueue = c, b.flags |= 4), $409124218b1e663f$var$Dj(f, !0), null === f.tail && "hidden" === f.tailMode && !g.alternate && !$409124218b1e663f$var$I) return $409124218b1e663f$var$S(b), null;
                    } else 2 * $409124218b1e663f$var$B() - f.renderingStartTime > $409124218b1e663f$var$Gj && 1073741824 !== c && (b.flags |= 128, d = !0, $409124218b1e663f$var$Dj(f, !1), b.lanes = 4194304);
                }
                f.isBackwards ? (g.sibling = b.child, b.child = g) : (c = f.last, null !== c ? c.sibling = g : b.child = g, f.last = g);
            }
            if (null !== f.tail) return b = f.tail, f.rendering = b, f.tail = b.sibling, f.renderingStartTime = $409124218b1e663f$var$B(), b.sibling = null, c = $409124218b1e663f$var$L.current, $409124218b1e663f$var$G($409124218b1e663f$var$L, d ? c & 1 | 2 : c & 1), b;
            $409124218b1e663f$var$S(b);
            return null;
        case 22:
        case 23:
            return $409124218b1e663f$var$Hj(), d = null !== b.memoizedState, null !== a && null !== a.memoizedState !== d && (b.flags |= 8192), d && 0 !== (b.mode & 1) ? 0 !== ($409124218b1e663f$var$fj & 1073741824) && ($409124218b1e663f$var$S(b), b.subtreeFlags & 6 && (b.flags |= 8192)) : $409124218b1e663f$var$S(b), null;
        case 24:
            return null;
        case 25:
            return null;
    }
    throw Error($409124218b1e663f$var$p(156, b.tag));
}
function $409124218b1e663f$var$Ij(a, b) {
    $409124218b1e663f$var$wg(b);
    switch(b.tag){
        case 1:
            return $409124218b1e663f$var$Zf(b.type) && $409124218b1e663f$var$$f(), a = b.flags, a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 3:
            return $409124218b1e663f$var$zh(), $409124218b1e663f$var$E($409124218b1e663f$var$Wf), $409124218b1e663f$var$E($409124218b1e663f$var$H), $409124218b1e663f$var$Eh(), a = b.flags, 0 !== (a & 65536) && 0 === (a & 128) ? (b.flags = a & -65537 | 128, b) : null;
        case 5:
            return $409124218b1e663f$var$Bh(b), null;
        case 13:
            $409124218b1e663f$var$E($409124218b1e663f$var$L);
            a = b.memoizedState;
            if (null !== a && null !== a.dehydrated) {
                if (null === b.alternate) throw Error($409124218b1e663f$var$p(340));
                $409124218b1e663f$var$Ig();
            }
            a = b.flags;
            return a & 65536 ? (b.flags = a & -65537 | 128, b) : null;
        case 19:
            return $409124218b1e663f$var$E($409124218b1e663f$var$L), null;
        case 4:
            return $409124218b1e663f$var$zh(), null;
        case 10:
            return $409124218b1e663f$var$ah(b.type._context), null;
        case 22:
        case 23:
            return $409124218b1e663f$var$Hj(), null;
        case 24:
            return null;
        default:
            return null;
    }
}
var $409124218b1e663f$var$Jj = !1, $409124218b1e663f$var$U = !1, $409124218b1e663f$var$Kj = "function" === typeof WeakSet ? WeakSet : Set, $409124218b1e663f$var$V = null;
function $409124218b1e663f$var$Lj(a, b) {
    var c = a.ref;
    if (null !== c) {
        if ("function" === typeof c) try {
            c(null);
        } catch (d) {
            $409124218b1e663f$var$W(a, b, d);
        }
        else c.current = null;
    }
}
function $409124218b1e663f$var$Mj(a, b, c) {
    try {
        c();
    } catch (d) {
        $409124218b1e663f$var$W(a, b, d);
    }
}
var $409124218b1e663f$var$Nj = !1;
function $409124218b1e663f$var$Oj(a, b) {
    $409124218b1e663f$var$Cf = $409124218b1e663f$var$dd;
    a = $409124218b1e663f$var$Me();
    if ($409124218b1e663f$var$Ne(a)) {
        if ("selectionStart" in a) var c = {
            start: a.selectionStart,
            end: a.selectionEnd
        };
        else a: {
            c = (c = a.ownerDocument) && c.defaultView || window;
            var d = c.getSelection && c.getSelection();
            if (d && 0 !== d.rangeCount) {
                c = d.anchorNode;
                var e = d.anchorOffset, f = d.focusNode;
                d = d.focusOffset;
                try {
                    c.nodeType, f.nodeType;
                } catch (F) {
                    c = null;
                    break a;
                }
                var g = 0, h = -1, k = -1, l = 0, m = 0, q = a, r = null;
                b: for(;;){
                    for(var y;;){
                        q !== c || 0 !== e && 3 !== q.nodeType || (h = g + e);
                        q !== f || 0 !== d && 3 !== q.nodeType || (k = g + d);
                        3 === q.nodeType && (g += q.nodeValue.length);
                        if (null === (y = q.firstChild)) break;
                        r = q;
                        q = y;
                    }
                    for(;;){
                        if (q === a) break b;
                        r === c && ++l === e && (h = g);
                        r === f && ++m === d && (k = g);
                        if (null !== (y = q.nextSibling)) break;
                        q = r;
                        r = q.parentNode;
                    }
                    q = y;
                }
                c = -1 === h || -1 === k ? null : {
                    start: h,
                    end: k
                };
            } else c = null;
        }
        c = c || {
            start: 0,
            end: 0
        };
    } else c = null;
    $409124218b1e663f$var$Df = {
        focusedElem: a,
        selectionRange: c
    };
    $409124218b1e663f$var$dd = !1;
    for($409124218b1e663f$var$V = b; null !== $409124218b1e663f$var$V;)if (b = $409124218b1e663f$var$V, a = b.child, 0 !== (b.subtreeFlags & 1028) && null !== a) a.return = b, $409124218b1e663f$var$V = a;
    else for(; null !== $409124218b1e663f$var$V;){
        b = $409124218b1e663f$var$V;
        try {
            var n = b.alternate;
            if (0 !== (b.flags & 1024)) switch(b.tag){
                case 0:
                case 11:
                case 15:
                    break;
                case 1:
                    if (null !== n) {
                        var t = n.memoizedProps, J = n.memoizedState, x = b.stateNode, w = x.getSnapshotBeforeUpdate(b.elementType === b.type ? t : $409124218b1e663f$var$Ci(b.type, t), J);
                        x.__reactInternalSnapshotBeforeUpdate = w;
                    }
                    break;
                case 3:
                    var u = b.stateNode.containerInfo;
                    1 === u.nodeType ? u.textContent = "" : 9 === u.nodeType && u.documentElement && u.removeChild(u.documentElement);
                    break;
                case 5:
                case 6:
                case 4:
                case 17:
                    break;
                default:
                    throw Error($409124218b1e663f$var$p(163));
            }
        } catch (F) {
            $409124218b1e663f$var$W(b, b.return, F);
        }
        a = b.sibling;
        if (null !== a) {
            a.return = b.return;
            $409124218b1e663f$var$V = a;
            break;
        }
        $409124218b1e663f$var$V = b.return;
    }
    n = $409124218b1e663f$var$Nj;
    $409124218b1e663f$var$Nj = !1;
    return n;
}
function $409124218b1e663f$var$Pj(a, b, c) {
    var d = b.updateQueue;
    d = null !== d ? d.lastEffect : null;
    if (null !== d) {
        var e = d = d.next;
        do {
            if ((e.tag & a) === a) {
                var f = e.destroy;
                e.destroy = void 0;
                void 0 !== f && $409124218b1e663f$var$Mj(b, c, f);
            }
            e = e.next;
        }while (e !== d);
    }
}
function $409124218b1e663f$var$Qj(a, b) {
    b = b.updateQueue;
    b = null !== b ? b.lastEffect : null;
    if (null !== b) {
        var c = b = b.next;
        do {
            if ((c.tag & a) === a) {
                var d = c.create;
                c.destroy = d();
            }
            c = c.next;
        }while (c !== b);
    }
}
function $409124218b1e663f$var$Rj(a) {
    var b = a.ref;
    if (null !== b) {
        var c = a.stateNode;
        switch(a.tag){
            case 5:
                a = c;
                break;
            default:
                a = c;
        }
        "function" === typeof b ? b(a) : b.current = a;
    }
}
function $409124218b1e663f$var$Sj(a) {
    var b = a.alternate;
    null !== b && (a.alternate = null, $409124218b1e663f$var$Sj(b));
    a.child = null;
    a.deletions = null;
    a.sibling = null;
    5 === a.tag && (b = a.stateNode, null !== b && (delete b[$409124218b1e663f$var$Of], delete b[$409124218b1e663f$var$Pf], delete b[$409124218b1e663f$var$of], delete b[$409124218b1e663f$var$Qf], delete b[$409124218b1e663f$var$Rf]));
    a.stateNode = null;
    a.return = null;
    a.dependencies = null;
    a.memoizedProps = null;
    a.memoizedState = null;
    a.pendingProps = null;
    a.stateNode = null;
    a.updateQueue = null;
}
function $409124218b1e663f$var$Tj(a) {
    return 5 === a.tag || 3 === a.tag || 4 === a.tag;
}
function $409124218b1e663f$var$Uj(a) {
    a: for(;;){
        for(; null === a.sibling;){
            if (null === a.return || $409124218b1e663f$var$Tj(a.return)) return null;
            a = a.return;
        }
        a.sibling.return = a.return;
        for(a = a.sibling; 5 !== a.tag && 6 !== a.tag && 18 !== a.tag;){
            if (a.flags & 2) continue a;
            if (null === a.child || 4 === a.tag) continue a;
            else a.child.return = a, a = a.child;
        }
        if (!(a.flags & 2)) return a.stateNode;
    }
}
function $409124218b1e663f$var$Vj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? 8 === c.nodeType ? c.parentNode.insertBefore(a, b) : c.insertBefore(a, b) : (8 === c.nodeType ? (b = c.parentNode, b.insertBefore(a, c)) : (b = c, b.appendChild(a)), c = c._reactRootContainer, null !== c && void 0 !== c || null !== b.onclick || (b.onclick = $409124218b1e663f$var$Bf));
    else if (4 !== d && (a = a.child, null !== a)) for($409124218b1e663f$var$Vj(a, b, c), a = a.sibling; null !== a;)$409124218b1e663f$var$Vj(a, b, c), a = a.sibling;
}
function $409124218b1e663f$var$Wj(a, b, c) {
    var d = a.tag;
    if (5 === d || 6 === d) a = a.stateNode, b ? c.insertBefore(a, b) : c.appendChild(a);
    else if (4 !== d && (a = a.child, null !== a)) for($409124218b1e663f$var$Wj(a, b, c), a = a.sibling; null !== a;)$409124218b1e663f$var$Wj(a, b, c), a = a.sibling;
}
var $409124218b1e663f$var$X = null, $409124218b1e663f$var$Xj = !1;
function $409124218b1e663f$var$Yj(a, b, c) {
    for(c = c.child; null !== c;)$409124218b1e663f$var$Zj(a, b, c), c = c.sibling;
}
function $409124218b1e663f$var$Zj(a, b, c) {
    if ($409124218b1e663f$var$lc && "function" === typeof $409124218b1e663f$var$lc.onCommitFiberUnmount) try {
        $409124218b1e663f$var$lc.onCommitFiberUnmount($409124218b1e663f$var$kc, c);
    } catch (h) {}
    switch(c.tag){
        case 5:
            $409124218b1e663f$var$U || $409124218b1e663f$var$Lj(c, b);
        case 6:
            var d = $409124218b1e663f$var$X, e = $409124218b1e663f$var$Xj;
            $409124218b1e663f$var$X = null;
            $409124218b1e663f$var$Yj(a, b, c);
            $409124218b1e663f$var$X = d;
            $409124218b1e663f$var$Xj = e;
            null !== $409124218b1e663f$var$X && ($409124218b1e663f$var$Xj ? (a = $409124218b1e663f$var$X, c = c.stateNode, 8 === a.nodeType ? a.parentNode.removeChild(c) : a.removeChild(c)) : $409124218b1e663f$var$X.removeChild(c.stateNode));
            break;
        case 18:
            null !== $409124218b1e663f$var$X && ($409124218b1e663f$var$Xj ? (a = $409124218b1e663f$var$X, c = c.stateNode, 8 === a.nodeType ? $409124218b1e663f$var$Kf(a.parentNode, c) : 1 === a.nodeType && $409124218b1e663f$var$Kf(a, c), $409124218b1e663f$var$bd(a)) : $409124218b1e663f$var$Kf($409124218b1e663f$var$X, c.stateNode));
            break;
        case 4:
            d = $409124218b1e663f$var$X;
            e = $409124218b1e663f$var$Xj;
            $409124218b1e663f$var$X = c.stateNode.containerInfo;
            $409124218b1e663f$var$Xj = !0;
            $409124218b1e663f$var$Yj(a, b, c);
            $409124218b1e663f$var$X = d;
            $409124218b1e663f$var$Xj = e;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            if (!$409124218b1e663f$var$U && (d = c.updateQueue, null !== d && (d = d.lastEffect, null !== d))) {
                e = d = d.next;
                do {
                    var f = e, g = f.destroy;
                    f = f.tag;
                    void 0 !== g && (0 !== (f & 2) ? $409124218b1e663f$var$Mj(c, b, g) : 0 !== (f & 4) && $409124218b1e663f$var$Mj(c, b, g));
                    e = e.next;
                }while (e !== d);
            }
            $409124218b1e663f$var$Yj(a, b, c);
            break;
        case 1:
            if (!$409124218b1e663f$var$U && ($409124218b1e663f$var$Lj(c, b), d = c.stateNode, "function" === typeof d.componentWillUnmount)) try {
                d.props = c.memoizedProps, d.state = c.memoizedState, d.componentWillUnmount();
            } catch (h) {
                $409124218b1e663f$var$W(c, b, h);
            }
            $409124218b1e663f$var$Yj(a, b, c);
            break;
        case 21:
            $409124218b1e663f$var$Yj(a, b, c);
            break;
        case 22:
            c.mode & 1 ? ($409124218b1e663f$var$U = (d = $409124218b1e663f$var$U) || null !== c.memoizedState, $409124218b1e663f$var$Yj(a, b, c), $409124218b1e663f$var$U = d) : $409124218b1e663f$var$Yj(a, b, c);
            break;
        default:
            $409124218b1e663f$var$Yj(a, b, c);
    }
}
function $409124218b1e663f$var$ak(a) {
    var b = a.updateQueue;
    if (null !== b) {
        a.updateQueue = null;
        var c = a.stateNode;
        null === c && (c = a.stateNode = new $409124218b1e663f$var$Kj);
        b.forEach(function(b) {
            var d = $409124218b1e663f$var$bk.bind(null, a, b);
            c.has(b) || (c.add(b), b.then(d, d));
        });
    }
}
function $409124218b1e663f$var$ck(a, b) {
    var c = b.deletions;
    if (null !== c) for(var d = 0; d < c.length; d++){
        var e = c[d];
        try {
            var f = a, g = b, h = g;
            a: for(; null !== h;){
                switch(h.tag){
                    case 5:
                        $409124218b1e663f$var$X = h.stateNode;
                        $409124218b1e663f$var$Xj = !1;
                        break a;
                    case 3:
                        $409124218b1e663f$var$X = h.stateNode.containerInfo;
                        $409124218b1e663f$var$Xj = !0;
                        break a;
                    case 4:
                        $409124218b1e663f$var$X = h.stateNode.containerInfo;
                        $409124218b1e663f$var$Xj = !0;
                        break a;
                }
                h = h.return;
            }
            if (null === $409124218b1e663f$var$X) throw Error($409124218b1e663f$var$p(160));
            $409124218b1e663f$var$Zj(f, g, e);
            $409124218b1e663f$var$X = null;
            $409124218b1e663f$var$Xj = !1;
            var k = e.alternate;
            null !== k && (k.return = null);
            e.return = null;
        } catch (l) {
            $409124218b1e663f$var$W(e, b, l);
        }
    }
    if (b.subtreeFlags & 12854) for(b = b.child; null !== b;)$409124218b1e663f$var$dk(b, a), b = b.sibling;
}
function $409124218b1e663f$var$dk(a, b) {
    var c = a.alternate, d = a.flags;
    switch(a.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $409124218b1e663f$var$ck(b, a);
            $409124218b1e663f$var$ek(a);
            if (d & 4) {
                try {
                    $409124218b1e663f$var$Pj(3, a, a.return), $409124218b1e663f$var$Qj(3, a);
                } catch (t) {
                    $409124218b1e663f$var$W(a, a.return, t);
                }
                try {
                    $409124218b1e663f$var$Pj(5, a, a.return);
                } catch (t) {
                    $409124218b1e663f$var$W(a, a.return, t);
                }
            }
            break;
        case 1:
            $409124218b1e663f$var$ck(b, a);
            $409124218b1e663f$var$ek(a);
            d & 512 && null !== c && $409124218b1e663f$var$Lj(c, c.return);
            break;
        case 5:
            $409124218b1e663f$var$ck(b, a);
            $409124218b1e663f$var$ek(a);
            d & 512 && null !== c && $409124218b1e663f$var$Lj(c, c.return);
            if (a.flags & 32) {
                var e = a.stateNode;
                try {
                    $409124218b1e663f$var$ob(e, "");
                } catch (t) {
                    $409124218b1e663f$var$W(a, a.return, t);
                }
            }
            if (d & 4 && (e = a.stateNode, null != e)) {
                var f = a.memoizedProps, g = null !== c ? c.memoizedProps : f, h = a.type, k = a.updateQueue;
                a.updateQueue = null;
                if (null !== k) try {
                    "input" === h && "radio" === f.type && null != f.name && $409124218b1e663f$var$ab(e, f);
                    $409124218b1e663f$var$vb(h, g);
                    var l = $409124218b1e663f$var$vb(h, f);
                    for(g = 0; g < k.length; g += 2){
                        var m = k[g], q = k[g + 1];
                        "style" === m ? $409124218b1e663f$var$sb(e, q) : "dangerouslySetInnerHTML" === m ? $409124218b1e663f$var$nb(e, q) : "children" === m ? $409124218b1e663f$var$ob(e, q) : $409124218b1e663f$var$ta(e, m, q, l);
                    }
                    switch(h){
                        case "input":
                            $409124218b1e663f$var$bb(e, f);
                            break;
                        case "textarea":
                            $409124218b1e663f$var$ib(e, f);
                            break;
                        case "select":
                            var r = e._wrapperState.wasMultiple;
                            e._wrapperState.wasMultiple = !!f.multiple;
                            var y = f.value;
                            null != y ? $409124218b1e663f$var$fb(e, !!f.multiple, y, !1) : r !== !!f.multiple && (null != f.defaultValue ? $409124218b1e663f$var$fb(e, !!f.multiple, f.defaultValue, !0) : $409124218b1e663f$var$fb(e, !!f.multiple, f.multiple ? [] : "", !1));
                    }
                    e[$409124218b1e663f$var$Pf] = f;
                } catch (t) {
                    $409124218b1e663f$var$W(a, a.return, t);
                }
            }
            break;
        case 6:
            $409124218b1e663f$var$ck(b, a);
            $409124218b1e663f$var$ek(a);
            if (d & 4) {
                if (null === a.stateNode) throw Error($409124218b1e663f$var$p(162));
                e = a.stateNode;
                f = a.memoizedProps;
                try {
                    e.nodeValue = f;
                } catch (t) {
                    $409124218b1e663f$var$W(a, a.return, t);
                }
            }
            break;
        case 3:
            $409124218b1e663f$var$ck(b, a);
            $409124218b1e663f$var$ek(a);
            if (d & 4 && null !== c && c.memoizedState.isDehydrated) try {
                $409124218b1e663f$var$bd(b.containerInfo);
            } catch (t) {
                $409124218b1e663f$var$W(a, a.return, t);
            }
            break;
        case 4:
            $409124218b1e663f$var$ck(b, a);
            $409124218b1e663f$var$ek(a);
            break;
        case 13:
            $409124218b1e663f$var$ck(b, a);
            $409124218b1e663f$var$ek(a);
            e = a.child;
            e.flags & 8192 && (f = null !== e.memoizedState, e.stateNode.isHidden = f, !f || null !== e.alternate && null !== e.alternate.memoizedState || ($409124218b1e663f$var$fk = $409124218b1e663f$var$B()));
            d & 4 && $409124218b1e663f$var$ak(a);
            break;
        case 22:
            m = null !== c && null !== c.memoizedState;
            a.mode & 1 ? ($409124218b1e663f$var$U = (l = $409124218b1e663f$var$U) || m, $409124218b1e663f$var$ck(b, a), $409124218b1e663f$var$U = l) : $409124218b1e663f$var$ck(b, a);
            $409124218b1e663f$var$ek(a);
            if (d & 8192) {
                l = null !== a.memoizedState;
                if ((a.stateNode.isHidden = l) && !m && 0 !== (a.mode & 1)) for($409124218b1e663f$var$V = a, m = a.child; null !== m;){
                    for(q = $409124218b1e663f$var$V = m; null !== $409124218b1e663f$var$V;){
                        r = $409124218b1e663f$var$V;
                        y = r.child;
                        switch(r.tag){
                            case 0:
                            case 11:
                            case 14:
                            case 15:
                                $409124218b1e663f$var$Pj(4, r, r.return);
                                break;
                            case 1:
                                $409124218b1e663f$var$Lj(r, r.return);
                                var n = r.stateNode;
                                if ("function" === typeof n.componentWillUnmount) {
                                    d = r;
                                    c = r.return;
                                    try {
                                        b = d, n.props = b.memoizedProps, n.state = b.memoizedState, n.componentWillUnmount();
                                    } catch (t) {
                                        $409124218b1e663f$var$W(d, c, t);
                                    }
                                }
                                break;
                            case 5:
                                $409124218b1e663f$var$Lj(r, r.return);
                                break;
                            case 22:
                                if (null !== r.memoizedState) {
                                    $409124218b1e663f$var$gk(q);
                                    continue;
                                }
                        }
                        null !== y ? (y.return = r, $409124218b1e663f$var$V = y) : $409124218b1e663f$var$gk(q);
                    }
                    m = m.sibling;
                }
                a: for(m = null, q = a;;){
                    if (5 === q.tag) {
                        if (null === m) {
                            m = q;
                            try {
                                e = q.stateNode, l ? (f = e.style, "function" === typeof f.setProperty ? f.setProperty("display", "none", "important") : f.display = "none") : (h = q.stateNode, k = q.memoizedProps.style, g = void 0 !== k && null !== k && k.hasOwnProperty("display") ? k.display : null, h.style.display = $409124218b1e663f$var$rb("display", g));
                            } catch (t) {
                                $409124218b1e663f$var$W(a, a.return, t);
                            }
                        }
                    } else if (6 === q.tag) {
                        if (null === m) try {
                            q.stateNode.nodeValue = l ? "" : q.memoizedProps;
                        } catch (t) {
                            $409124218b1e663f$var$W(a, a.return, t);
                        }
                    } else if ((22 !== q.tag && 23 !== q.tag || null === q.memoizedState || q === a) && null !== q.child) {
                        q.child.return = q;
                        q = q.child;
                        continue;
                    }
                    if (q === a) break a;
                    for(; null === q.sibling;){
                        if (null === q.return || q.return === a) break a;
                        m === q && (m = null);
                        q = q.return;
                    }
                    m === q && (m = null);
                    q.sibling.return = q.return;
                    q = q.sibling;
                }
            }
            break;
        case 19:
            $409124218b1e663f$var$ck(b, a);
            $409124218b1e663f$var$ek(a);
            d & 4 && $409124218b1e663f$var$ak(a);
            break;
        case 21:
            break;
        default:
            $409124218b1e663f$var$ck(b, a), $409124218b1e663f$var$ek(a);
    }
}
function $409124218b1e663f$var$ek(a) {
    var b = a.flags;
    if (b & 2) {
        try {
            a: {
                for(var c = a.return; null !== c;){
                    if ($409124218b1e663f$var$Tj(c)) {
                        var d = c;
                        break a;
                    }
                    c = c.return;
                }
                throw Error($409124218b1e663f$var$p(160));
            }
            switch(d.tag){
                case 5:
                    var e = d.stateNode;
                    d.flags & 32 && ($409124218b1e663f$var$ob(e, ""), d.flags &= -33);
                    var f = $409124218b1e663f$var$Uj(a);
                    $409124218b1e663f$var$Wj(a, f, e);
                    break;
                case 3:
                case 4:
                    var g = d.stateNode.containerInfo, h = $409124218b1e663f$var$Uj(a);
                    $409124218b1e663f$var$Vj(a, h, g);
                    break;
                default:
                    throw Error($409124218b1e663f$var$p(161));
            }
        } catch (k) {
            $409124218b1e663f$var$W(a, a.return, k);
        }
        a.flags &= -3;
    }
    b & 4096 && (a.flags &= -4097);
}
function $409124218b1e663f$var$hk(a, b, c) {
    $409124218b1e663f$var$V = a;
    $409124218b1e663f$var$ik(a, b, c);
}
function $409124218b1e663f$var$ik(a, b, c) {
    for(var d = 0 !== (a.mode & 1); null !== $409124218b1e663f$var$V;){
        var e = $409124218b1e663f$var$V, f = e.child;
        if (22 === e.tag && d) {
            var g = null !== e.memoizedState || $409124218b1e663f$var$Jj;
            if (!g) {
                var h = e.alternate, k = null !== h && null !== h.memoizedState || $409124218b1e663f$var$U;
                h = $409124218b1e663f$var$Jj;
                var l = $409124218b1e663f$var$U;
                $409124218b1e663f$var$Jj = g;
                if (($409124218b1e663f$var$U = k) && !l) for($409124218b1e663f$var$V = e; null !== $409124218b1e663f$var$V;)g = $409124218b1e663f$var$V, k = g.child, 22 === g.tag && null !== g.memoizedState ? $409124218b1e663f$var$jk(e) : null !== k ? (k.return = g, $409124218b1e663f$var$V = k) : $409124218b1e663f$var$jk(e);
                for(; null !== f;)$409124218b1e663f$var$V = f, $409124218b1e663f$var$ik(f, b, c), f = f.sibling;
                $409124218b1e663f$var$V = e;
                $409124218b1e663f$var$Jj = h;
                $409124218b1e663f$var$U = l;
            }
            $409124218b1e663f$var$kk(a, b, c);
        } else 0 !== (e.subtreeFlags & 8772) && null !== f ? (f.return = e, $409124218b1e663f$var$V = f) : $409124218b1e663f$var$kk(a, b, c);
    }
}
function $409124218b1e663f$var$kk(a) {
    for(; null !== $409124218b1e663f$var$V;){
        var b = $409124218b1e663f$var$V;
        if (0 !== (b.flags & 8772)) {
            var c = b.alternate;
            try {
                if (0 !== (b.flags & 8772)) switch(b.tag){
                    case 0:
                    case 11:
                    case 15:
                        $409124218b1e663f$var$U || $409124218b1e663f$var$Qj(5, b);
                        break;
                    case 1:
                        var d = b.stateNode;
                        if (b.flags & 4 && !$409124218b1e663f$var$U) {
                            if (null === c) d.componentDidMount();
                            else {
                                var e = b.elementType === b.type ? c.memoizedProps : $409124218b1e663f$var$Ci(b.type, c.memoizedProps);
                                d.componentDidUpdate(e, c.memoizedState, d.__reactInternalSnapshotBeforeUpdate);
                            }
                        }
                        var f = b.updateQueue;
                        null !== f && $409124218b1e663f$var$sh(b, f, d);
                        break;
                    case 3:
                        var g = b.updateQueue;
                        if (null !== g) {
                            c = null;
                            if (null !== b.child) switch(b.child.tag){
                                case 5:
                                    c = b.child.stateNode;
                                    break;
                                case 1:
                                    c = b.child.stateNode;
                            }
                            $409124218b1e663f$var$sh(b, g, c);
                        }
                        break;
                    case 5:
                        var h = b.stateNode;
                        if (null === c && b.flags & 4) {
                            c = h;
                            var k = b.memoizedProps;
                            switch(b.type){
                                case "button":
                                case "input":
                                case "select":
                                case "textarea":
                                    k.autoFocus && c.focus();
                                    break;
                                case "img":
                                    k.src && (c.src = k.src);
                            }
                        }
                        break;
                    case 6:
                        break;
                    case 4:
                        break;
                    case 12:
                        break;
                    case 13:
                        if (null === b.memoizedState) {
                            var l = b.alternate;
                            if (null !== l) {
                                var m = l.memoizedState;
                                if (null !== m) {
                                    var q = m.dehydrated;
                                    null !== q && $409124218b1e663f$var$bd(q);
                                }
                            }
                        }
                        break;
                    case 19:
                    case 17:
                    case 21:
                    case 22:
                    case 23:
                    case 25:
                        break;
                    default:
                        throw Error($409124218b1e663f$var$p(163));
                }
                $409124218b1e663f$var$U || b.flags & 512 && $409124218b1e663f$var$Rj(b);
            } catch (r) {
                $409124218b1e663f$var$W(b, b.return, r);
            }
        }
        if (b === a) {
            $409124218b1e663f$var$V = null;
            break;
        }
        c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $409124218b1e663f$var$V = c;
            break;
        }
        $409124218b1e663f$var$V = b.return;
    }
}
function $409124218b1e663f$var$gk(a) {
    for(; null !== $409124218b1e663f$var$V;){
        var b = $409124218b1e663f$var$V;
        if (b === a) {
            $409124218b1e663f$var$V = null;
            break;
        }
        var c = b.sibling;
        if (null !== c) {
            c.return = b.return;
            $409124218b1e663f$var$V = c;
            break;
        }
        $409124218b1e663f$var$V = b.return;
    }
}
function $409124218b1e663f$var$jk(a) {
    for(; null !== $409124218b1e663f$var$V;){
        var b = $409124218b1e663f$var$V;
        try {
            switch(b.tag){
                case 0:
                case 11:
                case 15:
                    var c = b.return;
                    try {
                        $409124218b1e663f$var$Qj(4, b);
                    } catch (k) {
                        $409124218b1e663f$var$W(b, c, k);
                    }
                    break;
                case 1:
                    var d = b.stateNode;
                    if ("function" === typeof d.componentDidMount) {
                        var e = b.return;
                        try {
                            d.componentDidMount();
                        } catch (k) {
                            $409124218b1e663f$var$W(b, e, k);
                        }
                    }
                    var f = b.return;
                    try {
                        $409124218b1e663f$var$Rj(b);
                    } catch (k) {
                        $409124218b1e663f$var$W(b, f, k);
                    }
                    break;
                case 5:
                    var g = b.return;
                    try {
                        $409124218b1e663f$var$Rj(b);
                    } catch (k) {
                        $409124218b1e663f$var$W(b, g, k);
                    }
            }
        } catch (k) {
            $409124218b1e663f$var$W(b, b.return, k);
        }
        if (b === a) {
            $409124218b1e663f$var$V = null;
            break;
        }
        var h = b.sibling;
        if (null !== h) {
            h.return = b.return;
            $409124218b1e663f$var$V = h;
            break;
        }
        $409124218b1e663f$var$V = b.return;
    }
}
var $409124218b1e663f$var$lk = Math.ceil, $409124218b1e663f$var$mk = $409124218b1e663f$var$ua.ReactCurrentDispatcher, $409124218b1e663f$var$nk = $409124218b1e663f$var$ua.ReactCurrentOwner, $409124218b1e663f$var$ok = $409124218b1e663f$var$ua.ReactCurrentBatchConfig, $409124218b1e663f$var$K = 0, $409124218b1e663f$var$Q = null, $409124218b1e663f$var$Y = null, $409124218b1e663f$var$Z = 0, $409124218b1e663f$var$fj = 0, $409124218b1e663f$var$ej = $409124218b1e663f$var$Uf(0), $409124218b1e663f$var$T = 0, $409124218b1e663f$var$pk = null, $409124218b1e663f$var$rh = 0, $409124218b1e663f$var$qk = 0, $409124218b1e663f$var$rk = 0, $409124218b1e663f$var$sk = null, $409124218b1e663f$var$tk = null, $409124218b1e663f$var$fk = 0, $409124218b1e663f$var$Gj = Infinity, $409124218b1e663f$var$uk = null, $409124218b1e663f$var$Oi = !1, $409124218b1e663f$var$Pi = null, $409124218b1e663f$var$Ri = null, $409124218b1e663f$var$vk = !1, $409124218b1e663f$var$wk = null, $409124218b1e663f$var$xk = 0, $409124218b1e663f$var$yk = 0, $409124218b1e663f$var$zk = null, $409124218b1e663f$var$Ak = -1, $409124218b1e663f$var$Bk = 0;
function $409124218b1e663f$var$R() {
    return 0 !== ($409124218b1e663f$var$K & 6) ? $409124218b1e663f$var$B() : -1 !== $409124218b1e663f$var$Ak ? $409124218b1e663f$var$Ak : $409124218b1e663f$var$Ak = $409124218b1e663f$var$B();
}
function $409124218b1e663f$var$yi(a) {
    if (0 === (a.mode & 1)) return 1;
    if (0 !== ($409124218b1e663f$var$K & 2) && 0 !== $409124218b1e663f$var$Z) return $409124218b1e663f$var$Z & -$409124218b1e663f$var$Z;
    if (null !== $409124218b1e663f$var$Kg.transition) return 0 === $409124218b1e663f$var$Bk && ($409124218b1e663f$var$Bk = $409124218b1e663f$var$yc()), $409124218b1e663f$var$Bk;
    a = $409124218b1e663f$var$C;
    if (0 !== a) return a;
    a = window.event;
    a = void 0 === a ? 16 : $409124218b1e663f$var$jd(a.type);
    return a;
}
function $409124218b1e663f$var$gi(a, b, c, d) {
    if (50 < $409124218b1e663f$var$yk) throw $409124218b1e663f$var$yk = 0, $409124218b1e663f$var$zk = null, Error($409124218b1e663f$var$p(185));
    $409124218b1e663f$var$Ac(a, c, d);
    if (0 === ($409124218b1e663f$var$K & 2) || a !== $409124218b1e663f$var$Q) a === $409124218b1e663f$var$Q && (0 === ($409124218b1e663f$var$K & 2) && ($409124218b1e663f$var$qk |= c), 4 === $409124218b1e663f$var$T && $409124218b1e663f$var$Ck(a, $409124218b1e663f$var$Z)), $409124218b1e663f$var$Dk(a, d), 1 === c && 0 === $409124218b1e663f$var$K && 0 === (b.mode & 1) && ($409124218b1e663f$var$Gj = $409124218b1e663f$var$B() + 500, $409124218b1e663f$var$fg && $409124218b1e663f$var$jg());
}
function $409124218b1e663f$var$Dk(a, b) {
    var c = a.callbackNode;
    $409124218b1e663f$var$wc(a, b);
    var d = $409124218b1e663f$var$uc(a, a === $409124218b1e663f$var$Q ? $409124218b1e663f$var$Z : 0);
    if (0 === d) null !== c && $409124218b1e663f$var$bc(c), a.callbackNode = null, a.callbackPriority = 0;
    else if (b = d & -d, a.callbackPriority !== b) {
        null != c && $409124218b1e663f$var$bc(c);
        if (1 === b) 0 === a.tag ? $409124218b1e663f$var$ig($409124218b1e663f$var$Ek.bind(null, a)) : $409124218b1e663f$var$hg($409124218b1e663f$var$Ek.bind(null, a)), $409124218b1e663f$var$Jf(function() {
            0 === ($409124218b1e663f$var$K & 6) && $409124218b1e663f$var$jg();
        }), c = null;
        else {
            switch($409124218b1e663f$var$Dc(d)){
                case 1:
                    c = $409124218b1e663f$var$fc;
                    break;
                case 4:
                    c = $409124218b1e663f$var$gc;
                    break;
                case 16:
                    c = $409124218b1e663f$var$hc;
                    break;
                case 536870912:
                    c = $409124218b1e663f$var$jc;
                    break;
                default:
                    c = $409124218b1e663f$var$hc;
            }
            c = $409124218b1e663f$var$Fk(c, $409124218b1e663f$var$Gk.bind(null, a));
        }
        a.callbackPriority = b;
        a.callbackNode = c;
    }
}
function $409124218b1e663f$var$Gk(a, b) {
    $409124218b1e663f$var$Ak = -1;
    $409124218b1e663f$var$Bk = 0;
    if (0 !== ($409124218b1e663f$var$K & 6)) throw Error($409124218b1e663f$var$p(327));
    var c = a.callbackNode;
    if ($409124218b1e663f$var$Hk() && a.callbackNode !== c) return null;
    var d = $409124218b1e663f$var$uc(a, a === $409124218b1e663f$var$Q ? $409124218b1e663f$var$Z : 0);
    if (0 === d) return null;
    if (0 !== (d & 30) || 0 !== (d & a.expiredLanes) || b) b = $409124218b1e663f$var$Ik(a, d);
    else {
        b = d;
        var e = $409124218b1e663f$var$K;
        $409124218b1e663f$var$K |= 2;
        var f = $409124218b1e663f$var$Jk();
        if ($409124218b1e663f$var$Q !== a || $409124218b1e663f$var$Z !== b) $409124218b1e663f$var$uk = null, $409124218b1e663f$var$Gj = $409124218b1e663f$var$B() + 500, $409124218b1e663f$var$Kk(a, b);
        for(;;)try {
            $409124218b1e663f$var$Lk();
            break;
        } catch (h) {
            $409124218b1e663f$var$Mk(a, h);
        }
        $409124218b1e663f$var$$g();
        $409124218b1e663f$var$mk.current = f;
        $409124218b1e663f$var$K = e;
        null !== $409124218b1e663f$var$Y ? b = 0 : ($409124218b1e663f$var$Q = null, $409124218b1e663f$var$Z = 0, b = $409124218b1e663f$var$T);
    }
    if (0 !== b) {
        2 === b && (e = $409124218b1e663f$var$xc(a), 0 !== e && (d = e, b = $409124218b1e663f$var$Nk(a, e)));
        if (1 === b) throw c = $409124218b1e663f$var$pk, $409124218b1e663f$var$Kk(a, 0), $409124218b1e663f$var$Ck(a, d), $409124218b1e663f$var$Dk(a, $409124218b1e663f$var$B()), c;
        if (6 === b) $409124218b1e663f$var$Ck(a, d);
        else {
            e = a.current.alternate;
            if (0 === (d & 30) && !$409124218b1e663f$var$Ok(e) && (b = $409124218b1e663f$var$Ik(a, d), 2 === b && (f = $409124218b1e663f$var$xc(a), 0 !== f && (d = f, b = $409124218b1e663f$var$Nk(a, f))), 1 === b)) throw c = $409124218b1e663f$var$pk, $409124218b1e663f$var$Kk(a, 0), $409124218b1e663f$var$Ck(a, d), $409124218b1e663f$var$Dk(a, $409124218b1e663f$var$B()), c;
            a.finishedWork = e;
            a.finishedLanes = d;
            switch(b){
                case 0:
                case 1:
                    throw Error($409124218b1e663f$var$p(345));
                case 2:
                    $409124218b1e663f$var$Pk(a, $409124218b1e663f$var$tk, $409124218b1e663f$var$uk);
                    break;
                case 3:
                    $409124218b1e663f$var$Ck(a, d);
                    if ((d & 130023424) === d && (b = $409124218b1e663f$var$fk + 500 - $409124218b1e663f$var$B(), 10 < b)) {
                        if (0 !== $409124218b1e663f$var$uc(a, 0)) break;
                        e = a.suspendedLanes;
                        if ((e & d) !== d) {
                            $409124218b1e663f$var$R();
                            a.pingedLanes |= a.suspendedLanes & e;
                            break;
                        }
                        a.timeoutHandle = $409124218b1e663f$var$Ff($409124218b1e663f$var$Pk.bind(null, a, $409124218b1e663f$var$tk, $409124218b1e663f$var$uk), b);
                        break;
                    }
                    $409124218b1e663f$var$Pk(a, $409124218b1e663f$var$tk, $409124218b1e663f$var$uk);
                    break;
                case 4:
                    $409124218b1e663f$var$Ck(a, d);
                    if ((d & 4194240) === d) break;
                    b = a.eventTimes;
                    for(e = -1; 0 < d;){
                        var g = 31 - $409124218b1e663f$var$oc(d);
                        f = 1 << g;
                        g = b[g];
                        g > e && (e = g);
                        d &= ~f;
                    }
                    d = e;
                    d = $409124218b1e663f$var$B() - d;
                    d = (120 > d ? 120 : 480 > d ? 480 : 1080 > d ? 1080 : 1920 > d ? 1920 : 3E3 > d ? 3E3 : 4320 > d ? 4320 : 1960 * $409124218b1e663f$var$lk(d / 1960)) - d;
                    if (10 < d) {
                        a.timeoutHandle = $409124218b1e663f$var$Ff($409124218b1e663f$var$Pk.bind(null, a, $409124218b1e663f$var$tk, $409124218b1e663f$var$uk), d);
                        break;
                    }
                    $409124218b1e663f$var$Pk(a, $409124218b1e663f$var$tk, $409124218b1e663f$var$uk);
                    break;
                case 5:
                    $409124218b1e663f$var$Pk(a, $409124218b1e663f$var$tk, $409124218b1e663f$var$uk);
                    break;
                default:
                    throw Error($409124218b1e663f$var$p(329));
            }
        }
    }
    $409124218b1e663f$var$Dk(a, $409124218b1e663f$var$B());
    return a.callbackNode === c ? $409124218b1e663f$var$Gk.bind(null, a) : null;
}
function $409124218b1e663f$var$Nk(a, b) {
    var c = $409124218b1e663f$var$sk;
    a.current.memoizedState.isDehydrated && ($409124218b1e663f$var$Kk(a, b).flags |= 256);
    a = $409124218b1e663f$var$Ik(a, b);
    2 !== a && (b = $409124218b1e663f$var$tk, $409124218b1e663f$var$tk = c, null !== b && $409124218b1e663f$var$Fj(b));
    return a;
}
function $409124218b1e663f$var$Fj(a) {
    null === $409124218b1e663f$var$tk ? $409124218b1e663f$var$tk = a : $409124218b1e663f$var$tk.push.apply($409124218b1e663f$var$tk, a);
}
function $409124218b1e663f$var$Ok(a) {
    for(var b = a;;){
        if (b.flags & 16384) {
            var c = b.updateQueue;
            if (null !== c && (c = c.stores, null !== c)) for(var d = 0; d < c.length; d++){
                var e = c[d], f = e.getSnapshot;
                e = e.value;
                try {
                    if (!$409124218b1e663f$var$He(f(), e)) return !1;
                } catch (g) {
                    return !1;
                }
            }
        }
        c = b.child;
        if (b.subtreeFlags & 16384 && null !== c) c.return = b, b = c;
        else {
            if (b === a) break;
            for(; null === b.sibling;){
                if (null === b.return || b.return === a) return !0;
                b = b.return;
            }
            b.sibling.return = b.return;
            b = b.sibling;
        }
    }
    return !0;
}
function $409124218b1e663f$var$Ck(a, b) {
    b &= ~$409124218b1e663f$var$rk;
    b &= ~$409124218b1e663f$var$qk;
    a.suspendedLanes |= b;
    a.pingedLanes &= ~b;
    for(a = a.expirationTimes; 0 < b;){
        var c = 31 - $409124218b1e663f$var$oc(b), d = 1 << c;
        a[c] = -1;
        b &= ~d;
    }
}
function $409124218b1e663f$var$Ek(a) {
    if (0 !== ($409124218b1e663f$var$K & 6)) throw Error($409124218b1e663f$var$p(327));
    $409124218b1e663f$var$Hk();
    var b = $409124218b1e663f$var$uc(a, 0);
    if (0 === (b & 1)) return $409124218b1e663f$var$Dk(a, $409124218b1e663f$var$B()), null;
    var c = $409124218b1e663f$var$Ik(a, b);
    if (0 !== a.tag && 2 === c) {
        var d = $409124218b1e663f$var$xc(a);
        0 !== d && (b = d, c = $409124218b1e663f$var$Nk(a, d));
    }
    if (1 === c) throw c = $409124218b1e663f$var$pk, $409124218b1e663f$var$Kk(a, 0), $409124218b1e663f$var$Ck(a, b), $409124218b1e663f$var$Dk(a, $409124218b1e663f$var$B()), c;
    if (6 === c) throw Error($409124218b1e663f$var$p(345));
    a.finishedWork = a.current.alternate;
    a.finishedLanes = b;
    $409124218b1e663f$var$Pk(a, $409124218b1e663f$var$tk, $409124218b1e663f$var$uk);
    $409124218b1e663f$var$Dk(a, $409124218b1e663f$var$B());
    return null;
}
function $409124218b1e663f$var$Qk(a, b) {
    var c = $409124218b1e663f$var$K;
    $409124218b1e663f$var$K |= 1;
    try {
        return a(b);
    } finally{
        $409124218b1e663f$var$K = c, 0 === $409124218b1e663f$var$K && ($409124218b1e663f$var$Gj = $409124218b1e663f$var$B() + 500, $409124218b1e663f$var$fg && $409124218b1e663f$var$jg());
    }
}
function $409124218b1e663f$var$Rk(a) {
    null !== $409124218b1e663f$var$wk && 0 === $409124218b1e663f$var$wk.tag && 0 === ($409124218b1e663f$var$K & 6) && $409124218b1e663f$var$Hk();
    var b = $409124218b1e663f$var$K;
    $409124218b1e663f$var$K |= 1;
    var c = $409124218b1e663f$var$ok.transition, d = $409124218b1e663f$var$C;
    try {
        if ($409124218b1e663f$var$ok.transition = null, $409124218b1e663f$var$C = 1, a) return a();
    } finally{
        $409124218b1e663f$var$C = d, $409124218b1e663f$var$ok.transition = c, $409124218b1e663f$var$K = b, 0 === ($409124218b1e663f$var$K & 6) && $409124218b1e663f$var$jg();
    }
}
function $409124218b1e663f$var$Hj() {
    $409124218b1e663f$var$fj = $409124218b1e663f$var$ej.current;
    $409124218b1e663f$var$E($409124218b1e663f$var$ej);
}
function $409124218b1e663f$var$Kk(a, b) {
    a.finishedWork = null;
    a.finishedLanes = 0;
    var c = a.timeoutHandle;
    -1 !== c && (a.timeoutHandle = -1, $409124218b1e663f$var$Gf(c));
    if (null !== $409124218b1e663f$var$Y) for(c = $409124218b1e663f$var$Y.return; null !== c;){
        var d = c;
        $409124218b1e663f$var$wg(d);
        switch(d.tag){
            case 1:
                d = d.type.childContextTypes;
                null !== d && void 0 !== d && $409124218b1e663f$var$$f();
                break;
            case 3:
                $409124218b1e663f$var$zh();
                $409124218b1e663f$var$E($409124218b1e663f$var$Wf);
                $409124218b1e663f$var$E($409124218b1e663f$var$H);
                $409124218b1e663f$var$Eh();
                break;
            case 5:
                $409124218b1e663f$var$Bh(d);
                break;
            case 4:
                $409124218b1e663f$var$zh();
                break;
            case 13:
                $409124218b1e663f$var$E($409124218b1e663f$var$L);
                break;
            case 19:
                $409124218b1e663f$var$E($409124218b1e663f$var$L);
                break;
            case 10:
                $409124218b1e663f$var$ah(d.type._context);
                break;
            case 22:
            case 23:
                $409124218b1e663f$var$Hj();
        }
        c = c.return;
    }
    $409124218b1e663f$var$Q = a;
    $409124218b1e663f$var$Y = a = $409124218b1e663f$var$Pg(a.current, null);
    $409124218b1e663f$var$Z = $409124218b1e663f$var$fj = b;
    $409124218b1e663f$var$T = 0;
    $409124218b1e663f$var$pk = null;
    $409124218b1e663f$var$rk = $409124218b1e663f$var$qk = $409124218b1e663f$var$rh = 0;
    $409124218b1e663f$var$tk = $409124218b1e663f$var$sk = null;
    if (null !== $409124218b1e663f$var$fh) {
        for(b = 0; b < $409124218b1e663f$var$fh.length; b++)if (c = $409124218b1e663f$var$fh[b], d = c.interleaved, null !== d) {
            c.interleaved = null;
            var e = d.next, f = c.pending;
            if (null !== f) {
                var g = f.next;
                f.next = e;
                d.next = g;
            }
            c.pending = d;
        }
        $409124218b1e663f$var$fh = null;
    }
    return a;
}
function $409124218b1e663f$var$Mk(a, b) {
    do {
        var c = $409124218b1e663f$var$Y;
        try {
            $409124218b1e663f$var$$g();
            $409124218b1e663f$var$Fh.current = $409124218b1e663f$var$Rh;
            if ($409124218b1e663f$var$Ih) {
                for(var d = $409124218b1e663f$var$M.memoizedState; null !== d;){
                    var e = d.queue;
                    null !== e && (e.pending = null);
                    d = d.next;
                }
                $409124218b1e663f$var$Ih = !1;
            }
            $409124218b1e663f$var$Hh = 0;
            $409124218b1e663f$var$O = $409124218b1e663f$var$N = $409124218b1e663f$var$M = null;
            $409124218b1e663f$var$Jh = !1;
            $409124218b1e663f$var$Kh = 0;
            $409124218b1e663f$var$nk.current = null;
            if (null === c || null === c.return) {
                $409124218b1e663f$var$T = 1;
                $409124218b1e663f$var$pk = b;
                $409124218b1e663f$var$Y = null;
                break;
            }
            a: {
                var f = a, g = c.return, h = c, k = b;
                b = $409124218b1e663f$var$Z;
                h.flags |= 32768;
                if (null !== k && "object" === typeof k && "function" === typeof k.then) {
                    var l = k, m = h, q = m.tag;
                    if (0 === (m.mode & 1) && (0 === q || 11 === q || 15 === q)) {
                        var r = m.alternate;
                        r ? (m.updateQueue = r.updateQueue, m.memoizedState = r.memoizedState, m.lanes = r.lanes) : (m.updateQueue = null, m.memoizedState = null);
                    }
                    var y = $409124218b1e663f$var$Ui(g);
                    if (null !== y) {
                        y.flags &= -257;
                        $409124218b1e663f$var$Vi(y, g, h, f, b);
                        y.mode & 1 && $409124218b1e663f$var$Si(f, l, b);
                        b = y;
                        k = l;
                        var n = b.updateQueue;
                        if (null === n) {
                            var t = new Set;
                            t.add(k);
                            b.updateQueue = t;
                        } else n.add(k);
                        break a;
                    } else {
                        if (0 === (b & 1)) {
                            $409124218b1e663f$var$Si(f, l, b);
                            $409124218b1e663f$var$tj();
                            break a;
                        }
                        k = Error($409124218b1e663f$var$p(426));
                    }
                } else if ($409124218b1e663f$var$I && h.mode & 1) {
                    var J = $409124218b1e663f$var$Ui(g);
                    if (null !== J) {
                        0 === (J.flags & 65536) && (J.flags |= 256);
                        $409124218b1e663f$var$Vi(J, g, h, f, b);
                        $409124218b1e663f$var$Jg($409124218b1e663f$var$Ji(k, h));
                        break a;
                    }
                }
                f = k = $409124218b1e663f$var$Ji(k, h);
                4 !== $409124218b1e663f$var$T && ($409124218b1e663f$var$T = 2);
                null === $409124218b1e663f$var$sk ? $409124218b1e663f$var$sk = [
                    f
                ] : $409124218b1e663f$var$sk.push(f);
                f = g;
                do {
                    switch(f.tag){
                        case 3:
                            f.flags |= 65536;
                            b &= -b;
                            f.lanes |= b;
                            var x = $409124218b1e663f$var$Ni(f, k, b);
                            $409124218b1e663f$var$ph(f, x);
                            break a;
                        case 1:
                            h = k;
                            var w = f.type, u = f.stateNode;
                            if (0 === (f.flags & 128) && ("function" === typeof w.getDerivedStateFromError || null !== u && "function" === typeof u.componentDidCatch && (null === $409124218b1e663f$var$Ri || !$409124218b1e663f$var$Ri.has(u)))) {
                                f.flags |= 65536;
                                b &= -b;
                                f.lanes |= b;
                                var F = $409124218b1e663f$var$Qi(f, h, b);
                                $409124218b1e663f$var$ph(f, F);
                                break a;
                            }
                    }
                    f = f.return;
                }while (null !== f);
            }
            $409124218b1e663f$var$Sk(c);
        } catch (na) {
            b = na;
            $409124218b1e663f$var$Y === c && null !== c && ($409124218b1e663f$var$Y = c = c.return);
            continue;
        }
        break;
    }while (1);
}
function $409124218b1e663f$var$Jk() {
    var a = $409124218b1e663f$var$mk.current;
    $409124218b1e663f$var$mk.current = $409124218b1e663f$var$Rh;
    return null === a ? $409124218b1e663f$var$Rh : a;
}
function $409124218b1e663f$var$tj() {
    if (0 === $409124218b1e663f$var$T || 3 === $409124218b1e663f$var$T || 2 === $409124218b1e663f$var$T) $409124218b1e663f$var$T = 4;
    null === $409124218b1e663f$var$Q || 0 === ($409124218b1e663f$var$rh & 268435455) && 0 === ($409124218b1e663f$var$qk & 268435455) || $409124218b1e663f$var$Ck($409124218b1e663f$var$Q, $409124218b1e663f$var$Z);
}
function $409124218b1e663f$var$Ik(a, b) {
    var c = $409124218b1e663f$var$K;
    $409124218b1e663f$var$K |= 2;
    var d = $409124218b1e663f$var$Jk();
    if ($409124218b1e663f$var$Q !== a || $409124218b1e663f$var$Z !== b) $409124218b1e663f$var$uk = null, $409124218b1e663f$var$Kk(a, b);
    for(;;)try {
        $409124218b1e663f$var$Tk();
        break;
    } catch (e) {
        $409124218b1e663f$var$Mk(a, e);
    }
    $409124218b1e663f$var$$g();
    $409124218b1e663f$var$K = c;
    $409124218b1e663f$var$mk.current = d;
    if (null !== $409124218b1e663f$var$Y) throw Error($409124218b1e663f$var$p(261));
    $409124218b1e663f$var$Q = null;
    $409124218b1e663f$var$Z = 0;
    return $409124218b1e663f$var$T;
}
function $409124218b1e663f$var$Tk() {
    for(; null !== $409124218b1e663f$var$Y;)$409124218b1e663f$var$Uk($409124218b1e663f$var$Y);
}
function $409124218b1e663f$var$Lk() {
    for(; null !== $409124218b1e663f$var$Y && !$409124218b1e663f$var$cc();)$409124218b1e663f$var$Uk($409124218b1e663f$var$Y);
}
function $409124218b1e663f$var$Uk(a) {
    var b = $409124218b1e663f$var$Vk(a.alternate, a, $409124218b1e663f$var$fj);
    a.memoizedProps = a.pendingProps;
    null === b ? $409124218b1e663f$var$Sk(a) : $409124218b1e663f$var$Y = b;
    $409124218b1e663f$var$nk.current = null;
}
function $409124218b1e663f$var$Sk(a) {
    var b = a;
    do {
        var c = b.alternate;
        a = b.return;
        if (0 === (b.flags & 32768)) {
            if (c = $409124218b1e663f$var$Ej(c, b, $409124218b1e663f$var$fj), null !== c) {
                $409124218b1e663f$var$Y = c;
                return;
            }
        } else {
            c = $409124218b1e663f$var$Ij(c, b);
            if (null !== c) {
                c.flags &= 32767;
                $409124218b1e663f$var$Y = c;
                return;
            }
            if (null !== a) a.flags |= 32768, a.subtreeFlags = 0, a.deletions = null;
            else {
                $409124218b1e663f$var$T = 6;
                $409124218b1e663f$var$Y = null;
                return;
            }
        }
        b = b.sibling;
        if (null !== b) {
            $409124218b1e663f$var$Y = b;
            return;
        }
        $409124218b1e663f$var$Y = b = a;
    }while (null !== b);
    0 === $409124218b1e663f$var$T && ($409124218b1e663f$var$T = 5);
}
function $409124218b1e663f$var$Pk(a, b, c) {
    var d = $409124218b1e663f$var$C, e = $409124218b1e663f$var$ok.transition;
    try {
        $409124218b1e663f$var$ok.transition = null, $409124218b1e663f$var$C = 1, $409124218b1e663f$var$Wk(a, b, c, d);
    } finally{
        $409124218b1e663f$var$ok.transition = e, $409124218b1e663f$var$C = d;
    }
    return null;
}
function $409124218b1e663f$var$Wk(a, b, c, d) {
    do $409124218b1e663f$var$Hk();
    while (null !== $409124218b1e663f$var$wk);
    if (0 !== ($409124218b1e663f$var$K & 6)) throw Error($409124218b1e663f$var$p(327));
    c = a.finishedWork;
    var e = a.finishedLanes;
    if (null === c) return null;
    a.finishedWork = null;
    a.finishedLanes = 0;
    if (c === a.current) throw Error($409124218b1e663f$var$p(177));
    a.callbackNode = null;
    a.callbackPriority = 0;
    var f = c.lanes | c.childLanes;
    $409124218b1e663f$var$Bc(a, f);
    a === $409124218b1e663f$var$Q && ($409124218b1e663f$var$Y = $409124218b1e663f$var$Q = null, $409124218b1e663f$var$Z = 0);
    0 === (c.subtreeFlags & 2064) && 0 === (c.flags & 2064) || $409124218b1e663f$var$vk || ($409124218b1e663f$var$vk = !0, $409124218b1e663f$var$Fk($409124218b1e663f$var$hc, function() {
        $409124218b1e663f$var$Hk();
        return null;
    }));
    f = 0 !== (c.flags & 15990);
    if (0 !== (c.subtreeFlags & 15990) || f) {
        f = $409124218b1e663f$var$ok.transition;
        $409124218b1e663f$var$ok.transition = null;
        var g = $409124218b1e663f$var$C;
        $409124218b1e663f$var$C = 1;
        var h = $409124218b1e663f$var$K;
        $409124218b1e663f$var$K |= 4;
        $409124218b1e663f$var$nk.current = null;
        $409124218b1e663f$var$Oj(a, c);
        $409124218b1e663f$var$dk(c, a);
        $409124218b1e663f$var$Oe($409124218b1e663f$var$Df);
        $409124218b1e663f$var$dd = !!$409124218b1e663f$var$Cf;
        $409124218b1e663f$var$Df = $409124218b1e663f$var$Cf = null;
        a.current = c;
        $409124218b1e663f$var$hk(c, a, e);
        $409124218b1e663f$var$dc();
        $409124218b1e663f$var$K = h;
        $409124218b1e663f$var$C = g;
        $409124218b1e663f$var$ok.transition = f;
    } else a.current = c;
    $409124218b1e663f$var$vk && ($409124218b1e663f$var$vk = !1, $409124218b1e663f$var$wk = a, $409124218b1e663f$var$xk = e);
    f = a.pendingLanes;
    0 === f && ($409124218b1e663f$var$Ri = null);
    $409124218b1e663f$var$mc(c.stateNode, d);
    $409124218b1e663f$var$Dk(a, $409124218b1e663f$var$B());
    if (null !== b) for(d = a.onRecoverableError, c = 0; c < b.length; c++)e = b[c], d(e.value, {
        componentStack: e.stack,
        digest: e.digest
    });
    if ($409124218b1e663f$var$Oi) throw $409124218b1e663f$var$Oi = !1, a = $409124218b1e663f$var$Pi, $409124218b1e663f$var$Pi = null, a;
    0 !== ($409124218b1e663f$var$xk & 1) && 0 !== a.tag && $409124218b1e663f$var$Hk();
    f = a.pendingLanes;
    0 !== (f & 1) ? a === $409124218b1e663f$var$zk ? $409124218b1e663f$var$yk++ : ($409124218b1e663f$var$yk = 0, $409124218b1e663f$var$zk = a) : $409124218b1e663f$var$yk = 0;
    $409124218b1e663f$var$jg();
    return null;
}
function $409124218b1e663f$var$Hk() {
    if (null !== $409124218b1e663f$var$wk) {
        var a = $409124218b1e663f$var$Dc($409124218b1e663f$var$xk), b = $409124218b1e663f$var$ok.transition, c = $409124218b1e663f$var$C;
        try {
            $409124218b1e663f$var$ok.transition = null;
            $409124218b1e663f$var$C = 16 > a ? 16 : a;
            if (null === $409124218b1e663f$var$wk) var d = !1;
            else {
                a = $409124218b1e663f$var$wk;
                $409124218b1e663f$var$wk = null;
                $409124218b1e663f$var$xk = 0;
                if (0 !== ($409124218b1e663f$var$K & 6)) throw Error($409124218b1e663f$var$p(331));
                var e = $409124218b1e663f$var$K;
                $409124218b1e663f$var$K |= 4;
                for($409124218b1e663f$var$V = a.current; null !== $409124218b1e663f$var$V;){
                    var f = $409124218b1e663f$var$V, g = f.child;
                    if (0 !== ($409124218b1e663f$var$V.flags & 16)) {
                        var h = f.deletions;
                        if (null !== h) {
                            for(var k = 0; k < h.length; k++){
                                var l = h[k];
                                for($409124218b1e663f$var$V = l; null !== $409124218b1e663f$var$V;){
                                    var m = $409124218b1e663f$var$V;
                                    switch(m.tag){
                                        case 0:
                                        case 11:
                                        case 15:
                                            $409124218b1e663f$var$Pj(8, m, f);
                                    }
                                    var q = m.child;
                                    if (null !== q) q.return = m, $409124218b1e663f$var$V = q;
                                    else for(; null !== $409124218b1e663f$var$V;){
                                        m = $409124218b1e663f$var$V;
                                        var r = m.sibling, y = m.return;
                                        $409124218b1e663f$var$Sj(m);
                                        if (m === l) {
                                            $409124218b1e663f$var$V = null;
                                            break;
                                        }
                                        if (null !== r) {
                                            r.return = y;
                                            $409124218b1e663f$var$V = r;
                                            break;
                                        }
                                        $409124218b1e663f$var$V = y;
                                    }
                                }
                            }
                            var n = f.alternate;
                            if (null !== n) {
                                var t = n.child;
                                if (null !== t) {
                                    n.child = null;
                                    do {
                                        var J = t.sibling;
                                        t.sibling = null;
                                        t = J;
                                    }while (null !== t);
                                }
                            }
                            $409124218b1e663f$var$V = f;
                        }
                    }
                    if (0 !== (f.subtreeFlags & 2064) && null !== g) g.return = f, $409124218b1e663f$var$V = g;
                    else b: for(; null !== $409124218b1e663f$var$V;){
                        f = $409124218b1e663f$var$V;
                        if (0 !== (f.flags & 2048)) switch(f.tag){
                            case 0:
                            case 11:
                            case 15:
                                $409124218b1e663f$var$Pj(9, f, f.return);
                        }
                        var x = f.sibling;
                        if (null !== x) {
                            x.return = f.return;
                            $409124218b1e663f$var$V = x;
                            break b;
                        }
                        $409124218b1e663f$var$V = f.return;
                    }
                }
                var w = a.current;
                for($409124218b1e663f$var$V = w; null !== $409124218b1e663f$var$V;){
                    g = $409124218b1e663f$var$V;
                    var u = g.child;
                    if (0 !== (g.subtreeFlags & 2064) && null !== u) u.return = g, $409124218b1e663f$var$V = u;
                    else b: for(g = w; null !== $409124218b1e663f$var$V;){
                        h = $409124218b1e663f$var$V;
                        if (0 !== (h.flags & 2048)) try {
                            switch(h.tag){
                                case 0:
                                case 11:
                                case 15:
                                    $409124218b1e663f$var$Qj(9, h);
                            }
                        } catch (na) {
                            $409124218b1e663f$var$W(h, h.return, na);
                        }
                        if (h === g) {
                            $409124218b1e663f$var$V = null;
                            break b;
                        }
                        var F = h.sibling;
                        if (null !== F) {
                            F.return = h.return;
                            $409124218b1e663f$var$V = F;
                            break b;
                        }
                        $409124218b1e663f$var$V = h.return;
                    }
                }
                $409124218b1e663f$var$K = e;
                $409124218b1e663f$var$jg();
                if ($409124218b1e663f$var$lc && "function" === typeof $409124218b1e663f$var$lc.onPostCommitFiberRoot) try {
                    $409124218b1e663f$var$lc.onPostCommitFiberRoot($409124218b1e663f$var$kc, a);
                } catch (na) {}
                d = !0;
            }
            return d;
        } finally{
            $409124218b1e663f$var$C = c, $409124218b1e663f$var$ok.transition = b;
        }
    }
    return !1;
}
function $409124218b1e663f$var$Xk(a, b, c) {
    b = $409124218b1e663f$var$Ji(c, b);
    b = $409124218b1e663f$var$Ni(a, b, 1);
    a = $409124218b1e663f$var$nh(a, b, 1);
    b = $409124218b1e663f$var$R();
    null !== a && ($409124218b1e663f$var$Ac(a, 1, b), $409124218b1e663f$var$Dk(a, b));
}
function $409124218b1e663f$var$W(a, b, c) {
    if (3 === a.tag) $409124218b1e663f$var$Xk(a, a, c);
    else for(; null !== b;){
        if (3 === b.tag) {
            $409124218b1e663f$var$Xk(b, a, c);
            break;
        } else if (1 === b.tag) {
            var d = b.stateNode;
            if ("function" === typeof b.type.getDerivedStateFromError || "function" === typeof d.componentDidCatch && (null === $409124218b1e663f$var$Ri || !$409124218b1e663f$var$Ri.has(d))) {
                a = $409124218b1e663f$var$Ji(c, a);
                a = $409124218b1e663f$var$Qi(b, a, 1);
                b = $409124218b1e663f$var$nh(b, a, 1);
                a = $409124218b1e663f$var$R();
                null !== b && ($409124218b1e663f$var$Ac(b, 1, a), $409124218b1e663f$var$Dk(b, a));
                break;
            }
        }
        b = b.return;
    }
}
function $409124218b1e663f$var$Ti(a, b, c) {
    var d = a.pingCache;
    null !== d && d.delete(b);
    b = $409124218b1e663f$var$R();
    a.pingedLanes |= a.suspendedLanes & c;
    $409124218b1e663f$var$Q === a && ($409124218b1e663f$var$Z & c) === c && (4 === $409124218b1e663f$var$T || 3 === $409124218b1e663f$var$T && ($409124218b1e663f$var$Z & 130023424) === $409124218b1e663f$var$Z && 500 > $409124218b1e663f$var$B() - $409124218b1e663f$var$fk ? $409124218b1e663f$var$Kk(a, 0) : $409124218b1e663f$var$rk |= c);
    $409124218b1e663f$var$Dk(a, b);
}
function $409124218b1e663f$var$Yk(a, b) {
    0 === b && (0 === (a.mode & 1) ? b = 1 : (b = $409124218b1e663f$var$sc, $409124218b1e663f$var$sc <<= 1, 0 === ($409124218b1e663f$var$sc & 130023424) && ($409124218b1e663f$var$sc = 4194304)));
    var c = $409124218b1e663f$var$R();
    a = $409124218b1e663f$var$ih(a, b);
    null !== a && ($409124218b1e663f$var$Ac(a, b, c), $409124218b1e663f$var$Dk(a, c));
}
function $409124218b1e663f$var$uj(a) {
    var b = a.memoizedState, c = 0;
    null !== b && (c = b.retryLane);
    $409124218b1e663f$var$Yk(a, c);
}
function $409124218b1e663f$var$bk(a, b) {
    var c = 0;
    switch(a.tag){
        case 13:
            var d = a.stateNode;
            var e = a.memoizedState;
            null !== e && (c = e.retryLane);
            break;
        case 19:
            d = a.stateNode;
            break;
        default:
            throw Error($409124218b1e663f$var$p(314));
    }
    null !== d && d.delete(b);
    $409124218b1e663f$var$Yk(a, c);
}
var $409124218b1e663f$var$Vk;
$409124218b1e663f$var$Vk = function(a, b, c) {
    if (null !== a) {
        if (a.memoizedProps !== b.pendingProps || $409124218b1e663f$var$Wf.current) $409124218b1e663f$var$dh = !0;
        else {
            if (0 === (a.lanes & c) && 0 === (b.flags & 128)) return $409124218b1e663f$var$dh = !1, $409124218b1e663f$var$yj(a, b, c);
            $409124218b1e663f$var$dh = 0 !== (a.flags & 131072) ? !0 : !1;
        }
    } else $409124218b1e663f$var$dh = !1, $409124218b1e663f$var$I && 0 !== (b.flags & 1048576) && $409124218b1e663f$var$ug(b, $409124218b1e663f$var$ng, b.index);
    b.lanes = 0;
    switch(b.tag){
        case 2:
            var d = b.type;
            $409124218b1e663f$var$ij(a, b);
            a = b.pendingProps;
            var e = $409124218b1e663f$var$Yf(b, $409124218b1e663f$var$H.current);
            $409124218b1e663f$var$ch(b, c);
            e = $409124218b1e663f$var$Nh(null, b, d, a, e, c);
            var f = $409124218b1e663f$var$Sh();
            b.flags |= 1;
            "object" === typeof e && null !== e && "function" === typeof e.render && void 0 === e.$$typeof ? (b.tag = 1, b.memoizedState = null, b.updateQueue = null, $409124218b1e663f$var$Zf(d) ? (f = !0, $409124218b1e663f$var$cg(b)) : f = !1, b.memoizedState = null !== e.state && void 0 !== e.state ? e.state : null, $409124218b1e663f$var$kh(b), e.updater = $409124218b1e663f$var$Ei, b.stateNode = e, e._reactInternals = b, $409124218b1e663f$var$Ii(b, d, a, c), b = $409124218b1e663f$var$jj(null, b, d, !0, f, c)) : (b.tag = 0, $409124218b1e663f$var$I && f && $409124218b1e663f$var$vg(b), $409124218b1e663f$var$Xi(null, b, e, c), b = b.child);
            return b;
        case 16:
            d = b.elementType;
            a: {
                $409124218b1e663f$var$ij(a, b);
                a = b.pendingProps;
                e = d._init;
                d = e(d._payload);
                b.type = d;
                e = b.tag = $409124218b1e663f$var$Zk(d);
                a = $409124218b1e663f$var$Ci(d, a);
                switch(e){
                    case 0:
                        b = $409124218b1e663f$var$cj(null, b, d, a, c);
                        break a;
                    case 1:
                        b = $409124218b1e663f$var$hj(null, b, d, a, c);
                        break a;
                    case 11:
                        b = $409124218b1e663f$var$Yi(null, b, d, a, c);
                        break a;
                    case 14:
                        b = $409124218b1e663f$var$$i(null, b, d, $409124218b1e663f$var$Ci(d.type, a), c);
                        break a;
                }
                throw Error($409124218b1e663f$var$p(306, d, ""));
            }
            return b;
        case 0:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $409124218b1e663f$var$Ci(d, e), $409124218b1e663f$var$cj(a, b, d, e, c);
        case 1:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $409124218b1e663f$var$Ci(d, e), $409124218b1e663f$var$hj(a, b, d, e, c);
        case 3:
            a: {
                $409124218b1e663f$var$kj(b);
                if (null === a) throw Error($409124218b1e663f$var$p(387));
                d = b.pendingProps;
                f = b.memoizedState;
                e = f.element;
                $409124218b1e663f$var$lh(a, b);
                $409124218b1e663f$var$qh(b, d, null, c);
                var g = b.memoizedState;
                d = g.element;
                if (f.isDehydrated) {
                    if (f = {
                        element: d,
                        isDehydrated: !1,
                        cache: g.cache,
                        pendingSuspenseBoundaries: g.pendingSuspenseBoundaries,
                        transitions: g.transitions
                    }, b.updateQueue.baseState = f, b.memoizedState = f, b.flags & 256) {
                        e = $409124218b1e663f$var$Ji(Error($409124218b1e663f$var$p(423)), b);
                        b = $409124218b1e663f$var$lj(a, b, d, c, e);
                        break a;
                    } else if (d !== e) {
                        e = $409124218b1e663f$var$Ji(Error($409124218b1e663f$var$p(424)), b);
                        b = $409124218b1e663f$var$lj(a, b, d, c, e);
                        break a;
                    } else for($409124218b1e663f$var$yg = $409124218b1e663f$var$Lf(b.stateNode.containerInfo.firstChild), $409124218b1e663f$var$xg = b, $409124218b1e663f$var$I = !0, $409124218b1e663f$var$zg = null, c = $409124218b1e663f$var$Vg(b, null, d, c), b.child = c; c;)c.flags = c.flags & -3 | 4096, c = c.sibling;
                } else {
                    $409124218b1e663f$var$Ig();
                    if (d === e) {
                        b = $409124218b1e663f$var$Zi(a, b, c);
                        break a;
                    }
                    $409124218b1e663f$var$Xi(a, b, d, c);
                }
                b = b.child;
            }
            return b;
        case 5:
            return $409124218b1e663f$var$Ah(b), null === a && $409124218b1e663f$var$Eg(b), d = b.type, e = b.pendingProps, f = null !== a ? a.memoizedProps : null, g = e.children, $409124218b1e663f$var$Ef(d, e) ? g = null : null !== f && $409124218b1e663f$var$Ef(d, f) && (b.flags |= 32), $409124218b1e663f$var$gj(a, b), $409124218b1e663f$var$Xi(a, b, g, c), b.child;
        case 6:
            return null === a && $409124218b1e663f$var$Eg(b), null;
        case 13:
            return $409124218b1e663f$var$oj(a, b, c);
        case 4:
            return $409124218b1e663f$var$yh(b, b.stateNode.containerInfo), d = b.pendingProps, null === a ? b.child = $409124218b1e663f$var$Ug(b, null, d, c) : $409124218b1e663f$var$Xi(a, b, d, c), b.child;
        case 11:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $409124218b1e663f$var$Ci(d, e), $409124218b1e663f$var$Yi(a, b, d, e, c);
        case 7:
            return $409124218b1e663f$var$Xi(a, b, b.pendingProps, c), b.child;
        case 8:
            return $409124218b1e663f$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 12:
            return $409124218b1e663f$var$Xi(a, b, b.pendingProps.children, c), b.child;
        case 10:
            a: {
                d = b.type._context;
                e = b.pendingProps;
                f = b.memoizedProps;
                g = e.value;
                $409124218b1e663f$var$G($409124218b1e663f$var$Wg, d._currentValue);
                d._currentValue = g;
                if (null !== f) {
                    if ($409124218b1e663f$var$He(f.value, g)) {
                        if (f.children === e.children && !$409124218b1e663f$var$Wf.current) {
                            b = $409124218b1e663f$var$Zi(a, b, c);
                            break a;
                        }
                    } else for(f = b.child, null !== f && (f.return = b); null !== f;){
                        var h = f.dependencies;
                        if (null !== h) {
                            g = f.child;
                            for(var k = h.firstContext; null !== k;){
                                if (k.context === d) {
                                    if (1 === f.tag) {
                                        k = $409124218b1e663f$var$mh(-1, c & -c);
                                        k.tag = 2;
                                        var l = f.updateQueue;
                                        if (null !== l) {
                                            l = l.shared;
                                            var m = l.pending;
                                            null === m ? k.next = k : (k.next = m.next, m.next = k);
                                            l.pending = k;
                                        }
                                    }
                                    f.lanes |= c;
                                    k = f.alternate;
                                    null !== k && (k.lanes |= c);
                                    $409124218b1e663f$var$bh(f.return, c, b);
                                    h.lanes |= c;
                                    break;
                                }
                                k = k.next;
                            }
                        } else if (10 === f.tag) g = f.type === b.type ? null : f.child;
                        else if (18 === f.tag) {
                            g = f.return;
                            if (null === g) throw Error($409124218b1e663f$var$p(341));
                            g.lanes |= c;
                            h = g.alternate;
                            null !== h && (h.lanes |= c);
                            $409124218b1e663f$var$bh(g, c, b);
                            g = f.sibling;
                        } else g = f.child;
                        if (null !== g) g.return = f;
                        else for(g = f; null !== g;){
                            if (g === b) {
                                g = null;
                                break;
                            }
                            f = g.sibling;
                            if (null !== f) {
                                f.return = g.return;
                                g = f;
                                break;
                            }
                            g = g.return;
                        }
                        f = g;
                    }
                }
                $409124218b1e663f$var$Xi(a, b, e.children, c);
                b = b.child;
            }
            return b;
        case 9:
            return e = b.type, d = b.pendingProps.children, $409124218b1e663f$var$ch(b, c), e = $409124218b1e663f$var$eh(e), d = d(e), b.flags |= 1, $409124218b1e663f$var$Xi(a, b, d, c), b.child;
        case 14:
            return d = b.type, e = $409124218b1e663f$var$Ci(d, b.pendingProps), e = $409124218b1e663f$var$Ci(d.type, e), $409124218b1e663f$var$$i(a, b, d, e, c);
        case 15:
            return $409124218b1e663f$var$bj(a, b, b.type, b.pendingProps, c);
        case 17:
            return d = b.type, e = b.pendingProps, e = b.elementType === d ? e : $409124218b1e663f$var$Ci(d, e), $409124218b1e663f$var$ij(a, b), b.tag = 1, $409124218b1e663f$var$Zf(d) ? (a = !0, $409124218b1e663f$var$cg(b)) : a = !1, $409124218b1e663f$var$ch(b, c), $409124218b1e663f$var$Gi(b, d, e), $409124218b1e663f$var$Ii(b, d, e, c), $409124218b1e663f$var$jj(null, b, d, !0, a, c);
        case 19:
            return $409124218b1e663f$var$xj(a, b, c);
        case 22:
            return $409124218b1e663f$var$dj(a, b, c);
    }
    throw Error($409124218b1e663f$var$p(156, b.tag));
};
function $409124218b1e663f$var$Fk(a, b) {
    return $409124218b1e663f$var$ac(a, b);
}
function $409124218b1e663f$var$$k(a, b, c, d) {
    this.tag = a;
    this.key = c;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.ref = null;
    this.pendingProps = b;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = d;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $409124218b1e663f$var$Bg(a, b, c, d) {
    return new $409124218b1e663f$var$$k(a, b, c, d);
}
function $409124218b1e663f$var$aj(a) {
    a = a.prototype;
    return !(!a || !a.isReactComponent);
}
function $409124218b1e663f$var$Zk(a) {
    if ("function" === typeof a) return $409124218b1e663f$var$aj(a) ? 1 : 0;
    if (void 0 !== a && null !== a) {
        a = a.$$typeof;
        if (a === $409124218b1e663f$var$Da) return 11;
        if (a === $409124218b1e663f$var$Ga) return 14;
    }
    return 2;
}
function $409124218b1e663f$var$Pg(a, b) {
    var c = a.alternate;
    null === c ? (c = $409124218b1e663f$var$Bg(a.tag, b, a.key, a.mode), c.elementType = a.elementType, c.type = a.type, c.stateNode = a.stateNode, c.alternate = a, a.alternate = c) : (c.pendingProps = b, c.type = a.type, c.flags = 0, c.subtreeFlags = 0, c.deletions = null);
    c.flags = a.flags & 14680064;
    c.childLanes = a.childLanes;
    c.lanes = a.lanes;
    c.child = a.child;
    c.memoizedProps = a.memoizedProps;
    c.memoizedState = a.memoizedState;
    c.updateQueue = a.updateQueue;
    b = a.dependencies;
    c.dependencies = null === b ? null : {
        lanes: b.lanes,
        firstContext: b.firstContext
    };
    c.sibling = a.sibling;
    c.index = a.index;
    c.ref = a.ref;
    return c;
}
function $409124218b1e663f$var$Rg(a, b, c, d, e, f) {
    var g = 2;
    d = a;
    if ("function" === typeof a) $409124218b1e663f$var$aj(a) && (g = 1);
    else if ("string" === typeof a) g = 5;
    else a: switch(a){
        case $409124218b1e663f$var$ya:
            return $409124218b1e663f$var$Tg(c.children, e, f, b);
        case $409124218b1e663f$var$za:
            g = 8;
            e |= 8;
            break;
        case $409124218b1e663f$var$Aa:
            return a = $409124218b1e663f$var$Bg(12, c, b, e | 2), a.elementType = $409124218b1e663f$var$Aa, a.lanes = f, a;
        case $409124218b1e663f$var$Ea:
            return a = $409124218b1e663f$var$Bg(13, c, b, e), a.elementType = $409124218b1e663f$var$Ea, a.lanes = f, a;
        case $409124218b1e663f$var$Fa:
            return a = $409124218b1e663f$var$Bg(19, c, b, e), a.elementType = $409124218b1e663f$var$Fa, a.lanes = f, a;
        case $409124218b1e663f$var$Ia:
            return $409124218b1e663f$var$pj(c, e, f, b);
        default:
            if ("object" === typeof a && null !== a) switch(a.$$typeof){
                case $409124218b1e663f$var$Ba:
                    g = 10;
                    break a;
                case $409124218b1e663f$var$Ca:
                    g = 9;
                    break a;
                case $409124218b1e663f$var$Da:
                    g = 11;
                    break a;
                case $409124218b1e663f$var$Ga:
                    g = 14;
                    break a;
                case $409124218b1e663f$var$Ha:
                    g = 16;
                    d = null;
                    break a;
            }
            throw Error($409124218b1e663f$var$p(130, null == a ? a : typeof a, ""));
    }
    b = $409124218b1e663f$var$Bg(g, c, b, e);
    b.elementType = a;
    b.type = d;
    b.lanes = f;
    return b;
}
function $409124218b1e663f$var$Tg(a, b, c, d) {
    a = $409124218b1e663f$var$Bg(7, a, d, b);
    a.lanes = c;
    return a;
}
function $409124218b1e663f$var$pj(a, b, c, d) {
    a = $409124218b1e663f$var$Bg(22, a, d, b);
    a.elementType = $409124218b1e663f$var$Ia;
    a.lanes = c;
    a.stateNode = {
        isHidden: !1
    };
    return a;
}
function $409124218b1e663f$var$Qg(a, b, c) {
    a = $409124218b1e663f$var$Bg(6, a, null, b);
    a.lanes = c;
    return a;
}
function $409124218b1e663f$var$Sg(a, b, c) {
    b = $409124218b1e663f$var$Bg(4, null !== a.children ? a.children : [], a.key, b);
    b.lanes = c;
    b.stateNode = {
        containerInfo: a.containerInfo,
        pendingChildren: null,
        implementation: a.implementation
    };
    return b;
}
function $409124218b1e663f$var$al(a, b, c, d, e) {
    this.tag = b;
    this.containerInfo = a;
    this.finishedWork = this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.pendingContext = this.context = null;
    this.callbackPriority = 0;
    this.eventTimes = $409124218b1e663f$var$zc(0);
    this.expirationTimes = $409124218b1e663f$var$zc(-1);
    this.entangledLanes = this.finishedLanes = this.mutableReadLanes = this.expiredLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $409124218b1e663f$var$zc(0);
    this.identifierPrefix = d;
    this.onRecoverableError = e;
    this.mutableSourceEagerHydrationData = null;
}
function $409124218b1e663f$var$bl(a, b, c, d, e, f, g, h, k) {
    a = new $409124218b1e663f$var$al(a, b, c, h, k);
    1 === b ? (b = 1, !0 === f && (b |= 8)) : b = 0;
    f = $409124218b1e663f$var$Bg(3, null, null, b);
    a.current = f;
    f.stateNode = a;
    f.memoizedState = {
        element: d,
        isDehydrated: c,
        cache: null,
        transitions: null,
        pendingSuspenseBoundaries: null
    };
    $409124218b1e663f$var$kh(f);
    return a;
}
function $409124218b1e663f$var$cl(a, b, c) {
    var d = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $409124218b1e663f$var$wa,
        key: null == d ? null : "" + d,
        children: a,
        containerInfo: b,
        implementation: c
    };
}
function $409124218b1e663f$var$dl(a) {
    if (!a) return $409124218b1e663f$var$Vf;
    a = a._reactInternals;
    a: {
        if ($409124218b1e663f$var$Vb(a) !== a || 1 !== a.tag) throw Error($409124218b1e663f$var$p(170));
        var b = a;
        do {
            switch(b.tag){
                case 3:
                    b = b.stateNode.context;
                    break a;
                case 1:
                    if ($409124218b1e663f$var$Zf(b.type)) {
                        b = b.stateNode.__reactInternalMemoizedMergedChildContext;
                        break a;
                    }
            }
            b = b.return;
        }while (null !== b);
        throw Error($409124218b1e663f$var$p(171));
    }
    if (1 === a.tag) {
        var c = a.type;
        if ($409124218b1e663f$var$Zf(c)) return $409124218b1e663f$var$bg(a, c, b);
    }
    return b;
}
function $409124218b1e663f$var$el(a, b, c, d, e, f, g, h, k) {
    a = $409124218b1e663f$var$bl(c, d, !0, a, e, f, g, h, k);
    a.context = $409124218b1e663f$var$dl(null);
    c = a.current;
    d = $409124218b1e663f$var$R();
    e = $409124218b1e663f$var$yi(c);
    f = $409124218b1e663f$var$mh(d, e);
    f.callback = void 0 !== b && null !== b ? b : null;
    $409124218b1e663f$var$nh(c, f, e);
    a.current.lanes = e;
    $409124218b1e663f$var$Ac(a, e, d);
    $409124218b1e663f$var$Dk(a, d);
    return a;
}
function $409124218b1e663f$var$fl(a, b, c, d) {
    var e = b.current, f = $409124218b1e663f$var$R(), g = $409124218b1e663f$var$yi(e);
    c = $409124218b1e663f$var$dl(c);
    null === b.context ? b.context = c : b.pendingContext = c;
    b = $409124218b1e663f$var$mh(f, g);
    b.payload = {
        element: a
    };
    d = void 0 === d ? null : d;
    null !== d && (b.callback = d);
    a = $409124218b1e663f$var$nh(e, b, g);
    null !== a && ($409124218b1e663f$var$gi(a, e, g, f), $409124218b1e663f$var$oh(a, e, g));
    return g;
}
function $409124218b1e663f$var$gl(a) {
    a = a.current;
    if (!a.child) return null;
    switch(a.child.tag){
        case 5:
            return a.child.stateNode;
        default:
            return a.child.stateNode;
    }
}
function $409124218b1e663f$var$hl(a, b) {
    a = a.memoizedState;
    if (null !== a && null !== a.dehydrated) {
        var c = a.retryLane;
        a.retryLane = 0 !== c && c < b ? c : b;
    }
}
function $409124218b1e663f$var$il(a, b) {
    $409124218b1e663f$var$hl(a, b);
    (a = a.alternate) && $409124218b1e663f$var$hl(a, b);
}
function $409124218b1e663f$var$jl() {
    return null;
}
var $409124218b1e663f$var$kl = "function" === typeof reportError ? reportError : function(a) {
    console.error(a);
};
function $409124218b1e663f$var$ll(a) {
    this._internalRoot = a;
}
$409124218b1e663f$var$ml.prototype.render = $409124218b1e663f$var$ll.prototype.render = function(a) {
    var b = this._internalRoot;
    if (null === b) throw Error($409124218b1e663f$var$p(409));
    $409124218b1e663f$var$fl(a, b, null, null);
};
$409124218b1e663f$var$ml.prototype.unmount = $409124218b1e663f$var$ll.prototype.unmount = function() {
    var a = this._internalRoot;
    if (null !== a) {
        this._internalRoot = null;
        var b = a.containerInfo;
        $409124218b1e663f$var$Rk(function() {
            $409124218b1e663f$var$fl(null, a, null, null);
        });
        b[$409124218b1e663f$var$uf] = null;
    }
};
function $409124218b1e663f$var$ml(a) {
    this._internalRoot = a;
}
$409124218b1e663f$var$ml.prototype.unstable_scheduleHydration = function(a) {
    if (a) {
        var b = $409124218b1e663f$var$Hc();
        a = {
            blockedOn: null,
            target: a,
            priority: b
        };
        for(var c = 0; c < $409124218b1e663f$var$Qc.length && 0 !== b && b < $409124218b1e663f$var$Qc[c].priority; c++);
        $409124218b1e663f$var$Qc.splice(c, 0, a);
        0 === c && $409124218b1e663f$var$Vc(a);
    }
};
function $409124218b1e663f$var$nl(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType);
}
function $409124218b1e663f$var$ol(a) {
    return !(!a || 1 !== a.nodeType && 9 !== a.nodeType && 11 !== a.nodeType && (8 !== a.nodeType || " react-mount-point-unstable " !== a.nodeValue));
}
function $409124218b1e663f$var$pl() {}
function $409124218b1e663f$var$ql(a, b, c, d, e) {
    if (e) {
        if ("function" === typeof d) {
            var f = d;
            d = function() {
                var a = $409124218b1e663f$var$gl(g);
                f.call(a);
            };
        }
        var g = $409124218b1e663f$var$el(b, d, a, 0, null, !1, !1, "", $409124218b1e663f$var$pl);
        a._reactRootContainer = g;
        a[$409124218b1e663f$var$uf] = g.current;
        $409124218b1e663f$var$sf(8 === a.nodeType ? a.parentNode : a);
        $409124218b1e663f$var$Rk();
        return g;
    }
    for(; e = a.lastChild;)a.removeChild(e);
    if ("function" === typeof d) {
        var h = d;
        d = function() {
            var a = $409124218b1e663f$var$gl(k);
            h.call(a);
        };
    }
    var k = $409124218b1e663f$var$bl(a, 0, !1, null, null, !1, !1, "", $409124218b1e663f$var$pl);
    a._reactRootContainer = k;
    a[$409124218b1e663f$var$uf] = k.current;
    $409124218b1e663f$var$sf(8 === a.nodeType ? a.parentNode : a);
    $409124218b1e663f$var$Rk(function() {
        $409124218b1e663f$var$fl(b, k, c, d);
    });
    return k;
}
function $409124218b1e663f$var$rl(a, b, c, d, e) {
    var f = c._reactRootContainer;
    if (f) {
        var g = f;
        if ("function" === typeof e) {
            var h = e;
            e = function() {
                var a = $409124218b1e663f$var$gl(g);
                h.call(a);
            };
        }
        $409124218b1e663f$var$fl(b, g, a, e);
    } else g = $409124218b1e663f$var$ql(c, b, a, e, d);
    return $409124218b1e663f$var$gl(g);
}
$409124218b1e663f$var$Ec = function(a) {
    switch(a.tag){
        case 3:
            var b = a.stateNode;
            if (b.current.memoizedState.isDehydrated) {
                var c = $409124218b1e663f$var$tc(b.pendingLanes);
                0 !== c && ($409124218b1e663f$var$Cc(b, c | 1), $409124218b1e663f$var$Dk(b, $409124218b1e663f$var$B()), 0 === ($409124218b1e663f$var$K & 6) && ($409124218b1e663f$var$Gj = $409124218b1e663f$var$B() + 500, $409124218b1e663f$var$jg()));
            }
            break;
        case 13:
            $409124218b1e663f$var$Rk(function() {
                var b = $409124218b1e663f$var$ih(a, 1);
                if (null !== b) {
                    var c = $409124218b1e663f$var$R();
                    $409124218b1e663f$var$gi(b, a, 1, c);
                }
            }), $409124218b1e663f$var$il(a, 1);
    }
};
$409124218b1e663f$var$Fc = function(a) {
    if (13 === a.tag) {
        var b = $409124218b1e663f$var$ih(a, 134217728);
        if (null !== b) {
            var c = $409124218b1e663f$var$R();
            $409124218b1e663f$var$gi(b, a, 134217728, c);
        }
        $409124218b1e663f$var$il(a, 134217728);
    }
};
$409124218b1e663f$var$Gc = function(a) {
    if (13 === a.tag) {
        var b = $409124218b1e663f$var$yi(a), c = $409124218b1e663f$var$ih(a, b);
        if (null !== c) {
            var d = $409124218b1e663f$var$R();
            $409124218b1e663f$var$gi(c, a, b, d);
        }
        $409124218b1e663f$var$il(a, b);
    }
};
$409124218b1e663f$var$Hc = function() {
    return $409124218b1e663f$var$C;
};
$409124218b1e663f$var$Ic = function(a, b) {
    var c = $409124218b1e663f$var$C;
    try {
        return $409124218b1e663f$var$C = a, b();
    } finally{
        $409124218b1e663f$var$C = c;
    }
};
$409124218b1e663f$var$yb = function(a, b, c) {
    switch(b){
        case "input":
            $409124218b1e663f$var$bb(a, c);
            b = c.name;
            if ("radio" === c.type && null != b) {
                for(c = a; c.parentNode;)c = c.parentNode;
                c = c.querySelectorAll("input[name=" + JSON.stringify("" + b) + '][type="radio"]');
                for(b = 0; b < c.length; b++){
                    var d = c[b];
                    if (d !== a && d.form === a.form) {
                        var e = $409124218b1e663f$var$Db(d);
                        if (!e) throw Error($409124218b1e663f$var$p(90));
                        $409124218b1e663f$var$Wa(d);
                        $409124218b1e663f$var$bb(d, e);
                    }
                }
            }
            break;
        case "textarea":
            $409124218b1e663f$var$ib(a, c);
            break;
        case "select":
            b = c.value, null != b && $409124218b1e663f$var$fb(a, !!c.multiple, b, !1);
    }
};
$409124218b1e663f$var$Gb = $409124218b1e663f$var$Qk;
$409124218b1e663f$var$Hb = $409124218b1e663f$var$Rk;
var $409124218b1e663f$var$sl = {
    usingClientEntryPoint: !1,
    Events: [
        $409124218b1e663f$var$Cb,
        $409124218b1e663f$var$ue,
        $409124218b1e663f$var$Db,
        $409124218b1e663f$var$Eb,
        $409124218b1e663f$var$Fb,
        $409124218b1e663f$var$Qk
    ]
}, $409124218b1e663f$var$tl = {
    findFiberByHostInstance: $409124218b1e663f$var$Wc,
    bundleType: 0,
    version: "18.3.1",
    rendererPackageName: "react-dom"
};
var $409124218b1e663f$var$ul = {
    bundleType: $409124218b1e663f$var$tl.bundleType,
    version: $409124218b1e663f$var$tl.version,
    rendererPackageName: $409124218b1e663f$var$tl.rendererPackageName,
    rendererConfig: $409124218b1e663f$var$tl.rendererConfig,
    overrideHookState: null,
    overrideHookStateDeletePath: null,
    overrideHookStateRenamePath: null,
    overrideProps: null,
    overridePropsDeletePath: null,
    overridePropsRenamePath: null,
    setErrorHandler: null,
    setSuspenseHandler: null,
    scheduleUpdate: null,
    currentDispatcherRef: $409124218b1e663f$var$ua.ReactCurrentDispatcher,
    findHostInstanceByFiber: function(a) {
        a = $409124218b1e663f$var$Zb(a);
        return null === a ? null : a.stateNode;
    },
    findFiberByHostInstance: $409124218b1e663f$var$tl.findFiberByHostInstance || $409124218b1e663f$var$jl,
    findHostInstancesForRefresh: null,
    scheduleRefresh: null,
    scheduleRoot: null,
    setRefreshHandler: null,
    getCurrentFiber: null,
    reconcilerVersion: "18.3.1-next-f1338f8080-20240426"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $409124218b1e663f$var$vl = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$409124218b1e663f$var$vl.isDisabled && $409124218b1e663f$var$vl.supportsFiber) try {
        $409124218b1e663f$var$kc = $409124218b1e663f$var$vl.inject($409124218b1e663f$var$ul), $409124218b1e663f$var$lc = $409124218b1e663f$var$vl;
    } catch (a) {}
}
$409124218b1e663f$export$ae55be85d98224ed = $409124218b1e663f$var$sl;
$409124218b1e663f$export$d39a5bbd09211389 = function(a, b) {
    var c = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!$409124218b1e663f$var$nl(b)) throw Error($409124218b1e663f$var$p(200));
    return $409124218b1e663f$var$cl(a, b, null, c);
};
$409124218b1e663f$export$882461b6382ed46c = function(a, b) {
    if (!$409124218b1e663f$var$nl(a)) throw Error($409124218b1e663f$var$p(299));
    var c = !1, d = "", e = $409124218b1e663f$var$kl;
    null !== b && void 0 !== b && (!0 === b.unstable_strictMode && (c = !0), void 0 !== b.identifierPrefix && (d = b.identifierPrefix), void 0 !== b.onRecoverableError && (e = b.onRecoverableError));
    b = $409124218b1e663f$var$bl(a, 1, !1, null, null, c, !1, d, e);
    a[$409124218b1e663f$var$uf] = b.current;
    $409124218b1e663f$var$sf(8 === a.nodeType ? a.parentNode : a);
    return new $409124218b1e663f$var$ll(b);
};
$409124218b1e663f$export$466bfc07425424d5 = function(a) {
    if (null == a) return null;
    if (1 === a.nodeType) return a;
    var b = a._reactInternals;
    if (void 0 === b) {
        if ("function" === typeof a.render) throw Error($409124218b1e663f$var$p(188));
        a = Object.keys(a).join(",");
        throw Error($409124218b1e663f$var$p(268, a));
    }
    a = $409124218b1e663f$var$Zb(b);
    a = null === a ? null : a.stateNode;
    return a;
};
$409124218b1e663f$export$cd75ccfd720a3cd4 = function(a) {
    return $409124218b1e663f$var$Rk(a);
};
$409124218b1e663f$export$fa8d919ba61d84db = function(a, b, c) {
    if (!$409124218b1e663f$var$ol(b)) throw Error($409124218b1e663f$var$p(200));
    return $409124218b1e663f$var$rl(null, a, b, !0, c);
};
$409124218b1e663f$export$757ceba2d55c277e = function(a, b, c) {
    if (!$409124218b1e663f$var$nl(a)) throw Error($409124218b1e663f$var$p(405));
    var d = null != c && c.hydratedSources || null, e = !1, f = "", g = $409124218b1e663f$var$kl;
    null !== c && void 0 !== c && (!0 === c.unstable_strictMode && (e = !0), void 0 !== c.identifierPrefix && (f = c.identifierPrefix), void 0 !== c.onRecoverableError && (g = c.onRecoverableError));
    b = $409124218b1e663f$var$el(b, null, a, 1, null != c ? c : null, e, !1, f, g);
    a[$409124218b1e663f$var$uf] = b.current;
    $409124218b1e663f$var$sf(a);
    if (d) for(a = 0; a < d.length; a++)c = d[a], e = c._getVersion, e = e(c._source), null == b.mutableSourceEagerHydrationData ? b.mutableSourceEagerHydrationData = [
        c,
        e
    ] : b.mutableSourceEagerHydrationData.push(c, e);
    return new $409124218b1e663f$var$ml(b);
};
$409124218b1e663f$export$b3890eb0ae9dca99 = function(a, b, c) {
    if (!$409124218b1e663f$var$ol(b)) throw Error($409124218b1e663f$var$p(200));
    return $409124218b1e663f$var$rl(null, a, b, !1, c);
};
$409124218b1e663f$export$502457920280e6be = function(a) {
    if (!$409124218b1e663f$var$ol(a)) throw Error($409124218b1e663f$var$p(40));
    return a._reactRootContainer ? ($409124218b1e663f$var$Rk(function() {
        $409124218b1e663f$var$rl(null, null, a, !1, function() {
            a._reactRootContainer = null;
            a[$409124218b1e663f$var$uf] = null;
        });
    }), !0) : !1;
};
$409124218b1e663f$export$c78a37762a8d58e1 = $409124218b1e663f$var$Qk;
$409124218b1e663f$export$dc54d992c10e8a18 = function(a, b, c, d) {
    if (!$409124218b1e663f$var$ol(c)) throw Error($409124218b1e663f$var$p(200));
    if (null == a || void 0 === a._reactInternals) throw Error($409124218b1e663f$var$p(38));
    return $409124218b1e663f$var$rl(a, b, c, !1, d);
};
$409124218b1e663f$export$83d89fbfd8236492 = "18.3.1-next-f1338f8080-20240426";

});
parcelRegister("bUepA", function(module, exports) {
'use strict';

module.exports = (parcelRequire("gxCyE"));

});
parcelRegister("gxCyE", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $c0ada330b5874b64$export$c4744153514ff05d; }, function (v) { return $c0ada330b5874b64$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $c0ada330b5874b64$export$3e506c1ccc9cc1a7; }, function (v) { return $c0ada330b5874b64$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $c0ada330b5874b64$export$e26fe2ed2fa76875; }, function (v) { return $c0ada330b5874b64$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $c0ada330b5874b64$export$502329bbf4b505b1; }, function (v) { return $c0ada330b5874b64$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $c0ada330b5874b64$export$6e3807111c4874c4; }, function (v) { return $c0ada330b5874b64$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $c0ada330b5874b64$export$c27134553091fb3a; }, function (v) { return $c0ada330b5874b64$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $c0ada330b5874b64$export$33ee1acdc04fd2a2; }, function (v) { return $c0ada330b5874b64$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $c0ada330b5874b64$export$b00a404bbd5edef2; }, function (v) { return $c0ada330b5874b64$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_continueExecution", function () { return $c0ada330b5874b64$export$8352ce38b91d0c62; }, function (v) { return $c0ada330b5874b64$export$8352ce38b91d0c62 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $c0ada330b5874b64$export$d66a1c1c77bd778b; }, function (v) { return $c0ada330b5874b64$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $c0ada330b5874b64$export$d3dfb8e4810cb555; }, function (v) { return $c0ada330b5874b64$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_getFirstCallbackNode", function () { return $c0ada330b5874b64$export$839f9183b0465a69; }, function (v) { return $c0ada330b5874b64$export$839f9183b0465a69 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $c0ada330b5874b64$export$72fdf0e06517287b; }, function (v) { return $c0ada330b5874b64$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_pauseExecution", function () { return $c0ada330b5874b64$export$4b844e58a3e414b4; }, function (v) { return $c0ada330b5874b64$export$4b844e58a3e414b4 = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $c0ada330b5874b64$export$816d2913ae6b83b1; }, function (v) { return $c0ada330b5874b64$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $c0ada330b5874b64$export$61bcfe829111a1d0; }, function (v) { return $c0ada330b5874b64$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $c0ada330b5874b64$export$7ee8c9beb337bc3f; }, function (v) { return $c0ada330b5874b64$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $c0ada330b5874b64$export$b5836b71941fa3ed; }, function (v) { return $c0ada330b5874b64$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $c0ada330b5874b64$export$cf845f2c119da08a; }, function (v) { return $c0ada330b5874b64$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $c0ada330b5874b64$export$c4744153514ff05d;
var $c0ada330b5874b64$export$3e506c1ccc9cc1a7;
var $c0ada330b5874b64$export$e26fe2ed2fa76875;
var $c0ada330b5874b64$export$502329bbf4b505b1;
var $c0ada330b5874b64$export$6e3807111c4874c4;
var $c0ada330b5874b64$export$c27134553091fb3a;
var $c0ada330b5874b64$export$33ee1acdc04fd2a2;
var $c0ada330b5874b64$export$b00a404bbd5edef2;
var $c0ada330b5874b64$export$8352ce38b91d0c62;
var $c0ada330b5874b64$export$d66a1c1c77bd778b;
var $c0ada330b5874b64$export$d3dfb8e4810cb555;
var $c0ada330b5874b64$export$839f9183b0465a69;
var $c0ada330b5874b64$export$72fdf0e06517287b;
var $c0ada330b5874b64$export$4b844e58a3e414b4;
var $c0ada330b5874b64$export$816d2913ae6b83b1;
var $c0ada330b5874b64$export$61bcfe829111a1d0;
var $c0ada330b5874b64$export$7ee8c9beb337bc3f;
var $c0ada330b5874b64$export$b5836b71941fa3ed;
var $c0ada330b5874b64$export$cf845f2c119da08a;
'use strict';
function $c0ada330b5874b64$var$f(a, b) {
    var c = a.length;
    a.push(b);
    a: for(; 0 < c;){
        var d = c - 1 >>> 1, e = a[d];
        if (0 < $c0ada330b5874b64$var$g(e, b)) a[d] = b, a[c] = e, c = d;
        else break a;
    }
}
function $c0ada330b5874b64$var$h(a) {
    return 0 === a.length ? null : a[0];
}
function $c0ada330b5874b64$var$k(a) {
    if (0 === a.length) return null;
    var b = a[0], c = a.pop();
    if (c !== b) {
        a[0] = c;
        a: for(var d = 0, e = a.length, w = e >>> 1; d < w;){
            var m = 2 * (d + 1) - 1, C = a[m], n = m + 1, x = a[n];
            if (0 > $c0ada330b5874b64$var$g(C, c)) n < e && 0 > $c0ada330b5874b64$var$g(x, C) ? (a[d] = x, a[n] = c, d = n) : (a[d] = C, a[m] = c, d = m);
            else if (n < e && 0 > $c0ada330b5874b64$var$g(x, c)) a[d] = x, a[n] = c, d = n;
            else break a;
        }
    }
    return b;
}
function $c0ada330b5874b64$var$g(a, b) {
    var c = a.sortIndex - b.sortIndex;
    return 0 !== c ? c : a.id - b.id;
}
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $c0ada330b5874b64$var$l = performance;
    $c0ada330b5874b64$export$c4744153514ff05d = function() {
        return $c0ada330b5874b64$var$l.now();
    };
} else {
    var $c0ada330b5874b64$var$p = Date, $c0ada330b5874b64$var$q = $c0ada330b5874b64$var$p.now();
    $c0ada330b5874b64$export$c4744153514ff05d = function() {
        return $c0ada330b5874b64$var$p.now() - $c0ada330b5874b64$var$q;
    };
}
var $c0ada330b5874b64$var$r = [], $c0ada330b5874b64$var$t = [], $c0ada330b5874b64$var$u = 1, $c0ada330b5874b64$var$v = null, $c0ada330b5874b64$var$y = 3, $c0ada330b5874b64$var$z = !1, $c0ada330b5874b64$var$A = !1, $c0ada330b5874b64$var$B = !1, $c0ada330b5874b64$var$D = "function" === typeof setTimeout ? setTimeout : null, $c0ada330b5874b64$var$E = "function" === typeof clearTimeout ? clearTimeout : null, $c0ada330b5874b64$var$F = "undefined" !== typeof setImmediate ? setImmediate : null;
"undefined" !== typeof navigator && void 0 !== navigator.scheduling && void 0 !== navigator.scheduling.isInputPending && navigator.scheduling.isInputPending.bind(navigator.scheduling);
function $c0ada330b5874b64$var$G(a) {
    for(var b = $c0ada330b5874b64$var$h($c0ada330b5874b64$var$t); null !== b;){
        if (null === b.callback) $c0ada330b5874b64$var$k($c0ada330b5874b64$var$t);
        else if (b.startTime <= a) $c0ada330b5874b64$var$k($c0ada330b5874b64$var$t), b.sortIndex = b.expirationTime, $c0ada330b5874b64$var$f($c0ada330b5874b64$var$r, b);
        else break;
        b = $c0ada330b5874b64$var$h($c0ada330b5874b64$var$t);
    }
}
function $c0ada330b5874b64$var$H(a) {
    $c0ada330b5874b64$var$B = !1;
    $c0ada330b5874b64$var$G(a);
    if (!$c0ada330b5874b64$var$A) {
        if (null !== $c0ada330b5874b64$var$h($c0ada330b5874b64$var$r)) $c0ada330b5874b64$var$A = !0, $c0ada330b5874b64$var$I($c0ada330b5874b64$var$J);
        else {
            var b = $c0ada330b5874b64$var$h($c0ada330b5874b64$var$t);
            null !== b && $c0ada330b5874b64$var$K($c0ada330b5874b64$var$H, b.startTime - a);
        }
    }
}
function $c0ada330b5874b64$var$J(a, b) {
    $c0ada330b5874b64$var$A = !1;
    $c0ada330b5874b64$var$B && ($c0ada330b5874b64$var$B = !1, $c0ada330b5874b64$var$E($c0ada330b5874b64$var$L), $c0ada330b5874b64$var$L = -1);
    $c0ada330b5874b64$var$z = !0;
    var c = $c0ada330b5874b64$var$y;
    try {
        $c0ada330b5874b64$var$G(b);
        for($c0ada330b5874b64$var$v = $c0ada330b5874b64$var$h($c0ada330b5874b64$var$r); null !== $c0ada330b5874b64$var$v && (!($c0ada330b5874b64$var$v.expirationTime > b) || a && !$c0ada330b5874b64$var$M());){
            var d = $c0ada330b5874b64$var$v.callback;
            if ("function" === typeof d) {
                $c0ada330b5874b64$var$v.callback = null;
                $c0ada330b5874b64$var$y = $c0ada330b5874b64$var$v.priorityLevel;
                var e = d($c0ada330b5874b64$var$v.expirationTime <= b);
                b = $c0ada330b5874b64$export$c4744153514ff05d();
                "function" === typeof e ? $c0ada330b5874b64$var$v.callback = e : $c0ada330b5874b64$var$v === $c0ada330b5874b64$var$h($c0ada330b5874b64$var$r) && $c0ada330b5874b64$var$k($c0ada330b5874b64$var$r);
                $c0ada330b5874b64$var$G(b);
            } else $c0ada330b5874b64$var$k($c0ada330b5874b64$var$r);
            $c0ada330b5874b64$var$v = $c0ada330b5874b64$var$h($c0ada330b5874b64$var$r);
        }
        if (null !== $c0ada330b5874b64$var$v) var w = !0;
        else {
            var m = $c0ada330b5874b64$var$h($c0ada330b5874b64$var$t);
            null !== m && $c0ada330b5874b64$var$K($c0ada330b5874b64$var$H, m.startTime - b);
            w = !1;
        }
        return w;
    } finally{
        $c0ada330b5874b64$var$v = null, $c0ada330b5874b64$var$y = c, $c0ada330b5874b64$var$z = !1;
    }
}
var $c0ada330b5874b64$var$N = !1, $c0ada330b5874b64$var$O = null, $c0ada330b5874b64$var$L = -1, $c0ada330b5874b64$var$P = 5, $c0ada330b5874b64$var$Q = -1;
function $c0ada330b5874b64$var$M() {
    return $c0ada330b5874b64$export$c4744153514ff05d() - $c0ada330b5874b64$var$Q < $c0ada330b5874b64$var$P ? !1 : !0;
}
function $c0ada330b5874b64$var$R() {
    if (null !== $c0ada330b5874b64$var$O) {
        var a = $c0ada330b5874b64$export$c4744153514ff05d();
        $c0ada330b5874b64$var$Q = a;
        var b = !0;
        try {
            b = $c0ada330b5874b64$var$O(!0, a);
        } finally{
            b ? $c0ada330b5874b64$var$S() : ($c0ada330b5874b64$var$N = !1, $c0ada330b5874b64$var$O = null);
        }
    } else $c0ada330b5874b64$var$N = !1;
}
var $c0ada330b5874b64$var$S;
if ("function" === typeof $c0ada330b5874b64$var$F) $c0ada330b5874b64$var$S = function() {
    $c0ada330b5874b64$var$F($c0ada330b5874b64$var$R);
};
else if ("undefined" !== typeof MessageChannel) {
    var $c0ada330b5874b64$var$T = new MessageChannel, $c0ada330b5874b64$var$U = $c0ada330b5874b64$var$T.port2;
    $c0ada330b5874b64$var$T.port1.onmessage = $c0ada330b5874b64$var$R;
    $c0ada330b5874b64$var$S = function() {
        $c0ada330b5874b64$var$U.postMessage(null);
    };
} else $c0ada330b5874b64$var$S = function() {
    $c0ada330b5874b64$var$D($c0ada330b5874b64$var$R, 0);
};
function $c0ada330b5874b64$var$I(a) {
    $c0ada330b5874b64$var$O = a;
    $c0ada330b5874b64$var$N || ($c0ada330b5874b64$var$N = !0, $c0ada330b5874b64$var$S());
}
function $c0ada330b5874b64$var$K(a, b) {
    $c0ada330b5874b64$var$L = $c0ada330b5874b64$var$D(function() {
        a($c0ada330b5874b64$export$c4744153514ff05d());
    }, b);
}
$c0ada330b5874b64$export$3e506c1ccc9cc1a7 = 5;
$c0ada330b5874b64$export$e26fe2ed2fa76875 = 1;
$c0ada330b5874b64$export$502329bbf4b505b1 = 4;
$c0ada330b5874b64$export$6e3807111c4874c4 = 3;
$c0ada330b5874b64$export$c27134553091fb3a = null;
$c0ada330b5874b64$export$33ee1acdc04fd2a2 = 2;
$c0ada330b5874b64$export$b00a404bbd5edef2 = function(a) {
    a.callback = null;
};
$c0ada330b5874b64$export$8352ce38b91d0c62 = function() {
    $c0ada330b5874b64$var$A || $c0ada330b5874b64$var$z || ($c0ada330b5874b64$var$A = !0, $c0ada330b5874b64$var$I($c0ada330b5874b64$var$J));
};
$c0ada330b5874b64$export$d66a1c1c77bd778b = function(a) {
    0 > a || 125 < a ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $c0ada330b5874b64$var$P = 0 < a ? Math.floor(1E3 / a) : 5;
};
$c0ada330b5874b64$export$d3dfb8e4810cb555 = function() {
    return $c0ada330b5874b64$var$y;
};
$c0ada330b5874b64$export$839f9183b0465a69 = function() {
    return $c0ada330b5874b64$var$h($c0ada330b5874b64$var$r);
};
$c0ada330b5874b64$export$72fdf0e06517287b = function(a) {
    switch($c0ada330b5874b64$var$y){
        case 1:
        case 2:
        case 3:
            var b = 3;
            break;
        default:
            b = $c0ada330b5874b64$var$y;
    }
    var c = $c0ada330b5874b64$var$y;
    $c0ada330b5874b64$var$y = b;
    try {
        return a();
    } finally{
        $c0ada330b5874b64$var$y = c;
    }
};
$c0ada330b5874b64$export$4b844e58a3e414b4 = function() {};
$c0ada330b5874b64$export$816d2913ae6b83b1 = function() {};
$c0ada330b5874b64$export$61bcfe829111a1d0 = function(a, b) {
    switch(a){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            a = 3;
    }
    var c = $c0ada330b5874b64$var$y;
    $c0ada330b5874b64$var$y = a;
    try {
        return b();
    } finally{
        $c0ada330b5874b64$var$y = c;
    }
};
$c0ada330b5874b64$export$7ee8c9beb337bc3f = function(a, b, c) {
    var d = $c0ada330b5874b64$export$c4744153514ff05d();
    "object" === typeof c && null !== c ? (c = c.delay, c = "number" === typeof c && 0 < c ? d + c : d) : c = d;
    switch(a){
        case 1:
            var e = -1;
            break;
        case 2:
            e = 250;
            break;
        case 5:
            e = 1073741823;
            break;
        case 4:
            e = 1E4;
            break;
        default:
            e = 5E3;
    }
    e = c + e;
    a = {
        id: $c0ada330b5874b64$var$u++,
        callback: b,
        priorityLevel: a,
        startTime: c,
        expirationTime: e,
        sortIndex: -1
    };
    c > d ? (a.sortIndex = c, $c0ada330b5874b64$var$f($c0ada330b5874b64$var$t, a), null === $c0ada330b5874b64$var$h($c0ada330b5874b64$var$r) && a === $c0ada330b5874b64$var$h($c0ada330b5874b64$var$t) && ($c0ada330b5874b64$var$B ? ($c0ada330b5874b64$var$E($c0ada330b5874b64$var$L), $c0ada330b5874b64$var$L = -1) : $c0ada330b5874b64$var$B = !0, $c0ada330b5874b64$var$K($c0ada330b5874b64$var$H, c - d))) : (a.sortIndex = e, $c0ada330b5874b64$var$f($c0ada330b5874b64$var$r, a), $c0ada330b5874b64$var$A || $c0ada330b5874b64$var$z || ($c0ada330b5874b64$var$A = !0, $c0ada330b5874b64$var$I($c0ada330b5874b64$var$J)));
    return a;
};
$c0ada330b5874b64$export$b5836b71941fa3ed = $c0ada330b5874b64$var$M;
$c0ada330b5874b64$export$cf845f2c119da08a = function(a) {
    var b = $c0ada330b5874b64$var$y;
    return function() {
        var c = $c0ada330b5874b64$var$y;
        $c0ada330b5874b64$var$y = b;
        try {
            return a.apply(this, arguments);
        } finally{
            $c0ada330b5874b64$var$y = c;
        }
    };
};

});



var $2cd5ba3b1cc28e95$exports = {};
$parcel$extendImportMap({
    "1ZPz9": "babyplanner_veronica.5c2f1d7b.png",
    "jdZSe": "fondo.a98db728.jpg",
    "iIi0I": "Logo_Vero_Echavarria_Vector.72dc2058.svg"
});

var $8c08c62dc09ea562$exports = {};
'use strict';

$8c08c62dc09ea562$exports = (parcelRequire("1DXtE"));



var $6SWiB = parcelRequire("6SWiB");
var $582122ffcee3ecd1$exports = {};

$parcel$export($582122ffcee3ecd1$exports, "createRoot", function () { return $582122ffcee3ecd1$export$882461b6382ed46c; }, function (v) { return $582122ffcee3ecd1$export$882461b6382ed46c = v; });
$parcel$export($582122ffcee3ecd1$exports, "hydrateRoot", function () { return $582122ffcee3ecd1$export$757ceba2d55c277e; }, function (v) { return $582122ffcee3ecd1$export$757ceba2d55c277e = v; });
var $582122ffcee3ecd1$export$882461b6382ed46c;
var $582122ffcee3ecd1$export$757ceba2d55c277e;
'use strict';
var $ac53942f71d960c8$exports = {};
'use strict';
function $ac53942f71d960c8$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($ac53942f71d960c8$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$ac53942f71d960c8$var$checkDCE();

$ac53942f71d960c8$exports = (parcelRequire("5xGGd"));


var $582122ffcee3ecd1$var$i;
$582122ffcee3ecd1$export$882461b6382ed46c = $ac53942f71d960c8$exports.createRoot;
$582122ffcee3ecd1$export$757ceba2d55c277e = $ac53942f71d960c8$exports.hydrateRoot;



parcelRequire("6SWiB");
/**
 * React Router DOM v6.30.4
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $6SWiB = parcelRequire("6SWiB");

/**
 * @remix-run/router v1.23.3
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $dae0ef9fca964cc6$var$_extends() {
    return $dae0ef9fca964cc6$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $dae0ef9fca964cc6$var$_extends.apply(null, arguments);
}
////////////////////////////////////////////////////////////////////////////////
//#region Types and Constants
////////////////////////////////////////////////////////////////////////////////
/**
 * Actions represent the type of change to a location value.
 */ var $dae0ef9fca964cc6$export$e19cd5f9376f8cee;
(function(Action) {
    /**
   * A POP indicates a change to an arbitrary index in the history stack, such
   * as a back or forward navigation. It does not describe the direction of the
   * navigation, only that the current index changed.
   *
   * Note: This is the default action for newly created history objects.
   */ Action["Pop"] = "POP";
    /**
   * A PUSH indicates a new entry being added to the history stack, such as when
   * a link is clicked and a new page loads. When this happens, all subsequent
   * entries in the stack are lost.
   */ Action["Push"] = "PUSH";
    /**
   * A REPLACE indicates the entry at the current index in the history stack
   * being replaced by a new one.
   */ Action["Replace"] = "REPLACE";
})($dae0ef9fca964cc6$export$e19cd5f9376f8cee || ($dae0ef9fca964cc6$export$e19cd5f9376f8cee = {}));
const $dae0ef9fca964cc6$var$PopStateEventType = "popstate";
/**
 * Memory history stores the current location in memory. It is designed for use
 * in stateful non-browser environments like tests and React Native.
 */ function $dae0ef9fca964cc6$export$2b76ad033c6e6d08(options) {
    if (options === void 0) options = {};
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries; // Declare so we can access from createMemoryLocation
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : undefined));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = $dae0ef9fca964cc6$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state, key) {
        if (state === void 0) state = null;
        let location = $dae0ef9fca964cc6$var$createLocation(entries ? getCurrentLocation().pathname : "/", to, state, key);
        $dae0ef9fca964cc6$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: " + JSON.stringify(to));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $dae0ef9fca964cc6$export$fe53371bee54353d(to);
    }
    let history = {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $dae0ef9fca964cc6$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = $dae0ef9fca964cc6$export$e19cd5f9376f8cee.Push;
            let nextLocation = createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = $dae0ef9fca964cc6$export$e19cd5f9376f8cee.Replace;
            let nextLocation = createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = $dae0ef9fca964cc6$export$e19cd5f9376f8cee.Pop;
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
    return history;
}
/**
 * Browser history stores the location in regular URLs. This is the standard for
 * most web apps, but it requires some configuration on the server to ensure you
 * serve the same app at multiple URLs.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
 */ function $dae0ef9fca964cc6$export$719fc203c4e16dee(options) {
    if (options === void 0) options = {};
    function createBrowserLocation(window1, globalHistory) {
        let { pathname: pathname, search: search, hash: hash } = window1.location;
        return $dae0ef9fca964cc6$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createBrowserHref(window1, to) {
        return typeof to === "string" ? to : $dae0ef9fca964cc6$export$fe53371bee54353d(to);
    }
    return $dae0ef9fca964cc6$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
 * Hash history stores the location in window.location.hash. This makes it ideal
 * for situations where you don't want to send the location to the server for
 * some reason, either because you do cannot configure it or the URL space is
 * reserved for something else.
 *
 * @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
 */ function $dae0ef9fca964cc6$export$b71fdd3798280242(options) {
    if (options === void 0) options = {};
    function createHashLocation(window1, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $dae0ef9fca964cc6$export$8ccf933b0513f8d0(window1.location.hash.substr(1));
        // Hash URL should always have a leading / just like window.location.pathname
        // does, so if an app ends up at a route like /#something then we add a
        // leading slash so all of our path-matching behaves the same as if it would
        // in a browser router.  This is particularly important when there exists a
        // root splat route (<Route path="*">) since that matches internally against
        // "/*" and we'd expect /#something to 404 in a hash router app.
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $dae0ef9fca964cc6$var$createLocation("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, // state defaults to `null` because `window.history.state` does
        globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window1, to) {
        let base = window1.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window1.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $dae0ef9fca964cc6$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $dae0ef9fca964cc6$export$c0e02632e14916fd(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(" + JSON.stringify(to) + ")");
    }
    return $dae0ef9fca964cc6$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $dae0ef9fca964cc6$export$3e9cee6b33872309(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $dae0ef9fca964cc6$export$c0e02632e14916fd(cond, message) {
    if (!cond) {
        // eslint-disable-next-line no-console
        if (typeof console !== "undefined") console.warn(message);
        try {
            // Welcome to debugging history!
            //
            // This error is thrown as a convenience, so you can more easily
            // find the source for a warning that appears in the console by
            // enabling "pause on exceptions" in your JavaScript debugger.
            throw new Error(message);
        // eslint-disable-next-line no-empty
        } catch (e) {}
    }
}
function $dae0ef9fca964cc6$var$createKey() {
    return Math.random().toString(36).substr(2, 8);
}
/**
 * For browser-based histories, we combine the state and key into an object
 */ function $dae0ef9fca964cc6$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index
    };
}
/**
 * Creates a Location object with a unique key from the given Path
 */ function $dae0ef9fca964cc6$var$createLocation(current, to, state, key) {
    if (state === void 0) state = null;
    let location = $dae0ef9fca964cc6$var$_extends({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $dae0ef9fca964cc6$export$8ccf933b0513f8d0(to) : to, {
        state: state,
        // TODO: This could be cleaned up.  push/replace should probably just take
        // full Locations now and avoid the need to run through this flow at all
        // But that's a pretty big refactor to the current test suite so going to
        // keep as is for the time being and just let any incoming keys take precedence
        key: to && to.key || key || $dae0ef9fca964cc6$var$createKey()
    });
    return location;
}
/**
 * Creates a string URL path from the given pathname, search, and hash components.
 */ function $dae0ef9fca964cc6$export$fe53371bee54353d(_ref) {
    let { pathname: pathname = "/", search: search = "", hash: hash = "" } = _ref;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
 * Parses a string URL path into its separate pathname, search, and hash components.
 */ function $dae0ef9fca964cc6$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substr(hashIndex);
            path = path.substr(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substr(searchIndex);
            path = path.substr(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $dae0ef9fca964cc6$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options) {
    if (options === void 0) options = {};
    let { window: window1 = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window1.history;
    let action = $dae0ef9fca964cc6$export$e19cd5f9376f8cee.Pop;
    let listener = null;
    let index = getIndex();
    // Index should only be null when we initialize. If not, it's because the
    // user called history.pushState or history.replaceState directly, in which
    // case we should log a warning as it will result in bugs.
    if (index == null) {
        index = 0;
        globalHistory.replaceState($dae0ef9fca964cc6$var$_extends({}, globalHistory.state, {
            idx: index
        }), "");
    }
    function getIndex() {
        let state = globalHistory.state || {
            idx: null
        };
        return state.idx;
    }
    function handlePop() {
        action = $dae0ef9fca964cc6$export$e19cd5f9376f8cee.Pop;
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = $dae0ef9fca964cc6$export$e19cd5f9376f8cee.Push;
        let location = $dae0ef9fca964cc6$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $dae0ef9fca964cc6$var$getHistoryState(location, index);
        let url = history.createHref(location);
        // try...catch because iOS limits us to 100 pushState calls :/
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            // If the exception is because `state` can't be serialized, let that throw
            // outwards just like a replace call would so the dev knows the cause
            // https://html.spec.whatwg.org/multipage/nav-history-apis.html#shared-history-push/replace-state-steps
            // https://html.spec.whatwg.org/multipage/structured-data.html#structuredserializeinternal
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            // They are going to lose state here, but there is no real
            // way to warn them about it since the page will refresh...
            window1.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = $dae0ef9fca964cc6$export$e19cd5f9376f8cee.Replace;
        let location = $dae0ef9fca964cc6$var$createLocation(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $dae0ef9fca964cc6$var$getHistoryState(location, index);
        let url = history.createHref(location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        // window.location.origin is "null" (the literal string value) in Firefox
        // under certain conditions, notably when serving from a local HTML file
        // See https://bugzilla.mozilla.org/show_bug.cgi?id=878297
        let base = window1.location.origin !== "null" ? window1.location.origin : window1.location.href;
        let href = typeof to === "string" ? to : $dae0ef9fca964cc6$export$fe53371bee54353d(to);
        // Treating this as a full URL will strip any trailing spaces so we need to
        // pre-encode them since they might be part of a matching splat param from
        // an ancestor route
        href = href.replace(/ $/, "%20");
        $dae0ef9fca964cc6$export$3e9cee6b33872309(base, "No window.location.(origin|href) available to create URL for href: " + href);
        return new URL(href, base);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window1, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window1.addEventListener($dae0ef9fca964cc6$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window1.removeEventListener($dae0ef9fca964cc6$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window1, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            // Encode a Location the same way window.location would
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
//#endregion
var $dae0ef9fca964cc6$var$ResultType;
(function(ResultType) {
    ResultType["data"] = "data";
    ResultType["deferred"] = "deferred";
    ResultType["redirect"] = "redirect";
    ResultType["error"] = "error";
})($dae0ef9fca964cc6$var$ResultType || ($dae0ef9fca964cc6$var$ResultType = {}));
const $dae0ef9fca964cc6$var$immutableRouteKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function $dae0ef9fca964cc6$var$isIndexRoute(route) {
    return route.index === true;
}
// Walk the route tree generating unique IDs where necessary, so we are working
// solely with AgnosticDataRouteObject's within the Router
function $dae0ef9fca964cc6$export$4a6d22b32134ea5d(routes, mapRouteProperties, parentPath, manifest) {
    if (parentPath === void 0) parentPath = [];
    if (manifest === void 0) manifest = {};
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        $dae0ef9fca964cc6$export$3e9cee6b33872309(route.index !== true || !route.children, "Cannot specify children on an index route");
        $dae0ef9fca964cc6$export$3e9cee6b33872309(!manifest[id], "Found a route id collision on id \"" + id + "\".  Route " + "id's must be globally unique within Data Router usages");
        if ($dae0ef9fca964cc6$var$isIndexRoute(route)) {
            let indexRoute = $dae0ef9fca964cc6$var$_extends({}, route, mapRouteProperties(route), {
                id: id
            });
            manifest[id] = indexRoute;
            return indexRoute;
        } else {
            let pathOrLayoutRoute = $dae0ef9fca964cc6$var$_extends({}, route, mapRouteProperties(route), {
                id: id,
                children: undefined
            });
            manifest[id] = pathOrLayoutRoute;
            if (route.children) pathOrLayoutRoute.children = $dae0ef9fca964cc6$export$4a6d22b32134ea5d(route.children, mapRouteProperties, treePath, manifest);
            return pathOrLayoutRoute;
        }
    });
}
/**
 * Matches the given routes to a location and returns the match data.
 *
 * @see https://reactrouter.com/v6/utils/match-routes
 */ function $dae0ef9fca964cc6$export$2708184779ceb39d(routes, locationArg, basename) {
    if (basename === void 0) basename = "/";
    return $dae0ef9fca964cc6$var$matchRoutesImpl(routes, locationArg, basename, false);
}
function $dae0ef9fca964cc6$var$matchRoutesImpl(routes, locationArg, basename, allowPartial) {
    let location = typeof locationArg === "string" ? $dae0ef9fca964cc6$export$8ccf933b0513f8d0(locationArg) : locationArg;
    let pathname = $dae0ef9fca964cc6$export$b69e3301ce081aa3(location.pathname || "/", basename);
    if (pathname == null) return null;
    let branches = $dae0ef9fca964cc6$var$flattenRoutes(routes);
    $dae0ef9fca964cc6$var$rankRouteBranches(branches);
    let matches = null;
    let decoded = $dae0ef9fca964cc6$export$30d21fd6d7295f52(pathname);
    for(let i = 0; matches == null && i < branches.length; ++i)// Incoming pathnames are generally encoded from either window.location
    // or from router.navigate, but we want to match against the unencoded
    // paths in the route definitions.  Memory router locations won't be
    // encoded here but there also shouldn't be anything to decode so this
    // should be a safe operation.  This avoids needing matchRoutes to be
    // history-aware.
    matches = $dae0ef9fca964cc6$var$matchRouteBranch(branches[i], decoded, allowPartial);
    return matches;
}
function $dae0ef9fca964cc6$export$b3fac024fad9e8ff(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        data: loaderData[route.id],
        handle: route.handle
    };
}
function $dae0ef9fca964cc6$var$flattenRoutes(routes, branches, parentsMeta, parentPath) {
    if (branches === void 0) branches = [];
    if (parentsMeta === void 0) parentsMeta = [];
    if (parentPath === void 0) parentPath = "";
    let flattenRoute = (route, index, relativePath)=>{
        let meta = {
            relativePath: relativePath === undefined ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            $dae0ef9fca964cc6$export$3e9cee6b33872309(meta.relativePath.startsWith(parentPath), "Absolute route path \"" + meta.relativePath + "\" nested under path " + ("\"" + parentPath + "\" is not valid. An absolute child route path ") + "must start with the combined path of all its parent routes.");
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $dae0ef9fca964cc6$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        // Add the children before adding this route to the array, so we traverse the
        // route tree depth-first and child routes appear before their parents in
        // the "flattened" version.
        if (route.children && route.children.length > 0) {
            $dae0ef9fca964cc6$export$3e9cee6b33872309(// Our types know better, but runtime JS may not!
            // @ts-expect-error
            route.index !== true, "Index routes must not have child routes. Please remove " + ("all child routes from route path \"" + path + "\"."));
            $dae0ef9fca964cc6$var$flattenRoutes(route.children, branches, routesMeta, path);
        }
        // Routes without a path shouldn't ever match by themselves unless they are
        // index routes, so don't add them to the list of possible branches.
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $dae0ef9fca964cc6$var$computeScore(path, route.index),
            routesMeta: routesMeta
        });
    };
    routes.forEach((route, index)=>{
        var _route$path;
        // coarse-grain check for optional params
        if (route.path === "" || !((_route$path = route.path) != null && _route$path.includes("?"))) flattenRoute(route, index);
        else for (let exploded of $dae0ef9fca964cc6$var$explodeOptionalSegments(route.path))flattenRoute(route, index, exploded);
    });
    return branches;
}
/**
 * Computes all combinations of optional path segments for a given path,
 * excluding combinations that are ambiguous and of lower priority.
 *
 * For example, `/one/:two?/three/:four?/:five?` explodes to:
 * - `/one/three`
 * - `/one/:two/three`
 * - `/one/three/:four`
 * - `/one/three/:five`
 * - `/one/:two/three/:four`
 * - `/one/:two/three/:five`
 * - `/one/three/:four/:five`
 * - `/one/:two/three/:four/:five`
 */ function $dae0ef9fca964cc6$var$explodeOptionalSegments(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    // Optional path segments are denoted by a trailing `?`
    let isOptional = first.endsWith("?");
    // Compute the corresponding required segment: `foo?` -> `foo`
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) // Intepret empty string as omitting an optional segment
    // `["one", "", "three"]` corresponds to omitting `:two` from `/one/:two?/three` -> `/one/three`
    return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $dae0ef9fca964cc6$var$explodeOptionalSegments(rest.join("/"));
    let result = [];
    // All child paths with the prefix.  Do this for all children before the
    // optional version for all children, so we get consistent ordering where the
    // parent optional aspect is preferred as required.  Otherwise, we can get
    // child sections interspersed where deeper optional segments are higher than
    // parent optional segments, where for example, /:two would explode _earlier_
    // then /:one.  By always including the parent as required _for all children_
    // first, we avoid this issue
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    // Then, if this is an optional value, add all child versions without
    if (isOptional) result.push(...restExploded);
    // for absolute paths, ensure `/` instead of empty segment
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $dae0ef9fca964cc6$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score // Higher score first
         : $dae0ef9fca964cc6$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $dae0ef9fca964cc6$var$paramRe = /^:[\w-]+$/;
const $dae0ef9fca964cc6$var$dynamicSegmentValue = 3;
const $dae0ef9fca964cc6$var$indexRouteValue = 2;
const $dae0ef9fca964cc6$var$emptySegmentValue = 1;
const $dae0ef9fca964cc6$var$staticSegmentValue = 10;
const $dae0ef9fca964cc6$var$splatPenalty = -2;
const $dae0ef9fca964cc6$var$isSplat = (s)=>s === "*";
function $dae0ef9fca964cc6$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($dae0ef9fca964cc6$var$isSplat)) initialScore += $dae0ef9fca964cc6$var$splatPenalty;
    if (index) initialScore += $dae0ef9fca964cc6$var$indexRouteValue;
    return segments.filter((s)=>!$dae0ef9fca964cc6$var$isSplat(s)).reduce((score, segment)=>score + ($dae0ef9fca964cc6$var$paramRe.test(segment) ? $dae0ef9fca964cc6$var$dynamicSegmentValue : segment === "" ? $dae0ef9fca964cc6$var$emptySegmentValue : $dae0ef9fca964cc6$var$staticSegmentValue), initialScore);
}
function $dae0ef9fca964cc6$var$compareIndexes(a, b) {
    let siblings = a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]);
    return siblings ? // If two routes are siblings, we should try to match the earlier sibling
    // first. This allows people to have fine-grained control over the matching
    // behavior by simply putting routes with identical paths in the order they
    // want them tried.
    a[a.length - 1] - b[b.length - 1] : // Otherwise, it doesn't really make sense to rank non-siblings by index,
    // so they sort equally.
    0;
}
function $dae0ef9fca964cc6$var$matchRouteBranch(branch, pathname, allowPartial) {
    if (allowPartial === void 0) allowPartial = false;
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let match = $dae0ef9fca964cc6$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        }, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $dae0ef9fca964cc6$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            // TODO: Can this as be avoided?
            params: matchedParams,
            pathname: $dae0ef9fca964cc6$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $dae0ef9fca964cc6$export$a5c6d149b50c1d86($dae0ef9fca964cc6$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $dae0ef9fca964cc6$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
 * Returns a path with params interpolated.
 *
 * @see https://reactrouter.com/v6/utils/generate-path
 */ function $dae0ef9fca964cc6$export$82476f982757e71e(originalPath, params) {
    if (params === void 0) params = {};
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        $dae0ef9fca964cc6$export$c0e02632e14916fd(false, "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
        path = path.replace(/\*$/, "/*");
    }
    // ensure `/` is added at the beginning if the path is absolute
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    const segments = path.split(/\/+/).map((segment, index, array)=>{
        const isLastSegment = index === array.length - 1;
        // only apply the splat if it's the last segment
        if (isLastSegment && segment === "*") {
            const star = "*";
            // Apply the splat
            return stringify(params[star]);
        }
        const keyMatch = segment.match(/^:([\w-]+)(\??)$/);
        if (keyMatch) {
            const [, key, optional] = keyMatch;
            let param = params[key];
            $dae0ef9fca964cc6$export$3e9cee6b33872309(optional === "?" || param != null, "Missing \":" + key + "\" param");
            return stringify(param);
        }
        // Remove any optional markers from optional static segments
        return segment.replace(/\?$/g, "");
    })// Remove empty segments
    .filter((segment)=>!!segment);
    return prefix + segments.join("/");
}
/**
 * Performs pattern matching on a URL pathname and returns information about
 * the match.
 *
 * @see https://reactrouter.com/v6/utils/match-path
 */ function $dae0ef9fca964cc6$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $dae0ef9fca964cc6$var$compilePath(pattern.path, pattern.caseSensitive, pattern.end);
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = matchedPathname.replace(/(.)\/+$/, "$1");
    let captureGroups = match.slice(1);
    let params = compiledParams.reduce((memo, _ref, index)=>{
        let { paramName: paramName, isOptional: isOptional } = _ref;
        // We need to compute the pathnameBase here using the raw splat value
        // instead of using params["*"] later because it will be decoded then
        if (paramName === "*") {
            let splatValue = captureGroups[index] || "";
            pathnameBase = matchedPathname.slice(0, matchedPathname.length - splatValue.length).replace(/(.)\/+$/, "$1");
        }
        const value = captureGroups[index];
        if (isOptional && !value) memo[paramName] = undefined;
        else memo[paramName] = (value || "").replace(/%2F/g, "/");
        return memo;
    }, {});
    return {
        params: params,
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $dae0ef9fca964cc6$var$compilePath(path, caseSensitive, end) {
    if (caseSensitive === void 0) caseSensitive = false;
    if (end === void 0) end = true;
    $dae0ef9fca964cc6$export$c0e02632e14916fd(path === "*" || !path.endsWith("*") || path.endsWith("/*"), "Route path \"" + path + "\" will be treated as if it were " + ("\"" + path.replace(/\*$/, "/*") + "\" because the `*` character must ") + "always follow a `/` in the pattern. To get rid of this warning, " + ("please change the route path to \"" + path.replace(/\*$/, "/*") + "\"."));
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "") // Ignore trailing / and /*, we'll handle it below
    .replace(/^\/*/, "/") // Make sure it has a leading /
    .replace(/[\\.*+^${}|()[\]]/g, "\\$&") // Escape special regex chars
    .replace(/\/:([\w-]+)(\?)?/g, (_, paramName, isOptional)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        return isOptional ? "/?([^\\/]+)?" : "/([^\\/]+)";
    });
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" // Already matched the initial /, just match the rest
         : "(?:\\/(.+)|\\/*)$"; // Don't include the / in params["*"]
    } else if (end) // When matching to the end, ignore trailing slashes
    regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") // If our path is non-empty and contains anything beyond an initial slash,
    // then we have _some_ form of path in our regex, so we should expect to
    // match only if we find the end of this path segment.  Look for an optional
    // non-captured trailing slash (to match a portion of the URL) or the end
    // of the path (if we've matched to the end).  We used to do this with a
    // word boundary but that gives false positives on routes like
    // /user-preferences since `-` counts as a word boundary.
    regexpSource += "(?:(?=\\/|$))";
    let matcher = new RegExp(regexpSource, caseSensitive ? undefined : "i");
    return [
        matcher,
        params
    ];
}
function $dae0ef9fca964cc6$export$30d21fd6d7295f52(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        $dae0ef9fca964cc6$export$c0e02632e14916fd(false, "The URL path \"" + value + "\" could not be decoded because it is is a " + "malformed URL segment. This is probably due to a bad percent " + ("encoding (" + error + ")."));
        return value;
    }
}
/**
 * @private
 */ function $dae0ef9fca964cc6$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    // We want to leave trailing slash behavior in the user's control, so if they
    // specify a basename with a trailing slash, we should support it
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") // pathname does not start with basename/
    return null;
    return pathname.slice(startIndex) || "/";
}
const $dae0ef9fca964cc6$var$ABSOLUTE_URL_REGEX$1 = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $dae0ef9fca964cc6$var$isAbsoluteUrl = (url)=>$dae0ef9fca964cc6$var$ABSOLUTE_URL_REGEX$1.test(url);
/**
 * Returns a resolved path object relative to the given pathname.
 *
 * @see https://reactrouter.com/v6/utils/resolve-path
 */ function $dae0ef9fca964cc6$export$b09f2ff0bbcb43c7(to, fromPathname) {
    if (fromPathname === void 0) fromPathname = "/";
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? $dae0ef9fca964cc6$export$8ccf933b0513f8d0(to) : to;
    let pathname;
    if (toPathname) {
        if ($dae0ef9fca964cc6$var$isAbsoluteUrl(toPathname)) pathname = toPathname;
        else {
            if (toPathname.includes("//")) {
                let oldPathname = toPathname;
                toPathname = $dae0ef9fca964cc6$var$removeDoubleSlashes(toPathname);
                $dae0ef9fca964cc6$export$c0e02632e14916fd(false, "Pathnames cannot have embedded double slashes - normalizing " + (oldPathname + " -> " + toPathname));
            }
            if (toPathname.startsWith("/")) pathname = $dae0ef9fca964cc6$var$resolvePathname(toPathname.substring(1), "/");
            else pathname = $dae0ef9fca964cc6$var$resolvePathname(toPathname, fromPathname);
        }
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $dae0ef9fca964cc6$var$normalizeSearch(search),
        hash: $dae0ef9fca964cc6$var$normalizeHash(hash)
    };
}
function $dae0ef9fca964cc6$var$resolvePathname(relativePath, fromPathname) {
    let segments = fromPathname.replace(/\/+$/, "").split("/");
    let relativeSegments = relativePath.split("/");
    relativeSegments.forEach((segment)=>{
        if (segment === "..") // Keep the root "" segment so the pathname starts at /
        {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $dae0ef9fca964cc6$var$getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '" + char + "' character in a manually specified " + ("`to." + field + "` field [" + JSON.stringify(path) + "].  Please separate it out to the ") + ("`to." + dest + "` field. Alternatively you may provide the full path as ") + "a string in <Link to=\"...\"> and the router will parse it for you.";
}
/**
 * @private
 *
 * When processing relative navigation we want to ignore ancestor routes that
 * do not contribute to the path, such that index/pathless layout routes don't
 * interfere.
 *
 * For example, when moving a route element into an index route and/or a
 * pathless layout route, relative link behavior contained within should stay
 * the same.  Both of the following examples should link back to the root:
 *
 *   <Route path="/">
 *     <Route path="accounts" element={<Link to=".."}>
 *   </Route>
 *
 *   <Route path="/">
 *     <Route path="accounts">
 *       <Route element={<AccountsLayout />}>       // <-- Does not contribute
 *         <Route index element={<Link to=".."} />  // <-- Does not contribute
 *       </Route
 *     </Route>
 *   </Route>
 */ function $dae0ef9fca964cc6$var$getPathContributingMatches(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
// Return the array of pathnames for the current route matches - used to
// generate the routePathnames input for resolveTo()
function $dae0ef9fca964cc6$export$a5784978eca585fa(matches, v7_relativeSplatPath) {
    let pathMatches = $dae0ef9fca964cc6$var$getPathContributingMatches(matches);
    // When v7_relativeSplatPath is enabled, use the full pathname for the leaf
    // match so we include splat values for "." links.  See:
    // https://github.com/remix-run/react-router/issues/11052#issuecomment-1836589329
    if (v7_relativeSplatPath) return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
    return pathMatches.map((match)=>match.pathnameBase);
}
/**
 * @private
 */ function $dae0ef9fca964cc6$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative) {
    if (isPathRelative === void 0) isPathRelative = false;
    let to;
    if (typeof toArg === "string") to = $dae0ef9fca964cc6$export$8ccf933b0513f8d0(toArg);
    else {
        to = $dae0ef9fca964cc6$var$_extends({}, toArg);
        $dae0ef9fca964cc6$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("?"), $dae0ef9fca964cc6$var$getInvalidPathError("?", "pathname", "search", to));
        $dae0ef9fca964cc6$export$3e9cee6b33872309(!to.pathname || !to.pathname.includes("#"), $dae0ef9fca964cc6$var$getInvalidPathError("#", "pathname", "hash", to));
        $dae0ef9fca964cc6$export$3e9cee6b33872309(!to.search || !to.search.includes("#"), $dae0ef9fca964cc6$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    // Routing is relative to the current pathname if explicitly requested.
    //
    // If a pathname is explicitly provided in `to`, it should be relative to the
    // route context. This is explained in `Note on `<Link to>` values` in our
    // migration guide from v5 as a means of disambiguation between `to` values
    // that begin with `/` and those that do not. However, this is problematic for
    // `to` values that do not provide a pathname. `to` can simply be a search or
    // hash string, in which case we should assume that the navigation is relative
    // to the current location's pathname and *not* the route pathname.
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        // With relative="route" (the default), each leading .. segment means
        // "go up one route" instead of "go up one URL segment".  This is a key
        // difference from how <a href> works and a major reason we call this a
        // "to" value instead of a "href".
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $dae0ef9fca964cc6$export$b09f2ff0bbcb43c7(to, from);
    // Ensure the pathname has a trailing slash if the original "to" had one
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    // Or if this was a link to the current path which has a trailing slash
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
/**
 * @private
 */ function $dae0ef9fca964cc6$export$f5655dfea9d981c7(to) {
    // Empty strings should be treated the same as / paths
    return to === "" || to.pathname === "" ? "/" : typeof to === "string" ? $dae0ef9fca964cc6$export$8ccf933b0513f8d0(to).pathname : to.pathname;
}
const $dae0ef9fca964cc6$var$removeDoubleSlashes = (path)=>path.replace(/\/\/+/g, "/");
/**
 * @private
 */ const $dae0ef9fca964cc6$export$86d9a7913e44197e = (paths)=>$dae0ef9fca964cc6$var$removeDoubleSlashes(paths.join("/"));
/**
 * @private
 */ const $dae0ef9fca964cc6$export$a5c6d149b50c1d86 = (pathname)=>pathname.replace(/\/+$/, "").replace(/^\/*/, "/");
/**
 * @private
 */ const $dae0ef9fca964cc6$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
/**
 * @private
 */ const $dae0ef9fca964cc6$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
/**
 * This is a shortcut for creating `application/json` responses. Converts `data`
 * to JSON and sets the `Content-Type` header.
 *
 * @deprecated The `json` method is deprecated in favor of returning raw objects.
 * This method will be removed in v7.
 */ const $dae0ef9fca964cc6$export$7b419323e6ed4f31 = function json(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    let headers = new Headers(responseInit.headers);
    if (!headers.has("Content-Type")) headers.set("Content-Type", "application/json; charset=utf-8");
    return new Response(JSON.stringify(data), $dae0ef9fca964cc6$var$_extends({}, responseInit, {
        headers: headers
    }));
};
class $dae0ef9fca964cc6$var$DataWithResponseInit {
    constructor(data, init){
        this.type = "DataWithResponseInit";
        this.data = data;
        this.init = init || null;
    }
}
/**
 * Create "responses" that contain `status`/`headers` without forcing
 * serialization into an actual `Response` - used by Remix single fetch
 */ function $dae0ef9fca964cc6$export$4051a07651545597(data, init) {
    return new $dae0ef9fca964cc6$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
class $dae0ef9fca964cc6$export$42a99a7a4bc0e76a extends Error {
}
class $dae0ef9fca964cc6$export$61d759255b4eec65 {
    trackPromise(key, value) {
        if (!(value instanceof Promise)) return value;
        this.deferredKeys.push(key);
        this.pendingKeysSet.add(key);
        // We store a little wrapper promise that will be extended with
        // _data/_error props upon resolve/reject
        let promise = Promise.race([
            value,
            this.abortPromise
        ]).then((data)=>this.onSettle(promise, key, undefined, data), (error)=>this.onSettle(promise, key, error));
        // Register rejection listeners to avoid uncaught promise rejections on
        // errors or aborted deferred values
        promise.catch(()=>{});
        Object.defineProperty(promise, "_tracked", {
            get: ()=>true
        });
        return promise;
    }
    onSettle(promise, key, error, data) {
        if (this.controller.signal.aborted && error instanceof $dae0ef9fca964cc6$export$42a99a7a4bc0e76a) {
            this.unlistenAbortSignal();
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            return Promise.reject(error);
        }
        this.pendingKeysSet.delete(key);
        if (this.done) // Nothing left to abort!
        this.unlistenAbortSignal();
        // If the promise was resolved/rejected with undefined, we'll throw an error as you
        // should always resolve with a value or null
        if (error === undefined && data === undefined) {
            let undefinedError = new Error("Deferred data for key \"" + key + "\" resolved/rejected with `undefined`, " + "you must resolve/reject with a value or `null`.");
            Object.defineProperty(promise, "_error", {
                get: ()=>undefinedError
            });
            this.emit(false, key);
            return Promise.reject(undefinedError);
        }
        if (data === undefined) {
            Object.defineProperty(promise, "_error", {
                get: ()=>error
            });
            this.emit(false, key);
            return Promise.reject(error);
        }
        Object.defineProperty(promise, "_data", {
            get: ()=>data
        });
        this.emit(false, key);
        return data;
    }
    emit(aborted, settledKey) {
        this.subscribers.forEach((subscriber)=>subscriber(aborted, settledKey));
    }
    subscribe(fn) {
        this.subscribers.add(fn);
        return ()=>this.subscribers.delete(fn);
    }
    cancel() {
        this.controller.abort();
        this.pendingKeysSet.forEach((v, k)=>this.pendingKeysSet.delete(k));
        this.emit(true);
    }
    async resolveData(signal) {
        let aborted = false;
        if (!this.done) {
            let onAbort = ()=>this.cancel();
            signal.addEventListener("abort", onAbort);
            aborted = await new Promise((resolve)=>{
                this.subscribe((aborted)=>{
                    signal.removeEventListener("abort", onAbort);
                    if (aborted || this.done) resolve(aborted);
                });
            });
        }
        return aborted;
    }
    get done() {
        return this.pendingKeysSet.size === 0;
    }
    get unwrappedData() {
        $dae0ef9fca964cc6$export$3e9cee6b33872309(this.data !== null && this.done, "Can only unwrap data on initialized and settled deferreds");
        return Object.entries(this.data).reduce((acc, _ref3)=>{
            let [key, value] = _ref3;
            return Object.assign(acc, {
                [key]: $dae0ef9fca964cc6$var$unwrapTrackedPromise(value)
            });
        }, {});
    }
    get pendingKeys() {
        return Array.from(this.pendingKeysSet);
    }
    constructor(data, responseInit){
        this.pendingKeysSet = new Set();
        this.subscribers = new Set();
        this.deferredKeys = [];
        $dae0ef9fca964cc6$export$3e9cee6b33872309(data && typeof data === "object" && !Array.isArray(data), "defer() only accepts plain objects");
        // Set up an AbortController + Promise we can race against to exit early
        // cancellation
        let reject;
        this.abortPromise = new Promise((_, r)=>reject = r);
        this.controller = new AbortController();
        let onAbort = ()=>reject(new $dae0ef9fca964cc6$export$42a99a7a4bc0e76a("Deferred data aborted"));
        this.unlistenAbortSignal = ()=>this.controller.signal.removeEventListener("abort", onAbort);
        this.controller.signal.addEventListener("abort", onAbort);
        this.data = Object.entries(data).reduce((acc, _ref2)=>{
            let [key, value] = _ref2;
            return Object.assign(acc, {
                [key]: this.trackPromise(key, value)
            });
        }, {});
        if (this.done) // All incoming values were resolved
        this.unlistenAbortSignal();
        this.init = responseInit;
    }
}
function $dae0ef9fca964cc6$var$isTrackedPromise(value) {
    return value instanceof Promise && value._tracked === true;
}
function $dae0ef9fca964cc6$var$unwrapTrackedPromise(value) {
    if (!$dae0ef9fca964cc6$var$isTrackedPromise(value)) return value;
    if (value._error) throw value._error;
    return value._data;
}
/**
 * @deprecated The `defer` method is deprecated in favor of returning raw
 * objects. This method will be removed in v7.
 */ const $dae0ef9fca964cc6$export$260e5c0943f31606 = function defer(data, init) {
    if (init === void 0) init = {};
    let responseInit = typeof init === "number" ? {
        status: init
    } : init;
    return new $dae0ef9fca964cc6$export$61d759255b4eec65(data, responseInit);
};
/**
 * A redirect response. Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $dae0ef9fca964cc6$export$89e12c5b50f7529d = function redirect(url, init) {
    if (init === void 0) init = 302;
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, $dae0ef9fca964cc6$var$_extends({}, responseInit, {
        headers: headers
    }));
};
/**
 * A redirect response that will force a document reload to the new location.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $dae0ef9fca964cc6$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $dae0ef9fca964cc6$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
 * A redirect response that will perform a `history.replaceState` instead of a
 * `history.pushState` for client-side navigation redirects.
 * Sets the status code and the `Location` header.
 * Defaults to "302 Found".
 */ const $dae0ef9fca964cc6$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $dae0ef9fca964cc6$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
/**
 * @private
 * Utility class we use to hold auto-unwrapped 4xx/5xx Response bodies
 *
 * We don't export the class for public use since it's an implementation
 * detail, but we export the interface above so folks can build their own
 * abstractions around instances via isRouteErrorResponse()
 */ class $dae0ef9fca964cc6$export$6c6580e81da25755 {
    constructor(status, statusText, data, internal){
        if (internal === void 0) internal = false;
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
}
/**
 * Check if the given error is an ErrorResponse generated from a 4xx/5xx
 * Response thrown from an action/loader
 */ function $dae0ef9fca964cc6$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
const $dae0ef9fca964cc6$var$validMutationMethodsArr = [
    "post",
    "put",
    "patch",
    "delete"
];
const $dae0ef9fca964cc6$var$validMutationMethods = new Set($dae0ef9fca964cc6$var$validMutationMethodsArr);
const $dae0ef9fca964cc6$var$validRequestMethodsArr = [
    "get",
    ...$dae0ef9fca964cc6$var$validMutationMethodsArr
];
const $dae0ef9fca964cc6$var$validRequestMethods = new Set($dae0ef9fca964cc6$var$validRequestMethodsArr);
const $dae0ef9fca964cc6$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $dae0ef9fca964cc6$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $dae0ef9fca964cc6$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $dae0ef9fca964cc6$export$52eace9c284d3585 = {
    state: "idle",
    data: undefined,
    formMethod: undefined,
    formAction: undefined,
    formEncType: undefined,
    formData: undefined,
    json: undefined,
    text: undefined
};
const $dae0ef9fca964cc6$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: undefined,
    reset: undefined,
    location: undefined
};
const $dae0ef9fca964cc6$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
const $dae0ef9fca964cc6$var$defaultMapRouteProperties = (route)=>({
        hasErrorBoundary: Boolean(route.hasErrorBoundary)
    });
const $dae0ef9fca964cc6$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createRouter
////////////////////////////////////////////////////////////////////////////////
/**
 * Create a router and listen to history POP navigations
 */ function $dae0ef9fca964cc6$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : undefined;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    const isServer = !isBrowser;
    $dae0ef9fca964cc6$export$3e9cee6b33872309(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let mapRouteProperties;
    if (init.mapRouteProperties) mapRouteProperties = init.mapRouteProperties;
    else if (init.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = init.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $dae0ef9fca964cc6$var$defaultMapRouteProperties;
    // Routes keyed by ID
    let manifest = {};
    // Routes in tree format for matching
    let dataRoutes = $dae0ef9fca964cc6$export$4a6d22b32134ea5d(init.routes, mapRouteProperties, undefined, manifest);
    let inFlightDataRoutes;
    let basename = init.basename || "/";
    let dataStrategyImpl = init.dataStrategy || $dae0ef9fca964cc6$var$defaultDataStrategy;
    let patchRoutesOnNavigationImpl = init.patchRoutesOnNavigation;
    // Config driven behavior flags
    let future = $dae0ef9fca964cc6$var$_extends({
        v7_fetcherPersist: false,
        v7_normalizeFormMethod: false,
        v7_partialHydration: false,
        v7_prependBasename: false,
        v7_relativeSplatPath: false,
        v7_skipActionErrorRevalidation: false
    }, init.future);
    // Cleanup function for history
    let unlistenHistory = null;
    // Externally-provided functions to call on all state changes
    let subscribers = new Set();
    // Externally-provided object to hold scroll restoration locations during routing
    let savedScrollPositions = null;
    // Externally-provided function to get scroll restoration keys
    let getScrollRestorationKey = null;
    // Externally-provided function to get current scroll position
    let getScrollPosition = null;
    // One-time flag to control the initial hydration scroll restoration.  Because
    // we don't get the saved positions from <ScrollRestoration /> until _after_
    // the initial render, we need to manually trigger a separate updateState to
    // send along the restoreScrollPosition
    // Set to true if we have `hydrationData` since we assume we were SSR'd and that
    // SSR did the initial scroll restoration.
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = $dae0ef9fca964cc6$export$2708184779ceb39d(dataRoutes, init.history.location, basename);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    if (initialMatches == null && !patchRoutesOnNavigationImpl) {
        // If we do not match a user-provided-route, fall back to the root
        // to allow the error boundary to take over
        let error = $dae0ef9fca964cc6$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $dae0ef9fca964cc6$var$getShortCircuitMatches(dataRoutes);
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    }
    // In SPA apps, if the user provided a patchRoutesOnNavigation implementation and
    // our initial match is a splat route, clear them out so we run through lazy
    // discovery on hydration in case there's a more accurate lazy route match.
    // In SSR apps (with `hydrationData`), we expect that the server will send
    // up the proper matched routes so we don't want to run lazy discovery on
    // initial hydration and want to hydrate into the splat route.
    if (initialMatches && !init.hydrationData) {
        let fogOfWar = checkFogOfWar(initialMatches, dataRoutes, init.history.location.pathname);
        if (fogOfWar.active) initialMatches = null;
    }
    let initialized;
    if (!initialMatches) {
        initialized = false;
        initialMatches = [];
        // If partial hydration and fog of war is enabled, we will be running
        // `patchRoutesOnNavigation` during hydration so include any partial matches as
        // the initial matches so we can properly render `HydrateFallback`'s
        if (future.v7_partialHydration) {
            let fogOfWar = checkFogOfWar(null, dataRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        }
    } else if (initialMatches.some((m)=>m.route.lazy)) // All initialMatches need to be loaded before we're ready.  If we have lazy
    // functions around still then we'll need to run them in initialize()
    initialized = false;
    else if (!initialMatches.some((m)=>m.route.loader)) // If we've got no loaders to run, then we're good to go
    initialized = true;
    else if (future.v7_partialHydration) {
        // If partial hydration is enabled, we're initialized so long as we were
        // provided with hydrationData for every route with a loader, and no loaders
        // were marked for explicit hydration
        let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
        let errors = init.hydrationData ? init.hydrationData.errors : null;
        // If errors exist, don't consider routes below the boundary
        if (errors) {
            let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== undefined);
            initialized = initialMatches.slice(0, idx + 1).every((m)=>!$dae0ef9fca964cc6$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
        } else initialized = initialMatches.every((m)=>!$dae0ef9fca964cc6$var$shouldLoadRouteOnHydration(m.route, loaderData, errors));
    } else // Without partial hydration - we're initialized if we were provided any
    // hydrationData - which is expected to be complete
    initialized = init.hydrationData != null;
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        navigation: $dae0ef9fca964cc6$export$ed3e14b2f9e105d0,
        // Don't restore on initial updateState() if we were SSR'd
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: new Map(),
        blockers: new Map()
    };
    // -- Stateful internal variables to manage navigations --
    // Current navigation in progress (to be committed in completeNavigation)
    let pendingAction = $dae0ef9fca964cc6$export$e19cd5f9376f8cee.Pop;
    // Should the current navigation prevent the scroll reset if scroll cannot
    // be restored?
    let pendingPreventScrollReset = false;
    // AbortController for the active navigation
    let pendingNavigationController;
    // Should the current navigation enable document.startViewTransition?
    let pendingViewTransitionEnabled = false;
    // Store applied view transitions so we can apply them on POP
    let appliedViewTransitions = new Map();
    // Cleanup function for persisting applied transitions to sessionStorage
    let removePageHideEventListener = null;
    // We use this to avoid touching history in completeNavigation if a
    // revalidation is entirely uninterrupted
    let isUninterruptedRevalidation = false;
    // Use this internal flag to force revalidation of all loaders:
    //  - submissions (completed or interrupted)
    //  - useRevalidator()
    //  - X-Remix-Revalidate (from redirect)
    let isRevalidationRequired = false;
    // Use this internal array to capture routes that require revalidation due
    // to a cancelled deferred on action submission
    let cancelledDeferredRoutes = [];
    // Use this internal array to capture fetcher loads that were cancelled by an
    // action navigation and require revalidation
    let cancelledFetcherLoads = new Set();
    // AbortControllers for any in-flight fetchers
    let fetchControllers = new Map();
    // Track loads based on the order in which they started
    let incrementingLoadId = 0;
    // Track the outstanding pending navigation data load to be compared against
    // the globally incrementing load when a fetcher load lands after a completed
    // navigation
    let pendingNavigationLoadId = -1;
    // Fetchers that triggered data reloads as a result of their actions
    let fetchReloadIds = new Map();
    // Fetchers that triggered redirect navigations
    let fetchRedirectIds = new Set();
    // Most recent href/match for fetcher.load calls for fetchers
    let fetchLoadMatches = new Map();
    // Ref-count mounted fetchers so we know when it's ok to clean them up
    let activeFetchers = new Map();
    // Fetchers that have requested a delete when using v7_fetcherPersist,
    // they'll be officially removed after they return to idle
    let deletedFetchers = new Set();
    // Store DeferredData instances for active route matches.  When a
    // route loader returns defer() we stick one in here.  Then, when a nested
    // promise resolves we update loaderData.  If a new navigation starts we
    // cancel active deferreds for eliminated routes.
    let activeDeferreds = new Map();
    // Store blocker functions in a separate Map outside of router state since
    // we don't need to update UI state if they change
    let blockerFunctions = new Map();
    // Flag to ignore the next history update, so we can revert the URL change on
    // a POP navigation that was blocked by the user without touching router state
    let unblockBlockerHistoryUpdate = undefined;
    // Initialize the router, all side effects should be kicked off from here.
    // Implemented as a Fluent API for ease of:
    //   let router = createRouter(init).initialize();
    function initialize() {
        // If history informs us of a POP navigation, start the navigation but do not update
        // state.  We'll update our own state once the navigation completes
        unlistenHistory = init.history.listen((_ref)=>{
            let { action: historyAction, location: location, delta: delta } = _ref;
            // Ignore this event if it was just us resetting the URL from a
            // blocked POP navigation
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = undefined;
                return;
            }
            $dae0ef9fca964cc6$export$c0e02632e14916fd(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                // Restore the URL to match the current UI, but don't update router state
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                // Put the blocker into a blocked state
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: undefined,
                            reset: undefined,
                            location: location
                        });
                        // Re-do the same POP navigation we just blocked, after the url
                        // restoration is also complete.  See:
                        // https://github.com/remix-run/react-router/issues/11613
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $dae0ef9fca964cc6$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            // FIXME: This feels gross.  How can we cleanup the lines between
            // scrollRestoration/appliedTransitions persistance?
            $dae0ef9fca964cc6$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$dae0ef9fca964cc6$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        // Kick off initial data load if needed.  Use Pop to avoid modifying history
        // Note we don't do any handling of lazy here.  For SPA's it'll get handled
        // in the normal navigation flow.  For SSR it's expected that lazy modules are
        // resolved prior to router creation since we can't go into a fallbackElement
        // UI for SSR'd apps
        if (!state.initialized) startNavigation($dae0ef9fca964cc6$export$e19cd5f9376f8cee.Pop, state.location, {
            initialHydration: true
        });
        return router;
    }
    // Clean up a router and it's side effects
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    // Subscribe to state updates for the router
    function subscribe(fn) {
        subscribers.add(fn);
        return ()=>subscribers.delete(fn);
    }
    // Update our state and notify the calling context of the change
    function updateState(newState, opts) {
        if (opts === void 0) opts = {};
        state = $dae0ef9fca964cc6$var$_extends({}, state, newState);
        // Prep fetcher cleanup so we can tell the UI which fetcher data entries
        // can be removed
        let completedFetchers = [];
        let deletedFetchersKeys = [];
        if (future.v7_fetcherPersist) state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (deletedFetchers.has(key)) // Unmounted from the UI and can be totally removed
                deletedFetchersKeys.push(key);
                else // Returned to idle but still mounted in the UI, so semi-remains for
                // revalidations and such
                completedFetchers.push(key);
            }
        });
        // Remove any lingering deleted fetchers that have already been removed
        // from state.fetchers
        deletedFetchers.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) deletedFetchersKeys.push(key);
        });
        // Iterate over a local copy so that if flushSync is used and we end up
        // removing and adding a new subscriber due to the useCallback dependencies,
        // we don't get ourselves into a loop calling the new subscriber immediately
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: deletedFetchersKeys,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        // Remove idle fetchers from state since we only care about in-flight fetchers.
        if (future.v7_fetcherPersist) {
            completedFetchers.forEach((key)=>state.fetchers.delete(key));
            deletedFetchersKeys.forEach((key)=>deleteFetcher(key));
        } else // We already called deleteFetcher() on these, can remove them from this
        // Set now that we've handed the keys off to the data layer
        deletedFetchersKeys.forEach((key)=>deletedFetchers.delete(key));
    }
    // Complete a navigation returning the state.navigation back to the IDLE_NAVIGATION
    // and setting state.[historyAction/location/matches] to the new route.
    // - Location is a required param
    // - Navigation will always be set to IDLE_NAVIGATION
    // - Can pass any other state in newState
    function completeNavigation(location, newState, _temp) {
        var _location$state, _location$state2;
        let { flushSync: flushSync } = _temp === void 0 ? {} : _temp;
        // Deduce if we're in a loading/actionReload state:
        // - We have committed actionData in the store
        // - The current navigation was a mutation submission
        // - We're past the submitting state and into the loading state
        // - The location being loaded is not the result of a redirect
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $dae0ef9fca964cc6$var$isMutationMethod(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location$state = location.state) == null ? void 0 : _location$state._isRedirect) !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else // Empty actionData -> clear prior actionData due to an action error
            actionData = null;
        } else if (isActionReload) // Keep the current data if we're wrapping up the action reload
        actionData = state.actionData;
        else // Clear actionData on any other completed navigations
        actionData = null;
        // Always preserve any existing loaderData from re-used routes
        let loaderData = newState.loaderData ? $dae0ef9fca964cc6$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        // On a successful navigation we can assume we got through all blockers
        // so we can start fresh
        let blockers = state.blockers;
        if (blockers.size > 0) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $dae0ef9fca964cc6$export$386d57f03f0b2883));
        }
        // Always respect the user flag.  Otherwise don't reset on mutation
        // submission navigations unless they redirect
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $dae0ef9fca964cc6$var$isMutationMethod(state.navigation.formMethod) && ((_location$state2 = location.state) == null ? void 0 : _location$state2._isRedirect) !== true;
        // Commit any in-flight routes at the end of the HMR revalidation "navigation"
        if (inFlightDataRoutes) {
            dataRoutes = inFlightDataRoutes;
            inFlightDataRoutes = undefined;
        }
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === $dae0ef9fca964cc6$export$e19cd5f9376f8cee.Pop) ;
        else if (pendingAction === $dae0ef9fca964cc6$export$e19cd5f9376f8cee.Push) init.history.push(location, location.state);
        else if (pendingAction === $dae0ef9fca964cc6$export$e19cd5f9376f8cee.Replace) init.history.replace(location, location.state);
        let viewTransitionOpts;
        // On POP, enable transitions if they were enabled on the original navigation
        if (pendingAction === $dae0ef9fca964cc6$export$e19cd5f9376f8cee.Pop) {
            // Forward takes precedence so they behave like the original navigation
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) // If we don't have a previous forward nav, assume we're popping back to
            // the new location and enable if that location previously enabled
            viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            // Store the applied transition on PUSH/REPLACE
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState($dae0ef9fca964cc6$var$_extends({}, newState, {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            navigation: $dae0ef9fca964cc6$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: getSavedScrollPosition(location, newState.matches || state.matches),
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        // Reset stateful navigation vars
        pendingAction = $dae0ef9fca964cc6$export$e19cd5f9376f8cee.Pop;
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        cancelledDeferredRoutes = [];
    }
    // Trigger a navigation event, which can either be a numerical POP or a PUSH
    // replace with an optional submission
    async function navigate(to, opts) {
        if (typeof to === "number") {
            init.history.go(to);
            return;
        }
        let normalizedPath = $dae0ef9fca964cc6$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, to, future.v7_relativeSplatPath, opts == null ? void 0 : opts.fromRouteId, opts == null ? void 0 : opts.relative);
        let { path: path, submission: submission, error: error } = $dae0ef9fca964cc6$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, false, normalizedPath, opts);
        let currentLocation = state.location;
        let nextLocation = $dae0ef9fca964cc6$var$createLocation(state.location, path, opts && opts.state);
        // When using navigate as a PUSH/REPLACE we aren't reading an already-encoded
        // URL from window.location, so we need to encode it here so the behavior
        // remains the same as POP and non-data-router usages.  new URL() does all
        // the same encoding we'd get from a history.pushState/window.location read
        // without having to touch history
        nextLocation = $dae0ef9fca964cc6$var$_extends({}, nextLocation, init.history.encodeLocation(nextLocation));
        let userReplace = opts && opts.replace != null ? opts.replace : undefined;
        let historyAction = $dae0ef9fca964cc6$export$e19cd5f9376f8cee.Push;
        if (userReplace === true) historyAction = $dae0ef9fca964cc6$export$e19cd5f9376f8cee.Replace;
        else if (userReplace === false) ;
        else if (submission != null && $dae0ef9fca964cc6$var$isMutationMethod(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) // By default on submissions to the current location we REPLACE so that
        // users don't have to double-click the back button to get to the prior
        // location.  If the user redirects to a different location from the
        // action/loader this will be ignored and the redirect will be a PUSH
        historyAction = $dae0ef9fca964cc6$export$e19cd5f9376f8cee.Replace;
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : undefined;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            // Put the blocker into a blocked state
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: undefined,
                        reset: undefined,
                        location: nextLocation
                    });
                    // Send the same navigation through
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $dae0ef9fca964cc6$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        return await startNavigation(historyAction, nextLocation, {
            submission: submission,
            // Send through the formData serialization error if we have one so we can
            // render at the right error boundary after we match routes
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync
        });
    }
    // Revalidate all current loaders.  If a navigation is in progress or if this
    // is interrupted by a navigation, allow this to "succeed" by calling all
    // loaders during the next loader round
    function revalidate() {
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        // If we're currently submitting an action, we don't need to start a new
        // navigation, we'll just let the follow up loader execution call all loaders
        if (state.navigation.state === "submitting") return;
        // If we're currently in an idle state, start a new navigation for the current
        // action/location and mark it as uninterrupted, which will skip the history
        // update in completeNavigation
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return;
        }
        // Otherwise, if we're currently in a loading state, just start a new
        // navigation to the navigation.location but do not trigger an uninterrupted
        // revalidation so that history correctly updates once the navigation completes
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            // Proxy through any rending view transition
            enableViewTransition: pendingViewTransitionEnabled === true
        });
    }
    // Start a navigation to the given action/location.  Can optionally provide a
    // overrideNavigation which will override the normalLoad in the case of a redirect
    // navigation
    async function startNavigation(historyAction, location, opts) {
        // Abort any in-progress navigations and start a new one. Unset any ongoing
        // uninterrupted revalidations unless told otherwise, since we want this
        // new navigation to update history normally
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        // Save the current scroll position every time we start a new navigation,
        // and track whether we should reset scroll on completion
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let loadingNavigation = opts && opts.overrideNavigation;
        let matches = opts != null && opts.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? // `matchRoutes()` has already been called if we're in here via `router.initialize()`
        state.matches : $dae0ef9fca964cc6$export$2708184779ceb39d(routesToUse, location, basename);
        let flushSync = (opts && opts.flushSync) === true;
        // Short circuit if it's only a hash change and not a revalidation or
        // mutation submission.
        //
        // Ignore on initial page loads because since the initial hydration will always
        // be "same hash".  For example, on /page#hash and submit a <Form method="post">
        // which will default to a navigation to /page
        if (matches && state.initialized && !isRevalidationRequired && $dae0ef9fca964cc6$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $dae0ef9fca964cc6$var$isMutationMethod(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        // Short circuit with a 404 on the root error boundary if we match nothing
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        // Create a controller/Request for this navigation
        pendingNavigationController = new AbortController();
        let request = $dae0ef9fca964cc6$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let pendingActionResult;
        if (opts && opts.pendingError) // If we have a pendingError, it means the user attempted a GET submission
        // with binary FormData so assign here and skip to handleLoaders.  That
        // way we handle calling loaders above the boundary etc.  It's not really
        // different from an actionError in that sense.
        pendingActionResult = [
            $dae0ef9fca964cc6$var$findNearestBoundary(matches).route.id,
            {
                type: $dae0ef9fca964cc6$var$ResultType.error,
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $dae0ef9fca964cc6$var$isMutationMethod(opts.submission.formMethod)) {
            // Call action if we received an action submission
            let actionResult = await handleAction(request, location, opts.submission, matches, fogOfWar.active, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            // If we received a 404 from handleAction, it's because we couldn't lazily
            // discover the destination route so we don't want to call loaders
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($dae0ef9fca964cc6$var$isErrorResult(result) && $dae0ef9fca964cc6$export$972111febbeef05b(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $dae0ef9fca964cc6$var$getLoadingNavigation(location, opts.submission);
            flushSync = false;
            // No need to do fog of war matching again on loader execution
            fogOfWar.active = false;
            // Create a GET request for the loaders
            request = $dae0ef9fca964cc6$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        // Call loaders
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors } = await handleLoaders(request, location, matches, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult);
        if (shortCircuited) return;
        // Clean up now that the action/loaders have completed.  Don't clean up if
        // we short circuited because pendingNavigationController will have already
        // been assigned to a new controller for the next navigation
        pendingNavigationController = null;
        completeNavigation(location, $dae0ef9fca964cc6$var$_extends({
            matches: updatedMatches || matches
        }, $dae0ef9fca964cc6$var$getActionDataForCommit(pendingActionResult), {
            loaderData: loaderData,
            errors: errors
        }));
    }
    // Call the action matched by the leaf route for this navigation and handle
    // redirects/errors
    async function handleAction(request, location, submission, matches, isFogOfWar, opts) {
        if (opts === void 0) opts = {};
        interruptActiveLoads();
        // Put us in a submitting state
        let navigation = $dae0ef9fca964cc6$var$getSubmittingNavigation(location, submission);
        updateState({
            navigation: navigation
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $dae0ef9fca964cc6$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: $dae0ef9fca964cc6$var$ResultType.error,
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: $dae0ef9fca964cc6$var$ResultType.error,
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        // Call our action and get the result
        let result;
        let actionMatch = $dae0ef9fca964cc6$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: $dae0ef9fca964cc6$var$ResultType.error,
            error: $dae0ef9fca964cc6$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy("action", state, request, [
                actionMatch
            ], matches, null);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($dae0ef9fca964cc6$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else {
                // If the user didn't explicity indicate replace behavior, replace if
                // we redirected to the exact same location we're currently at to avoid
                // double back-buttons
                let location = $dae0ef9fca964cc6$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history);
                replace = location === state.location.pathname + state.location.search;
            }
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($dae0ef9fca964cc6$var$isDeferredResult(result)) throw $dae0ef9fca964cc6$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        if ($dae0ef9fca964cc6$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = $dae0ef9fca964cc6$var$findNearestBoundary(matches, actionMatch.route.id);
            // By default, all submissions to the current location are REPLACE
            // navigations, but if the action threw an error that'll be rendered in
            // an errorElement, we fall back to PUSH so that the user can use the
            // back button to get back to the pre-submission form location to try
            // again
            if ((opts && opts.replace) !== true) pendingAction = $dae0ef9fca964cc6$export$e19cd5f9376f8cee.Push;
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    // Call all applicable loaders for the given matches, handling redirects,
    // errors, etc.
    async function handleLoaders(request, location, matches, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult) {
        // Figure out the right navigation we want to use for data loading
        let loadingNavigation = overrideNavigation || $dae0ef9fca964cc6$var$getLoadingNavigation(location, submission);
        // If this was a redirect from an action we don't have a "submission" but
        // we have it on the loading navigation so use that if available
        let activeSubmission = submission || fetcherSubmission || $dae0ef9fca964cc6$var$getSubmissionFromNavigation(loadingNavigation);
        // If this is an uninterrupted revalidation, we remain in our current idle
        // state.  If not, we need to switch to our loading state and load data,
        // preserving any new action data or existing action data (in the case of
        // a revalidation interrupting an actionReload)
        // If we have partialHydration enabled, then don't update the state for the
        // initial data load since it's not a "navigation"
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && (!future.v7_partialHydration || !initialHydration);
        // When fog of war is enabled, we enter our `loading` state earlier so we
        // can discover new routes during the `loading` state.  We skip this if
        // we've already run actions since we would have done our matching already.
        // If the children() function threw then, we want to proceed with the
        // partial matches it discovered.
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState($dae0ef9fca964cc6$var$_extends({
                    navigation: loadingNavigation
                }, actionData !== undefined ? {
                    actionData: actionData
                } : {}), {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                let boundaryId = $dae0ef9fca964cc6$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let [matchesToLoad, revalidatingFetchers] = $dae0ef9fca964cc6$var$getMatchesToLoad(init.history, state, matches, activeSubmission, location, future.v7_partialHydration && initialHydration === true, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult);
        // Cancel pending deferreds for no-longer-matched routes or routes we're
        // about to reload.  Note that if this is an action reload we would have
        // already cancelled all pending deferreds so this would be a no-op
        cancelActiveDeferreds((routeId)=>!(matches && matches.some((m)=>m.route.id === routeId)) || matchesToLoad && matchesToLoad.some((m)=>m.route.id === routeId));
        pendingNavigationLoadId = ++incrementingLoadId;
        // Short circuit if we have no loaders to run
        if (matchesToLoad.length === 0 && revalidatingFetchers.length === 0) {
            let updatedFetchers = markFetchRedirectsDone();
            completeNavigation(location, $dae0ef9fca964cc6$var$_extends({
                matches: matches,
                loaderData: {},
                // Commit pending error if we're short circuiting
                errors: pendingActionResult && $dae0ef9fca964cc6$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null
            }, $dae0ef9fca964cc6$var$getActionDataForCommit(pendingActionResult), updatedFetchers ? {
                fetchers: new Map(state.fetchers)
            } : {}), {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                // Only update navigation/actionNData if we didn't already do it above
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== undefined) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) // Fetchers use an independent AbortController so that aborting a fetcher
            // (via deleteFetcher) does not abort the triggering navigation that
            // triggered the revalidation
            fetchControllers.set(rf.key, rf.controller);
        });
        // Proxy navigation abort through to revalidation fetchers
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, request);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        // Clean up _after_ loaders have completed.  Don't clean up if we short
        // circuited because fetchControllers would have been aborted and
        // reassigned to new controllers for the next navigation
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        // If any loaders returned a redirect Response, start a new REPLACE navigation
        let redirect = $dae0ef9fca964cc6$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $dae0ef9fca964cc6$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $dae0ef9fca964cc6$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Wire up subscribers to update loaderData as promises settle
        activeDeferreds.forEach((deferredData, routeId)=>{
            deferredData.subscribe((aborted)=>{
                // Note: No need to updateState here since the TrackedPromise on
                // loaderData is stable across resolve/reject
                // Remove this instance if we were aborted or if promises have settled
                if (aborted || deferredData.done) activeDeferreds.delete(routeId);
            });
        });
        // Preserve SSR errors during partial hydration
        if (future.v7_partialHydration && initialHydration && state.errors) errors = $dae0ef9fca964cc6$var$_extends({}, state.errors, errors);
        let updatedFetchers = markFetchRedirectsDone();
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId);
        let shouldUpdateFetchers = updatedFetchers || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return $dae0ef9fca964cc6$var$_extends({
            matches: matches,
            loaderData: loaderData,
            errors: errors
        }, shouldUpdateFetchers ? {
            fetchers: new Map(state.fetchers)
        } : {});
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$dae0ef9fca964cc6$var$isErrorResult(pendingActionResult[1])) // This is cast to `any` currently because `RouteData`uses any and it
        // would be a breaking change to use any.
        // TODO: v7 - change `RouteData` to use `unknown` instead of `any`
        return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = state.fetchers.get(rf.key);
            let revalidatingFetcher = $dae0ef9fca964cc6$var$getLoadingFetcher(undefined, fetcher ? fetcher.data : undefined);
            state.fetchers.set(rf.key, revalidatingFetcher);
        });
        return new Map(state.fetchers);
    }
    // Trigger a fetcher load/submit for the given fetcher key
    function fetch(key, routeId, href, opts) {
        if (isServer) throw new Error("router.fetch() was called during the server render, but it shouldn't be. You are likely calling a useFetcher() method in the body of your component. Try moving it to a useEffect or a callback.");
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let normalizedPath = $dae0ef9fca964cc6$var$normalizeTo(state.location, state.matches, basename, future.v7_prependBasename, href, future.v7_relativeSplatPath, routeId, opts == null ? void 0 : opts.relative);
        let matches = $dae0ef9fca964cc6$export$2708184779ceb39d(routesToUse, normalizedPath, basename);
        let fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (!matches) {
            setFetcherError(key, routeId, $dae0ef9fca964cc6$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $dae0ef9fca964cc6$var$normalizeNavigateOptions(future.v7_normalizeFormMethod, true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let match = $dae0ef9fca964cc6$var$getTargetMatch(matches, path);
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $dae0ef9fca964cc6$var$isMutationMethod(submission.formMethod)) {
            handleFetcherAction(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
            return;
        }
        // Store off the match so we can call it's shouldRevalidate on subsequent
        // revalidations
        fetchLoadMatches.set(key, {
            routeId: routeId,
            path: path
        });
        handleFetcherLoader(key, routeId, path, match, matches, fogOfWar.active, flushSync, preventScrollReset, submission);
    }
    // Call the action for the matched fetcher.submit(), and then handle redirects,
    // errors, and revalidation
    async function handleFetcherAction(key, routeId, path, match, requestMatches, isFogOfWar, flushSync, preventScrollReset, submission) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        function detectAndHandle405Error(m) {
            if (!m.route.action && !m.route.lazy) {
                let error = $dae0ef9fca964cc6$var$getInternalRouterError(405, {
                    method: submission.formMethod,
                    pathname: path,
                    routeId: routeId
                });
                setFetcherError(key, routeId, error, {
                    flushSync: flushSync
                });
                return true;
            }
            return false;
        }
        if (!isFogOfWar && detectAndHandle405Error(match)) return;
        // Put this fetcher into it's submitting state
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $dae0ef9fca964cc6$var$getSubmittingFetcher(submission, existingFetcher), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $dae0ef9fca964cc6$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $dae0ef9fca964cc6$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                requestMatches = discoverResult.matches;
                match = $dae0ef9fca964cc6$var$getTargetMatch(requestMatches, path);
                if (detectAndHandle405Error(match)) return;
            }
        }
        // Call the action for the fetcher
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let actionResults = await callDataStrategy("action", state, fetchRequest, [
            match
        ], requestMatches, key);
        let actionResult = actionResults[match.route.id];
        if (fetchRequest.signal.aborted) {
            // We can delete this so long as we weren't aborted by our own fetcher
            // re-submit which would have put _new_ controller is in fetchControllers
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        // When using v7_fetcherPersist, we don't want errors bubbling up to the UI
        // or redirects processed for unmounted fetchers so we just revert them to
        // idle
        if (future.v7_fetcherPersist && deletedFetchers.has(key)) {
            if ($dae0ef9fca964cc6$var$isRedirectResult(actionResult) || $dae0ef9fca964cc6$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $dae0ef9fca964cc6$var$getDoneFetcher(undefined));
                return;
            }
        } else {
            if ($dae0ef9fca964cc6$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    // A new navigation was kicked off after our action started, so that
                    // should take precedence over this redirect navigation.  We already
                    // set isRevalidationRequired so all loaders for the new route should
                    // fire unless opted out via shouldRevalidate
                    updateFetcherState(key, $dae0ef9fca964cc6$var$getDoneFetcher(undefined));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $dae0ef9fca964cc6$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            // Process any non-redirect errors thrown
            if ($dae0ef9fca964cc6$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        if ($dae0ef9fca964cc6$var$isDeferredResult(actionResult)) throw $dae0ef9fca964cc6$var$getInternalRouterError(400, {
            type: "defer-action"
        });
        // Start the data load for current matches, or the next location if we're
        // in the middle of a navigation
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $dae0ef9fca964cc6$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let matches = state.navigation.state !== "idle" ? $dae0ef9fca964cc6$export$2708184779ceb39d(routesToUse, state.navigation.location, basename) : state.matches;
        $dae0ef9fca964cc6$export$3e9cee6b33872309(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let loadFetcher = $dae0ef9fca964cc6$var$getLoadingFetcher(submission, actionResult.data);
        state.fetchers.set(key, loadFetcher);
        let [matchesToLoad, revalidatingFetchers] = $dae0ef9fca964cc6$var$getMatchesToLoad(init.history, state, matches, submission, nextLocation, false, future.v7_skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, [
            match.route.id,
            actionResult
        ]);
        // Put all revalidating fetchers into the loading state, except for the
        // current fetcher which we want to keep in it's current loading state which
        // contains it's action submission info + action data
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = state.fetchers.get(staleKey);
            let revalidatingFetcher = $dae0ef9fca964cc6$var$getLoadingFetcher(undefined, existingFetcher ? existingFetcher.data : undefined);
            state.fetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: new Map(state.fetchers)
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(state, matches, matchesToLoad, revalidatingFetchers, revalidationRequest);
        if (abortController.signal.aborted) return;
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let redirect = $dae0ef9fca964cc6$var$findRedirect(loaderResults);
        if (redirect) return startRedirectNavigation(revalidationRequest, redirect.result, false, {
            preventScrollReset: preventScrollReset
        });
        redirect = $dae0ef9fca964cc6$var$findRedirect(fetcherResults);
        if (redirect) {
            // If this redirect came from a fetcher make sure we mark it in
            // fetchRedirectIds so it doesn't get revalidated on the next set of
            // loader executions
            fetchRedirectIds.add(redirect.key);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        // Process and commit output from loaders
        let { loaderData: loaderData, errors: errors } = $dae0ef9fca964cc6$var$processLoaderData(state, matches, loaderResults, undefined, revalidatingFetchers, fetcherResults, activeDeferreds);
        // Since we let revalidations complete even if the submitting fetcher was
        // deleted, only put it back to idle if it hasn't been deleted
        if (state.fetchers.has(key)) {
            let doneFetcher = $dae0ef9fca964cc6$var$getDoneFetcher(actionResult.data);
            state.fetchers.set(key, doneFetcher);
        }
        abortStaleFetchLoads(loadId);
        // If we are currently in a navigation loading state and this fetcher is
        // more recent than the navigation, we want the newer data so abort the
        // navigation and complete it with the fetcher data
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            $dae0ef9fca964cc6$export$3e9cee6b33872309(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: new Map(state.fetchers)
            });
        } else {
            // otherwise just update with the fetcher data, preserving any existing
            // loaderData for loaders that did not need to reload.  We have to
            // manually merge here since we aren't going through completeNavigation
            updateState({
                errors: errors,
                loaderData: $dae0ef9fca964cc6$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: new Map(state.fetchers)
            });
            isRevalidationRequired = false;
        }
    }
    // Call the matched loader for fetcher.load(), handling redirects, errors, etc.
    async function handleFetcherLoader(key, routeId, path, match, matches, isFogOfWar, flushSync, preventScrollReset, submission) {
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $dae0ef9fca964cc6$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : undefined), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $dae0ef9fca964cc6$var$createClientSideRequest(init.history, path, abortController.signal);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $dae0ef9fca964cc6$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                match = $dae0ef9fca964cc6$var$getTargetMatch(matches, path);
            }
        }
        // Call the loader for this fetcher route match
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy("loader", state, fetchRequest, [
            match
        ], matches, key);
        let result = results[match.route.id];
        // Deferred isn't supported for fetcher loads, await everything and treat it
        // as a normal load.  resolveDeferredData will return undefined if this
        // fetcher gets aborted, so we just leave result untouched and short circuit
        // below if that happens
        if ($dae0ef9fca964cc6$var$isDeferredResult(result)) result = await $dae0ef9fca964cc6$var$resolveDeferredData(result, fetchRequest.signal, true) || result;
        // We can delete this so long as we weren't aborted by our our own fetcher
        // re-load which would have put _new_ controller is in fetchControllers
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        // We don't want errors bubbling up or redirects followed for unmounted
        // fetchers, so short circuit here if it was removed from the UI
        if (deletedFetchers.has(key)) {
            updateFetcherState(key, $dae0ef9fca964cc6$var$getDoneFetcher(undefined));
            return;
        }
        // If the loader threw a redirect Response, start a new REPLACE navigation
        if ($dae0ef9fca964cc6$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                // A new navigation was kicked off after our loader started, so that
                // should take precedence over this redirect navigation
                updateFetcherState(key, $dae0ef9fca964cc6$var$getDoneFetcher(undefined));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        // Process any non-redirect errors thrown
        if ($dae0ef9fca964cc6$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        $dae0ef9fca964cc6$export$3e9cee6b33872309(!$dae0ef9fca964cc6$var$isDeferredResult(result), "Unhandled fetcher deferred data");
        // Put the fetcher back into an idle state
        updateFetcherState(key, $dae0ef9fca964cc6$var$getDoneFetcher(result.data));
    }
    /**
   * Utility function to handle redirects returned from an action or loader.
   * Normally, a redirect "replaces" the navigation that triggered it.  So, for
   * example:
   *
   *  - user is on /a
   *  - user clicks a link to /b
   *  - loader for /b redirects to /c
   *
   * In a non-JS app the browser would track the in-flight navigation to /b and
   * then replace it with /c when it encountered the redirect response.  In
   * the end it would only ever update the URL bar with /c.
   *
   * In client-side routing using pushState/replaceState, we aim to emulate
   * this behavior and we also do not update history until the end of the
   * navigation (including processed redirects).  This means that we never
   * actually touch history until we've processed redirects, so we just use
   * the history action from the original navigation (PUSH or REPLACE).
   */ async function startRedirectNavigation(request, redirect, isNavigation, _temp2) {
        let { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = _temp2 === void 0 ? {} : _temp2;
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        $dae0ef9fca964cc6$export$3e9cee6b33872309(location, "Expected a Location header on the redirect Response");
        location = $dae0ef9fca964cc6$var$normalizeRedirectLocation(location, new URL(request.url), basename, init.history);
        let redirectLocation = $dae0ef9fca964cc6$var$createLocation(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) // Hard reload if the response contained X-Remix-Reload-Document
            isDocumentReload = true;
            else if ($dae0ef9fca964cc6$var$ABSOLUTE_URL_REGEX.test(location)) {
                const url = init.history.createURL(location);
                isDocumentReload = // Hard reload if it's an absolute URL to a new origin
                url.origin !== routerWindow.location.origin || // Hard reload if it's an absolute URL that does not match our basename
                $dae0ef9fca964cc6$export$b69e3301ce081aa3(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        // There's no need to abort on redirects, since we don't detect the
        // redirect until the action/loaders have settled
        pendingNavigationController = null;
        let redirectHistoryAction = replace === true || redirect.response.headers.has("X-Remix-Replace") ? $dae0ef9fca964cc6$export$e19cd5f9376f8cee.Replace : $dae0ef9fca964cc6$export$e19cd5f9376f8cee.Push;
        // Use the incoming submission if provided, fallback on the active one in
        // state.navigation
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $dae0ef9fca964cc6$var$getSubmissionFromNavigation(state.navigation);
        // If this was a 307/308 submission we want to preserve the HTTP method and
        // re-submit the GET/POST/PUT/PATCH/DELETE as a submission navigation to the
        // redirected location
        let activeSubmission = submission || fetcherSubmission;
        if ($dae0ef9fca964cc6$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $dae0ef9fca964cc6$var$isMutationMethod(activeSubmission.formMethod)) await startNavigation(redirectHistoryAction, redirectLocation, {
            submission: $dae0ef9fca964cc6$var$_extends({}, activeSubmission, {
                formAction: location
            }),
            // Preserve these flags across redirects
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
        });
        else {
            // If we have a navigation submission, we will preserve it through the
            // redirect navigation
            let overrideNavigation = $dae0ef9fca964cc6$var$getLoadingNavigation(redirectLocation, submission);
            await startNavigation(redirectHistoryAction, redirectLocation, {
                overrideNavigation: overrideNavigation,
                fetcherSubmission: // Send fetcher submissions through for shouldRevalidate
                fetcherSubmission,
                // Preserve these flags across redirects
                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : undefined
            });
        }
    }
    // Utility wrapper for calling dataStrategy client-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, state, request, matchesToLoad, matches, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $dae0ef9fca964cc6$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties);
        } catch (e) {
            // If the outer dataStrategy method throws, just return the error for all
            // matches - and it'll naturally bubble to the root
            matchesToLoad.forEach((m)=>{
                dataResults[m.route.id] = {
                    type: $dae0ef9fca964cc6$var$ResultType.error,
                    error: e
                };
            });
            return dataResults;
        }
        for (let [routeId, result] of Object.entries(results))if ($dae0ef9fca964cc6$var$isRedirectDataStrategyResultResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: $dae0ef9fca964cc6$var$ResultType.redirect,
                response: $dae0ef9fca964cc6$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, future.v7_relativeSplatPath)
            };
        } else dataResults[routeId] = await $dae0ef9fca964cc6$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(state, matches, matchesToLoad, fetchersToLoad, request) {
        let currentMatches = state.matches;
        // Kick off loaders and fetchers in parallel
        let loaderResultsPromise = callDataStrategy("loader", state, request, matchesToLoad, matches, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.controller) {
                let results = await callDataStrategy("loader", state, $dae0ef9fca964cc6$var$createClientSideRequest(init.history, f.path, f.controller.signal), [
                    f.match
                ], f.matches, f.key);
                let result = results[f.match.route.id];
                // Fetcher results are keyed by fetcher key from here on out, not routeId
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: $dae0ef9fca964cc6$var$ResultType.error,
                    error: $dae0ef9fca964cc6$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        let loaderResults = await loaderResultsPromise;
        let fetcherResults = (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {});
        await Promise.all([
            $dae0ef9fca964cc6$var$resolveNavigationDeferredResults(matches, loaderResults, request.signal, currentMatches, state.loaderData),
            $dae0ef9fca964cc6$var$resolveFetcherDeferredResults(matches, fetcherResults, fetchersToLoad)
        ]);
        return {
            loaderResults: loaderResults,
            fetcherResults: fetcherResults
        };
    }
    function interruptActiveLoads() {
        // Every interruption triggers a revalidation
        isRevalidationRequired = true;
        // Cancel pending route-level deferreds and mark cancelled routes for
        // revalidation
        cancelledDeferredRoutes.push(...cancelActiveDeferreds());
        // Abort in-flight fetcher loads
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts) {
        if (opts === void 0) opts = {};
        state.fetchers.set(key, fetcher);
        updateState({
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts) {
        if (opts === void 0) opts = {};
        let boundaryMatch = $dae0ef9fca964cc6$var$findNearestBoundary(state.matches, routeId);
        deleteFetcher(key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: new Map(state.fetchers)
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        // If this fetcher was previously marked for deletion, unmark it since we
        // have a new instance
        if (deletedFetchers.has(key)) deletedFetchers.delete(key);
        return state.fetchers.get(key) || $dae0ef9fca964cc6$export$52eace9c284d3585;
    }
    function deleteFetcher(key) {
        let fetcher = state.fetchers.get(key);
        // Don't abort the controller if this is a deletion of a fetcher.submit()
        // in it's loading phase since - we don't want to abort the corresponding
        // revalidation and want them to complete and land
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        // If we opted into the flag we can clear this now since we're calling
        // deleteFetcher() at the end of updateState() and we've already handed the
        // deleted fetcher keys off to the data layer.
        // If not, we're eagerly calling deleteFetcher() and we need to keep this
        // Set populated until the next updateState call, and we'll clear
        // `deletedFetchers` then
        if (future.v7_fetcherPersist) deletedFetchers.delete(key);
        cancelledFetcherLoads.delete(key);
        state.fetchers.delete(key);
    }
    function deleteFetcherAndUpdateState(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            deletedFetchers.add(key);
            if (!future.v7_fetcherPersist) deleteFetcher(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort();
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys) {
        for (let key of keys){
            let fetcher = getFetcher(key);
            let doneFetcher = $dae0ef9fca964cc6$var$getDoneFetcher(fetcher.data);
            state.fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone() {
        let doneKeys = [];
        let updatedFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = state.fetchers.get(key);
            $dae0ef9fca964cc6$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                updatedFetchers = true;
            }
        }
        markFetchersDone(doneKeys);
        return updatedFetchers;
    }
    function abortStaleFetchLoads(landedId) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = state.fetchers.get(key);
            $dae0ef9fca964cc6$export$3e9cee6b33872309(fetcher, "Expected fetcher: " + key);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $dae0ef9fca964cc6$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    // Utility function to update blockers, ensuring valid state transitions
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $dae0ef9fca964cc6$export$386d57f03f0b2883;
        // Poor mans state machine :)
        // https://mermaid.live/edit#pako:eNqVkc9OwzAMxl8l8nnjAYrEtDIOHEBIgwvKJTReGy3_lDpIqO27k6awMG0XcrLlnz87nwdonESogKXXBuE79rq75XZO3-yHds0RJVuv70YrPlUrCEe2HfrORS3rubqZfuhtpg5C9wk5tZ4VKcRUq88q9Z8RS0-48cE1iHJkL0ugbHuFLus9L6spZy8nX9MP2CNdomVaposqu3fGayT8T8-jJQwhepo_UtpgBQaDEUom04dZhAN1aJBDlUKJBxE1ceB2Smj0Mln-IBW5AFU2dwUiktt_2Qaq2dBfaKdEup85UV7Yd-dKjlnkabl2Pvr0DTkTreM
        $dae0ef9fca964cc6$export$3e9cee6b33872309(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: " + blocker.state + " -> " + newBlocker.state);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(_ref2) {
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = _ref2;
        if (blockerFunctions.size === 0) return;
        // We ony support a single active blocker at the moment since we don't have
        // any compelling use cases for multi-blocker yet
        if (blockerFunctions.size > 1) $dae0ef9fca964cc6$export$c0e02632e14916fd(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") // If the blocker is currently proceeding, we don't need to re-check
        // it and can let this navigation continue
        return;
        // At this point, we know we're unblocked/blocked so we need to check the
        // user-provided blocker function
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $dae0ef9fca964cc6$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = inFlightDataRoutes || dataRoutes;
        let { matches: matches, route: route } = $dae0ef9fca964cc6$var$getShortCircuitMatches(routesToUse);
        // Cancel all pending deferred on 404s since we don't keep any routes
        cancelActiveDeferreds();
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function cancelActiveDeferreds(predicate) {
        let cancelledRouteIds = [];
        activeDeferreds.forEach((dfd, routeId)=>{
            if (!predicate || predicate(routeId)) {
                // Cancel the deferred - but do not remove from activeDeferreds here -
                // we rely on the subscribers to do that so our tests can assert proper
                // cleanup via _internalActiveDeferreds
                dfd.cancel();
                cancelledRouteIds.push(routeId);
                activeDeferreds.delete(routeId);
            }
        });
        return cancelledRouteIds;
    }
    // Opt in to capturing and reporting scroll positions during navigations,
    // used by the <ScrollRestoration> component
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        // Perform initial hydration scroll restoration, since we miss the boat on
        // the initial updateState() because we've not yet rendered <ScrollRestoration/>
        // and therefore have no savedScrollPositions available
        if (!initialScrollRestored && state.navigation === $dae0ef9fca964cc6$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) {
            let key = getScrollRestorationKey(location, matches.map((m)=>$dae0ef9fca964cc6$export$b3fac024fad9e8ff(m, state.loaderData)));
            return key || location.key;
        }
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (patchRoutesOnNavigationImpl) {
            if (!matches) {
                let fogMatches = $dae0ef9fca964cc6$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: fogMatches || []
                };
            } else if (Object.keys(matches[0].params).length > 0) {
                // If we matched a dynamic param or a splat, it might only be because
                // we haven't yet discovered other routes that would match with a
                // higher score.  Call patchRoutesOnNavigation just to be sure
                let partialMatches = $dae0ef9fca964cc6$var$matchRoutesImpl(routesToUse, pathname, basename, true);
                return {
                    active: true,
                    matches: partialMatches
                };
            }
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!patchRoutesOnNavigationImpl) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let isNonHMR = inFlightDataRoutes == null;
            let routesToUse = inFlightDataRoutes || dataRoutes;
            let localManifest = manifest;
            try {
                await patchRoutesOnNavigationImpl({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $dae0ef9fca964cc6$var$patchRoutesImpl(routeId, children, routesToUse, localManifest, mapRouteProperties);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            } finally{
                // If we are not in the middle of an HMR revalidation and we changed the
                // routes, provide a new identity so when we `updateState` at the end of
                // this navigation/fetch `router.routes` will be a new identity and
                // trigger a re-run of memoized `router.routes` dependencies.
                // HMR will already update the identity and reflow when it lands
                // `inFlightDataRoutes` in `completeNavigation`
                if (isNonHMR && !signal.aborted) dataRoutes = [
                    ...dataRoutes
                ];
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = $dae0ef9fca964cc6$export$2708184779ceb39d(routesToUse, pathname, basename);
            if (newMatches) return {
                type: "success",
                matches: newMatches
            };
            let newPartialMatches = $dae0ef9fca964cc6$var$matchRoutesImpl(routesToUse, pathname, basename, true);
            // Avoid loops if the second pass results in the same partial matches
            if (!newPartialMatches || partialMatches.length === newPartialMatches.length && partialMatches.every((m, i)=>m.route.id === newPartialMatches[i].route.id)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        inFlightDataRoutes = $dae0ef9fca964cc6$export$4a6d22b32134ea5d(newRoutes, mapRouteProperties, undefined, manifest);
    }
    function patchRoutes(routeId, children) {
        let isNonHMR = inFlightDataRoutes == null;
        let routesToUse = inFlightDataRoutes || dataRoutes;
        $dae0ef9fca964cc6$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties);
        // If we are not in the middle of an HMR revalidation and we changed the
        // routes, provide a new identity and trigger a reflow via `updateState`
        // to re-run memoized `router.routes` dependencies.
        // HMR will already update the identity and reflow when it lands
        // `inFlightDataRoutes` in `completeNavigation`
        if (isNonHMR) {
            dataRoutes = [
                ...dataRoutes
            ];
            updateState({});
        }
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        // Passthrough to history-aware createHref used by useHref so we get proper
        // hash-aware URLs in DOM paths
        createHref: (to)=>init.history.createHref(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        deleteFetcher: deleteFetcherAndUpdateState,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalActiveDeferreds: activeDeferreds,
        _internalSetRoutes: // TODO: Remove setRoutes, it's temporary to avoid dealing with
        // updating the tree while validating the update algorithm.
        _internalSetRoutes
    };
    return router;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region createStaticHandler
////////////////////////////////////////////////////////////////////////////////
const $dae0ef9fca964cc6$export$4d0306f8f6a4585b = Symbol("deferred");
function $dae0ef9fca964cc6$export$3336b097a6fbc59a(routes, opts) {
    $dae0ef9fca964cc6$export$3e9cee6b33872309(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let mapRouteProperties;
    if (opts != null && opts.mapRouteProperties) mapRouteProperties = opts.mapRouteProperties;
    else if (opts != null && opts.detectErrorBoundary) {
        // If they are still using the deprecated version, wrap it with the new API
        let detectErrorBoundary = opts.detectErrorBoundary;
        mapRouteProperties = (route)=>({
                hasErrorBoundary: detectErrorBoundary(route)
            });
    } else mapRouteProperties = $dae0ef9fca964cc6$var$defaultMapRouteProperties;
    // Config driven behavior flags
    let future = $dae0ef9fca964cc6$var$_extends({
        v7_relativeSplatPath: false,
        v7_throwAbortReason: false
    }, opts ? opts.future : null);
    let dataRoutes = $dae0ef9fca964cc6$export$4a6d22b32134ea5d(routes, mapRouteProperties, undefined, manifest);
    /**
   * The query() method is intended for document requests, in which we want to
   * call an optional action and potentially multiple loaders for all nested
   * routes.  It returns a StaticHandlerContext object, which is very similar
   * to the router state (location, loaderData, actionData, errors, etc.) and
   * also adds SSR-specific information such as the statusCode and headers
   * from action/loaders Responses.
   *
   * It _should_ never throw and should report all errors through the
   * returned context.errors object, properly associating errors to their error
   * boundary.  Additionally, it tracks _deepestRenderedBoundaryId which can be
   * used to emulate React error boundaries during SSr by performing a second
   * pass only down to the boundaryId.
   *
   * The one exception where we do not return a StaticHandlerContext is when a
   * redirect response is returned or thrown from any action/loader.  We
   * propagate that out and return the raw Response so the HTTP server can
   * return it directly.
   *
   * - `opts.requestContext` is an optional server context that will be passed
   *   to actions/loaders in the `context` parameter
   * - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
   *   the bubbling of errors which allows single-fetch-type implementations
   *   where the client will handle the bubbling and we may need to return data
   *   for the handling route
   */ async function query(request, _temp3) {
        let { requestContext: requestContext, skipLoaderErrorBubbling: skipLoaderErrorBubbling, dataStrategy: dataStrategy } = _temp3 === void 0 ? {} : _temp3;
        let url = new URL(request.url);
        let method = request.method;
        let location = $dae0ef9fca964cc6$var$createLocation("", $dae0ef9fca964cc6$export$fe53371bee54353d(url), null, "default");
        let matches = $dae0ef9fca964cc6$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$dae0ef9fca964cc6$var$isValidMethod(method) && method !== "HEAD") {
            let error = $dae0ef9fca964cc6$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $dae0ef9fca964cc6$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        } else if (!matches) {
            let error = $dae0ef9fca964cc6$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $dae0ef9fca964cc6$var$getShortCircuitMatches(dataRoutes);
            return {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null);
        if ($dae0ef9fca964cc6$var$isResponse(result)) return result;
        // When returning StaticHandlerContext, we patch back in the location here
        // since we need it for React Context.  But this helps keep our submit and
        // loadRouteData operating on a Request instead of a Location
        return $dae0ef9fca964cc6$var$_extends({
            location: location,
            basename: basename
        }, result);
    }
    /**
   * The queryRoute() method is intended for targeted route requests, either
   * for fetch ?_data requests or resource route requests.  In this case, we
   * are only ever calling a single action or loader, and we are returning the
   * returned value directly.  In most cases, this will be a Response returned
   * from the action/loader, but it may be a primitive or other value as well -
   * and in such cases the calling context should handle that accordingly.
   *
   * We do respect the throw/return differentiation, so if an action/loader
   * throws, then this method will throw the value.  This is important so we
   * can do proper boundary identification in Remix where a thrown Response
   * must go to the Catch Boundary but a returned Response is happy-path.
   *
   * One thing to note is that any Router-initiated Errors that make sense
   * to associate with a status code will be thrown as an ErrorResponse
   * instance which include the raw Error, such that the calling context can
   * serialize the error as they see fit while including the proper response
   * code.  Examples here are 404 and 405 errors that occur prior to reaching
   * any user-defined loaders.
   *
   * - `opts.routeId` allows you to specify the specific route handler to call.
   *   If not provided the handler will determine the proper route by matching
   *   against `request.url`
   * - `opts.requestContext` is an optional server context that will be passed
   *    to actions/loaders in the `context` parameter
   */ async function queryRoute(request, _temp4) {
        let { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy } = _temp4 === void 0 ? {} : _temp4;
        let url = new URL(request.url);
        let method = request.method;
        let location = $dae0ef9fca964cc6$var$createLocation("", $dae0ef9fca964cc6$export$fe53371bee54353d(url), null, "default");
        let matches = $dae0ef9fca964cc6$export$2708184779ceb39d(dataRoutes, location, basename);
        // SSR supports HEAD requests while SPA doesn't
        if (!$dae0ef9fca964cc6$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $dae0ef9fca964cc6$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $dae0ef9fca964cc6$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $dae0ef9fca964cc6$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $dae0ef9fca964cc6$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) // This should never hit I don't think?
        throw $dae0ef9fca964cc6$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match);
        if ($dae0ef9fca964cc6$var$isResponse(result)) return result;
        let error = result.errors ? Object.values(result.errors)[0] : undefined;
        if (error !== undefined) // If we got back result.errors, that means the loader/action threw
        // _something_ that wasn't a Response, but it's not guaranteed/required
        // to be an `instanceof Error` either, so we have to use throw here to
        // preserve the "error" state outside of queryImpl.
        throw error;
        // Pick off the right state value to return
        if (result.actionData) return Object.values(result.actionData)[0];
        if (result.loaderData) {
            var _result$activeDeferre;
            let data = Object.values(result.loaderData)[0];
            if ((_result$activeDeferre = result.activeDeferreds) != null && _result$activeDeferre[match.route.id]) data[$dae0ef9fca964cc6$export$4d0306f8f6a4585b] = result.activeDeferreds[match.route.id];
            return data;
        }
        return undefined;
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch) {
        $dae0ef9fca964cc6$export$3e9cee6b33872309(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($dae0ef9fca964cc6$var$isMutationMethod(request.method.toLowerCase())) {
                let result = await submit(request, matches, routeMatch || $dae0ef9fca964cc6$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null);
                return result;
            }
            let result = await loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch);
            return $dae0ef9fca964cc6$var$isResponse(result) ? result : $dae0ef9fca964cc6$var$_extends({}, result, {
                actionData: null,
                actionHeaders: {}
            });
        } catch (e) {
            // If the user threw/returned a Response in callLoaderOrAction for a
            // `queryRoute` call, we throw the `DataStrategyResult` to bail out early
            // and then return or throw the raw Response here accordingly
            if ($dae0ef9fca964cc6$var$isDataStrategyResult(e) && $dae0ef9fca964cc6$var$isResponse(e.result)) {
                if (e.type === $dae0ef9fca964cc6$var$ResultType.error) throw e.result;
                return e.result;
            }
            // Redirects are always returned since they don't propagate to catch
            // boundaries
            if ($dae0ef9fca964cc6$var$isRedirectResponse(e)) return e;
            throw e;
        }
    }
    async function submit(request, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $dae0ef9fca964cc6$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: $dae0ef9fca964cc6$var$ResultType.error,
                error: error
            };
        } else {
            let results = await callDataStrategy("action", request, [
                actionMatch
            ], matches, isRouteRequest, requestContext, dataStrategy);
            result = results[actionMatch.route.id];
            if (request.signal.aborted) $dae0ef9fca964cc6$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        }
        if ($dae0ef9fca964cc6$var$isRedirectResult(result)) // Uhhhh - this should never happen, we should always throw these from
        // callLoaderOrAction, but the type narrowing here keeps TS happy and we
        // can get back on the "throw all redirect responses" train here should
        // this ever happen :/
        throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if ($dae0ef9fca964cc6$var$isDeferredResult(result)) {
            let error = $dae0ef9fca964cc6$var$getInternalRouterError(400, {
                type: "defer-action"
            });
            if (isRouteRequest) throw error;
            result = {
                type: $dae0ef9fca964cc6$var$ResultType.error,
                error: error
            };
        }
        if (isRouteRequest) {
            // Note: This should only be non-Response values if we get here, since
            // isRouteRequest should throw any Response received in callLoaderOrAction
            if ($dae0ef9fca964cc6$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                // Note: statusCode + headers are unused here since queryRoute will
                // return the raw Response or value
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {},
                activeDeferreds: null
            };
        }
        // Create a GET request for the loaders
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($dae0ef9fca964cc6$var$isErrorResult(result)) {
            // Store off the pending error - we use it to determine which loaders
            // to call and will commit it when we complete the navigation
            let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $dae0ef9fca964cc6$var$findNearestBoundary(matches, actionMatch.route.id);
            let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, [
                boundaryMatch.route.id,
                result
            ]);
            // action status codes take precedence over loader status codes
            return $dae0ef9fca964cc6$var$_extends({}, context, {
                statusCode: $dae0ef9fca964cc6$export$972111febbeef05b(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                actionData: null,
                actionHeaders: $dae0ef9fca964cc6$var$_extends({}, result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {})
            });
        }
        let context = await loadRouteData(loaderRequest, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null);
        return $dae0ef9fca964cc6$var$_extends({}, context, {
            actionData: {
                [actionMatch.route.id]: result.data
            }
        }, result.statusCode ? {
            statusCode: result.statusCode
        } : {}, {
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        });
    }
    async function loadRouteData(request, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        // Short circuit if we have no loaders to run (queryRoute())
        if (isRouteRequest && !(routeMatch != null && routeMatch.route.loader) && !(routeMatch != null && routeMatch.route.lazy)) throw $dae0ef9fca964cc6$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch == null ? void 0 : routeMatch.route.id
        });
        let requestMatches = routeMatch ? [
            routeMatch
        ] : pendingActionResult && $dae0ef9fca964cc6$var$isErrorResult(pendingActionResult[1]) ? $dae0ef9fca964cc6$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]) : matches;
        let matchesToLoad = requestMatches.filter((m)=>m.route.loader || m.route.lazy);
        // Short circuit if we have no loaders to run (query())
        if (matchesToLoad.length === 0) return {
            matches: matches,
            // Add a null for all matched routes for proper revalidation on the client
            loaderData: matches.reduce((acc, m)=>Object.assign(acc, {
                    [m.route.id]: null
                }), {}),
            errors: pendingActionResult && $dae0ef9fca964cc6$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {},
            activeDeferreds: null
        };
        let results = await callDataStrategy("loader", request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $dae0ef9fca964cc6$var$throwStaticHandlerAbortedError(request, isRouteRequest, future);
        // Process and commit output from loaders
        let activeDeferreds = new Map();
        let context = $dae0ef9fca964cc6$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling);
        // Add a null for any non-loader matches for proper revalidation on the client
        let executedLoaders = new Set(matchesToLoad.map((match)=>match.route.id));
        matches.forEach((match)=>{
            if (!executedLoaders.has(match.route.id)) context.loaderData[match.route.id] = null;
        });
        return $dae0ef9fca964cc6$var$_extends({}, context, {
            matches: matches,
            activeDeferreds: activeDeferreds.size > 0 ? Object.fromEntries(activeDeferreds.entries()) : null
        });
    }
    // Utility wrapper for calling dataStrategy server-side without having to
    // pass around the manifest, mapRouteProperties, etc.
    async function callDataStrategy(type, request, matchesToLoad, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $dae0ef9fca964cc6$var$callDataStrategyImpl(dataStrategy || $dae0ef9fca964cc6$var$defaultDataStrategy, type, null, request, matchesToLoad, matches, null, manifest, mapRouteProperties, requestContext);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($dae0ef9fca964cc6$var$isRedirectDataStrategyResultResult(result)) {
                let response = result.result;
                // Throw redirects and let the server handle them with an HTTP redirect
                throw $dae0ef9fca964cc6$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename, future.v7_relativeSplatPath);
            }
            if ($dae0ef9fca964cc6$var$isResponse(result.result) && isRouteRequest) // For SSR single-route requests, we want to hand Responses back
            // directly without unwrapping
            throw result;
            dataResults[match.route.id] = await $dae0ef9fca964cc6$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        query: query,
        queryRoute: queryRoute
    };
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Helpers
////////////////////////////////////////////////////////////////////////////////
/**
 * Given an existing StaticHandlerContext and an error thrown at render time,
 * provide an updated StaticHandlerContext suitable for a second SSR render
 */ function $dae0ef9fca964cc6$export$fec11da027c70692(routes, context, error) {
    let newContext = $dae0ef9fca964cc6$var$_extends({}, context, {
        statusCode: $dae0ef9fca964cc6$export$972111febbeef05b(error) ? error.status : 500,
        errors: {
            [context._deepestRenderedBoundaryId || routes[0].id]: error
        }
    });
    return newContext;
}
function $dae0ef9fca964cc6$var$throwStaticHandlerAbortedError(request, isRouteRequest, future) {
    if (future.v7_throwAbortReason && request.signal.reason !== undefined) throw request.signal.reason;
    let method = isRouteRequest ? "queryRoute" : "query";
    throw new Error(method + "() call aborted: " + request.method + " " + request.url);
}
function $dae0ef9fca964cc6$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== undefined);
}
function $dae0ef9fca964cc6$var$normalizeTo(location, matches, basename, prependBasename, to, v7_relativeSplatPath, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        // Grab matches up to the calling route so our route-relative logic is
        // relative to the correct source route
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    // Resolve the relative path
    let path = $dae0ef9fca964cc6$export$cae722b0cc860f13(to ? to : ".", $dae0ef9fca964cc6$export$a5784978eca585fa(contextualMatches, v7_relativeSplatPath), $dae0ef9fca964cc6$export$b69e3301ce081aa3(location.pathname, basename) || location.pathname, relative === "path");
    // When `to` is not specified we inherit search/hash from the current
    // location, unlike when to="." and we just inherit the path.
    // See https://github.com/remix-run/remix/issues/927
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    // Account for `?index` params when routing to the current location
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $dae0ef9fca964cc6$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) // Add one when we're targeting an index route
        path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            // Remove existing ones when we're not
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    // If we're operating within a basename, prepend it to the pathname.  If
    // this is a root navigation, then just use the raw basename which allows
    // the basename to have full control over the presence of a trailing slash
    // on root actions
    if (prependBasename && basename !== "/") path.pathname = path.pathname === "/" ? basename : $dae0ef9fca964cc6$export$86d9a7913e44197e([
        basename,
        path.pathname
    ]);
    return $dae0ef9fca964cc6$export$fe53371bee54353d(path);
}
// Normalize navigation options by converting formMethod=GET formData objects to
// URLSearchParams so they behave identically to links with query params
function $dae0ef9fca964cc6$var$normalizeNavigateOptions(normalizeFormMethod, isFetcher, path, opts) {
    // Return location verbatim on non-submission navigations
    if (!opts || !$dae0ef9fca964cc6$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$dae0ef9fca964cc6$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $dae0ef9fca964cc6$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $dae0ef9fca964cc6$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    // Create a Submission on non-GET navigations
    let rawFormMethod = opts.formMethod || "get";
    let formMethod = normalizeFormMethod ? rawFormMethod.toUpperCase() : rawFormMethod.toLowerCase();
    let formAction = $dae0ef9fca964cc6$var$stripHashFromPath(path);
    if (opts.body !== undefined) {
        if (opts.formEncType === "text/plain") {
            // text only support POST/PUT/PATCH/DELETE submissions
            if (!$dae0ef9fca964cc6$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? // https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#plain-text-form-data
            Array.from(opts.body.entries()).reduce((acc, _ref3)=>{
                let [name, value] = _ref3;
                return "" + acc + name + "=" + value + "\n";
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: undefined,
                    json: undefined,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            // json only supports POST/PUT/PATCH/DELETE submissions
            if (!$dae0ef9fca964cc6$var$isMutationMethod(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: undefined,
                        json: json,
                        text: undefined
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    $dae0ef9fca964cc6$export$3e9cee6b33872309(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $dae0ef9fca964cc6$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $dae0ef9fca964cc6$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $dae0ef9fca964cc6$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $dae0ef9fca964cc6$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: undefined,
        text: undefined
    };
    if ($dae0ef9fca964cc6$var$isMutationMethod(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    // Flatten submission onto URLSearchParams for GET submissions
    let parsedPath = $dae0ef9fca964cc6$export$8ccf933b0513f8d0(path);
    // On GET navigation submissions we can drop the ?index param from the
    // resulting location since all loaders will run.  But fetcher GET submissions
    // only run a single loader so we need to preserve any incoming ?index params
    if (isFetcher && parsedPath.search && $dae0ef9fca964cc6$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?" + searchParams;
    return {
        path: $dae0ef9fca964cc6$export$fe53371bee54353d(parsedPath),
        submission: submission
    };
}
// Filter out all routes at/below any caught error as they aren't going to
// render so we don't need to load them
function $dae0ef9fca964cc6$var$getLoaderMatchesUntilBoundary(matches, boundaryId, includeBoundary) {
    if (includeBoundary === void 0) includeBoundary = false;
    let index = matches.findIndex((m)=>m.route.id === boundaryId);
    if (index >= 0) return matches.slice(0, includeBoundary ? index + 1 : index);
    return matches;
}
function $dae0ef9fca964cc6$var$getMatchesToLoad(history, state, matches, submission, location, initialHydration, skipActionErrorRevalidation, isRevalidationRequired, cancelledDeferredRoutes, cancelledFetcherLoads, deletedFetchers, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, pendingActionResult) {
    let actionResult = pendingActionResult ? $dae0ef9fca964cc6$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : undefined;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    // Pick navigation matches that are net-new or qualify for revalidation
    let boundaryMatches = matches;
    if (initialHydration && state.errors) // On initial hydration, only consider matches up to _and including_ the boundary.
    // This is inclusive to handle cases where a server loader ran successfully,
    // a child server loader bubbled up to this route, but this route has
    // `clientLoader.hydrate` so we want to still run the `clientLoader` so that
    // we have a complete version of `loaderData`
    boundaryMatches = $dae0ef9fca964cc6$var$getLoaderMatchesUntilBoundary(matches, Object.keys(state.errors)[0], true);
    else if (pendingActionResult && $dae0ef9fca964cc6$var$isErrorResult(pendingActionResult[1])) // If an action threw an error, we call loaders up to, but not including the
    // boundary
    boundaryMatches = $dae0ef9fca964cc6$var$getLoaderMatchesUntilBoundary(matches, pendingActionResult[0]);
    // Don't revalidate loaders by default after action 4xx/5xx responses
    // when the flag is enabled.  They can still opt-into revalidation via
    // `shouldRevalidate` via `actionResult`
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : undefined;
    let shouldSkipRevalidation = skipActionErrorRevalidation && actionStatus && actionStatus >= 400;
    let navigationMatches = boundaryMatches.filter((match, index)=>{
        let { route: route } = match;
        if (route.lazy) // We haven't loaded this route yet so we don't know if it's got a loader!
        return true;
        if (route.loader == null) return false;
        if (initialHydration) return $dae0ef9fca964cc6$var$shouldLoadRouteOnHydration(route, state.loaderData, state.errors);
        // Always call the loader on new route instances and pending defer cancellations
        if ($dae0ef9fca964cc6$var$isNewLoader(state.loaderData, state.matches[index], match) || cancelledDeferredRoutes.some((id)=>id === match.route.id)) return true;
        // This is the default implementation for when we revalidate.  If the route
        // provides it's own implementation, then we give them full control but
        // provide this value so they can leverage it if needed after they check
        // their own specific use cases
        let currentRouteMatch = state.matches[index];
        let nextRouteMatch = match;
        return $dae0ef9fca964cc6$var$shouldRevalidateLoader(match, $dae0ef9fca964cc6$var$_extends({
            currentUrl: currentUrl,
            currentParams: currentRouteMatch.params,
            nextUrl: nextUrl,
            nextParams: nextRouteMatch.params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : // Forced revalidation due to submission, useRevalidator, or X-Remix-Revalidate
            isRevalidationRequired || currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search || // Search params affect all loaders
            currentUrl.search !== nextUrl.search || $dae0ef9fca964cc6$var$isNewRouteInstance(currentRouteMatch, nextRouteMatch)
        }));
    });
    // Pick fetcher.loads that need to be revalidated
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        // Don't revalidate:
        //  - on initial hydration (shouldn't be any fetchers then anyway)
        //  - if fetcher won't be present in the subsequent render
        //    - no longer matches the URL (v7_fetcherPersist=false)
        //    - was unmounted but persisted due to v7_fetcherPersist=true
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || deletedFetchers.has(key)) return;
        let fetcherMatches = $dae0ef9fca964cc6$export$2708184779ceb39d(routesToUse, f.path, basename);
        // If the fetcher path no longer matches, push it in with null matches so
        // we can trigger a 404 in callLoadersAndMaybeResolveData.  Note this is
        // currently only a use-case for Remix HMR where the route tree can change
        // at runtime and remove a route previously loaded via a fetcher
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                controller: null
            });
            return;
        }
        // Revalidating fetchers are decoupled from the route matches since they
        // load from a static href.  They revalidate based on explicit revalidation
        // (submission, useRevalidator, or X-Remix-Revalidate)
        let fetcher = state.fetchers.get(key);
        let fetcherMatch = $dae0ef9fca964cc6$var$getTargetMatch(fetcherMatches, f.path);
        let shouldRevalidate = false;
        if (fetchRedirectIds.has(key)) // Never trigger a revalidation of an actively redirecting fetcher
        shouldRevalidate = false;
        else if (cancelledFetcherLoads.has(key)) {
            // Always mark for revalidation if the fetcher was cancelled
            cancelledFetcherLoads.delete(key);
            shouldRevalidate = true;
        } else if (fetcher && fetcher.state !== "idle" && fetcher.data === undefined) // If the fetcher hasn't ever completed loading yet, then this isn't a
        // revalidation, it would just be a brand new load if an explicit
        // revalidation is required
        shouldRevalidate = isRevalidationRequired;
        else // Otherwise fall back on any user-defined shouldRevalidate, defaulting
        // to explicit revalidations only
        shouldRevalidate = $dae0ef9fca964cc6$var$shouldRevalidateLoader(fetcherMatch, $dae0ef9fca964cc6$var$_extends({
            currentUrl: currentUrl,
            currentParams: state.matches[state.matches.length - 1].params,
            nextUrl: nextUrl,
            nextParams: matches[matches.length - 1].params
        }, submission, {
            actionResult: actionResult,
            actionStatus: actionStatus,
            defaultShouldRevalidate: shouldSkipRevalidation ? false : isRevalidationRequired
        }));
        if (shouldRevalidate) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherMatches,
            match: fetcherMatch,
            controller: new AbortController()
        });
    });
    return [
        navigationMatches,
        revalidatingFetchers
    ];
}
function $dae0ef9fca964cc6$var$shouldLoadRouteOnHydration(route, loaderData, errors) {
    // We dunno if we have a loader - gotta find out!
    if (route.lazy) return true;
    // No loader, nothing to initialize
    if (!route.loader) return false;
    let hasData = loaderData != null && loaderData[route.id] !== undefined;
    let hasError = errors != null && errors[route.id] !== undefined;
    // Don't run if we error'd during SSR
    if (!hasData && hasError) return false;
    // Explicitly opting-in to running on hydration
    if (typeof route.loader === "function" && route.loader.hydrate === true) return true;
    // Otherwise, run if we're not yet initialized with anything
    return !hasData && !hasError;
}
function $dae0ef9fca964cc6$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = // [a] -> [a, b]
    !currentMatch || // [a, b] -> [a, c]
    match.route.id !== currentMatch.route.id;
    // Handle the case that we don't have data for a re-used route, potentially
    // from a prior error or from a cancelled pending deferred
    let isMissingData = currentLoaderData[match.route.id] === undefined;
    // Always load if this is a net-new route or we don't yet have data
    return isNew || isMissingData;
}
function $dae0ef9fca964cc6$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return(// param change for this match, /users/123 -> /users/456
    currentMatch.pathname !== match.pathname || // splat param changed, which is not present in match.path
    // e.g. /files/images/avatar.jpg -> files/finances.xls
    currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"]);
}
function $dae0ef9fca964cc6$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $dae0ef9fca964cc6$var$patchRoutesImpl(routeId, children, routesToUse, manifest, mapRouteProperties) {
    var _childrenToPatch;
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        $dae0ef9fca964cc6$export$3e9cee6b33872309(route, "No route found to patch children into: routeId = " + routeId);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = routesToUse;
    // Don't patch in routes we already know about so that `patch` is idempotent
    // to simplify user-land code. This is useful because we re-call the
    // `patchRoutesOnNavigation` function for matched routes with params.
    let uniqueChildren = children.filter((newRoute)=>!childrenToPatch.some((existingRoute)=>$dae0ef9fca964cc6$var$isSameRoute(newRoute, existingRoute)));
    let newRoutes = $dae0ef9fca964cc6$export$4a6d22b32134ea5d(uniqueChildren, mapRouteProperties, [
        routeId || "_",
        "patch",
        String(((_childrenToPatch = childrenToPatch) == null ? void 0 : _childrenToPatch.length) || "0")
    ], manifest);
    childrenToPatch.push(...newRoutes);
}
function $dae0ef9fca964cc6$var$isSameRoute(newRoute, existingRoute) {
    // Most optimal check is by id
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    // Second is by pathing differences
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    // Pathless layout routes are trickier since we need to check children.
    // If they have no children then they're the same as far as we can tell
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    // Otherwise, we look to see if every child in the new route is already
    // represented in the existing route's children
    return newRoute.children.every((aChild, i)=>{
        var _existingRoute$childr;
        return (_existingRoute$childr = existingRoute.children) == null ? void 0 : _existingRoute$childr.some((bChild)=>$dae0ef9fca964cc6$var$isSameRoute(aChild, bChild));
    });
}
/**
 * Execute route.lazy() methods to lazily load route modules (loader, action,
 * shouldRevalidate) and update the routeManifest in place which shares objects
 * with dataRoutes so those get updated as well.
 */ async function $dae0ef9fca964cc6$var$loadLazyRouteModule(route, mapRouteProperties, manifest) {
    if (!route.lazy) return;
    let lazyRoute = await route.lazy();
    // If the lazy route function was executed and removed by another parallel
    // call then we can return - first lazy() to finish wins because the return
    // value of lazy is expected to be static
    if (!route.lazy) return;
    let routeToUpdate = manifest[route.id];
    $dae0ef9fca964cc6$export$3e9cee6b33872309(routeToUpdate, "No route found in manifest");
    // Update the route in place.  This should be safe because there's no way
    // we could yet be sitting on this route as we can't get there without
    // resolving lazy() first.
    //
    // This is different than the HMR "update" use-case where we may actively be
    // on the route being updated.  The main concern boils down to "does this
    // mutation affect any ongoing navigations or any current state.matches
    // values?".  If not, it should be safe to update in place.
    let routeUpdates = {};
    for(let lazyRouteProperty in lazyRoute){
        let staticRouteValue = routeToUpdate[lazyRouteProperty];
        let isPropertyStaticallyDefined = staticRouteValue !== undefined && // This property isn't static since it should always be updated based
        // on the route updates
        lazyRouteProperty !== "hasErrorBoundary";
        $dae0ef9fca964cc6$export$c0e02632e14916fd(!isPropertyStaticallyDefined, "Route \"" + routeToUpdate.id + "\" has a static property \"" + lazyRouteProperty + "\" " + "defined but its lazy function is also returning a value for this property. " + ("The lazy route property \"" + lazyRouteProperty + "\" will be ignored."));
        if (!isPropertyStaticallyDefined && !$dae0ef9fca964cc6$var$immutableRouteKeys.has(lazyRouteProperty)) routeUpdates[lazyRouteProperty] = lazyRoute[lazyRouteProperty];
    }
    // Mutate the route with the provided updates.  Do this first so we pass
    // the updated version to mapRouteProperties
    Object.assign(routeToUpdate, routeUpdates);
    // Mutate the `hasErrorBoundary` property on the route based on the route
    // updates and remove the `lazy` function so we don't resolve the lazy
    // route again.
    Object.assign(routeToUpdate, $dae0ef9fca964cc6$var$_extends({}, mapRouteProperties(routeToUpdate), {
        lazy: undefined
    }));
}
// Default implementation of `dataStrategy` which fetches all loaders in parallel
async function $dae0ef9fca964cc6$var$defaultDataStrategy(_ref4) {
    let { matches: matches } = _ref4;
    let matchesToLoad = matches.filter((m)=>m.shouldLoad);
    let results = await Promise.all(matchesToLoad.map((m)=>m.resolve()));
    return results.reduce((acc, result, i)=>Object.assign(acc, {
            [matchesToLoad[i].route.id]: result
        }), {});
}
async function $dae0ef9fca964cc6$var$callDataStrategyImpl(dataStrategyImpl, type, state, request, matchesToLoad, matches, fetcherKey, manifest, mapRouteProperties, requestContext) {
    let loadRouteDefinitionsPromises = matches.map((m)=>m.route.lazy ? $dae0ef9fca964cc6$var$loadLazyRouteModule(m.route, mapRouteProperties, manifest) : undefined);
    let dsMatches = matches.map((match, i)=>{
        let loadRoutePromise = loadRouteDefinitionsPromises[i];
        let shouldLoad = matchesToLoad.some((m)=>m.route.id === match.route.id);
        // `resolve` encapsulates route.lazy(), executing the loader/action,
        // and mapping return values/thrown errors to a `DataStrategyResult`.  Users
        // can pass a callback to take fine-grained control over the execution
        // of the loader/action
        let resolve = async (handlerOverride)=>{
            if (handlerOverride && request.method === "GET" && (match.route.lazy || match.route.loader)) shouldLoad = true;
            return shouldLoad ? $dae0ef9fca964cc6$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, requestContext) : Promise.resolve({
                type: $dae0ef9fca964cc6$var$ResultType.data,
                result: undefined
            });
        };
        return $dae0ef9fca964cc6$var$_extends({}, match, {
            shouldLoad: shouldLoad,
            resolve: resolve
        });
    });
    // Send all matches here to allow for a middleware-type implementation.
    // handler will be a no-op for unneeded routes and we filter those results
    // back out below.
    let results = await dataStrategyImpl({
        matches: dsMatches,
        request: request,
        params: matches[0].params,
        fetcherKey: fetcherKey,
        context: requestContext
    });
    // Wait for all routes to load here but 'swallow the error since we want
    // it to bubble up from the `await loadRoutePromise` in `callLoaderOrAction` -
    // called from `match.resolve()`
    try {
        await Promise.all(loadRouteDefinitionsPromises);
    } catch (e) {
    // No-op
    }
    return results;
}
// Default logic for calling a loader/action is the user has no specified a dataStrategy
async function $dae0ef9fca964cc6$var$callLoaderOrAction(type, request, match, loadRoutePromise, handlerOverride, staticContext) {
    let result;
    let onReject;
    let runHandler = (handler)=>{
        // Setup a promise we can race against so that abort signals short circuit
        let reject;
        // This will never resolve so safe to type it as Promise<DataStrategyResult> to
        // satisfy the function return value
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(new Error("You cannot call the handler for a route which defines a boolean " + ("\"" + type + "\" [routeId: " + match.route.id + "]")));
            return handler({
                request: request,
                params: match.params,
                context: staticContext
            }, ...ctx !== undefined ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                let val = await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler());
                return {
                    type: "data",
                    result: val
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = match.route[type];
        // If we have a route.lazy promise, await that first
        if (loadRoutePromise) {
            if (handler) {
                // Run statically defined handler in parallel with lazy()
                let handlerError;
                let [value] = await Promise.all([
                    // If the handler throws, don't let it immediately bubble out,
                    // since we need to let the lazy() execution finish so we know if this
                    // route has a boundary that can handle the error
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    loadRoutePromise
                ]);
                if (handlerError !== undefined) throw handlerError;
                result = value;
            } else {
                // Load lazy route module, then run any returned handler
                await loadRoutePromise;
                handler = match.route[type];
                if (handler) // Handler still runs even if we got interrupted to maintain consistency
                // with un-abortable behavior of handler execution on non-lazy or
                // previously-lazy-loaded routes
                result = await runHandler(handler);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $dae0ef9fca964cc6$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else // lazy() route has no loader to run.  Short circuit here so we don't
                // hit the invariant below that errors on returning undefined.
                return {
                    type: $dae0ef9fca964cc6$var$ResultType.data,
                    result: undefined
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            let pathname = url.pathname + url.search;
            throw $dae0ef9fca964cc6$var$getInternalRouterError(404, {
                pathname: pathname
            });
        } else result = await runHandler(handler);
        $dae0ef9fca964cc6$export$3e9cee6b33872309(result.result !== undefined, "You defined " + (type === "action" ? "an action" : "a loader") + " for route " + ("\"" + match.route.id + "\" but didn't return anything from your `" + type + "` ") + "function. Please return a value or `null`.");
    } catch (e) {
        // We should already be catching and converting normal handler executions to
        // DataStrategyResults and returning them, so anything that throws here is an
        // unexpected error we still need to wrap
        return {
            type: $dae0ef9fca964cc6$var$ResultType.error,
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $dae0ef9fca964cc6$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($dae0ef9fca964cc6$var$isResponse(result)) {
        let data;
        try {
            let contentType = result.headers.get("Content-Type");
            // Check between word boundaries instead of startsWith() due to the last
            // paragraph of https://httpwg.org/specs/rfc9110.html#field.content-type
            if (contentType && /\bapplication\/json\b/.test(contentType)) {
                if (result.body == null) data = null;
                else data = await result.json();
            } else data = await result.text();
        } catch (e) {
            return {
                type: $dae0ef9fca964cc6$var$ResultType.error,
                error: e
            };
        }
        if (type === $dae0ef9fca964cc6$var$ResultType.error) return {
            type: $dae0ef9fca964cc6$var$ResultType.error,
            error: new $dae0ef9fca964cc6$export$6c6580e81da25755(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: $dae0ef9fca964cc6$var$ResultType.data,
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === $dae0ef9fca964cc6$var$ResultType.error) {
        if ($dae0ef9fca964cc6$export$e0163cfdf7bc9cfa(result)) {
            var _result$init3, _result$init4;
            if (result.data instanceof Error) {
                var _result$init, _result$init2;
                return {
                    type: $dae0ef9fca964cc6$var$ResultType.error,
                    error: result.data,
                    statusCode: (_result$init = result.init) == null ? void 0 : _result$init.status,
                    headers: (_result$init2 = result.init) != null && _result$init2.headers ? new Headers(result.init.headers) : undefined
                };
            }
            // Convert thrown data() to ErrorResponse instances
            return {
                type: $dae0ef9fca964cc6$var$ResultType.error,
                error: new $dae0ef9fca964cc6$export$6c6580e81da25755(((_result$init3 = result.init) == null ? void 0 : _result$init3.status) || 500, undefined, result.data),
                statusCode: $dae0ef9fca964cc6$export$972111febbeef05b(result) ? result.status : undefined,
                headers: (_result$init4 = result.init) != null && _result$init4.headers ? new Headers(result.init.headers) : undefined
            };
        }
        return {
            type: $dae0ef9fca964cc6$var$ResultType.error,
            error: result,
            statusCode: $dae0ef9fca964cc6$export$972111febbeef05b(result) ? result.status : undefined
        };
    }
    if ($dae0ef9fca964cc6$export$fbcedacb60443473(result)) {
        var _result$init5, _result$init6;
        return {
            type: $dae0ef9fca964cc6$var$ResultType.deferred,
            deferredData: result,
            statusCode: (_result$init5 = result.init) == null ? void 0 : _result$init5.status,
            headers: ((_result$init6 = result.init) == null ? void 0 : _result$init6.headers) && new Headers(result.init.headers)
        };
    }
    if ($dae0ef9fca964cc6$export$e0163cfdf7bc9cfa(result)) {
        var _result$init7, _result$init8;
        return {
            type: $dae0ef9fca964cc6$var$ResultType.data,
            data: result.data,
            statusCode: (_result$init7 = result.init) == null ? void 0 : _result$init7.status,
            headers: (_result$init8 = result.init) != null && _result$init8.headers ? new Headers(result.init.headers) : undefined
        };
    }
    return {
        type: $dae0ef9fca964cc6$var$ResultType.data,
        data: result
    };
}
// Support relative routing in internal redirects
function $dae0ef9fca964cc6$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename, v7_relativeSplatPath) {
    let location = response.headers.get("Location");
    $dae0ef9fca964cc6$export$3e9cee6b33872309(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!$dae0ef9fca964cc6$var$ABSOLUTE_URL_REGEX.test(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $dae0ef9fca964cc6$var$normalizeTo(new URL(request.url), trimmedMatches, basename, true, location, v7_relativeSplatPath);
        response.headers.set("Location", location);
    }
    return response;
}
function $dae0ef9fca964cc6$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    // Match Chrome's behavior:
    // https://github.com/chromium/chromium/blob/216dbeb61db0c667e62082e5f5400a32d6983df3/content/public/common/url_utils.cc#L82
    let invalidProtocols = [
        "about:",
        "blob:",
        "chrome:",
        "chrome-untrusted:",
        "content:",
        "data:",
        "devtools:",
        "file:",
        "filesystem:",
        // eslint-disable-next-line no-script-url
        "javascript:"
    ];
    if ($dae0ef9fca964cc6$var$ABSOLUTE_URL_REGEX.test(location)) {
        // Strip off the protocol+origin for same-origin + same-basename absolute redirects
        let normalizedLocation = location;
        let url = normalizedLocation.startsWith("//") ? new URL(currentUrl.protocol + normalizedLocation) : new URL(normalizedLocation);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
        let isSameBasename = $dae0ef9fca964cc6$export$b69e3301ce081aa3(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return $dae0ef9fca964cc6$var$removeDoubleSlashes(url.pathname) + url.search + url.hash;
    }
    try {
        let url = historyInstance.createURL(location);
        if (invalidProtocols.includes(url.protocol)) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
// Utility method for creating the Request instances for loaders/actions during
// client-side navigations and fetches.  During SSR we will always have a
// Request instance from the static handler (query/queryRoute)
function $dae0ef9fca964cc6$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($dae0ef9fca964cc6$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $dae0ef9fca964cc6$var$isMutationMethod(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        // Didn't think we needed this but it turns out unlike other methods, patch
        // won't be properly normalized to uppercase and results in a 405 error.
        // See: https://fetch.spec.whatwg.org/#concept-method
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = $dae0ef9fca964cc6$var$convertFormDataToSearchParams(submission.formData);
        else // Content-Type is inferred (https://fetch.spec.whatwg.org/#dom-request)
        init.body = submission.formData;
    }
    return new Request(url, init);
}
function $dae0ef9fca964cc6$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())// https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#converting-an-entry-list-to-a-list-of-name-value-pairs
    searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $dae0ef9fca964cc6$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $dae0ef9fca964cc6$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, skipLoaderErrorBubbling) {
    // Fill in loaderData/errors from our loaders
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $dae0ef9fca964cc6$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : undefined;
    // Process loader results into state.loaderData/state.errors
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        $dae0ef9fca964cc6$export$3e9cee6b33872309(!$dae0ef9fca964cc6$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($dae0ef9fca964cc6$var$isErrorResult(result)) {
            let error = result.error;
            // If we have a pending action error, we report it at the highest-route
            // that throws a loader error, and then clear it out to indicate that
            // it was consumed
            if (pendingError !== undefined) {
                error = pendingError;
                pendingError = undefined;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                // Look upwards from the matched route for the closest ancestor error
                // boundary, defaulting to the root match.  Prefer higher error values
                // if lower errors bubble to the same boundary
                let boundaryMatch = $dae0ef9fca964cc6$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            // Clear our any prior loaderData for the throwing route
            loaderData[id] = undefined;
            // Once we find our first (highest) error, we set the status code and
            // prevent deeper status codes from overriding
            if (!foundError) {
                foundError = true;
                statusCode = $dae0ef9fca964cc6$export$972111febbeef05b(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else if ($dae0ef9fca964cc6$var$isDeferredResult(result)) {
            activeDeferreds.set(id, result.deferredData);
            loaderData[id] = result.deferredData.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode != null && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            // Error status codes always override success status codes, but if all
            // loaders are successful we take the deepest status code.
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    // If we didn't consume the pending action error (i.e., all loaders
    // resolved), then consume it here.  Also clear out any loaderData for the
    // throwing route
    if (pendingError !== undefined && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        loaderData[pendingActionResult[0]] = undefined;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $dae0ef9fca964cc6$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, activeDeferreds) {
    let { loaderData: loaderData, errors: errors } = $dae0ef9fca964cc6$var$processRouteLoaderData(matches, results, pendingActionResult, activeDeferreds, false // This method is only called client side so we always want to bubble
    );
    // Process results from our revalidating fetchers
    revalidatingFetchers.forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        let result = fetcherResults[key];
        $dae0ef9fca964cc6$export$3e9cee6b33872309(result, "Did not find corresponding fetcher result");
        // Process fetcher non-redirect errors
        if (controller && controller.signal.aborted) // Nothing to do for aborted fetchers
        return;
        else if ($dae0ef9fca964cc6$var$isErrorResult(result)) {
            let boundaryMatch = $dae0ef9fca964cc6$var$findNearestBoundary(state.matches, match == null ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = $dae0ef9fca964cc6$var$_extends({}, errors, {
                [boundaryMatch.route.id]: result.error
            });
            state.fetchers.delete(key);
        } else if ($dae0ef9fca964cc6$var$isRedirectResult(result)) // Should never get here, redirects should get processed above, but we
        // keep this to type narrow to a success result in the else
        $dae0ef9fca964cc6$export$3e9cee6b33872309(false, "Unhandled fetcher revalidation redirect");
        else if ($dae0ef9fca964cc6$var$isDeferredResult(result)) // Should never get here, deferred data should be awaited for fetchers
        // in resolveDeferredResults
        $dae0ef9fca964cc6$export$3e9cee6b33872309(false, "Unhandled fetcher deferred data");
        else {
            let doneFetcher = $dae0ef9fca964cc6$var$getDoneFetcher(result.data);
            state.fetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $dae0ef9fca964cc6$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = $dae0ef9fca964cc6$var$_extends({}, newLoaderData);
    for (let match of matches){
        let id = match.route.id;
        if (newLoaderData.hasOwnProperty(id)) {
            if (newLoaderData[id] !== undefined) mergedLoaderData[id] = newLoaderData[id];
        } else if (loaderData[id] !== undefined && match.route.loader) // Preserve existing keys not included in newLoaderData and where a loader
        // wasn't removed by HMR
        mergedLoaderData[id] = loaderData[id];
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return mergedLoaderData;
}
function $dae0ef9fca964cc6$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $dae0ef9fca964cc6$var$isErrorResult(pendingActionResult[1]) ? {
        // Clear out prior actionData on errors
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
// Find the nearest error boundary, looking upwards from the leaf route (or the
// route specified by routeId) for the closest ancestor error boundary,
// defaulting to the root match
function $dae0ef9fca964cc6$var$findNearestBoundary(matches, routeId) {
    let eligibleMatches = routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ];
    return eligibleMatches.reverse().find((m)=>m.route.hasErrorBoundary === true) || matches[0];
}
function $dae0ef9fca964cc6$var$getShortCircuitMatches(routes) {
    // Prefer a root layout route if present, otherwise shim in a route object
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $dae0ef9fca964cc6$var$getInternalRouterError(status, _temp5) {
    let { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = _temp5 === void 0 ? {} : _temp5;
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a " + method + " request to \"" + pathname + "\" but " + ("did not provide a `loader` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (type === "defer-action") errorMessage = "defer() is not supported in actions";
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = "Route \"" + routeId + "\" does not match URL \"" + pathname + "\"";
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = "No route matches URL \"" + pathname + "\"";
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a " + method.toUpperCase() + " request to \"" + pathname + "\" but " + ("did not provide an `action` for route \"" + routeId + "\", ") + "so there is no way to handle the request.";
        else if (method) errorMessage = "Invalid request method \"" + method.toUpperCase() + "\"";
    }
    return new $dae0ef9fca964cc6$export$6c6580e81da25755(status || 500, statusText, new Error(errorMessage), true);
}
// Find any returned redirect errors, starting from the lowest match
function $dae0ef9fca964cc6$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($dae0ef9fca964cc6$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $dae0ef9fca964cc6$var$stripHashFromPath(path) {
    let parsedPath = typeof path === "string" ? $dae0ef9fca964cc6$export$8ccf933b0513f8d0(path) : path;
    return $dae0ef9fca964cc6$export$fe53371bee54353d($dae0ef9fca964cc6$var$_extends({}, parsedPath, {
        hash: ""
    }));
}
function $dae0ef9fca964cc6$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") // /page -> /page#hash
    return b.hash !== "";
    else if (a.hash === b.hash) // /page#hash -> /page#hash
    return true;
    else if (b.hash !== "") // /page#hash -> /page#other
    return true;
    // If the hash is removed the browser will re-perform a request to the server
    // /page#hash -> /page
    return false;
}
function $dae0ef9fca964cc6$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === $dae0ef9fca964cc6$var$ResultType.data || result.type === $dae0ef9fca964cc6$var$ResultType.error);
}
function $dae0ef9fca964cc6$var$isRedirectDataStrategyResultResult(result) {
    return $dae0ef9fca964cc6$var$isResponse(result.result) && $dae0ef9fca964cc6$var$redirectStatusCodes.has(result.result.status);
}
function $dae0ef9fca964cc6$var$isDeferredResult(result) {
    return result.type === $dae0ef9fca964cc6$var$ResultType.deferred;
}
function $dae0ef9fca964cc6$var$isErrorResult(result) {
    return result.type === $dae0ef9fca964cc6$var$ResultType.error;
}
function $dae0ef9fca964cc6$var$isRedirectResult(result) {
    return (result && result.type) === $dae0ef9fca964cc6$var$ResultType.redirect;
}
function $dae0ef9fca964cc6$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $dae0ef9fca964cc6$export$fbcedacb60443473(value) {
    let deferred = value;
    return deferred && typeof deferred === "object" && typeof deferred.data === "object" && typeof deferred.subscribe === "function" && typeof deferred.cancel === "function" && typeof deferred.resolveData === "function";
}
function $dae0ef9fca964cc6$var$isResponse(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $dae0ef9fca964cc6$var$isRedirectResponse(result) {
    if (!$dae0ef9fca964cc6$var$isResponse(result)) return false;
    let status = result.status;
    let location = result.headers.get("Location");
    return status >= 300 && status <= 399 && location != null;
}
function $dae0ef9fca964cc6$var$isValidMethod(method) {
    return $dae0ef9fca964cc6$var$validRequestMethods.has(method.toLowerCase());
}
function $dae0ef9fca964cc6$var$isMutationMethod(method) {
    return $dae0ef9fca964cc6$var$validMutationMethods.has(method.toLowerCase());
}
async function $dae0ef9fca964cc6$var$resolveNavigationDeferredResults(matches, results, signal, currentMatches, currentLoaderData) {
    let entries = Object.entries(results);
    for(let index = 0; index < entries.length; index++){
        let [routeId, result] = entries[index];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        let currentMatch = currentMatches.find((m)=>m.route.id === match.route.id);
        let isRevalidatingLoader = currentMatch != null && !$dae0ef9fca964cc6$var$isNewRouteInstance(currentMatch, match) && (currentLoaderData && currentLoaderData[match.route.id]) !== undefined;
        if ($dae0ef9fca964cc6$var$isDeferredResult(result) && isRevalidatingLoader) // Note: we do not have to touch activeDeferreds here since we race them
        // against the signal in resolveDeferredData and they'll get aborted
        // there if needed
        await $dae0ef9fca964cc6$var$resolveDeferredData(result, signal, false).then((result)=>{
            if (result) results[routeId] = result;
        });
    }
}
async function $dae0ef9fca964cc6$var$resolveFetcherDeferredResults(matches, results, revalidatingFetchers) {
    for(let index = 0; index < revalidatingFetchers.length; index++){
        let { key: key, routeId: routeId, controller: controller } = revalidatingFetchers[index];
        let result = results[key];
        let match = matches.find((m)=>(m == null ? void 0 : m.route.id) === routeId);
        // If we don't have a match, then we can have a deferred result to do
        // anything with.  This is for revalidating fetchers where the route was
        // removed during HMR
        if (!match) continue;
        if ($dae0ef9fca964cc6$var$isDeferredResult(result)) {
            // Note: we do not have to touch activeDeferreds here since we race them
            // against the signal in resolveDeferredData and they'll get aborted
            // there if needed
            $dae0ef9fca964cc6$export$3e9cee6b33872309(controller, "Expected an AbortController for revalidating fetcher deferred result");
            await $dae0ef9fca964cc6$var$resolveDeferredData(result, controller.signal, true).then((result)=>{
                if (result) results[key] = result;
            });
        }
    }
}
async function $dae0ef9fca964cc6$var$resolveDeferredData(result, signal, unwrap) {
    if (unwrap === void 0) unwrap = false;
    let aborted = await result.deferredData.resolveData(signal);
    if (aborted) return;
    if (unwrap) try {
        return {
            type: $dae0ef9fca964cc6$var$ResultType.data,
            data: result.deferredData.unwrappedData
        };
    } catch (e) {
        // Handle any TrackedPromise._error values encountered while unwrapping
        return {
            type: $dae0ef9fca964cc6$var$ResultType.error,
            error: e
        };
    }
    return {
        type: $dae0ef9fca964cc6$var$ResultType.data,
        data: result.deferredData.data
    };
}
function $dae0ef9fca964cc6$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $dae0ef9fca964cc6$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? $dae0ef9fca964cc6$export$8ccf933b0513f8d0(location).search : location.search;
    if (matches[matches.length - 1].route.index && $dae0ef9fca964cc6$var$hasNakedIndexQuery(search || "")) // Return the leaf index route when index is present
    return matches[matches.length - 1];
    // Otherwise grab the deepest "path contributing" match (ignoring index and
    // pathless layout routes)
    let pathMatches = $dae0ef9fca964cc6$var$getPathContributingMatches(matches);
    return pathMatches[pathMatches.length - 1];
}
function $dae0ef9fca964cc6$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: undefined,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: undefined,
        text: undefined
    };
    else if (json !== undefined) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: undefined,
        json: json,
        text: undefined
    };
}
function $dae0ef9fca964cc6$var$getLoadingNavigation(location, submission) {
    if (submission) {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text
        };
        return navigation;
    } else {
        let navigation = {
            state: "loading",
            location: location,
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined
        };
        return navigation;
    }
}
function $dae0ef9fca964cc6$var$getSubmittingNavigation(location, submission) {
    let navigation = {
        state: "submitting",
        location: location,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    return navigation;
}
function $dae0ef9fca964cc6$var$getLoadingFetcher(submission, data) {
    if (submission) {
        let fetcher = {
            state: "loading",
            formMethod: submission.formMethod,
            formAction: submission.formAction,
            formEncType: submission.formEncType,
            formData: submission.formData,
            json: submission.json,
            text: submission.text,
            data: data
        };
        return fetcher;
    } else {
        let fetcher = {
            state: "loading",
            formMethod: undefined,
            formAction: undefined,
            formEncType: undefined,
            formData: undefined,
            json: undefined,
            text: undefined,
            data: data
        };
        return fetcher;
    }
}
function $dae0ef9fca964cc6$var$getSubmittingFetcher(submission, existingFetcher) {
    let fetcher = {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : undefined
    };
    return fetcher;
}
function $dae0ef9fca964cc6$var$getDoneFetcher(data) {
    let fetcher = {
        state: "idle",
        formMethod: undefined,
        formAction: undefined,
        formEncType: undefined,
        formData: undefined,
        json: undefined,
        text: undefined,
        data: data
    };
    return fetcher;
}
function $dae0ef9fca964cc6$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($dae0ef9fca964cc6$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch (e) {
    // no-op, use default empty object
    }
}
function $dae0ef9fca964cc6$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($dae0ef9fca964cc6$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            $dae0ef9fca964cc6$export$c0e02632e14916fd(false, "Failed to save applied view transitions in sessionStorage (" + error + ").");
        }
    }
}

/**
 * React Router v6.30.4
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $6SWiB = parcelRequire("6SWiB");

function $576e41193d1785e0$var$_extends() {
    return $576e41193d1785e0$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $576e41193d1785e0$var$_extends.apply(null, arguments);
}
// Create react-specific types from the agnostic types in @remix-run/router to
// export from react-router
const $576e41193d1785e0$export$3add0d5dce533e2e = /*#__PURE__*/ $6SWiB.createContext(null);
const $576e41193d1785e0$export$145dfa71566a64dc = /*#__PURE__*/ $6SWiB.createContext(null);
const $576e41193d1785e0$var$AwaitContext = /*#__PURE__*/ $6SWiB.createContext(null);
/**
 * A Navigator is a "location changer"; it's how you get to different locations.
 *
 * Every history instance conforms to the Navigator interface, but the
 * distinction is useful primarily when it comes to the low-level `<Router>` API
 * where both the location and a navigator must be provided separately in order
 * to avoid "tearing" that may occur in a suspense-enabled app if the action
 * and/or location were to be read directly from the history instance.
 */ const $576e41193d1785e0$export$26749e8557646306 = /*#__PURE__*/ $6SWiB.createContext(null);
const $576e41193d1785e0$export$c7914228fb69b0f5 = /*#__PURE__*/ $6SWiB.createContext(null);
const $576e41193d1785e0$export$9072aa6dd1f93057 = /*#__PURE__*/ $6SWiB.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
const $576e41193d1785e0$var$RouteErrorContext = /*#__PURE__*/ $6SWiB.createContext(null);
/**
 * Returns the full href for the given "to" value. This is useful for building
 * custom links that are also accessible and preserve right-click behavior.
 *
 * @see https://reactrouter.com/v6/hooks/use-href
 */ function $576e41193d1785e0$export$b66bb29c5006f12f(to, _temp) {
    let { relative: relative } = _temp === void 0 ? {} : _temp;
    !$576e41193d1785e0$export$9c954a9d03d32f4a() && (0, $dae0ef9fca964cc6$export$3e9cee6b33872309)(false);
    let { basename: basename, navigator: navigator } = $6SWiB.useContext($576e41193d1785e0$export$26749e8557646306);
    let { hash: hash, pathname: pathname, search: search } = $576e41193d1785e0$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the href.  If this is a root navigation, then just use the raw
    // basename which allows the basename to have full control over the presence
    // of a trailing slash on root links
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $dae0ef9fca964cc6$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
 * Returns true if this component is a descendant of a `<Router>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-in-router-context
 */ function $576e41193d1785e0$export$9c954a9d03d32f4a() {
    return $6SWiB.useContext($576e41193d1785e0$export$c7914228fb69b0f5) != null;
}
/**
 * Returns the current location object, which represents the current URL in web
 * browsers.
 *
 * Note: If you're using this it may mean you're doing some of your own
 * "routing" in your app, and we'd like to know what your use case is. We may
 * be able to provide something higher-level to better suit your needs.
 *
 * @see https://reactrouter.com/v6/hooks/use-location
 */ function $576e41193d1785e0$export$45d76561a5302f2b() {
    !$576e41193d1785e0$export$9c954a9d03d32f4a() && (0, $dae0ef9fca964cc6$export$3e9cee6b33872309)(false);
    return $6SWiB.useContext($576e41193d1785e0$export$c7914228fb69b0f5).location;
}
/**
 * Returns the current navigation action which describes how the router came to
 * the current location, either by a pop, push, or replace on the history stack.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigation-type
 */ function $576e41193d1785e0$export$1b3f31771c5d07c() {
    return $6SWiB.useContext($576e41193d1785e0$export$c7914228fb69b0f5).navigationType;
}
/**
 * Returns a PathMatch object if the given pattern matches the current URL.
 * This is useful for components that need to know "active" state, e.g.
 * `<NavLink>`.
 *
 * @see https://reactrouter.com/v6/hooks/use-match
 */ function $576e41193d1785e0$export$6c330e8992e8a295(pattern) {
    !$576e41193d1785e0$export$9c954a9d03d32f4a() && (0, $dae0ef9fca964cc6$export$3e9cee6b33872309)(false);
    let { pathname: pathname } = $576e41193d1785e0$export$45d76561a5302f2b();
    return $6SWiB.useMemo(()=>(0, $dae0ef9fca964cc6$export$81336c211d5ff295)(pattern, (0, $dae0ef9fca964cc6$export$30d21fd6d7295f52)(pathname)), [
        pathname,
        pattern
    ]);
}
/**
 * The interface for the navigate() function returned from useNavigate().
 */ const $576e41193d1785e0$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
// Mute warnings for calls to useNavigate in SSR environments
function $576e41193d1785e0$var$useIsomorphicLayoutEffect(cb) {
    let isStatic = $6SWiB.useContext($576e41193d1785e0$export$26749e8557646306).static;
    if (!isStatic) // We should be able to get rid of this once react 18.3 is released
    // See: https://github.com/facebook/react/pull/26395
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $6SWiB.useLayoutEffect(cb);
}
/**
 * Returns an imperative method for changing the location. Used by `<Link>`s, but
 * may also be used by other elements to change the location.
 *
 * @see https://reactrouter.com/v6/hooks/use-navigate
 */ function $576e41193d1785e0$export$9770f232ac06a008() {
    let { isDataRoute: isDataRoute } = $6SWiB.useContext($576e41193d1785e0$export$9072aa6dd1f93057);
    // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    return isDataRoute ? $576e41193d1785e0$var$useNavigateStable() : $576e41193d1785e0$var$useNavigateUnstable();
}
function $576e41193d1785e0$var$useNavigateUnstable() {
    !$576e41193d1785e0$export$9c954a9d03d32f4a() && (0, $dae0ef9fca964cc6$export$3e9cee6b33872309)(false);
    let dataRouterContext = $6SWiB.useContext($576e41193d1785e0$export$3add0d5dce533e2e);
    let { basename: basename, future: future, navigator: navigator } = $6SWiB.useContext($576e41193d1785e0$export$26749e8557646306);
    let { matches: matches } = $6SWiB.useContext($576e41193d1785e0$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $576e41193d1785e0$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $dae0ef9fca964cc6$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    let activeRef = $6SWiB.useRef(false);
    $576e41193d1785e0$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $6SWiB.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our history listener yet
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $dae0ef9fca964cc6$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        // If we're operating within a basename, prepend it to the pathname prior
        // to handing off to history (but only if we're not in a data router,
        // otherwise it'll prepend the basename inside of the router).
        // If this is a root navigation, then we navigate to the raw basename
        // which allows the basename to have full control over the presence of a
        // trailing slash on root links
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $dae0ef9fca964cc6$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
    return navigate;
}
const $576e41193d1785e0$var$OutletContext = /*#__PURE__*/ $6SWiB.createContext(null);
/**
 * Returns the context (if provided) for the child route at this level of the route
 * hierarchy.
 * @see https://reactrouter.com/v6/hooks/use-outlet-context
 */ function $576e41193d1785e0$export$4138103a3ae699cc() {
    return $6SWiB.useContext($576e41193d1785e0$var$OutletContext);
}
/**
 * Returns the element for the child route at this level of the route
 * hierarchy. Used internally by `<Outlet>` to render child routes.
 *
 * @see https://reactrouter.com/v6/hooks/use-outlet
 */ function $576e41193d1785e0$export$a3be3530d8e40d0b(context) {
    let outlet = $6SWiB.useContext($576e41193d1785e0$export$9072aa6dd1f93057).outlet;
    if (outlet) return /*#__PURE__*/ $6SWiB.createElement($576e41193d1785e0$var$OutletContext.Provider, {
        value: context
    }, outlet);
    return outlet;
}
/**
 * Returns an object of key/value pairs of the dynamic params from the current
 * URL that were matched by the route path.
 *
 * @see https://reactrouter.com/v6/hooks/use-params
 */ function $576e41193d1785e0$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $6SWiB.useContext($576e41193d1785e0$export$9072aa6dd1f93057);
    let routeMatch = matches[matches.length - 1];
    return routeMatch ? routeMatch.params : {};
}
/**
 * Resolves the pathname of the given `to` value against the current location.
 *
 * @see https://reactrouter.com/v6/hooks/use-resolved-path
 */ function $576e41193d1785e0$export$e75d2a2d1b3c245b(to, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { future: future } = $6SWiB.useContext($576e41193d1785e0$export$26749e8557646306);
    let { matches: matches } = $6SWiB.useContext($576e41193d1785e0$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $576e41193d1785e0$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $dae0ef9fca964cc6$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath));
    return $6SWiB.useMemo(()=>(0, $dae0ef9fca964cc6$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
 * Returns the element of the route that matched the current location, prepared
 * with the correct context to render the remainder of the route tree. Route
 * elements in the tree must render an `<Outlet>` to render their child route's
 * element.
 *
 * @see https://reactrouter.com/v6/hooks/use-routes
 */ function $576e41193d1785e0$export$5d3fca4a98652595(routes, locationArg) {
    return $576e41193d1785e0$export$5fcee62552a12fbf(routes, locationArg);
}
// Internal implementation with accept optional param for RouterProvider usage
function $576e41193d1785e0$export$5fcee62552a12fbf(routes, locationArg, dataRouterState, future) {
    !$576e41193d1785e0$export$9c954a9d03d32f4a() && (0, $dae0ef9fca964cc6$export$3e9cee6b33872309)(false);
    let { navigator: navigator } = $6SWiB.useContext($576e41193d1785e0$export$26749e8557646306);
    let { matches: parentMatches } = $6SWiB.useContext($576e41193d1785e0$export$9072aa6dd1f93057);
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    let parentPathname = routeMatch ? routeMatch.pathname : "/";
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    let parentRoute = routeMatch && routeMatch.route;
    let locationFromContext = $576e41193d1785e0$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        var _parsedLocationArg$pa;
        let parsedLocationArg = typeof locationArg === "string" ? (0, $dae0ef9fca964cc6$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        !(parentPathnameBase === "/" || ((_parsedLocationArg$pa = parsedLocationArg.pathname) == null ? void 0 : _parsedLocationArg$pa.startsWith(parentPathnameBase))) && (0, $dae0ef9fca964cc6$export$3e9cee6b33872309)(false);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        // Determine the remaining pathname by removing the # of URL segments the
        // parentPathnameBase has, instead of removing based on character count.
        // This is because we can't guarantee that incoming/outgoing encodings/
        // decodings will match exactly.
        // We decode paths before matching on a per-segment basis with
        // decodeURIComponent(), but we re-encode pathnames via `new URL()` so they
        // match what `window.location.pathname` would reflect.  Those don't 100%
        // align when it comes to encoded URI characters such as % and &.
        //
        // So we may end up with:
        //   pathname:           "/descendant/a%25b/match"
        //   parentPathnameBase: "/descendant/a%b"
        //
        // And the direct substring removal approach won't work :/
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        let segments = pathname.replace(/^\//, "").split("/");
        remainingPathname = "/" + segments.slice(parentSegments.length).join("/");
    }
    let matches = (0, $dae0ef9fca964cc6$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $576e41193d1785e0$var$_renderMatches(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $dae0ef9fca964cc6$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $dae0ef9fca964cc6$export$86d9a7913e44197e)([
                parentPathnameBase,
                // Re-encode pathnames that were decoded inside matchRoutes
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterState, future);
    // When a user passes in a `locationArg`, the associated routes need to
    // be wrapped in a new `LocationContext.Provider` in order for `useLocation`
    // to use the scoped location instead of the global location.
    if (locationArg && renderedMatches) return /*#__PURE__*/ $6SWiB.createElement($576e41193d1785e0$export$c7914228fb69b0f5.Provider, {
        value: {
            location: $576e41193d1785e0$var$_extends({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default"
            }, location),
            navigationType: (0, $dae0ef9fca964cc6$export$e19cd5f9376f8cee).Pop
        }
    }, renderedMatches);
    return renderedMatches;
}
function $576e41193d1785e0$var$DefaultErrorComponent() {
    let error = $576e41193d1785e0$export$ed527bf60f6e05f2();
    let message = (0, $dae0ef9fca964cc6$export$972111febbeef05b)(error) ? error.status + " " + error.statusText : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    let lightgrey = "rgba(200,200,200, 0.5)";
    let preStyles = {
        padding: "0.5rem",
        backgroundColor: lightgrey
    };
    let codeStyles = {
        padding: "2px 4px",
        backgroundColor: lightgrey
    };
    let devInfo = null;
    return /*#__PURE__*/ $6SWiB.createElement($6SWiB.Fragment, null, /*#__PURE__*/ $6SWiB.createElement("h2", null, "Unexpected Application Error!"), /*#__PURE__*/ $6SWiB.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /*#__PURE__*/ $6SWiB.createElement("pre", {
        style: preStyles
    }, stack) : null, devInfo);
}
const $576e41193d1785e0$var$defaultErrorElement = /*#__PURE__*/ $6SWiB.createElement($576e41193d1785e0$var$DefaultErrorComponent, null);
class $576e41193d1785e0$var$RenderErrorBoundary extends $6SWiB.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        // When we get into an error state, the user will likely click "back" to the
        // previous page that didn't have an error. Because this wraps the entire
        // application, that will have no effect--the error page continues to display.
        // This gives us a mechanism to recover from the error when the location changes.
        //
        // Whether we're in an error state or not, we update the location in state
        // so that when we are in an error state, it gets reset when a new location
        // comes in and the user recovers from the error.
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        // If we're not changing locations, preserve the location but still surface
        // any new errors that may come through. We retain the existing error, we do
        // this because the error provided from the app state may be cleared without
        // the location changing.
        return {
            error: props.error !== undefined ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("React Router caught the following error during render", error, errorInfo);
    }
    render() {
        return this.state.error !== undefined ? /*#__PURE__*/ $6SWiB.createElement($576e41193d1785e0$export$9072aa6dd1f93057.Provider, {
            value: this.props.routeContext
        }, /*#__PURE__*/ $6SWiB.createElement($576e41193d1785e0$var$RouteErrorContext.Provider, {
            value: this.state.error,
            children: this.props.component
        })) : this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
}
function $576e41193d1785e0$var$RenderedRoute(_ref) {
    let { routeContext: routeContext, match: match, children: children } = _ref;
    let dataRouterContext = $6SWiB.useContext($576e41193d1785e0$export$3add0d5dce533e2e);
    // Track how deep we got in our render pass to emulate SSR componentDidCatch
    // in a DataStaticRouter
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /*#__PURE__*/ $6SWiB.createElement($576e41193d1785e0$export$9072aa6dd1f93057.Provider, {
        value: routeContext
    }, children);
}
function $576e41193d1785e0$var$_renderMatches(matches, parentMatches, dataRouterState, future) {
    var _dataRouterState;
    if (parentMatches === void 0) parentMatches = [];
    if (dataRouterState === void 0) dataRouterState = null;
    if (future === void 0) future = null;
    if (matches == null) {
        var _future;
        if (!dataRouterState) return null;
        if (dataRouterState.errors) // Don't bail if we have data router errors so we can render them in the
        // boundary.  Use the pre-matched (or shimmed) matches
        matches = dataRouterState.matches;
        else if ((_future = future) != null && _future.v7_partialHydration && parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) // Don't bail if we're initializing with partial hydration and we have
        // router matches.  That means we're actively running `patchRoutesOnNavigation`
        // so we should render down the partial matches to the appropriate
        // `HydrateFallback`.  We only do this if `parentMatches` is empty so it
        // only impacts the root matches for `RouterProvider` and no descendant
        // `<Routes>`
        matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    // If we have data errors, trim matches to the highest error boundary
    let errors = (_dataRouterState = dataRouterState) == null ? void 0 : _dataRouterState.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && (errors == null ? void 0 : errors[m.route.id]) !== undefined);
        !(errorIndex >= 0) && (0, $dae0ef9fca964cc6$export$3e9cee6b33872309)(false);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    // If we're in a partial hydration mode, detect if we need to render down to
    // a given HydrateFallback while we load the rest of the hydration data
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterState && future && future.v7_partialHydration) for(let i = 0; i < renderedMatches.length; i++){
        let match = renderedMatches[i];
        // Track the deepest fallback up until the first route without data
        if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
        if (match.route.id) {
            let { loaderData: loaderData, errors: errors } = dataRouterState;
            let needsToRunLoader = match.route.loader && loaderData[match.route.id] === undefined && (!errors || errors[match.route.id] === undefined);
            if (match.route.lazy || needsToRunLoader) {
                // We found the first route that's not ready to render (waiting on
                // lazy, or has a loader that hasn't run yet).  Flag that we need to
                // render a fallback and render up until the appropriate fallback
                renderFallback = true;
                if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                else renderedMatches = [
                    renderedMatches[0]
                ];
                break;
            }
        }
    }
    return renderedMatches.reduceRight((outlet, match, index)=>{
        // Only data routers handle errors/fallbacks
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : undefined;
            errorElement = match.route.errorElement || $576e41193d1785e0$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $576e41193d1785e0$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) // Note: This is a de-optimized path since React won't re-use the
            // ReactElement since it's identity changes with each new
            // React.createElement call.  We keep this so folks can use
            // `<Route Component={...}>` in `<Routes>` but generally `Component`
            // usage is only advised in `RouterProvider` when we can convert it to
            // `element` ahead of time.
            children = /*#__PURE__*/ $6SWiB.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /*#__PURE__*/ $6SWiB.createElement($576e41193d1785e0$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        // Only wrap in an error boundary within data router usages when we have an
        // ErrorBoundary/errorElement on this route.  Otherwise let it bubble up to
        // an ancestor ErrorBoundary/errorElement
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /*#__PURE__*/ $6SWiB.createElement($576e41193d1785e0$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            }
        }) : getChildren();
    }, null);
}
var $576e41193d1785e0$var$DataRouterHook = /*#__PURE__*/ function(DataRouterHook) {
    DataRouterHook["UseBlocker"] = "useBlocker";
    DataRouterHook["UseRevalidator"] = "useRevalidator";
    DataRouterHook["UseNavigateStable"] = "useNavigate";
    return DataRouterHook;
}($576e41193d1785e0$var$DataRouterHook || {});
var $576e41193d1785e0$var$DataRouterStateHook = /*#__PURE__*/ function(DataRouterStateHook) {
    DataRouterStateHook["UseBlocker"] = "useBlocker";
    DataRouterStateHook["UseLoaderData"] = "useLoaderData";
    DataRouterStateHook["UseActionData"] = "useActionData";
    DataRouterStateHook["UseRouteError"] = "useRouteError";
    DataRouterStateHook["UseNavigation"] = "useNavigation";
    DataRouterStateHook["UseRouteLoaderData"] = "useRouteLoaderData";
    DataRouterStateHook["UseMatches"] = "useMatches";
    DataRouterStateHook["UseRevalidator"] = "useRevalidator";
    DataRouterStateHook["UseNavigateStable"] = "useNavigate";
    DataRouterStateHook["UseRouteId"] = "useRouteId";
    return DataRouterStateHook;
}($576e41193d1785e0$var$DataRouterStateHook || {});
function $576e41193d1785e0$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $576e41193d1785e0$var$useDataRouterContext(hookName) {
    let ctx = $6SWiB.useContext($576e41193d1785e0$export$3add0d5dce533e2e);
    !ctx && (0, $dae0ef9fca964cc6$export$3e9cee6b33872309)(false);
    return ctx;
}
function $576e41193d1785e0$var$useDataRouterState(hookName) {
    let state = $6SWiB.useContext($576e41193d1785e0$export$145dfa71566a64dc);
    !state && (0, $dae0ef9fca964cc6$export$3e9cee6b33872309)(false);
    return state;
}
function $576e41193d1785e0$var$useRouteContext(hookName) {
    let route = $6SWiB.useContext($576e41193d1785e0$export$9072aa6dd1f93057);
    !route && (0, $dae0ef9fca964cc6$export$3e9cee6b33872309)(false);
    return route;
}
// Internal version with hookName-aware debugging
function $576e41193d1785e0$var$useCurrentRouteId(hookName) {
    let route = $576e41193d1785e0$var$useRouteContext(hookName);
    let thisRoute = route.matches[route.matches.length - 1];
    !thisRoute.route.id && (0, $dae0ef9fca964cc6$export$3e9cee6b33872309)(false);
    return thisRoute.route.id;
}
/**
 * Returns the ID for the nearest contextual route
 */ function $576e41193d1785e0$export$5fc8298006ad9e58() {
    return $576e41193d1785e0$var$useCurrentRouteId($576e41193d1785e0$var$DataRouterStateHook.UseRouteId);
}
/**
 * Returns the current navigation, defaulting to an "idle" navigation when
 * no navigation is in progress
 */ function $576e41193d1785e0$export$d0fd4b7106de2769() {
    let state = $576e41193d1785e0$var$useDataRouterState($576e41193d1785e0$var$DataRouterStateHook.UseNavigation);
    return state.navigation;
}
/**
 * Returns a revalidate function for manually triggering revalidation, as well
 * as the current state of any manual revalidations
 */ function $576e41193d1785e0$export$600dc272ed516c15() {
    let dataRouterContext = $576e41193d1785e0$var$useDataRouterContext($576e41193d1785e0$var$DataRouterHook.UseRevalidator);
    let state = $576e41193d1785e0$var$useDataRouterState($576e41193d1785e0$var$DataRouterStateHook.UseRevalidator);
    return $6SWiB.useMemo(()=>({
            revalidate: dataRouterContext.router.revalidate,
            state: state.revalidation
        }), [
        dataRouterContext.router.revalidate,
        state.revalidation
    ]);
}
/**
 * Returns the active route matches, useful for accessing loaderData for
 * parent/child routes or the route "handle" property
 */ function $576e41193d1785e0$export$2378eb7f5ff86053() {
    let { matches: matches, loaderData: loaderData } = $576e41193d1785e0$var$useDataRouterState($576e41193d1785e0$var$DataRouterStateHook.UseMatches);
    return $6SWiB.useMemo(()=>matches.map((m)=>(0, $dae0ef9fca964cc6$export$b3fac024fad9e8ff)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
 * Returns the loader data for the nearest ancestor Route loader
 */ function $576e41193d1785e0$export$1448a5050d252c4d() {
    let state = $576e41193d1785e0$var$useDataRouterState($576e41193d1785e0$var$DataRouterStateHook.UseLoaderData);
    let routeId = $576e41193d1785e0$var$useCurrentRouteId($576e41193d1785e0$var$DataRouterStateHook.UseLoaderData);
    if (state.errors && state.errors[routeId] != null) {
        console.error("You cannot `useLoaderData` in an errorElement (routeId: " + routeId + ")");
        return undefined;
    }
    return state.loaderData[routeId];
}
/**
 * Returns the loaderData for the given routeId
 */ function $576e41193d1785e0$export$fd5d37484eab868d(routeId) {
    let state = $576e41193d1785e0$var$useDataRouterState($576e41193d1785e0$var$DataRouterStateHook.UseRouteLoaderData);
    return state.loaderData[routeId];
}
/**
 * Returns the action data for the nearest ancestor Route action
 */ function $576e41193d1785e0$export$fdc00f3f26066d5e() {
    let state = $576e41193d1785e0$var$useDataRouterState($576e41193d1785e0$var$DataRouterStateHook.UseActionData);
    let routeId = $576e41193d1785e0$var$useCurrentRouteId($576e41193d1785e0$var$DataRouterStateHook.UseLoaderData);
    return state.actionData ? state.actionData[routeId] : undefined;
}
/**
 * Returns the nearest ancestor Route error, which could be a loader/action
 * error or a render error.  This is intended to be called from your
 * ErrorBoundary/errorElement to display a proper error message.
 */ function $576e41193d1785e0$export$ed527bf60f6e05f2() {
    var _state$errors;
    let error = $6SWiB.useContext($576e41193d1785e0$var$RouteErrorContext);
    let state = $576e41193d1785e0$var$useDataRouterState($576e41193d1785e0$var$DataRouterStateHook.UseRouteError);
    let routeId = $576e41193d1785e0$var$useCurrentRouteId($576e41193d1785e0$var$DataRouterStateHook.UseRouteError);
    // If this was a render error, we put it in a RouteError context inside
    // of RenderErrorBoundary
    if (error !== undefined) return error;
    // Otherwise look for errors from our data router state
    return (_state$errors = state.errors) == null ? void 0 : _state$errors[routeId];
}
/**
 * Returns the happy-path data from the nearest ancestor `<Await />` value
 */ function $576e41193d1785e0$export$78a72ddb39bdd145() {
    let value = $6SWiB.useContext($576e41193d1785e0$var$AwaitContext);
    return value == null ? void 0 : value._data;
}
/**
 * Returns the error from the nearest ancestor `<Await />` value
 */ function $576e41193d1785e0$export$17f53340677d5831() {
    let value = $6SWiB.useContext($576e41193d1785e0$var$AwaitContext);
    return value == null ? void 0 : value._error;
}
let $576e41193d1785e0$var$blockerId = 0;
/**
 * Allow the application to block navigations within the SPA and present the
 * user a confirmation dialog to confirm the navigation.  Mostly used to avoid
 * using half-filled form data.  This does not handle hard-reloads or
 * cross-origin navigations.
 */ function $576e41193d1785e0$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $576e41193d1785e0$var$useDataRouterContext($576e41193d1785e0$var$DataRouterHook.UseBlocker);
    let state = $576e41193d1785e0$var$useDataRouterState($576e41193d1785e0$var$DataRouterStateHook.UseBlocker);
    let [blockerKey, setBlockerKey] = $6SWiB.useState("");
    let blockerFunction = $6SWiB.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        // If they provided us a function and we've got an active basename, strip
        // it from the locations we expose to the user to match the behavior of
        // useLocation
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: $576e41193d1785e0$var$_extends({}, currentLocation, {
                pathname: (0, $dae0ef9fca964cc6$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: $576e41193d1785e0$var$_extends({}, nextLocation, {
                pathname: (0, $dae0ef9fca964cc6$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    // This effect is in charge of blocker key assignment and deletion (which is
    // tightly coupled to the key)
    $6SWiB.useEffect(()=>{
        let key = String(++$576e41193d1785e0$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    // This effect handles assigning the blockerFunction.  This is to handle
    // unstable blocker function identities, and happens only after the prior
    // effect so we don't get an orphaned blockerFunction in the router with a
    // key of "".  Until then we just have the IDLE_BLOCKER.
    $6SWiB.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    // Prefer the blocker from `state` not `router.state` since DataRouterContext
    // is memoized so this ensures we update on blocker state updates
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $dae0ef9fca964cc6$export$386d57f03f0b2883);
}
/**
 * Stable version of useNavigate that is used when we are in the context of
 * a RouterProvider.
 */ function $576e41193d1785e0$var$useNavigateStable() {
    let { router: router } = $576e41193d1785e0$var$useDataRouterContext($576e41193d1785e0$var$DataRouterHook.UseNavigateStable);
    let id = $576e41193d1785e0$var$useCurrentRouteId($576e41193d1785e0$var$DataRouterStateHook.UseNavigateStable);
    let activeRef = $6SWiB.useRef(false);
    $576e41193d1785e0$var$useIsomorphicLayoutEffect(()=>{
        activeRef.current = true;
    });
    let navigate = $6SWiB.useCallback(function(to, options) {
        if (options === void 0) options = {};
        // Short circuit here since if this happens on first render the navigate
        // is useless because we haven't wired up our router subscriber yet
        if (!activeRef.current) return;
        if (typeof to === "number") router.navigate(to);
        else router.navigate(to, $576e41193d1785e0$var$_extends({
            fromRouteId: id
        }, options));
    }, [
        router,
        id
    ]);
    return navigate;
}
const $576e41193d1785e0$var$alreadyWarned$1 = {};
function $576e41193d1785e0$var$warningOnce(key, cond, message) {
    if (!cond && !$576e41193d1785e0$var$alreadyWarned$1[key]) $576e41193d1785e0$var$alreadyWarned$1[key] = true;
}
const $576e41193d1785e0$var$alreadyWarned = {};
function $576e41193d1785e0$var$warnOnce(key, message) {}
const $576e41193d1785e0$var$logDeprecation = (flag, msg, link)=>$576e41193d1785e0$var$warnOnce(flag, "\u26A0\uFE0F React Router Future Flag Warning: " + msg + ". " + ("You can use the `" + flag + "` future flag to opt-in early. ") + ("For more information, see " + link + "."));
function $576e41193d1785e0$export$db5148ec97d6af7a(renderFuture, routerFuture) {
    if ((renderFuture == null ? void 0 : renderFuture.v7_startTransition) === undefined) $576e41193d1785e0$var$logDeprecation("v7_startTransition", "React Router will begin wrapping state updates in `React.startTransition` in v7", "https://reactrouter.com/v6/upgrading/future#v7_starttransition");
    if ((renderFuture == null ? void 0 : renderFuture.v7_relativeSplatPath) === undefined && (!routerFuture || routerFuture.v7_relativeSplatPath === undefined)) $576e41193d1785e0$var$logDeprecation("v7_relativeSplatPath", "Relative route resolution within Splat routes is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_relativesplatpath");
    if (routerFuture) {
        if (routerFuture.v7_fetcherPersist === undefined) $576e41193d1785e0$var$logDeprecation("v7_fetcherPersist", "The persistence behavior of fetchers is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_fetcherpersist");
        if (routerFuture.v7_normalizeFormMethod === undefined) $576e41193d1785e0$var$logDeprecation("v7_normalizeFormMethod", "Casing of `formMethod` fields is being normalized to uppercase in v7", "https://reactrouter.com/v6/upgrading/future#v7_normalizeformmethod");
        if (routerFuture.v7_partialHydration === undefined) $576e41193d1785e0$var$logDeprecation("v7_partialHydration", "`RouterProvider` hydration behavior is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_partialhydration");
        if (routerFuture.v7_skipActionErrorRevalidation === undefined) $576e41193d1785e0$var$logDeprecation("v7_skipActionErrorRevalidation", "The revalidation behavior after 4xx/5xx `action` responses is changing in v7", "https://reactrouter.com/v6/upgrading/future#v7_skipactionerrorrevalidation");
    }
}
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $576e41193d1785e0$var$START_TRANSITION = "startTransition";
const $576e41193d1785e0$var$startTransitionImpl = $6SWiB[$576e41193d1785e0$var$START_TRANSITION];
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $576e41193d1785e0$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $6SWiB.useState(router.state);
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $6SWiB.useCallback((newState)=>{
        if (v7_startTransition && $576e41193d1785e0$var$startTransitionImpl) $576e41193d1785e0$var$startTransitionImpl(()=>setStateImpl(newState));
        else setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $6SWiB.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $6SWiB.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $6SWiB.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $6SWiB.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    $6SWiB.useEffect(()=>$576e41193d1785e0$export$db5148ec97d6af7a(future, router.future), [
        router,
        future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $6SWiB.createElement($6SWiB.Fragment, null, /*#__PURE__*/ $6SWiB.createElement($576e41193d1785e0$export$3add0d5dce533e2e.Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $6SWiB.createElement($576e41193d1785e0$export$145dfa71566a64dc.Provider, {
        value: state
    }, /*#__PURE__*/ $6SWiB.createElement($576e41193d1785e0$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: {
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $6SWiB.createElement($576e41193d1785e0$var$DataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))), null);
}
function $576e41193d1785e0$var$DataRoutes(_ref2) {
    let { routes: routes, future: future, state: state } = _ref2;
    return $576e41193d1785e0$export$5fcee62552a12fbf(routes, undefined, state, future);
}
/**
 * A `<Router>` that stores all entries in memory.
 *
 * @see https://reactrouter.com/v6/router-components/memory-router
 */ function $576e41193d1785e0$export$ae46f04cfaffe093(_ref3) {
    let { basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, future: future } = _ref3;
    let historyRef = $6SWiB.useRef();
    if (historyRef.current == null) historyRef.current = (0, $dae0ef9fca964cc6$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $6SWiB.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $6SWiB.useCallback((newState)=>{
        v7_startTransition && $576e41193d1785e0$var$startTransitionImpl ? $576e41193d1785e0$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $6SWiB.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $6SWiB.useEffect(()=>$576e41193d1785e0$export$db5148ec97d6af7a(future), [
        future
    ]);
    return /*#__PURE__*/ $6SWiB.createElement($576e41193d1785e0$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * Changes the current location.
 *
 * Note: This API is mostly useful in React.Component subclasses that are not
 * able to use hooks. In functional components, we recommend you use the
 * `useNavigate` hook instead.
 *
 * @see https://reactrouter.com/v6/components/navigate
 */ function $576e41193d1785e0$export$444b3ab0cb9aec40(_ref4) {
    let { to: to, replace: replace, state: state, relative: relative } = _ref4;
    !$576e41193d1785e0$export$9c954a9d03d32f4a() && (0, $dae0ef9fca964cc6$export$3e9cee6b33872309)(false);
    let { future: future, static: isStatic } = $6SWiB.useContext($576e41193d1785e0$export$26749e8557646306);
    let { matches: matches } = $6SWiB.useContext($576e41193d1785e0$export$9072aa6dd1f93057);
    let { pathname: locationPathname } = $576e41193d1785e0$export$45d76561a5302f2b();
    let navigate = $576e41193d1785e0$export$9770f232ac06a008();
    // Resolve the path outside of the effect so that when effects run twice in
    // StrictMode they navigate to the same place
    let path = (0, $dae0ef9fca964cc6$export$cae722b0cc860f13)(to, (0, $dae0ef9fca964cc6$export$a5784978eca585fa)(matches, future.v7_relativeSplatPath), locationPathname, relative === "path");
    let jsonPath = JSON.stringify(path);
    $6SWiB.useEffect(()=>navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        }), [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
 * Renders the child route's element, if there is one.
 *
 * @see https://reactrouter.com/v6/components/outlet
 */ function $576e41193d1785e0$export$910ae8079b2c2852(props) {
    return $576e41193d1785e0$export$a3be3530d8e40d0b(props.context);
}
/**
 * Declares an element that should be rendered at a certain URL path.
 *
 * @see https://reactrouter.com/v6/components/route
 */ function $576e41193d1785e0$export$e7b0ac011bb776c6(_props) {
    (0, $dae0ef9fca964cc6$export$3e9cee6b33872309)(false);
}
/**
 * Provides location context for the rest of the app.
 *
 * Note: You usually won't render a `<Router>` directly. Instead, you'll render a
 * router that is more specific to your environment such as a `<BrowserRouter>`
 * in web browsers or a `<StaticRouter>` for server rendering.
 *
 * @see https://reactrouter.com/v6/router-components/router
 */ function $576e41193d1785e0$export$55185c17a0fcbe46(_ref5) {
    let { basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = (0, $dae0ef9fca964cc6$export$e19cd5f9376f8cee).Pop, navigator: navigator, static: staticProp = false, future: future } = _ref5;
    !!$576e41193d1785e0$export$9c954a9d03d32f4a() && (0, $dae0ef9fca964cc6$export$3e9cee6b33872309)(false);
    // Preserve trailing slashes on basename, so we can let the user control
    // the enforcement of trailing slashes throughout the app
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $6SWiB.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            future: $576e41193d1785e0$var$_extends({
                v7_relativeSplatPath: false
            }, future)
        }), [
        basename,
        future,
        navigator,
        staticProp
    ]);
    if (typeof locationProp === "string") locationProp = (0, $dae0ef9fca964cc6$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default" } = locationProp;
    let locationContext = $6SWiB.useMemo(()=>{
        let trailingPathname = (0, $dae0ef9fca964cc6$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType
    ]);
    if (locationContext == null) return null;
    return /*#__PURE__*/ $6SWiB.createElement($576e41193d1785e0$export$26749e8557646306.Provider, {
        value: navigationContext
    }, /*#__PURE__*/ $6SWiB.createElement($576e41193d1785e0$export$c7914228fb69b0f5.Provider, {
        children: children,
        value: locationContext
    }));
}
/**
 * A container for a nested tree of `<Route>` elements that renders the branch
 * that best matches the current location.
 *
 * @see https://reactrouter.com/v6/components/routes
 */ function $576e41193d1785e0$export$3565eb3d00ca5a74(_ref6) {
    let { children: children, location: location } = _ref6;
    return $576e41193d1785e0$export$5d3fca4a98652595($576e41193d1785e0$export$16da398f5434bdec(children), location);
}
/**
 * Component to use for rendering lazily loaded data from returning defer()
 * in a loader function
 */ function $576e41193d1785e0$export$6ddabde395c8c576(_ref7) {
    let { children: children, errorElement: errorElement, resolve: resolve } = _ref7;
    return /*#__PURE__*/ $6SWiB.createElement($576e41193d1785e0$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement
    }, /*#__PURE__*/ $6SWiB.createElement($576e41193d1785e0$var$ResolveAwait, null, children));
}
var $576e41193d1785e0$var$AwaitRenderStatus = /*#__PURE__*/ function(AwaitRenderStatus) {
    AwaitRenderStatus[AwaitRenderStatus["pending"] = 0] = "pending";
    AwaitRenderStatus[AwaitRenderStatus["success"] = 1] = "success";
    AwaitRenderStatus[AwaitRenderStatus["error"] = 2] = "error";
    return AwaitRenderStatus;
}($576e41193d1785e0$var$AwaitRenderStatus || {});
const $576e41193d1785e0$var$neverSettledPromise = new Promise(()=>{});
class $576e41193d1785e0$var$AwaitErrorBoundary extends $6SWiB.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = $576e41193d1785e0$var$AwaitRenderStatus.pending;
        if (!(resolve instanceof Promise)) {
            // Didn't get a promise - provide as a resolved promise
            status = $576e41193d1785e0$var$AwaitRenderStatus.success;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            // Caught a render error, provide it as a rejected promise
            status = $576e41193d1785e0$var$AwaitRenderStatus.error;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{}); // Avoid unhandled rejection warnings
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            // Already tracked promise - check contents
            promise = resolve;
            status = "_error" in promise ? $576e41193d1785e0$var$AwaitRenderStatus.error : "_data" in promise ? $576e41193d1785e0$var$AwaitRenderStatus.success : $576e41193d1785e0$var$AwaitRenderStatus.pending;
        } else {
            // Raw (untracked) promise - track it
            status = $576e41193d1785e0$var$AwaitRenderStatus.pending;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                }));
        }
        if (status === $576e41193d1785e0$var$AwaitRenderStatus.error && promise._error instanceof (0, $dae0ef9fca964cc6$export$42a99a7a4bc0e76a)) // Freeze the UI by throwing a never resolved promise
        throw $576e41193d1785e0$var$neverSettledPromise;
        if (status === $576e41193d1785e0$var$AwaitRenderStatus.error && !errorElement) // No errorElement, throw to the nearest route-level error boundary
        throw promise._error;
        if (status === $576e41193d1785e0$var$AwaitRenderStatus.error) // Render via our errorElement
        return /*#__PURE__*/ $6SWiB.createElement($576e41193d1785e0$var$AwaitContext.Provider, {
            value: promise,
            children: errorElement
        });
        if (status === $576e41193d1785e0$var$AwaitRenderStatus.success) // Render children with resolved value
        return /*#__PURE__*/ $6SWiB.createElement($576e41193d1785e0$var$AwaitContext.Provider, {
            value: promise,
            children: children
        });
        // Throw to the suspense boundary
        throw promise;
    }
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
}
/**
 * @private
 * Indirection to leverage useAsyncValue for a render-prop API on `<Await>`
 */ function $576e41193d1785e0$var$ResolveAwait(_ref8) {
    let { children: children } = _ref8;
    let data = $576e41193d1785e0$export$78a72ddb39bdd145();
    let toRender = typeof children === "function" ? children(data) : children;
    return /*#__PURE__*/ $6SWiB.createElement($6SWiB.Fragment, null, toRender);
}
///////////////////////////////////////////////////////////////////////////////
// UTILS
///////////////////////////////////////////////////////////////////////////////
/**
 * Creates a route config from a React "children" object, which is usually
 * either a `<Route>` element or an array of them. Used internally by
 * `<Routes>` to create a route config from its children.
 *
 * @see https://reactrouter.com/v6/utils/create-routes-from-children
 */ function $576e41193d1785e0$export$16da398f5434bdec(children, parentPath) {
    if (parentPath === void 0) parentPath = [];
    let routes = [];
    $6SWiB.Children.forEach(children, (element, index)=>{
        if (!/*#__PURE__*/ $6SWiB.isValidElement(element)) // Ignore non-elements. This allows people to more easily inline
        // conditionals in their route config.
        return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $6SWiB.Fragment) {
            // Transparently support React.Fragment and its children.
            routes.push.apply(routes, $576e41193d1785e0$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        !(element.type === $576e41193d1785e0$export$e7b0ac011bb776c6) && (0, $dae0ef9fca964cc6$export$3e9cee6b33872309)(false);
        !(!element.props.index || !element.props.children) && (0, $dae0ef9fca964cc6$export$3e9cee6b33872309)(false);
        let route = {
            id: element.props.id || treePath.join("-"),
            caseSensitive: element.props.caseSensitive,
            element: element.props.element,
            Component: element.props.Component,
            index: element.props.index,
            path: element.props.path,
            loader: element.props.loader,
            action: element.props.action,
            errorElement: element.props.errorElement,
            ErrorBoundary: element.props.ErrorBoundary,
            hasErrorBoundary: element.props.ErrorBoundary != null || element.props.errorElement != null,
            shouldRevalidate: element.props.shouldRevalidate,
            handle: element.props.handle,
            lazy: element.props.lazy
        };
        if (element.props.children) route.children = $576e41193d1785e0$export$16da398f5434bdec(element.props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
 * Renders the result of `matchRoutes()` into a React element.
 */ function $576e41193d1785e0$export$daf73786167a7f72(matches) {
    return $576e41193d1785e0$var$_renderMatches(matches);
}
function $576e41193d1785e0$export$52b333d321859367(route) {
    let updates = {
        // Note: this check also occurs in createRoutesFromChildren so update
        // there if you change this -- please and thank you!
        hasErrorBoundary: route.ErrorBoundary != null || route.errorElement != null
    };
    if (route.Component) Object.assign(updates, {
        element: /*#__PURE__*/ $6SWiB.createElement(route.Component),
        Component: undefined
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: /*#__PURE__*/ $6SWiB.createElement(route.HydrateFallback),
        HydrateFallback: undefined
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: /*#__PURE__*/ $6SWiB.createElement(route.ErrorBoundary),
        ErrorBoundary: undefined
    });
    return updates;
}
function $576e41193d1785e0$export$f30f7e456d254e83(routes, opts) {
    return (0, $dae0ef9fca964cc6$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $576e41193d1785e0$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $dae0ef9fca964cc6$export$2b76ad033c6e6d08)({
            initialEntries: opts == null ? void 0 : opts.initialEntries,
            initialIndex: opts == null ? void 0 : opts.initialIndex
        }),
        hydrationData: opts == null ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: $576e41193d1785e0$export$52b333d321859367,
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation
    }).initialize();
}



function $fd8010543425d4bc$var$_extends() {
    return $fd8010543425d4bc$var$_extends = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $fd8010543425d4bc$var$_extends.apply(null, arguments);
}
function $fd8010543425d4bc$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}
const $fd8010543425d4bc$var$defaultMethod = "get";
const $fd8010543425d4bc$var$defaultEncType = "application/x-www-form-urlencoded";
function $fd8010543425d4bc$var$isHtmlElement(object) {
    return object != null && typeof object.tagName === "string";
}
function $fd8010543425d4bc$var$isButtonElement(object) {
    return $fd8010543425d4bc$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $fd8010543425d4bc$var$isFormElement(object) {
    return $fd8010543425d4bc$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $fd8010543425d4bc$var$isInputElement(object) {
    return $fd8010543425d4bc$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $fd8010543425d4bc$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $fd8010543425d4bc$var$shouldProcessLinkClick(event, target) {
    return event.button === 0 && // Ignore everything but left clicks
    (!target || target === "_self") && // Let browser handle "target=_blank" etc.
    !$fd8010543425d4bc$var$isModifiedEvent(event) // Ignore clicks with modifier keys
    ;
}
/**
 * Creates a URLSearchParams object using the given initializer.
 *
 * This is identical to `new URLSearchParams(init)` except it also
 * supports arrays as values in the object form of the initializer
 * instead of just strings. This is convenient when you need multiple
 * values for a given key, but don't want to use an array initializer.
 *
 * For example, instead of:
 *
 *   let searchParams = new URLSearchParams([
 *     ['sort', 'name'],
 *     ['sort', 'price']
 *   ]);
 *
 * you can do:
 *
 *   let searchParams = createSearchParams({
 *     sort: ['name', 'price']
 *   });
 */ function $fd8010543425d4bc$export$a2e4e2dcc7b1f22f(init) {
    if (init === void 0) init = "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $fd8010543425d4bc$var$getSearchParamsForLocation(locationSearch, defaultSearchParams) {
    let searchParams = $fd8010543425d4bc$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) // Use `defaultSearchParams.forEach(...)` here instead of iterating of
    // `defaultSearchParams.keys()` to work-around a bug in Firefox related to
    // web extensions. Relevant Bugzilla tickets:
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1414602
    // https://bugzilla.mozilla.org/show_bug.cgi?id=1023984
    defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
// One-time check for submitter support
let $fd8010543425d4bc$var$_formDataSupportsSubmitter = null;
function $fd8010543425d4bc$var$isFormDataSubmitterSupported() {
    if ($fd8010543425d4bc$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), // @ts-expect-error if FormData supports the submitter parameter, this will throw
        0);
        $fd8010543425d4bc$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $fd8010543425d4bc$var$_formDataSupportsSubmitter = true;
    }
    return $fd8010543425d4bc$var$_formDataSupportsSubmitter;
}
const $fd8010543425d4bc$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $fd8010543425d4bc$var$getFormEncType(encType) {
    if (encType != null && !$fd8010543425d4bc$var$supportedFormEncTypes.has(encType)) return null;
    return encType;
}
function $fd8010543425d4bc$var$getFormSubmissionInfo(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($fd8010543425d4bc$var$isFormElement(target)) {
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("action");
        action = attr ? (0, $dae0ef9fca964cc6$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || $fd8010543425d4bc$var$defaultMethod;
        encType = $fd8010543425d4bc$var$getFormEncType(target.getAttribute("enctype")) || $fd8010543425d4bc$var$defaultEncType;
        formData = new FormData(target);
    } else if ($fd8010543425d4bc$var$isButtonElement(target) || $fd8010543425d4bc$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error("Cannot submit a <button> or <input type=\"submit\"> without a <form>");
        // <button>/<input type="submit"> may override attributes of <form>
        // When grabbing the action from the element, it will have had the basename
        // prefixed to ensure non-JS scenarios work, so strip it since we'll
        // re-prefix in the router
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $dae0ef9fca964cc6$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || $fd8010543425d4bc$var$defaultMethod;
        encType = $fd8010543425d4bc$var$getFormEncType(target.getAttribute("formenctype")) || $fd8010543425d4bc$var$getFormEncType(form.getAttribute("enctype")) || $fd8010543425d4bc$var$defaultEncType;
        // Build a FormData object populated from a form and submitter
        formData = new FormData(form, target);
        // If this browser doesn't support the `FormData(el, submitter)` format,
        // then tack on the submitter value at the end.  This is a lightweight
        // solution that is not 100% spec compliant.  For complete support in older
        // browsers, consider using the `formdata-submitter-polyfill` package
        if (!$fd8010543425d4bc$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? name + "." : "";
                formData.append(prefix + "x", "0");
                formData.append(prefix + "y", "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($fd8010543425d4bc$var$isHtmlElement(target)) throw new Error('Cannot submit element that is not <form>, <button>, or <input type="submit|image">');
    else {
        method = $fd8010543425d4bc$var$defaultMethod;
        action = null;
        encType = $fd8010543425d4bc$var$defaultEncType;
        body = target;
    }
    // Send body for <Form encType="text/plain" so we encode it into text
    if (formData && encType === "text/plain") {
        body = formData;
        formData = undefined;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}
const $fd8010543425d4bc$var$_excluded = [
    "onClick",
    "relative",
    "reloadDocument",
    "replace",
    "state",
    "target",
    "to",
    "preventScrollReset",
    "viewTransition"
], $fd8010543425d4bc$var$_excluded2 = [
    "aria-current",
    "caseSensitive",
    "className",
    "end",
    "style",
    "to",
    "viewTransition",
    "children"
], $fd8010543425d4bc$var$_excluded3 = [
    "fetcherKey",
    "navigate",
    "reloadDocument",
    "replace",
    "state",
    "method",
    "action",
    "onSubmit",
    "relative",
    "preventScrollReset",
    "viewTransition"
];
// HEY YOU! DON'T TOUCH THIS VARIABLE!
//
// It is replaced with the proper version at build time via a babel plugin in
// the rollup config.
//
// Export a global property onto the window for React Router detection by the
// Core Web Vitals Technology Report.  This way they can configure the `wappalyzer`
// to detect and properly classify live websites as being built with React Router:
// https://github.com/HTTPArchive/wappalyzer/blob/main/src/technologies/r.json
const $fd8010543425d4bc$var$REACT_ROUTER_VERSION = "6";
try {
    window.__reactRouterVersion = $fd8010543425d4bc$var$REACT_ROUTER_VERSION;
} catch (e) {
// no-op
}
function $fd8010543425d4bc$export$1f3f55432a00e06d(routes, opts) {
    return (0, $dae0ef9fca964cc6$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $fd8010543425d4bc$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $dae0ef9fca964cc6$export$719fc203c4e16dee)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $fd8010543425d4bc$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $576e41193d1785e0$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $fd8010543425d4bc$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $dae0ef9fca964cc6$export$baddd0131ee8c05b)({
        basename: opts == null ? void 0 : opts.basename,
        future: $fd8010543425d4bc$var$_extends({}, opts == null ? void 0 : opts.future, {
            v7_prependBasename: true
        }),
        history: (0, $dae0ef9fca964cc6$export$b71fdd3798280242)({
            window: opts == null ? void 0 : opts.window
        }),
        hydrationData: (opts == null ? void 0 : opts.hydrationData) || $fd8010543425d4bc$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $576e41193d1785e0$export$52b333d321859367),
        dataStrategy: opts == null ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts == null ? void 0 : opts.patchRoutesOnNavigation,
        window: opts == null ? void 0 : opts.window
    }).initialize();
}
function $fd8010543425d4bc$var$parseHydrationData() {
    var _window;
    let state = (_window = window) == null ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = $fd8010543425d4bc$var$_extends({}, state, {
        errors: $fd8010543425d4bc$var$deserializeErrors(state.errors)
    });
    return state;
}
function $fd8010543425d4bc$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries){
        // Hey you!  If you change this, please change the corresponding logic in
        // serializeErrors in react-router-dom/server.tsx :)
        if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $dae0ef9fca964cc6$export$6c6580e81da25755)(val.status, val.statusText, val.data, val.internal === true);
        else if (val && val.__type === "Error") {
            // Attempt to reconstruct the right type of Error (i.e., ReferenceError)
            if (val.__subType) {
                let ErrorConstructor = window[val.__subType];
                if (typeof ErrorConstructor === "function") try {
                    // @ts-expect-error
                    let error = new ErrorConstructor(val.message);
                    // Wipe away the client-side stack trace.  Nothing to fill it in with
                    // because we don't serialize SSR stack traces for security reasons
                    error.stack = "";
                    serialized[key] = error;
                } catch (e) {
                // no-op - fall through and create a normal Error
                }
            }
            if (serialized[key] == null) {
                let error = new Error(val.message);
                // Wipe away the client-side stack trace.  Nothing to fill it in with
                // because we don't serialize SSR stack traces for security reasons
                error.stack = "";
                serialized[key] = error;
            }
        } else serialized[key] = val;
    }
    return serialized;
}
const $fd8010543425d4bc$export$7ad602f0e94e62d1 = /*#__PURE__*/ $6SWiB.createContext({
    isTransitioning: false
});
const $fd8010543425d4bc$export$148fd98d095596d4 = /*#__PURE__*/ $6SWiB.createContext(new Map());
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Components
////////////////////////////////////////////////////////////////////////////////
/**
  Webpack + React 17 fails to compile on any of the following because webpack
  complains that `startTransition` doesn't exist in `React`:
  * import { startTransition } from "react"
  * import * as React from from "react";
    "startTransition" in React ? React.startTransition(() => setState()) : setState()
  * import * as React from from "react";
    "startTransition" in React ? React["startTransition"](() => setState()) : setState()

  Moving it to a constant such as the following solves the Webpack/React 17 issue:
  * import * as React from from "react";
    const START_TRANSITION = "startTransition";
    START_TRANSITION in React ? React[START_TRANSITION](() => setState()) : setState()

  However, that introduces webpack/terser minification issues in production builds
  in React 18 where minification/obfuscation ends up removing the call of
  React.startTransition entirely from the first half of the ternary.  Grabbing
  this exported reference once up front resolves that issue.

  See https://github.com/remix-run/react-router/issues/10579
*/ const $fd8010543425d4bc$var$START_TRANSITION = "startTransition";
const $fd8010543425d4bc$var$startTransitionImpl = $6SWiB[$fd8010543425d4bc$var$START_TRANSITION];
const $fd8010543425d4bc$var$FLUSH_SYNC = "flushSync";
const $fd8010543425d4bc$var$flushSyncImpl = $ac53942f71d960c8$exports[$fd8010543425d4bc$var$FLUSH_SYNC];
const $fd8010543425d4bc$var$USE_ID = "useId";
const $fd8010543425d4bc$var$useIdImpl = $6SWiB[$fd8010543425d4bc$var$USE_ID];
function $fd8010543425d4bc$var$startTransitionSafe(cb) {
    if ($fd8010543425d4bc$var$startTransitionImpl) $fd8010543425d4bc$var$startTransitionImpl(cb);
    else cb();
}
function $fd8010543425d4bc$var$flushSyncSafe(cb) {
    if ($fd8010543425d4bc$var$flushSyncImpl) $fd8010543425d4bc$var$flushSyncImpl(cb);
    else cb();
}
class $fd8010543425d4bc$var$Deferred {
    constructor(){
        this.status = "pending";
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
}
/**
 * Given a Remix Router instance, render the appropriate UI
 */ function $fd8010543425d4bc$export$323e4fc2fa4753fb(_ref) {
    let { fallbackElement: fallbackElement, router: router, future: future } = _ref;
    let [state, setStateImpl] = $6SWiB.useState(router.state);
    let [pendingState, setPendingState] = $6SWiB.useState();
    let [vtContext, setVtContext] = $6SWiB.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $6SWiB.useState();
    let [transition, setTransition] = $6SWiB.useState();
    let [interruption, setInterruption] = $6SWiB.useState();
    let fetcherData = $6SWiB.useRef(new Map());
    let { v7_startTransition: v7_startTransition } = future || {};
    let optInStartTransition = $6SWiB.useCallback((cb)=>{
        if (v7_startTransition) $fd8010543425d4bc$var$startTransitionSafe(cb);
        else cb();
    }, [
        v7_startTransition
    ]);
    let setState = $6SWiB.useCallback((newState, _ref2)=>{
        let { deletedFetchers: deletedFetchers, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts } = _ref2;
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== undefined) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        let isViewTransitionUnavailable = router.window == null || router.window.document == null || typeof router.window.document.startViewTransition !== "function";
        // If this isn't a view transition or it's not available in this browser,
        // just update and be done with it
        if (!viewTransitionOpts || isViewTransitionUnavailable) {
            if (flushSync) $fd8010543425d4bc$var$flushSyncSafe(()=>setStateImpl(newState));
            else optInStartTransition(()=>setStateImpl(newState));
            return;
        }
        // flushSync + startViewTransition
        if (flushSync) {
            // Flush through the context to mark DOM elements as transition=ing
            $fd8010543425d4bc$var$flushSyncSafe(()=>{
                // Cancel any pending transitions
                if (transition) {
                    renderDfd && renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            // Update the DOM
            let t = router.window.document.startViewTransition(()=>{
                $fd8010543425d4bc$var$flushSyncSafe(()=>setStateImpl(newState));
            });
            // Clean up after the animation completes
            t.finished.finally(()=>{
                $fd8010543425d4bc$var$flushSyncSafe(()=>{
                    setRenderDfd(undefined);
                    setTransition(undefined);
                    setPendingState(undefined);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            $fd8010543425d4bc$var$flushSyncSafe(()=>setTransition(t));
            return;
        }
        // startTransition + startViewTransition
        if (transition) {
            // Interrupting an in-progress transition, cancel and let everything flush
            // out, and then kick off a new transition from the interruption state
            renderDfd && renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            // Completed navigation update with opted-in view transitions, let 'er rip
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        transition,
        renderDfd,
        fetcherData,
        optInStartTransition
    ]);
    // Need to use a layout effect here so we are subscribed early enough to
    // pick up on any render-driven redirects/navigations (useEffect/<Navigate>)
    $6SWiB.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    // When we start a view transition, create a Deferred we can use for the
    // eventual "completed" render
    $6SWiB.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $fd8010543425d4bc$var$Deferred());
    }, [
        vtContext
    ]);
    // Once the deferred is created, kick off startViewTransition() to update the
    // DOM and then wait on the Deferred to resolve (indicating the DOM update has
    // happened)
    $6SWiB.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                optInStartTransition(()=>setStateImpl(newState));
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(undefined);
                setTransition(undefined);
                setPendingState(undefined);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        optInStartTransition,
        pendingState,
        renderDfd,
        router.window
    ]);
    // When the new location finally renders and is committed to the DOM, this
    // effect will run to resolve the transition
    $6SWiB.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    // If we get interrupted with a new navigation during a transition, we skip
    // the active transition, let it cleanup, then kick it off again here
    $6SWiB.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(undefined);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    $6SWiB.useEffect(()=>{
    // Only log this once on initial mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);
    let navigator = $6SWiB.useMemo(()=>{
        return {
            createHref: router.createHref,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts == null ? void 0 : opts.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $6SWiB.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename
        }), [
        router,
        navigator,
        basename
    ]);
    let routerFuture = $6SWiB.useMemo(()=>({
            v7_relativeSplatPath: router.future.v7_relativeSplatPath
        }), [
        router.future.v7_relativeSplatPath
    ]);
    $6SWiB.useEffect(()=>(0, $576e41193d1785e0$export$db5148ec97d6af7a)(future, router.future), [
        future,
        router.future
    ]);
    // The fragment and {null} here are important!  We need them to keep React 18's
    // useId happy when we are server-rendering since we may have a <script> here
    // containing the hydrated server-side staticContext (from StaticRouterProvider).
    // useId relies on the component tree structure to generate deterministic id's
    // so we need to ensure it remains the same on the client even though
    // we don't need the <script> tag
    return /*#__PURE__*/ $6SWiB.createElement($6SWiB.Fragment, null, /*#__PURE__*/ $6SWiB.createElement((0, $576e41193d1785e0$export$3add0d5dce533e2e).Provider, {
        value: dataRouterContext
    }, /*#__PURE__*/ $6SWiB.createElement((0, $576e41193d1785e0$export$145dfa71566a64dc).Provider, {
        value: state
    }, /*#__PURE__*/ $6SWiB.createElement($fd8010543425d4bc$export$148fd98d095596d4.Provider, {
        value: fetcherData.current
    }, /*#__PURE__*/ $6SWiB.createElement($fd8010543425d4bc$export$7ad602f0e94e62d1.Provider, {
        value: vtContext
    }, /*#__PURE__*/ $6SWiB.createElement((0, $576e41193d1785e0$export$55185c17a0fcbe46), {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        future: routerFuture
    }, state.initialized || router.future.v7_partialHydration ? /*#__PURE__*/ $6SWiB.createElement($fd8010543425d4bc$var$MemoizedDataRoutes, {
        routes: router.routes,
        future: router.future,
        state: state
    }) : fallbackElement))))), null);
}
// Memoize to avoid re-renders when updating `ViewTransitionContext`
const $fd8010543425d4bc$var$MemoizedDataRoutes = /*#__PURE__*/ $6SWiB.memo($fd8010543425d4bc$var$DataRoutes);
function $fd8010543425d4bc$var$DataRoutes(_ref3) {
    let { routes: routes, future: future, state: state } = _ref3;
    return (0, $576e41193d1785e0$export$5fcee62552a12fbf)(routes, undefined, state, future);
}
/**
 * A `<Router>` for use in web browsers. Provides the cleanest URLs.
 */ function $fd8010543425d4bc$export$9ba4e89fdfa1fc54(_ref4) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref4;
    let historyRef = $6SWiB.useRef();
    if (historyRef.current == null) historyRef.current = (0, $dae0ef9fca964cc6$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $6SWiB.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $6SWiB.useCallback((newState)=>{
        v7_startTransition && $fd8010543425d4bc$var$startTransitionImpl ? $fd8010543425d4bc$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $6SWiB.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $6SWiB.useEffect(()=>(0, $576e41193d1785e0$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $6SWiB.createElement((0, $576e41193d1785e0$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` for use in web browsers. Stores the location in the hash
 * portion of the URL so it is not sent to the server.
 */ function $fd8010543425d4bc$export$7221d69dcfc8e36b(_ref5) {
    let { basename: basename, children: children, future: future, window: window1 } = _ref5;
    let historyRef = $6SWiB.useRef();
    if (historyRef.current == null) historyRef.current = (0, $dae0ef9fca964cc6$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $6SWiB.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $6SWiB.useCallback((newState)=>{
        v7_startTransition && $fd8010543425d4bc$var$startTransitionImpl ? $fd8010543425d4bc$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $6SWiB.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $6SWiB.useEffect(()=>(0, $576e41193d1785e0$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $6SWiB.createElement((0, $576e41193d1785e0$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
/**
 * A `<Router>` that accepts a pre-instantiated history object. It's important
 * to note that using your own history object is highly discouraged and may add
 * two versions of the history library to your bundles unless you use the same
 * version of the history library that React Router uses internally.
 */ function $fd8010543425d4bc$export$eefb0c834599897e(_ref6) {
    let { basename: basename, children: children, future: future, history: history } = _ref6;
    let [state, setStateImpl] = $6SWiB.useState({
        action: history.action,
        location: history.location
    });
    let { v7_startTransition: v7_startTransition } = future || {};
    let setState = $6SWiB.useCallback((newState)=>{
        v7_startTransition && $fd8010543425d4bc$var$startTransitionImpl ? $fd8010543425d4bc$var$startTransitionImpl(()=>setStateImpl(newState)) : setStateImpl(newState);
    }, [
        setStateImpl,
        v7_startTransition
    ]);
    $6SWiB.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    $6SWiB.useEffect(()=>(0, $576e41193d1785e0$export$db5148ec97d6af7a)(future), [
        future
    ]);
    return /*#__PURE__*/ $6SWiB.createElement((0, $576e41193d1785e0$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        future: future
    });
}
const $fd8010543425d4bc$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
const $fd8010543425d4bc$var$ABSOLUTE_URL_REGEX = /^(?:[a-z][a-z0-9+.-]*:|\/\/)/i;
/**
 * The public API for rendering a history-aware `<a>`.
 */ const $fd8010543425d4bc$export$a6c7ac8248d6e38a = /*#__PURE__*/ $6SWiB.forwardRef(function LinkWithRef(_ref7, ref) {
    let { onClick: onClick, relative: relative, reloadDocument: reloadDocument, replace: replace, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref7, rest = $fd8010543425d4bc$var$_objectWithoutPropertiesLoose(_ref7, $fd8010543425d4bc$var$_excluded);
    let { basename: basename } = $6SWiB.useContext((0, $576e41193d1785e0$export$26749e8557646306));
    // Rendered into <a href> for absolute URLs
    let absoluteHref;
    let isExternal = false;
    if (typeof to === "string" && $fd8010543425d4bc$var$ABSOLUTE_URL_REGEX.test(to)) {
        // Render the absolute href server- and client-side
        absoluteHref = to;
        // Only check for external origins client-side
        if ($fd8010543425d4bc$var$isBrowser) try {
            let currentUrl = new URL(window.location.href);
            let targetUrl = to.startsWith("//") ? new URL(currentUrl.protocol + to) : new URL(to);
            let path = (0, $dae0ef9fca964cc6$export$b69e3301ce081aa3)(targetUrl.pathname, basename);
            if (targetUrl.origin === currentUrl.origin && path != null) // Strip the protocol/origin/basename for same-origin absolute URLs
            to = path + targetUrl.search + targetUrl.hash;
            else isExternal = true;
        } catch (e) {}
    }
    // Rendered into <a href> for relative URLs
    let href = (0, $576e41193d1785e0$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let internalOnClick = $fd8010543425d4bc$export$67621102c14d847(to, {
        replace: replace,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    return(/*#__PURE__*/ // eslint-disable-next-line jsx-a11y/anchor-has-content
    $6SWiB.createElement("a", $fd8010543425d4bc$var$_extends({}, rest, {
        href: absoluteHref || href,
        onClick: isExternal || reloadDocument ? onClick : handleClick,
        ref: ref,
        target: target
    })));
});
/**
 * A `<Link>` wrapper that knows if it's "active" or not.
 */ const $fd8010543425d4bc$export$b0d92dbee9b5b60d = /*#__PURE__*/ $6SWiB.forwardRef(function NavLinkWithRef(_ref8, ref) {
    let { "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children } = _ref8, rest = $fd8010543425d4bc$var$_objectWithoutPropertiesLoose(_ref8, $fd8010543425d4bc$var$_excluded2);
    let path = (0, $576e41193d1785e0$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $576e41193d1785e0$export$45d76561a5302f2b)();
    let routerState = $6SWiB.useContext((0, $576e41193d1785e0$export$145dfa71566a64dc));
    let { navigator: navigator, basename: basename } = $6SWiB.useContext((0, $576e41193d1785e0$export$26749e8557646306));
    let isTransitioning = routerState != null && // Conditional usage is OK here because the usage of a data router is static
    // eslint-disable-next-line react-hooks/rules-of-hooks
    $fd8010543425d4bc$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $dae0ef9fca964cc6$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    // If the `to` has a trailing slash, look at that exact spot.  Otherwise,
    // we're looking for a slash _after_ what's in `to`.  For example:
    //
    // <NavLink to="/users"> and <NavLink to="/users/">
    // both want to look for a / at index 6 to match URL `/users/matt`
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(toPathname.length) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : undefined;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else // If the className prop is not a function, we use a default `active`
    // class for <NavLink />s that are active. In v5 `active` was the default
    // value for `activeClassName`, but we are removing that API and can still
    // use the old default behavior for a cleaner upgrade path and keep the
    // simple styling rules working as they currently do.
    className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /*#__PURE__*/ $6SWiB.createElement($fd8010543425d4bc$export$a6c7ac8248d6e38a, $fd8010543425d4bc$var$_extends({}, rest, {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
/**
 * A `@remix-run/router`-aware `<form>`. It behaves like a normal form except
 * that the interaction with the server is with `fetch` instead of new document
 * requests, allowing components to add nicer UX to the page as the form is
 * submitted and returns with data.
 */ const $fd8010543425d4bc$export$a7fed597f4b8afd8 = /*#__PURE__*/ $6SWiB.forwardRef((_ref9, forwardedRef)=>{
    let { fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = $fd8010543425d4bc$var$defaultMethod, action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition } = _ref9, props = $fd8010543425d4bc$var$_objectWithoutPropertiesLoose(_ref9, $fd8010543425d4bc$var$_excluded3);
    let submit = $fd8010543425d4bc$export$47c85c6e3a081d3();
    let formAction = $fd8010543425d4bc$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = (submitter == null ? void 0 : submitter.getAttribute("formmethod")) || method;
        submit(submitter || event.currentTarget, {
            fetcherKey: fetcherKey,
            method: submitMethod,
            navigate: navigate,
            replace: replace,
            state: state,
            relative: relative,
            preventScrollReset: preventScrollReset,
            viewTransition: viewTransition
        });
    };
    return /*#__PURE__*/ $6SWiB.createElement("form", $fd8010543425d4bc$var$_extends({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props));
});
/**
 * This component will emulate the browser's scroll restoration on location
 * changes.
 */ function $fd8010543425d4bc$export$11aac1aab828f1fa(_ref0) {
    let { getKey: getKey, storageKey: storageKey } = _ref0;
    $fd8010543425d4bc$export$25057cfe5591e3e9({
        getKey: getKey,
        storageKey: storageKey
    });
    return null;
}
//#endregion
////////////////////////////////////////////////////////////////////////////////
//#region Hooks
////////////////////////////////////////////////////////////////////////////////
var $fd8010543425d4bc$var$DataRouterHook;
(function(DataRouterHook) {
    DataRouterHook["UseScrollRestoration"] = "useScrollRestoration";
    DataRouterHook["UseSubmit"] = "useSubmit";
    DataRouterHook["UseSubmitFetcher"] = "useSubmitFetcher";
    DataRouterHook["UseFetcher"] = "useFetcher";
    DataRouterHook["useViewTransitionState"] = "useViewTransitionState";
})($fd8010543425d4bc$var$DataRouterHook || ($fd8010543425d4bc$var$DataRouterHook = {}));
var $fd8010543425d4bc$var$DataRouterStateHook;
(function(DataRouterStateHook) {
    DataRouterStateHook["UseFetcher"] = "useFetcher";
    DataRouterStateHook["UseFetchers"] = "useFetchers";
    DataRouterStateHook["UseScrollRestoration"] = "useScrollRestoration";
})($fd8010543425d4bc$var$DataRouterStateHook || ($fd8010543425d4bc$var$DataRouterStateHook = {}));
// Internal hooks
function $fd8010543425d4bc$var$getDataRouterConsoleError(hookName) {
    return hookName + " must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.";
}
function $fd8010543425d4bc$var$useDataRouterContext(hookName) {
    let ctx = $6SWiB.useContext((0, $576e41193d1785e0$export$3add0d5dce533e2e));
    !ctx && (0, $dae0ef9fca964cc6$export$3e9cee6b33872309)(false);
    return ctx;
}
function $fd8010543425d4bc$var$useDataRouterState(hookName) {
    let state = $6SWiB.useContext((0, $576e41193d1785e0$export$145dfa71566a64dc));
    !state && (0, $dae0ef9fca964cc6$export$3e9cee6b33872309)(false);
    return state;
}
// External hooks
/**
 * Handles the click behavior for router `<Link>` components. This is useful if
 * you need to create custom `<Link>` components with the same click behavior we
 * use in our exported `<Link>`.
 */ function $fd8010543425d4bc$export$67621102c14d847(to, _temp) {
    let { target: target, replace: replaceProp, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition } = _temp === void 0 ? {} : _temp;
    let navigate = (0, $576e41193d1785e0$export$9770f232ac06a008)();
    let location = (0, $576e41193d1785e0$export$45d76561a5302f2b)();
    let path = (0, $576e41193d1785e0$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $6SWiB.useCallback((event)=>{
        if ($fd8010543425d4bc$var$shouldProcessLinkClick(event, target)) {
            event.preventDefault();
            // If the URL hasn't changed, a regular <a> will do a replace instead of
            // a push, so do the same here unless the replace prop is explicitly set
            let replace = replaceProp !== undefined ? replaceProp : (0, $dae0ef9fca964cc6$export$fe53371bee54353d)(location) === (0, $dae0ef9fca964cc6$export$fe53371bee54353d)(path);
            navigate(to, {
                replace: replace,
                state: state,
                preventScrollReset: preventScrollReset,
                relative: relative,
                viewTransition: viewTransition
            });
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition
    ]);
}
/**
 * A convenient wrapper for reading and writing search parameters via the
 * URLSearchParams interface.
 */ function $fd8010543425d4bc$export$f1a78c17382fe22a(defaultInit) {
    let defaultSearchParamsRef = $6SWiB.useRef($fd8010543425d4bc$export$a2e4e2dcc7b1f22f(defaultInit));
    let hasSetSearchParamsRef = $6SWiB.useRef(false);
    let location = (0, $576e41193d1785e0$export$45d76561a5302f2b)();
    let searchParams = $6SWiB.useMemo(()=>// Only merge in the defaults if we haven't yet called setSearchParams.
        // Once we call that we want those to take precedence, otherwise you can't
        // remove a param with setSearchParams({}) if it has an initial value
        $fd8010543425d4bc$var$getSearchParamsForLocation(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $576e41193d1785e0$export$9770f232ac06a008)();
    let setSearchParams = $6SWiB.useCallback((nextInit, navigateOptions)=>{
        const newSearchParams = $fd8010543425d4bc$export$a2e4e2dcc7b1f22f(typeof nextInit === "function" ? nextInit(searchParams) : nextInit);
        hasSetSearchParamsRef.current = true;
        navigate("?" + newSearchParams, navigateOptions);
    }, [
        navigate,
        searchParams
    ]);
    return [
        searchParams,
        setSearchParams
    ];
}
function $fd8010543425d4bc$var$validateClientSideSubmission() {
    if (typeof document === "undefined") throw new Error("You are calling submit during the server render. Try calling submit within a `useEffect` or callback instead.");
}
let $fd8010543425d4bc$var$fetcherId = 0;
let $fd8010543425d4bc$var$getUniqueFetcherId = ()=>"__" + String(++$fd8010543425d4bc$var$fetcherId) + "__";
/**
 * Returns a function that may be used to programmatically submit a form (or
 * some arbitrary data) to the server.
 */ function $fd8010543425d4bc$export$47c85c6e3a081d3() {
    let { router: router } = $fd8010543425d4bc$var$useDataRouterContext($fd8010543425d4bc$var$DataRouterHook.UseSubmit);
    let { basename: basename } = $6SWiB.useContext((0, $576e41193d1785e0$export$26749e8557646306));
    let currentRouteId = (0, $576e41193d1785e0$export$5fc8298006ad9e58)();
    return $6SWiB.useCallback(function(target, options) {
        if (options === void 0) options = {};
        $fd8010543425d4bc$var$validateClientSideSubmission();
        let { action: action, method: method, encType: encType, formData: formData, body: body } = $fd8010543425d4bc$var$getFormSubmissionInfo(target, basename);
        if (options.navigate === false) {
            let key = options.fetcherKey || $fd8010543425d4bc$var$getUniqueFetcherId();
            router.fetch(key, currentRouteId, options.action || action, {
                preventScrollReset: options.preventScrollReset,
                formData: formData,
                body: body,
                formMethod: options.method || method,
                formEncType: options.encType || encType,
                flushSync: options.flushSync
            });
        } else router.navigate(options.action || action, {
            preventScrollReset: options.preventScrollReset,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        router,
        basename,
        currentRouteId
    ]);
}
// v7: Eventually we should deprecate this entirely in favor of using the
// router method directly?
function $fd8010543425d4bc$export$89a6bd6db0d97c56(action, _temp2) {
    let { relative: relative } = _temp2 === void 0 ? {} : _temp2;
    let { basename: basename } = $6SWiB.useContext((0, $576e41193d1785e0$export$26749e8557646306));
    let routeContext = $6SWiB.useContext((0, $576e41193d1785e0$export$9072aa6dd1f93057));
    !routeContext && (0, $dae0ef9fca964cc6$export$3e9cee6b33872309)(false);
    let [match] = routeContext.matches.slice(-1);
    // Shallow clone path so we can modify it below, otherwise we modify the
    // object referenced by useMemo inside useResolvedPath
    let path = $fd8010543425d4bc$var$_extends({}, (0, $576e41193d1785e0$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    // If no action was specified, browsers will persist current search params
    // when determining the path, so match that behavior
    // https://github.com/remix-run/remix/issues/927
    let location = (0, $576e41193d1785e0$export$45d76561a5302f2b)();
    if (action == null) {
        // Safe to write to this directly here since if action was undefined, we
        // would have called useResolvedPath(".") which will never include a search
        path.search = location.search;
        // When grabbing search params from the URL, remove any included ?index param
        // since it might not apply to our contextual route.  We add it back based
        // on match.route.index below
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        let hasNakedIndexParam = indexValues.some((v)=>v === "");
        if (hasNakedIndexParam) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? "?" + qs : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    // If we're operating within a basename, prepend it to the pathname prior
    // to creating the form action.  If this is a root navigation, then just use
    // the raw basename which allows the basename to have full control over the
    // presence of a trailing slash on root actions
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $dae0ef9fca964cc6$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $dae0ef9fca964cc6$export$fe53371bee54353d)(path);
}
// TODO: (v7) Change the useFetcher generic default from `any` to `unknown`
/**
 * Interacts with route loaders and actions without causing a navigation. Great
 * for any interaction that stays on the same page.
 */ function $fd8010543425d4bc$export$5b0d2d9a9921565a(_temp3) {
    var _route$matches;
    let { key: key } = _temp3 === void 0 ? {} : _temp3;
    let { router: router } = $fd8010543425d4bc$var$useDataRouterContext($fd8010543425d4bc$var$DataRouterHook.UseFetcher);
    let state = $fd8010543425d4bc$var$useDataRouterState($fd8010543425d4bc$var$DataRouterStateHook.UseFetcher);
    let fetcherData = $6SWiB.useContext($fd8010543425d4bc$export$148fd98d095596d4);
    let route = $6SWiB.useContext((0, $576e41193d1785e0$export$9072aa6dd1f93057));
    let routeId = (_route$matches = route.matches[route.matches.length - 1]) == null ? void 0 : _route$matches.route.id;
    !fetcherData && (0, $dae0ef9fca964cc6$export$3e9cee6b33872309)(false);
    !route && (0, $dae0ef9fca964cc6$export$3e9cee6b33872309)(false);
    !(routeId != null) && (0, $dae0ef9fca964cc6$export$3e9cee6b33872309)(false);
    // Fetcher key handling
    // OK to call conditionally to feature detect `useId`
    // eslint-disable-next-line react-hooks/rules-of-hooks
    let defaultKey = $fd8010543425d4bc$var$useIdImpl ? $fd8010543425d4bc$var$useIdImpl() : "";
    let [fetcherKey, setFetcherKey] = $6SWiB.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    else if (!fetcherKey) // We will only fall through here when `useId` is not available
    setFetcherKey($fd8010543425d4bc$var$getUniqueFetcherId());
    // Registration/cleanup
    $6SWiB.useEffect(()=>{
        router.getFetcher(fetcherKey);
        return ()=>{
            // Tell the router we've unmounted - if v7_fetcherPersist is enabled this
            // will not delete immediately but instead queue up a delete after the
            // fetcher returns to an `idle` state
            router.deleteFetcher(fetcherKey);
        };
    }, [
        router,
        fetcherKey
    ]);
    // Fetcher additions
    let load = $6SWiB.useCallback((href, opts)=>{
        !routeId && (0, $dae0ef9fca964cc6$export$3e9cee6b33872309)(false);
        router.fetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        router
    ]);
    let submitImpl = $fd8010543425d4bc$export$47c85c6e3a081d3();
    let submit = $6SWiB.useCallback((target, opts)=>{
        submitImpl(target, $fd8010543425d4bc$var$_extends({}, opts, {
            navigate: false,
            fetcherKey: fetcherKey
        }));
    }, [
        fetcherKey,
        submitImpl
    ]);
    let FetcherForm = $6SWiB.useMemo(()=>{
        let FetcherForm = /*#__PURE__*/ $6SWiB.forwardRef((props, ref)=>{
            return /*#__PURE__*/ $6SWiB.createElement($fd8010543425d4bc$export$a7fed597f4b8afd8, $fd8010543425d4bc$var$_extends({}, props, {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    // Exposed FetcherWithComponents
    let fetcher = state.fetchers.get(fetcherKey) || (0, $dae0ef9fca964cc6$export$52eace9c284d3585);
    let data = fetcherData.get(fetcherKey);
    let fetcherWithComponents = $6SWiB.useMemo(()=>$fd8010543425d4bc$var$_extends({
            Form: FetcherForm,
            submit: submit,
            load: load
        }, fetcher, {
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        fetcher,
        data
    ]);
    return fetcherWithComponents;
}
/**
 * Provides all fetchers currently on the page. Useful for layouts and parent
 * routes that need to provide pending/optimistic UI regarding the fetch.
 */ function $fd8010543425d4bc$export$fa996778a3a31087() {
    let state = $fd8010543425d4bc$var$useDataRouterState($fd8010543425d4bc$var$DataRouterStateHook.UseFetchers);
    return Array.from(state.fetchers.entries()).map((_ref1)=>{
        let [key, fetcher] = _ref1;
        return $fd8010543425d4bc$var$_extends({}, fetcher, {
            key: key
        });
    });
}
const $fd8010543425d4bc$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $fd8010543425d4bc$var$savedScrollPositions = {};
/**
 * When rendered inside a RouterProvider, will restore scroll positions on navigations
 */ function $fd8010543425d4bc$export$25057cfe5591e3e9(_temp4) {
    let { getKey: getKey, storageKey: storageKey } = _temp4 === void 0 ? {} : _temp4;
    let { router: router } = $fd8010543425d4bc$var$useDataRouterContext($fd8010543425d4bc$var$DataRouterHook.UseScrollRestoration);
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = $fd8010543425d4bc$var$useDataRouterState($fd8010543425d4bc$var$DataRouterStateHook.UseScrollRestoration);
    let { basename: basename } = $6SWiB.useContext((0, $576e41193d1785e0$export$26749e8557646306));
    let location = (0, $576e41193d1785e0$export$45d76561a5302f2b)();
    let matches = (0, $576e41193d1785e0$export$2378eb7f5ff86053)();
    let navigation = (0, $576e41193d1785e0$export$d0fd4b7106de2769)();
    // Trigger manual scroll restoration while we're active
    $6SWiB.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    // Save positions on pagehide
    $fd8010543425d4bc$var$usePageHide($6SWiB.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = (getKey ? getKey(location, matches) : null) || location.key;
            $fd8010543425d4bc$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $fd8010543425d4bc$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($fd8010543425d4bc$var$savedScrollPositions));
        } catch (error) {}
        window.history.scrollRestoration = "auto";
    }, [
        storageKey,
        getKey,
        navigation.state,
        location,
        matches
    ]));
    // Read in any saved scroll locations
    if (typeof document !== "undefined") {
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $6SWiB.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $fd8010543425d4bc$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $fd8010543425d4bc$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {
            // no-op, use default empty object
            }
        }, [
            storageKey
        ]);
        // Enable scroll restoration in the router
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $6SWiB.useLayoutEffect(()=>{
            let getKeyWithoutBasename = getKey && basename !== "/" ? (location, matches)=>getKey($fd8010543425d4bc$var$_extends({}, location, {
                    pathname: (0, $dae0ef9fca964cc6$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
                }), matches) : getKey;
            let disableScrollRestoration = router == null ? void 0 : router.enableScrollRestoration($fd8010543425d4bc$var$savedScrollPositions, ()=>window.scrollY, getKeyWithoutBasename);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        // Restore scrolling when state.restoreScrollPosition changes
        // eslint-disable-next-line react-hooks/rules-of-hooks
        $6SWiB.useLayoutEffect(()=>{
            // Explicit false means don't do anything (used for submissions)
            if (restoreScrollPosition === false) return;
            // been here before, scroll to it
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            // try to scroll to the hash
            if (location.hash) {
                let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                if (el) {
                    el.scrollIntoView();
                    return;
                }
            }
            // Don't reset if this navigation opted out
            if (preventScrollReset === true) return;
            // otherwise go to the top on new locations
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
 * Setup a callback to be fired on the window's `beforeunload` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $fd8010543425d4bc$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $6SWiB.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Setup a callback to be fired on the window's `pagehide` event. This is
 * useful for saving some data to `window.localStorage` just before the page
 * refreshes.  This event is better supported than beforeunload across browsers.
 *
 * Note: The `callback` argument should be a function created with
 * `React.useCallback()`.
 */ function $fd8010543425d4bc$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $6SWiB.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : undefined;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
 * Wrapper around useBlocker to show a window.confirm prompt to users instead
 * of building a custom UI with useBlocker.
 *
 * Warning: This has *a lot of rough edges* and behaves very differently (and
 * very incorrectly in some cases) across browsers if user click addition
 * back/forward navigations while the confirm is open.  Use at your own risk.
 */ function $fd8010543425d4bc$export$39f4eb3dbd812741(_ref10) {
    let { when: when, message: message } = _ref10;
    let blocker = (0, $576e41193d1785e0$export$b273b3273281a049)(when);
    $6SWiB.useEffect(()=>{
        if (blocker.state === "blocked") {
            let proceed = window.confirm(message);
            if (proceed) // This timeout is needed to avoid a weird "race" on POP navigations
            // between the `window.history` revert navigation and the result of
            // `window.confirm`
            setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $6SWiB.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
 * Return a boolean indicating if there is an active view transition to the
 * given href.  You can use this value to render CSS classes or viewTransitionName
 * styles onto your elements
 *
 * @param href The destination href
 * @param [opts.relative] Relative routing type ("route" | "path")
 */ function $fd8010543425d4bc$export$e262bd1977bea848(to, opts) {
    if (opts === void 0) opts = {};
    let vtContext = $6SWiB.useContext($fd8010543425d4bc$export$7ad602f0e94e62d1);
    !(vtContext != null) && (0, $dae0ef9fca964cc6$export$3e9cee6b33872309)(false);
    let { basename: basename } = $fd8010543425d4bc$var$useDataRouterContext($fd8010543425d4bc$var$DataRouterHook.useViewTransitionState);
    let path = (0, $576e41193d1785e0$export$e75d2a2d1b3c245b)(to, {
        relative: opts.relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $dae0ef9fca964cc6$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $dae0ef9fca964cc6$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    // Transition is active if we're going to or coming from the indicated
    // destination.  This ensures that other PUSH navigations that reverse
    // an indicated transition apply.  I.e., on the list view you have:
    //
    //   <NavLink to="/details/1" viewTransition>
    //
    // If you click the breadcrumb back to the list view:
    //
    //   <NavLink to="/list" viewTransition>
    //
    // We should apply the transition because it's indicated as active going
    // from /list -> /details/1 and therefore should be active on the reverse
    // (even though this isn't strictly a POP reverse)
    return (0, $dae0ef9fca964cc6$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $dae0ef9fca964cc6$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}


function $b810a898ac334676$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}


function $a5bc2f0ca9d10fc9$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $b810a898ac334676$export$71511d61b312f219)(target, key, source[key]);
        });
    }
    return target;
}


function $bf4fb21d2ea31b30$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $bf4fb21d2ea31b30$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $bf4fb21d2ea31b30$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}




var $6SWiB = parcelRequire("6SWiB");





var $6SWiB = parcelRequire("6SWiB");

const $b9b0c25068e74815$var$isLocalDevelopment = [
    'localhost',
    '127.0.0.1'
].includes(window.location.hostname);
const $b9b0c25068e74815$var$configuredApiBase = $b9b0c25068e74815$var$isLocalDevelopment ? `http://${window.location.hostname}:8484` : 'https://moe-pi.ddns.net/babyplanner-api';
const $b9b0c25068e74815$export$c3ee1e672e1e24e7 = $b9b0c25068e74815$var$configuredApiBase.replace(/\/$/, '');
const $b9b0c25068e74815$export$3e583ea2bc2e9d79 = "5bfc3aac61c4c42d5a750aed2c61c738fe827e300a4925faeed7835d2ac41a40";
function $b9b0c25068e74815$export$28580687276dadf(extraHeaders = {}) {
    return (0, $a5bc2f0ca9d10fc9$export$71511d61b312f219)({
        Authorization: `Bearer ${$b9b0c25068e74815$export$3e583ea2bc2e9d79}`
    }, extraHeaders);
}


var $26c35635f7f7b9b1$exports = {};
$26c35635f7f7b9b1$exports = $parcel$resolve("1ZPz9");


const $00ed64d40f0d09e0$var$veronicaPhoto = new URL($26c35635f7f7b9b1$exports).toString();
var $66df532de143025c$exports = {};
$66df532de143025c$exports = $parcel$resolve("jdZSe");


const $00ed64d40f0d09e0$var$backgroundPhoto = new URL($66df532de143025c$exports).toString();
var $189308772126ec9b$exports = {};
$189308772126ec9b$exports = $parcel$resolve("iIi0I");


const $00ed64d40f0d09e0$var$logoPhoto = new URL($189308772126ec9b$exports).toString();
const $00ed64d40f0d09e0$export$5e3bd82667d603ee = {
    logo: {
        src: $00ed64d40f0d09e0$var$logoPhoto,
        alt: 'Babyplanner Vero'
    },
    hero: {
        src: $00ed64d40f0d09e0$var$veronicaPhoto,
        alt: "Ver\xf3nica Echavarr\xeda, Babyplanner en Uruguay"
    },
    about: {
        src: $00ed64d40f0d09e0$var$veronicaPhoto,
        alt: "Ver\xf3nica Echavarr\xeda acompa\xf1ando maternidades"
    },
    method: {
        src: $00ed64d40f0d09e0$var$backgroundPhoto,
        alt: "Detalles c\xe1lidos para preparar la llegada del beb\xe9"
    },
    services: {
        src: $00ed64d40f0d09e0$var$backgroundPhoto,
        alt: "Elementos para organizar la llegada del beb\xe9"
    },
    contact: {
        src: $00ed64d40f0d09e0$var$veronicaPhoto,
        alt: "Ver\xf3nica Echavarr\xeda"
    }
};
const $00ed64d40f0d09e0$export$bce7a36871692cab = [
    {
        title: "Planificaci\xf3n de la maternidad",
        subtitle: 'Tu hoja de ruta',
        description: "Ordenamos prioridades, compras, espacios y tiempos para recibir a tu beb\xe9 con menos ruido mental y m\xe1s calma.",
        items: [
            "Preparaci\xf3n del hogar",
            'Checklist de esenciales',
            'Rutinas familiares',
            'Plan postparto'
        ]
    },
    {
        title: "Asesor\xeda en lactancia",
        subtitle: "Acompa\xf1amiento claro",
        description: "Resolvemos dudas desde un enfoque respetuoso, pr\xe1ctico y adaptado a tu realidad.",
        items: [
            'Agarre y posiciones',
            "Extracci\xf3n y conservaci\xf3n",
            'Dificultades frecuentes',
            "Contenci\xf3n emocional"
        ]
    },
    {
        title: 'Talleres online',
        subtitle: 'Aprender sin abrumarte',
        description: "Encuentros concretos para prepararte, organizarte y tomar decisiones con informaci\xf3n confiable.",
        items: [
            "Organizaci\xf3n del hogar",
            'Primeros cuidados',
            'Lactancia y rutinas',
            "Bienestar de la mam\xe1"
        ]
    },
    {
        title: "Consultor\xedas personalizadas",
        subtitle: 'Un plan para ustedes',
        description: "Sesiones a medida para mirar tu contexto, resolver preguntas espec\xedficas y avanzar con pasos concretos.",
        items: [
            "Sesi\xf3n de diagn\xf3stico",
            "Plan de acci\xf3n",
            'Recomendaciones',
            'Seguimiento'
        ]
    }
];
const $00ed64d40f0d09e0$export$b522f850768a289b = [
    {
        title: 'Planifica',
        copy: "Definimos qu\xe9 necesitan t\xfa, tu beb\xe9 y tu familia antes de que todo se vuelva urgente."
    },
    {
        title: 'Aprende',
        copy: "Traducimos la sobreinformaci\xf3n en criterios simples para decidir mejor."
    },
    {
        title: 'Siente',
        copy: 'Le damos lugar a tus emociones, expectativas y forma de vivir esta etapa.'
    },
    {
        title: 'Organiza',
        copy: 'Convertimos el plan en espacios, rutinas, listas y acciones posibles.'
    }
];
const $00ed64d40f0d09e0$export$b7e5cef71fa42514 = [
    {
        title: 'Recomendaciones de Amazon',
        copy: "Una selecci\xf3n de productos que recomiendo para el cuidado del beb\xe9 y la mam\xe1.",
        items: [
            "Pijamas c\xf3modos para la mam\xe1",
            "Monitores de beb\xe9",
            'Sillas de auto de alta seguridad',
            "Bolsas para pa\xf1ales"
        ]
    },
    {
        title: 'Mis tiendas preferidas',
        copy: "Espacios que pueden ayudarte a encontrar productos \xfatiles, lindos y pensados para esta etapa.",
        items: [
            "Productos exclusivos para maternidad y beb\xe9",
            "Opciones ecol\xf3gicas y sostenibles",
            "Accesorios y ropa para reci\xe9n nacidos"
        ]
    },
    {
        title: 'Profesionales de confianza',
        copy: "Una red de profesionales recomendados para complementar tu acompa\xf1amiento.",
        items: [
            "Pediatr\xeda",
            'Fisioterapia postparto',
            "Nutrici\xf3n para mam\xe1s y beb\xe9s"
        ]
    }
];
const $00ed64d40f0d09e0$export$24ebf593b331c8aa = [
    {
        name: 'Laura G.',
        quote: "Ver\xf3nica me ayud\xf3 a planificar toda la llegada de mi beb\xe9. Cada detalle estuvo pensado para que nuestra experiencia fuera m\xe1s tranquila."
    },
    {
        name: 'Carolina R.',
        quote: "Con la asesor\xeda en lactancia pude superar mis dificultades y sentirme acompa\xf1ada sin juicios."
    }
];
const $00ed64d40f0d09e0$export$b03c451a0c8ad826 = {
    hero: {
        eyebrow: 'Babyplanner en Uruguay',
        title: "Soy Ver\xf3nica y te ayudo a planificar la llegada de tu beb\xe9 con calma, criterio y mucho amor.",
        description: "Dise\xf1amos una hoja de ruta para que atravieses el embarazo, la lactancia y el postparto con menos sobreinformaci\xf3n y m\xe1s seguridad.",
        primaryButton: "Quiero saber m\xe1s",
        secondaryButton: "Ver mi m\xe9todo"
    },
    lead: {
        eyebrow: "Querida mam\xe1",
        title: "Di adi\xf3s a las noches buscando respuestas sueltas. Este proceso puede sentirse m\xe1s simple.",
        description: "Te acompa\xf1o a ordenar lo pr\xe1ctico y tambi\xe9n lo emocional: qu\xe9 comprar, c\xf3mo preparar la casa, c\xf3mo pensar la lactancia, qu\xe9 rutinas imaginar y qu\xe9 decisiones merecen hacerse a tu manera."
    },
    about: {
        eyebrow: 'Hola',
        title: "Soy Ver\xf3nica Echavarr\xeda, Babyplanner, odont\xf3loga y asesora en lactancia.",
        paragraphs: [
            "Acompa\xf1o a familias que quieren vivir la llegada de su beb\xe9 con organizaci\xf3n, contenci\xf3n y decisiones m\xe1s conscientes. Mi trabajo une planificaci\xf3n, salud, lactancia y una mirada muy humana de esta etapa.",
            'No se trata de tener todo perfecto. Se trata de construir un plan posible para tu casa, tu cuerpo, tus tiempos y tu forma de maternar.'
        ],
        button: "Agenda una conversaci\xf3n"
    },
    method: {
        eyebrow: "Mi m\xe9todo",
        title: "Planifica, aprende, siente y organiza siendo t\xfa.",
        description: "La personalizaci\xf3n es el centro del acompa\xf1amiento. Seleccionamos las \xe1reas que importan para tu familia y convertimos cada duda en un siguiente paso claro."
    },
    services: {
        eyebrow: 'Servicios',
        title: "Elige el acompa\xf1amiento que responda a lo que necesitas hoy."
    },
    callToAction: {
        eyebrow: "\xbfComenzamos?",
        title: "Hacerte la vida m\xe1s f\xe1cil en esta aventura es el punto de partida.",
        button: 'Estoy lista'
    },
    recommendations: {
        eyebrow: 'Recursos',
        title: "Recomendaciones para decidir con m\xe1s calma.",
        description: 'Productos, tiendas y profesionales que pueden ayudarte a preparar esta etapa con criterio y confianza.'
    },
    testimonials: {
        eyebrow: "Lo que dicen de m\xed",
        title: "Historias de mam\xe1s que se sintieron m\xe1s acompa\xf1adas."
    },
    contact: {
        eyebrow: 'Hablemos',
        title: "\xbfDudas? Cu\xe9ntame qu\xe9 necesitas preparar.",
        description: "Si quieres saber c\xf3mo puedo acompa\xf1arte, escr\xedbeme y vemos juntas el mejor punto de partida."
    }
};
const $00ed64d40f0d09e0$export$c1a59dbb44ed20be = {
    images: $00ed64d40f0d09e0$export$5e3bd82667d603ee,
    sections: $00ed64d40f0d09e0$export$b03c451a0c8ad826,
    methodSteps: $00ed64d40f0d09e0$export$b522f850768a289b,
    services: $00ed64d40f0d09e0$export$bce7a36871692cab,
    recommendations: $00ed64d40f0d09e0$export$b7e5cef71fa42514,
    testimonials: $00ed64d40f0d09e0$export$24ebf593b331c8aa
};


// Reemplaza este archivo con el módulo descargado desde /site-admin.
// Al estar versionado, Parcel lo incluye en GitHub Pages como fallback sin backend.
const $b084d896bb3f2e6b$export$e704e6c4f87f58c1 = null;


function $27d7bdbf046acfb1$var$mergeSiteContent(content, fallback) {
    if (!content) return fallback;
    const sections = Object.fromEntries(Object.entries(fallback.sections).map(([key, fields])=>{
        var _content_sections;
        return [
            key,
            (0, $a5bc2f0ca9d10fc9$export$71511d61b312f219)({}, fields, ((_content_sections = content.sections) === null || _content_sections === void 0 ? void 0 : _content_sections[key]) || {})
        ];
    }));
    return (0, $bf4fb21d2ea31b30$export$71511d61b312f219)((0, $a5bc2f0ca9d10fc9$export$71511d61b312f219)({}, fallback, content), {
        images: (0, $a5bc2f0ca9d10fc9$export$71511d61b312f219)({}, fallback.images, content.images || {}),
        sections: sections,
        methodSteps: Array.isArray(content.methodSteps) ? content.methodSteps : fallback.methodSteps,
        services: Array.isArray(content.services) ? content.services : fallback.services,
        recommendations: Array.isArray(content.recommendations) ? content.recommendations : fallback.recommendations,
        testimonials: Array.isArray(content.testimonials) ? content.testimonials : fallback.testimonials
    });
}
const $27d7bdbf046acfb1$export$ee693cb47e01ebc6 = $27d7bdbf046acfb1$var$mergeSiteContent((0, $b084d896bb3f2e6b$export$e704e6c4f87f58c1), (0, $00ed64d40f0d09e0$export$c1a59dbb44ed20be));
function $27d7bdbf046acfb1$export$8eaa4b3dca4db648(content) {
    return $27d7bdbf046acfb1$var$mergeSiteContent(content, $27d7bdbf046acfb1$export$ee693cb47e01ebc6);
}
const $27d7bdbf046acfb1$var$SiteContentContext = /*#__PURE__*/ (0, $6SWiB.createContext)($27d7bdbf046acfb1$export$ee693cb47e01ebc6);
function $27d7bdbf046acfb1$export$1ea66d1b3c07dae9(src) {
    if (!src || /^(https?:|data:|blob:)/.test(src)) return src;
    return `${0, $b9b0c25068e74815$export$c3ee1e672e1e24e7}${src.startsWith('/') ? '' : '/'}${src}`;
}
function $27d7bdbf046acfb1$export$c04d0574b227a65d({ children: children }) {
    const [content, setContent] = (0, $6SWiB.useState)($27d7bdbf046acfb1$export$ee693cb47e01ebc6);
    (0, $6SWiB.useEffect)(()=>{
        let active = true;
        fetch(`${(0, $b9b0c25068e74815$export$c3ee1e672e1e24e7)}/api/site-content`).then((response)=>response.ok ? response.json() : Promise.reject()).then((data)=>{
            if (active && data.content) setContent($27d7bdbf046acfb1$export$8eaa4b3dca4db648(data.content));
        }).catch(()=>{
        // GitHub Pages sigue usando el snapshot incluido en el build.
        });
        return ()=>{
            active = false;
        };
    }, []);
    const value = (0, $6SWiB.useMemo)(()=>content, [
        content
    ]);
    return /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)($27d7bdbf046acfb1$var$SiteContentContext.Provider, {
        value: value,
        children: children
    });
}
function $27d7bdbf046acfb1$export$89d825f022a4b803() {
    return (0, $6SWiB.useContext)($27d7bdbf046acfb1$var$SiteContentContext);
}




var $6SWiB = parcelRequire("6SWiB");
const $e2d39f2491491e0d$var$DEFAULT_FONT_SIZE = 100;
function $e2d39f2491491e0d$export$d3aab33c7c2e65f2() {
    const [theme, setTheme] = (0, $6SWiB.useState)(()=>localStorage.getItem("babyplanner_theme") || "light");
    const [fontSize, setFontSize] = (0, $6SWiB.useState)(()=>Number(localStorage.getItem("babyplanner_font") || $e2d39f2491491e0d$var$DEFAULT_FONT_SIZE));
    (0, $6SWiB.useEffect)(()=>{
        document.documentElement.dataset.theme = theme;
        localStorage.setItem("babyplanner_theme", theme);
    }, [
        theme
    ]);
    (0, $6SWiB.useEffect)(()=>{
        document.documentElement.style.setProperty("--font-scale", String(fontSize / $e2d39f2491491e0d$var$DEFAULT_FONT_SIZE));
        localStorage.setItem("babyplanner_font", String(fontSize));
    }, [
        fontSize
    ]);
    return {
        theme: theme,
        setTheme: setTheme,
        fontSize: fontSize,
        setFontSize: setFontSize
    };
}




var $6SWiB = parcelRequire("6SWiB");

const $012530f2a7d9abca$var$Context = /*#__PURE__*/ (0, $6SWiB.createContext)(null);
function $012530f2a7d9abca$export$88f24fd8fcfab6ca({ children: children }) {
    const [user, setUser] = (0, $6SWiB.useState)(()=>JSON.parse(localStorage.getItem("babyplanner_user") || "null"));
    const [token, setToken] = (0, $6SWiB.useState)(()=>localStorage.getItem("babyplanner_user_token") || "");
    const save = (d)=>{
        setUser(d.user);
        setToken(d.accessToken);
        localStorage.setItem("babyplanner_user", JSON.stringify(d.user));
        localStorage.setItem("babyplanner_user_token", d.accessToken);
    };
    const auth = async (path, body)=>{
        const r = await fetch((0, $b9b0c25068e74815$export$c3ee1e672e1e24e7) + path, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(body)
        });
        const d = await r.json();
        if (!r.ok) throw Error(d.error || "No se pudo completar la operaci\xf3n.");
        save(d);
    };
    const logout = ()=>{
        setUser(null);
        setToken("");
        localStorage.removeItem("babyplanner_user");
        localStorage.removeItem("babyplanner_user_token");
    };
    return /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)($012530f2a7d9abca$var$Context.Provider, {
        value: {
            user: user,
            token: token,
            login: (b)=>auth("/api/auth/login", b),
            register: (b)=>auth("/api/auth/register", b),
            logout: logout
        },
        children: children
    });
}
const $012530f2a7d9abca$export$23bbbc4533528f03 = ()=>(0, $6SWiB.useContext)($012530f2a7d9abca$var$Context);




const $cf3024de9b7a6a1b$var$navItems = [
    {
        href: '#inicio',
        label: 'Inicio'
    },
    {
        href: '#sobre-mi',
        label: "Sobre m\xed"
    },
    {
        href: '#servicios',
        label: 'Servicios'
    },
    {
        href: '#recomendaciones',
        label: 'Recomendaciones'
    },
    {
        href: '#testimonios',
        label: 'Testimonios'
    },
    {
        href: '#contacto',
        label: 'Contacto',
        cta: true
    }
];
function $cf3024de9b7a6a1b$var$Navbar() {
    const [isOpen, setIsOpen] = (0, $6SWiB.useState)(false);
    const navigate = (0, $576e41193d1785e0$export$9770f232ac06a008)();
    const { images: images } = (0, $27d7bdbf046acfb1$export$89d825f022a4b803)();
    const { theme: theme, setTheme: setTheme, fontSize: fontSize, setFontSize: setFontSize } = (0, $e2d39f2491491e0d$export$d3aab33c7c2e65f2)();
    const { user: user, login: login, register: register, logout: logout } = (0, $012530f2a7d9abca$export$23bbbc4533528f03)();
    const [authOpen, setAuthOpen] = (0, $6SWiB.useState)(false);
    const [mode, setMode] = (0, $6SWiB.useState)("login");
    const [form, setForm] = (0, $6SWiB.useState)({
        name: "",
        email: "",
        password: "",
        passwordConfirm: "",
        captchaAnswer: "",
        website: ""
    });
    const [captcha, setCaptcha] = (0, $6SWiB.useState)({
        question: "",
        token: ""
    });
    const [error, setError] = (0, $6SWiB.useState)("");
    const submitAuth = async (event)=>{
        event.preventDefault();
        setError("");
        try {
            await (mode === "login" ? login(form) : register((0, $bf4fb21d2ea31b30$export$71511d61b312f219)((0, $a5bc2f0ca9d10fc9$export$71511d61b312f219)({}, form), {
                captchaToken: captcha.token
            })));
            setAuthOpen(false);
        } catch (e) {
            setError(e.message);
        }
    };
    (0, $6SWiB.useEffect)(()=>{
        if (!authOpen || mode !== "register") return;
        fetch((0, $b9b0c25068e74815$export$c3ee1e672e1e24e7) + "/api/auth/captcha").then((r)=>r.json()).then(setCaptcha).catch(()=>setError("No se pudo cargar la verificaci\xf3n anti-bots."));
    }, [
        authOpen,
        mode
    ]);
    const closeMenu = ()=>setIsOpen(false);
    const goToSection = (event, href)=>{
        event.preventDefault();
        const id = href.replace(/^#/, "");
        const scroll = ()=>{
            var _document_getElementById;
            return (_document_getElementById = document.getElementById(id)) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.scrollIntoView({
                behavior: "smooth"
            });
        };
        if (window.location.hash !== "#/" && window.location.hash !== "") {
            navigate("/");
            window.setTimeout(scroll, 80);
        } else scroll();
        closeMenu();
    };
    return /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("header", {
        className: "site-header",
        children: [
            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("nav", {
                className: "navbar",
                "aria-label": "Principal",
                children: [
                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("a", {
                        href: "#inicio",
                        className: "brand",
                        onClick: (event)=>goToSection(event, "#inicio"),
                        children: [
                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("img", {
                                src: (0, $27d7bdbf046acfb1$export$1ea66d1b3c07dae9)(images.logo.src),
                                alt: images.logo.alt,
                                className: "logo"
                            }),
                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("span", {
                                className: "brand-copy",
                                children: [
                                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("strong", {
                                        children: "Vero Echavarria"
                                    }),
                                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("span", {
                                        children: "Mentora en maternidad"
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("button", {
                        className: `hamburger ${isOpen ? 'is-open' : ''}`,
                        type: "button",
                        onClick: ()=>setIsOpen(!isOpen),
                        "aria-label": "Abrir navegaci\xf3n",
                        "aria-expanded": isOpen,
                        children: [
                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("span", {
                                className: "bar"
                            }),
                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("span", {
                                className: "bar"
                            }),
                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("span", {
                                className: "bar"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("div", {
                        className: `nav-links ${isOpen ? 'open' : ''}`,
                        children: [
                            user && /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("a", {
                                href: "#/blog",
                                className: "nav-link",
                                onClick: closeMenu,
                                children: "Mi blog"
                            }),
                            $cf3024de9b7a6a1b$var$navItems.map((item)=>/*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("a", {
                                    href: item.href,
                                    className: `nav-link ${item.cta ? 'nav-cta' : ''}`,
                                    onClick: (event)=>goToSection(event, item.href),
                                    children: item.label
                                }, item.href))
                        ]
                    }),
                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("div", {
                        className: "accessibility-tools",
                        "aria-label": "Preferencias del sitio",
                        children: [
                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>setFontSize(Math.max(85, fontSize - 10)),
                                "aria-label": "Achicar letra",
                                children: "A\u2212"
                            }),
                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>setFontSize(Math.min(125, fontSize + 10)),
                                "aria-label": "Agrandar letra",
                                children: "A+"
                            }),
                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>setTheme(theme === "light" ? "dark" : "light"),
                                "aria-label": "Cambiar tema",
                                children: theme === "light" ? "\u263E" : "\u2600"
                            }),
                            user ? /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("button", {
                                type: "button",
                                className: "user-button",
                                onClick: ()=>setAuthOpen(true),
                                children: user.name
                            }) : /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("button", {
                                type: "button",
                                className: "user-button",
                                onClick: ()=>{
                                    setMode("login");
                                    setAuthOpen(true);
                                },
                                children: "Ingresar"
                            })
                        ]
                    })
                ]
            }),
            authOpen && /*#__PURE__*/ (0, $ac53942f71d960c8$exports.createPortal)(/*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("div", {
                className: "auth-overlay",
                role: "dialog",
                "aria-modal": "true",
                children: /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("section", {
                    className: "auth-card",
                    children: user ? /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)((0, $8c08c62dc09ea562$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("p", {
                                className: "eyebrow",
                                children: "Mi perfil"
                            }),
                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("h2", {
                                children: user.name
                            }),
                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("p", {
                                children: user.email
                            }),
                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("button", {
                                className: "button button-primary",
                                onClick: logout,
                                children: "Cerrar sesi\xf3n"
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)((0, $8c08c62dc09ea562$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("button", {
                                className: "auth-close",
                                onClick: ()=>setAuthOpen(false),
                                "aria-label": "Cerrar",
                                children: "\xd7"
                            }),
                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("p", {
                                className: "eyebrow",
                                children: "\xc1rea personal"
                            }),
                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("h2", {
                                children: mode === "login" ? "Ingresar" : "Crear cuenta"
                            }),
                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("form", {
                                className: "form-grid",
                                onSubmit: submitAuth,
                                children: [
                                    mode === "register" && /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("label", {
                                                htmlFor: "auth-name",
                                                children: "Nombre"
                                            }),
                                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("input", {
                                                id: "auth-name",
                                                required: true,
                                                value: form.name,
                                                onChange: (e)=>setForm((0, $bf4fb21d2ea31b30$export$71511d61b312f219)((0, $a5bc2f0ca9d10fc9$export$71511d61b312f219)({}, form), {
                                                        name: e.target.value
                                                    }))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("label", {
                                                htmlFor: "auth-email",
                                                children: "Email"
                                            }),
                                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("input", {
                                                id: "auth-email",
                                                type: "email",
                                                required: true,
                                                value: form.email,
                                                onChange: (e)=>setForm((0, $bf4fb21d2ea31b30$export$71511d61b312f219)((0, $a5bc2f0ca9d10fc9$export$71511d61b312f219)({}, form), {
                                                        email: e.target.value
                                                    }))
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("label", {
                                                htmlFor: "auth-password",
                                                children: "Contrase\xf1a"
                                            }),
                                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("input", {
                                                id: "auth-password",
                                                type: "password",
                                                minLength: "8",
                                                required: true,
                                                value: form.password,
                                                onChange: (e)=>setForm((0, $bf4fb21d2ea31b30$export$71511d61b312f219)((0, $a5bc2f0ca9d10fc9$export$71511d61b312f219)({}, form), {
                                                        password: e.target.value
                                                    }))
                                            })
                                        ]
                                    }),
                                    mode === "register" && /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)((0, $8c08c62dc09ea562$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("label", {
                                                        htmlFor: "auth-password-confirm",
                                                        children: "Repetir contrase\xf1a"
                                                    }),
                                                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("input", {
                                                        id: "auth-password-confirm",
                                                        type: "password",
                                                        minLength: "8",
                                                        required: true,
                                                        value: form.passwordConfirm,
                                                        onChange: (e)=>setForm((0, $bf4fb21d2ea31b30$export$71511d61b312f219)((0, $a5bc2f0ca9d10fc9$export$71511d61b312f219)({}, form), {
                                                                passwordConfirm: e.target.value
                                                            }))
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("div", {
                                                className: "form-field",
                                                children: [
                                                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("label", {
                                                        htmlFor: "auth-captcha",
                                                        children: captcha.question || "Cargando verificaci\xf3n\u2026"
                                                    }),
                                                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("input", {
                                                        id: "auth-captcha",
                                                        inputMode: "numeric",
                                                        required: true,
                                                        value: form.captchaAnswer,
                                                        onChange: (e)=>setForm((0, $bf4fb21d2ea31b30$export$71511d61b312f219)((0, $a5bc2f0ca9d10fc9$export$71511d61b312f219)({}, form), {
                                                                captchaAnswer: e.target.value
                                                            }))
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("input", {
                                                className: "honeypot",
                                                tabIndex: "-1",
                                                autoComplete: "off",
                                                "aria-hidden": "true",
                                                value: form.website,
                                                onChange: (e)=>setForm((0, $bf4fb21d2ea31b30$export$71511d61b312f219)((0, $a5bc2f0ca9d10fc9$export$71511d61b312f219)({}, form), {
                                                        website: e.target.value
                                                    }))
                                            })
                                        ]
                                    }),
                                    error && /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("p", {
                                        className: "form-status error",
                                        children: error
                                    }),
                                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("button", {
                                        className: "button button-primary",
                                        type: "submit",
                                        children: mode === "login" ? "Ingresar" : "Registrarme"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("button", {
                                className: "text-link",
                                type: "button",
                                onClick: ()=>setMode(mode === "login" ? "register" : "login"),
                                children: mode === "login" ? "Crear una cuenta" : "Ya tengo una cuenta"
                            })
                        ]
                    })
                })
            }), document.body)
        ]
    });
}
var $cf3024de9b7a6a1b$export$2e2bcd8739ae039 = $cf3024de9b7a6a1b$var$Navbar;



parcelRequire("6SWiB");
function $353fdf8b9828132f$var$Footer() {
    return /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("footer", {
        className: "site-footer",
        children: /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("div", {
            className: "footer-inner",
            children: [
                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("p", {
                    children: "Mi prop\xf3sito es ayudarte a vivir una maternidad plena, organizada y feliz."
                }),
                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("div", {
                    className: "footer-links",
                    children: [
                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("a", {
                            href: "/",
                            children: "Pol\xedtica de Privacidad"
                        }),
                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("a", {
                            href: "/",
                            children: "T\xe9rminos y Condiciones"
                        }),
                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("a", {
                            href: "https://instagram.com",
                            target: "_blank",
                            rel: "noreferrer",
                            children: "Instagram"
                        }),
                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("a", {
                            href: "https://facebook.com",
                            target: "_blank",
                            rel: "noreferrer",
                            children: "Facebook"
                        }),
                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("a", {
                            href: "https://linkedin.com",
                            target: "_blank",
                            rel: "noreferrer",
                            children: "LinkedIn"
                        })
                    ]
                })
            ]
        })
    });
}
var $353fdf8b9828132f$export$2e2bcd8739ae039 = $353fdf8b9828132f$var$Footer;






var $6SWiB = parcelRequire("6SWiB");

const $78c2c76c73ab90b3$var$quickReplies = [
    'Quiero conocer los servicios',
    'Necesito ayuda con lactancia',
    "Quiero organizar la llegada del beb\xe9"
];
function $78c2c76c73ab90b3$var$createSessionId() {
    var _window_crypto;
    if ((_window_crypto = window.crypto) === null || _window_crypto === void 0 ? void 0 : _window_crypto.randomUUID) return `chat_${window.crypto.randomUUID()}`;
    return `chat_${Date.now()}_${Math.random().toString(16).slice(2)}`;
}
function $78c2c76c73ab90b3$var$normalizeMessages(messages) {
    return messages.map((message)=>(0, $bf4fb21d2ea31b30$export$71511d61b312f219)((0, $a5bc2f0ca9d10fc9$export$71511d61b312f219)({}, message), {
            sender: message.sender === 'admin' ? 'bot admin' : message.sender,
            text: message.sender === 'admin' && message.displayName ? message.displayName + ': ' + message.text : message.text
        }));
}
function $78c2c76c73ab90b3$var$renderMessageText(text) {
    const parts = text.split(/(https?:\/\/[^\s]+)/g);
    return parts.map((part, index)=>{
        if (!part.match(/^https?:\/\//)) return part;
        const href = part.replace(/[.,;!?]+$/, '');
        const suffix = part.slice(href.length);
        const label = href.includes('#contacto') ? 'Ir al formulario de contacto' : href;
        return /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($6SWiB))).Fragment, {
            children: [
                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("a", {
                    href: href,
                    children: label
                }),
                suffix
            ]
        }, `message-link-${index}`);
    });
}
function $78c2c76c73ab90b3$var$ChatWidget() {
    const [isOpen, setIsOpen] = (0, $6SWiB.useState)(false);
    const [input, setInput] = (0, $6SWiB.useState)('');
    const [isLoading, setIsLoading] = (0, $6SWiB.useState)(false);
    const [adminActive, setAdminActive] = (0, $6SWiB.useState)(false);
    const [isMessagingHealthy, setIsMessagingHealthy] = (0, $6SWiB.useState)(false);
    const [sessionId] = (0, $6SWiB.useState)(()=>{
        const savedSessionId = window.localStorage.getItem('babyplanner_chat_session');
        const nextSessionId = savedSessionId || $78c2c76c73ab90b3$var$createSessionId();
        window.localStorage.setItem('babyplanner_chat_session', nextSessionId);
        return nextSessionId;
    });
    const [messages, setMessages] = (0, $6SWiB.useState)([
        {
            id: 'initial_message',
            sender: 'bot',
            text: "\xa1Hola! Soy el asistente de Babyplanner Vero. Puedo ayudarte a encontrar el servicio ideal o resolver dudas iniciales."
        }
    ]);
    const messagesRef = (0, $6SWiB.useRef)(null);
    const unreadLabel = (0, $6SWiB.useMemo)(()=>isOpen ? 'Cerrar chat' : 'Abrir chat', [
        isOpen
    ]);
    const syncSession = async ()=>{
        try {
            var _data_messages;
            const response = await fetch(`${(0, $b9b0c25068e74815$export$c3ee1e672e1e24e7)}/api/chat/${sessionId}`, {
                headers: (0, $b9b0c25068e74815$export$28580687276dadf)()
            });
            if (!response.ok) return;
            const data = await response.json();
            if ((_data_messages = data.messages) === null || _data_messages === void 0 ? void 0 : _data_messages.length) setMessages($78c2c76c73ab90b3$var$normalizeMessages(data.messages));
            setAdminActive(Boolean(data.adminActive));
        } catch (error) {
        // El backend del chat puede estar apagado durante la vista local.
        }
    };
    (0, $6SWiB.useEffect)(()=>{
        syncSession();
        const interval = window.setInterval(syncSession, 3000);
        return ()=>window.clearInterval(interval);
    }, [
        sessionId
    ]);
    (0, $6SWiB.useEffect)(()=>{
        let active = true;
        const checkMessagingHealth = async ()=>{
            try {
                var _data_lmStudio, _data_ollama;
                const response = await fetch(`${(0, $b9b0c25068e74815$export$c3ee1e672e1e24e7)}/api/health`);
                if (!response.ok) throw new Error('Health no disponible');
                const data = await response.json();
                const providerAvailable = Boolean(data.activeChatProvider || ((_data_lmStudio = data.lmStudio) === null || _data_lmStudio === void 0 ? void 0 : _data_lmStudio.available) || ((_data_ollama = data.ollama) === null || _data_ollama === void 0 ? void 0 : _data_ollama.available));
                if (active) setIsMessagingHealthy(providerAvailable);
            } catch (error) {
                if (active) setIsMessagingHealthy(false);
            }
        };
        checkMessagingHealth();
        const interval = window.setInterval(checkMessagingHealth, 30000);
        return ()=>{
            active = false;
            window.clearInterval(interval);
        };
    }, []);
    (0, $6SWiB.useEffect)(()=>{
        if (messagesRef.current) messagesRef.current.scrollTop = messagesRef.current.scrollHeight;
    }, [
        messages,
        isLoading
    ]);
    const sendMessage = async (text)=>{
        const trimmed = text.trim();
        if (!trimmed || isLoading) return;
        const optimisticUserMessage = {
            id: `pending_${Date.now()}`,
            sender: 'user',
            text: trimmed
        };
        setMessages((currentMessages)=>[
                ...currentMessages,
                optimisticUserMessage
            ]);
        setInput('');
        setIsOpen(true);
        setIsLoading(true);
        try {
            const response = await fetch(`${(0, $b9b0c25068e74815$export$c3ee1e672e1e24e7)}/api/chat`, {
                method: 'POST',
                headers: (0, $b9b0c25068e74815$export$28580687276dadf)({
                    'Content-Type': 'application/json'
                }),
                body: JSON.stringify({
                    sessionId: sessionId,
                    message: trimmed
                })
            });
            const data = await response.json();
            if (!response.ok && !data.messages) throw new Error(data.error || 'No se pudo enviar el mensaje.');
            setMessages($78c2c76c73ab90b3$var$normalizeMessages(data.messages || []));
            setAdminActive(Boolean(data.adminActive));
        } catch (error) {
            setMessages((currentMessages)=>[
                    ...currentMessages,
                    {
                        id: `error_${Date.now()}`,
                        sender: 'bot error',
                        text: "No pude conectar con el servidor del chat. Int\xe9ntalo nuevamente en unos minutos."
                    }
                ]);
        // El backend del chat puede estar apagado durante la vista local.
        } finally{
            setIsLoading(false);
        }
    };
    const handleSubmit = (event)=>{
        event.preventDefault();
        sendMessage(input);
    };
    return /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("div", {
        className: `chat-widget ${isOpen ? 'is-open' : ''}`,
        children: [
            isOpen && /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("section", {
                className: "chat-panel",
                "aria-label": "Chat de Babyplanner Vero",
                children: [
                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("header", {
                        className: "chat-header",
                        children: [
                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("span", {
                                        className: "chat-status"
                                    }),
                                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("strong", {
                                        children: "Babyplanner Vero"
                                    }),
                                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("p", {
                                        children: adminActive ? 'Te responde una persona' : 'Asistente con LM Studio'
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("button", {
                                type: "button",
                                className: "chat-close",
                                onClick: ()=>setIsOpen(false),
                                "aria-label": "Cerrar chat",
                                children: "\xd7"
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("div", {
                        className: "chat-messages",
                        "aria-live": "polite",
                        ref: messagesRef,
                        children: [
                            messages.map((message)=>/*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("div", {
                                    className: `chat-message ${message.sender}`,
                                    children: $78c2c76c73ab90b3$var$renderMessageText(message.text)
                                }, message.id)),
                            isLoading && /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("div", {
                                className: "chat-message bot typing",
                                children: [
                                    adminActive ? 'Enviando' : 'Escribiendo',
                                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("span", {
                                        children: "."
                                    }),
                                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("span", {
                                        children: "."
                                    }),
                                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("span", {
                                        children: "."
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("div", {
                        className: "chat-quick-replies",
                        "aria-label": "Respuestas r\xe1pidas",
                        children: $78c2c76c73ab90b3$var$quickReplies.map((reply)=>/*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("button", {
                                type: "button",
                                onClick: ()=>sendMessage(reply),
                                disabled: isLoading,
                                children: reply
                            }, reply))
                    }),
                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("form", {
                        className: "chat-form",
                        onSubmit: handleSubmit,
                        children: [
                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("input", {
                                type: "text",
                                value: input,
                                onChange: (event)=>setInput(event.target.value),
                                placeholder: "Escribe tu consulta...",
                                "aria-label": "Mensaje para el chat",
                                disabled: isLoading
                            }),
                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("button", {
                                type: "submit",
                                disabled: isLoading || !input.trim(),
                                children: isLoading ? '...' : 'Enviar'
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("button", {
                type: "button",
                className: "chat-toggle",
                onClick: ()=>setIsOpen(!isOpen),
                "aria-label": unreadLabel,
                "aria-expanded": isOpen,
                children: [
                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("span", {
                        className: "chat-toggle-icon",
                        children: isOpen ? "\xd7" : 'Chat'
                    }),
                    !isOpen && /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("span", {
                        className: `chat-notification ${isMessagingHealthy ? 'is-healthy' : ''}`,
                        title: isMessagingHealthy ? "Mensajer\xeda disponible" : "Mensajer\xeda no disponible",
                        children: "1"
                    })
                ]
            })
        ]
    });
}
var $78c2c76c73ab90b3$export$2e2bcd8739ae039 = $78c2c76c73ab90b3$var$ChatWidget;






var $6SWiB = parcelRequire("6SWiB");


function $a2bbadb3646a394d$var$Home() {
    const { images: images, sections: sections, methodSteps: methodSteps, recommendations: recommendations, services: services, testimonials: testimonials } = (0, $27d7bdbf046acfb1$export$89d825f022a4b803)();
    const [formData, setFormData] = (0, $6SWiB.useState)({
        nombre: '',
        email: '',
        mensaje: ''
    });
    const [isSubmitting, setIsSubmitting] = (0, $6SWiB.useState)(false);
    const [submitStatus, setSubmitStatus] = (0, $6SWiB.useState)({
        type: '',
        message: ''
    });
    const handleChange = (event)=>{
        setFormData((0, $bf4fb21d2ea31b30$export$71511d61b312f219)((0, $a5bc2f0ca9d10fc9$export$71511d61b312f219)({}, formData), {
            [event.target.name]: event.target.value
        }));
    };
    const handleSubmit = async (event)=>{
        event.preventDefault();
        setIsSubmitting(true);
        setSubmitStatus({
            type: '',
            message: ''
        });
        try {
            const response = await fetch(`${(0, $b9b0c25068e74815$export$c3ee1e672e1e24e7)}/api/contact`, {
                method: 'POST',
                headers: (0, $b9b0c25068e74815$export$28580687276dadf)({
                    'Content-Type': 'application/json'
                }),
                body: JSON.stringify(formData)
            });
            const data = await response.json().catch(()=>({}));
            if (!response.ok) throw new Error(data.error || "No se pudo enviar el mensaje. Int\xe9ntalo nuevamente.");
            setFormData({
                nombre: '',
                email: '',
                mensaje: ''
            });
            setSubmitStatus({
                type: 'success',
                message: "Mensaje recibido. Gracias por contactarme; te responder\xe9 a la brevedad."
            });
        } catch (error) {
            setSubmitStatus({
                type: 'error',
                message: error.message || "No se pudo enviar el mensaje. Int\xe9ntalo nuevamente."
            });
        } finally{
            setIsSubmitting(false);
        }
    };
    return /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("main", {
        className: "one-page editorial-site",
        children: [
            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("section", {
                id: "inicio",
                className: "editorial-hero one-page-section",
                children: [
                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("div", {
                        className: "editorial-hero-copy",
                        children: [
                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("p", {
                                className: "eyebrow",
                                children: sections.hero.eyebrow
                            }),
                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("h1", {
                                children: sections.hero.title
                            }),
                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("p", {
                                children: sections.hero.description
                            }),
                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("div", {
                                className: "hero-actions",
                                children: [
                                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("a", {
                                        href: "#servicios",
                                        className: "button button-primary",
                                        children: sections.hero.primaryButton
                                    }),
                                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("a", {
                                        href: "#metodo",
                                        className: "button button-secondary",
                                        children: sections.hero.secondaryButton
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("figure", {
                        className: "editorial-hero-media",
                        children: /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("img", {
                            src: (0, $27d7bdbf046acfb1$export$1ea66d1b3c07dae9)(images.hero.src),
                            alt: images.hero.alt
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("section", {
                className: "lead-feature one-page-section",
                children: [
                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("p", {
                                className: "eyebrow",
                                children: sections.lead.eyebrow
                            }),
                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("h2", {
                                children: sections.lead.title
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("p", {
                        children: sections.lead.description
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("section", {
                id: "sobre-mi",
                className: "story-section one-page-section",
                children: [
                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("figure", {
                        className: "story-image tall",
                        children: /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("img", {
                            src: (0, $27d7bdbf046acfb1$export$1ea66d1b3c07dae9)(images.about.src),
                            alt: images.about.alt
                        })
                    }),
                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("article", {
                        className: "story-copy",
                        children: [
                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("p", {
                                className: "eyebrow",
                                children: sections.about.eyebrow
                            }),
                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("h2", {
                                children: sections.about.title
                            }),
                            sections.about.paragraphs.map((paragraph, index)=>/*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("p", {
                                    children: paragraph
                                }, index)),
                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("a", {
                                href: "#contacto",
                                className: "text-link",
                                children: sections.about.button
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("section", {
                id: "metodo",
                className: "method-section one-page-section",
                children: [
                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("div", {
                        className: "method-intro",
                        children: [
                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("p", {
                                className: "eyebrow",
                                children: sections.method.eyebrow
                            }),
                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("h2", {
                                children: sections.method.title
                            }),
                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("p", {
                                children: sections.method.description
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("div", {
                        className: "method-grid",
                        children: methodSteps.map((step, index)=>/*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("article", {
                                className: "method-card",
                                children: [
                                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("span", {
                                        children: String(index + 1).padStart(2, '0')
                                    }),
                                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("h3", {
                                        children: step.title
                                    }),
                                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("p", {
                                        children: step.copy
                                    })
                                ]
                            }, step.title))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("section", {
                id: "servicios",
                className: "services-showcase one-page-section",
                children: [
                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("header", {
                        className: "section-header centered-heading",
                        children: [
                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("p", {
                                className: "eyebrow",
                                children: sections.services.eyebrow
                            }),
                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("h2", {
                                children: sections.services.title
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("div", {
                        className: "service-list",
                        children: services.map((service, index)=>/*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("article", {
                                className: "service-row",
                                children: [
                                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("div", {
                                        className: "service-number",
                                        children: String(index + 1).padStart(2, '0')
                                    }),
                                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("div", {
                                        children: [
                                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("p", {
                                                className: "service-subtitle",
                                                children: service.subtitle
                                            }),
                                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("h3", {
                                                children: service.title
                                            }),
                                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("p", {
                                                children: service.description
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("ul", {
                                        children: service.items.map((item)=>/*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("li", {
                                                children: item
                                            }, item))
                                    })
                                ]
                            }, service.title))
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("section", {
                className: "full-bleed-cta one-page-section",
                children: [
                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("img", {
                        src: (0, $27d7bdbf046acfb1$export$1ea66d1b3c07dae9)(images.method.src),
                        alt: images.method.alt
                    }),
                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("p", {
                                className: "eyebrow",
                                children: sections.callToAction.eyebrow
                            }),
                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("h2", {
                                children: sections.callToAction.title
                            }),
                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("a", {
                                href: "#contacto",
                                className: "button button-primary",
                                children: sections.callToAction.button
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("section", {
                id: "recomendaciones",
                className: "page-shell one-page-section",
                children: /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("div", {
                    className: "narrow-container",
                    children: [
                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("header", {
                            className: "section-header",
                            children: [
                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("p", {
                                    className: "eyebrow",
                                    children: sections.recommendations.eyebrow
                                }),
                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("h2", {
                                    children: sections.recommendations.title
                                }),
                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("p", {
                                    className: "section-lede",
                                    children: sections.recommendations.description
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("div", {
                            className: "recommendation-stack",
                            children: recommendations.map((section)=>/*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("article", {
                                    className: "recommendation-card",
                                    children: [
                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("h3", {
                                            children: section.title
                                        }),
                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("p", {
                                            children: section.copy
                                        }),
                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("ul", {
                                            className: "feature-list",
                                            children: section.items.map((item)=>/*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("li", {
                                                    children: item
                                                }, item))
                                        }),
                                        section.href && /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("a", {
                                            className: "text-link",
                                            href: section.href,
                                            target: "_blank",
                                            rel: "noreferrer",
                                            children: section.cta
                                        })
                                    ]
                                }, section.title))
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("section", {
                id: "testimonios",
                className: "testimonial-band one-page-section",
                children: /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("div", {
                    className: "container",
                    children: [
                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("header", {
                            className: "section-header centered-heading",
                            children: [
                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("p", {
                                    className: "eyebrow",
                                    children: sections.testimonials.eyebrow
                                }),
                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("h2", {
                                    children: sections.testimonials.title
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("div", {
                            className: "testimonials-grid",
                            children: testimonials.map((testimonial)=>/*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("article", {
                                    className: "modern-card",
                                    children: [
                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("div", {
                                            className: "quote-mark",
                                            children: "\u201C"
                                        }),
                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("p", {
                                            children: testimonial.quote
                                        }),
                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("h4", {
                                            children: testimonial.name
                                        })
                                    ]
                                }, testimonial.name))
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("section", {
                id: "contacto",
                className: "contact-split one-page-section",
                children: [
                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("figure", {
                        children: /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("img", {
                            src: (0, $27d7bdbf046acfb1$export$1ea66d1b3c07dae9)(images.contact.src),
                            alt: images.contact.alt
                        })
                    }),
                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("div", {
                        className: "contact-card",
                        children: [
                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("p", {
                                className: "eyebrow",
                                children: sections.contact.eyebrow
                            }),
                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("h2", {
                                children: sections.contact.title
                            }),
                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("p", {
                                className: "section-lede",
                                children: sections.contact.description
                            }),
                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("form", {
                                onSubmit: handleSubmit,
                                className: "form-grid",
                                children: [
                                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("label", {
                                                htmlFor: "nombre",
                                                children: "Nombre"
                                            }),
                                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("input", {
                                                id: "nombre",
                                                type: "text",
                                                name: "nombre",
                                                value: formData.nombre,
                                                onChange: handleChange,
                                                required: true
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("label", {
                                                htmlFor: "email",
                                                children: "Email"
                                            }),
                                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("input", {
                                                id: "email",
                                                type: "email",
                                                name: "email",
                                                value: formData.email,
                                                onChange: handleChange,
                                                required: true
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("div", {
                                        className: "form-field",
                                        children: [
                                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("label", {
                                                htmlFor: "mensaje",
                                                children: "Mensaje"
                                            }),
                                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("textarea", {
                                                id: "mensaje",
                                                name: "mensaje",
                                                value: formData.mensaje,
                                                onChange: handleChange,
                                                required: true
                                            })
                                        ]
                                    }),
                                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("button", {
                                        type: "submit",
                                        className: "button button-primary",
                                        disabled: isSubmitting,
                                        children: isSubmitting ? "Enviando\u2026" : 'Enviar mensaje'
                                    }),
                                    submitStatus.message && /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("p", {
                                        className: `form-status ${submitStatus.type}`,
                                        role: "status",
                                        "aria-live": "polite",
                                        children: submitStatus.message
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
}
var $a2bbadb3646a394d$export$2e2bcd8739ae039 = $a2bbadb3646a394d$var$Home;




var $6SWiB = parcelRequire("6SWiB");


function $f190811c54c48a7e$export$2e2bcd8739ae039() {
    const { token: token } = (0, $012530f2a7d9abca$export$23bbbc4533528f03)();
    const [posts, setPosts] = (0, $6SWiB.useState)([]);
    const [status, setStatus] = (0, $6SWiB.useState)("Cargando art\xedculos\u2026");
    (0, $6SWiB.useEffect)(()=>{
        fetch((0, $b9b0c25068e74815$export$c3ee1e672e1e24e7) + "/api/user/blog/posts", {
            headers: {
                Authorization: "Bearer " + token
            }
        }).then(async (r)=>{
            const d = await r.json();
            if (!r.ok) throw Error(d.error || "No se pudieron cargar los art\xedculos.");
            setPosts(d.posts || []);
            setStatus("");
        }).catch((e)=>setStatus(e.message));
    }, [
        token
    ]);
    return /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("main", {
        className: "page-shell blog-page",
        children: /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("div", {
            className: "narrow-container",
            children: [
                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("header", {
                    className: "section-header",
                    children: [
                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("p", {
                            className: "eyebrow",
                            children: "Contenido para miembros"
                        }),
                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("h1", {
                            children: "Mi blog"
                        }),
                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("p", {
                            className: "section-lede",
                            children: "Art\xedculos disponibles seg\xfan tu grupo y suscripci\xf3n."
                        })
                    ]
                }),
                status && /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("p", {
                    className: "site-admin-status warning",
                    children: status
                }),
                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("div", {
                    className: "blog-member-list",
                    children: [
                        posts.map((post)=>/*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("article", {
                                className: "content-panel blog-member-card",
                                children: [
                                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("p", {
                                        className: "eyebrow",
                                        children: new Date(post.createdAt).toLocaleDateString("es-UY")
                                    }),
                                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("h2", {
                                        children: post.title
                                    }),
                                    post.excerpt && /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("p", {
                                        className: "section-lede",
                                        children: post.excerpt
                                    }),
                                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("div", {
                                        className: "blog-member-body",
                                        children: post.body.split(/\r?\n/).map((line, i)=>line ? /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("p", {
                                                children: line
                                            }, i) : /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("br", {}, i))
                                    })
                                ]
                            }, post.id)),
                        !status && !posts.length && /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("p", {
                            className: "admin-empty",
                            children: "Todav\xeda no hay art\xedculos disponibles para tu perfil."
                        })
                    ]
                })
            ]
        })
    });
}






var $6SWiB = parcelRequire("6SWiB");

function $a9d931c52809af12$var$formatTime(value) {
    if (!value) return '';
    return new Intl.DateTimeFormat('es-UY', {
        dateStyle: 'short',
        timeStyle: 'short'
    }).format(new Date(value));
}
function $a9d931c52809af12$var$ChatAdmin() {
    const [token, setToken] = (0, $6SWiB.useState)(()=>window.localStorage.getItem('babyplanner_admin_token') || '');
    const [tokenInput, setTokenInput] = (0, $6SWiB.useState)(token);
    const [chats, setChats] = (0, $6SWiB.useState)([]);
    const [selectedChatId, setSelectedChatId] = (0, $6SWiB.useState)('');
    const [selectedChat, setSelectedChat] = (0, $6SWiB.useState)(null);
    const [reply, setReply] = (0, $6SWiB.useState)('');
    const [error, setError] = (0, $6SWiB.useState)('');
    const [isLoading, setIsLoading] = (0, $6SWiB.useState)(false);
    const [adminName, setAdminName] = (0, $6SWiB.useState)('Admin');
    const [activeTab, setActiveTab] = (0, $6SWiB.useState)('chats');
    const [contacts, setContacts] = (0, $6SWiB.useState)([]);
    const [contactsLoading, setContactsLoading] = (0, $6SWiB.useState)(false);
    const [contactActionId, setContactActionId] = (0, $6SWiB.useState)('');
    const [chatActionId, setChatActionId] = (0, $6SWiB.useState)('');
    const authHeaders = (0, $6SWiB.useMemo)(()=>({
            Authorization: `Bearer ${token}`
        }), [
        token
    ]);
    const selectedSummary = chats.find((chat)=>chat.id === selectedChatId);
    const loadChats = async ()=>{
        if (!token) return;
        try {
            var _data_chats;
            const response = await fetch(`${(0, $b9b0c25068e74815$export$c3ee1e672e1e24e7)}/api/admin/chats`, {
                headers: authHeaders
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.error || 'No se pudieron cargar los chats.');
            setChats(data.chats || []);
            setAdminName(data.adminName || 'Admin');
            setError('');
            if (!selectedChatId && ((_data_chats = data.chats) === null || _data_chats === void 0 ? void 0 : _data_chats[0])) setSelectedChatId(data.chats[0].id);
        } catch (loadError) {
            setError(loadError.message);
        }
    };
    const updateChatStatus = async (sessionId, updates)=>{
        setChatActionId(sessionId);
        try {
            const response = await fetch(`${(0, $b9b0c25068e74815$export$c3ee1e672e1e24e7)}/api/admin/chats/${sessionId}`, {
                method: 'PATCH',
                headers: (0, $bf4fb21d2ea31b30$export$71511d61b312f219)((0, $a5bc2f0ca9d10fc9$export$71511d61b312f219)({}, authHeaders), {
                    'Content-Type': 'application/json'
                }),
                body: JSON.stringify(updates)
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.error || "No se pudo actualizar la conversaci\xf3n.");
            setSelectedChat(data.chat);
            setChats((current)=>current.map((chat)=>chat.id === sessionId ? data.chat : chat));
            setError('');
            await loadChats();
        } catch (updateError) {
            setError(updateError.message);
        } finally{
            setChatActionId('');
        }
    };
    const deleteChat = async (chat)=>{
        const confirmed = window.confirm("\xbfEliminar definitivamente esta conversaci\xf3n? Esta acci\xf3n no se puede deshacer.");
        if (!confirmed) return;
        setChatActionId(chat.id);
        try {
            const response = await fetch(`${(0, $b9b0c25068e74815$export$c3ee1e672e1e24e7)}/api/admin/chats/${chat.id}`, {
                method: 'DELETE',
                headers: authHeaders
            });
            if (!response.ok) {
                const data = await response.json().catch(()=>({}));
                throw new Error(data.error || "No se pudo eliminar la conversaci\xf3n.");
            }
            setChats((current)=>current.filter((item)=>item.id !== chat.id));
            setSelectedChat(null);
            setSelectedChatId('');
            setError('');
        } catch (deleteError) {
            setError(deleteError.message);
        } finally{
            setChatActionId('');
        }
    };
    const loadContacts = async ()=>{
        if (!token) return;
        setContactsLoading(true);
        try {
            const response = await fetch(`${(0, $b9b0c25068e74815$export$c3ee1e672e1e24e7)}/api/admin/contacts`, {
                headers: authHeaders
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.error || 'No se pudieron cargar los contactos.');
            setContacts(data.contacts || []);
            setError('');
        } catch (loadError) {
            setError(loadError.message);
        } finally{
            setContactsLoading(false);
        }
    };
    const updateContactStatus = async (contactId, updates)=>{
        setContactActionId(contactId);
        try {
            const response = await fetch(`${(0, $b9b0c25068e74815$export$c3ee1e672e1e24e7)}/api/admin/contacts/${contactId}`, {
                method: 'PATCH',
                headers: (0, $bf4fb21d2ea31b30$export$71511d61b312f219)((0, $a5bc2f0ca9d10fc9$export$71511d61b312f219)({}, authHeaders), {
                    'Content-Type': 'application/json'
                }),
                body: JSON.stringify(updates)
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.error || 'No se pudo actualizar el contacto.');
            setContacts((current)=>current.map((contact)=>contact.id === contactId ? data.contact : contact));
            setError('');
            await loadContacts();
        } catch (updateError) {
            setError(updateError.message);
        } finally{
            setContactActionId('');
        }
    };
    const deleteContact = async (contact)=>{
        const confirmed = window.confirm(`\xbfEliminar definitivamente el mensaje de ${contact.name}? Esta acci\xf3n no se puede deshacer.`);
        if (!confirmed) return;
        setContactActionId(contact.id);
        try {
            const response = await fetch(`${(0, $b9b0c25068e74815$export$c3ee1e672e1e24e7)}/api/admin/contacts/${contact.id}`, {
                method: 'DELETE',
                headers: authHeaders
            });
            if (!response.ok) {
                const data = await response.json().catch(()=>({}));
                throw new Error(data.error || 'No se pudo eliminar el contacto.');
            }
            setContacts((current)=>current.filter((item)=>item.id !== contact.id));
            setError('');
        } catch (deleteError) {
            setError(deleteError.message);
        } finally{
            setContactActionId('');
        }
    };
    const loadSelectedChat = async ()=>{
        if (!token || !selectedChatId) return;
        try {
            var _data_chat;
            const response = await fetch(`${(0, $b9b0c25068e74815$export$c3ee1e672e1e24e7)}/api/admin/chats/${selectedChatId}`, {
                headers: authHeaders
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.error || "No se pudo cargar la conversaci\xf3n.");
            setSelectedChat(data.chat);
            setAdminName(((_data_chat = data.chat) === null || _data_chat === void 0 ? void 0 : _data_chat.adminName) || adminName);
            setError('');
        } catch (loadError) {
            setError(loadError.message);
        }
    };
    (0, $6SWiB.useEffect)(()=>{
        if (activeTab !== 'chats') return undefined;
        loadChats();
        const interval = window.setInterval(loadChats, 4000);
        return ()=>window.clearInterval(interval);
    }, [
        token,
        selectedChatId,
        activeTab
    ]);
    (0, $6SWiB.useEffect)(()=>{
        if (activeTab !== 'chats') return undefined;
        loadSelectedChat();
        const interval = window.setInterval(loadSelectedChat, 2500);
        return ()=>window.clearInterval(interval);
    }, [
        token,
        selectedChatId,
        activeTab
    ]);
    (0, $6SWiB.useEffect)(()=>{
        if (activeTab !== 'contacts') return undefined;
        loadContacts();
        const interval = window.setInterval(loadContacts, 10000);
        return ()=>window.clearInterval(interval);
    }, [
        token,
        activeTab
    ]);
    const handleLogin = (event)=>{
        event.preventDefault();
        const trimmed = tokenInput.trim();
        setToken(trimmed);
        window.localStorage.setItem('babyplanner_admin_token', trimmed);
    };
    const handleLogout = ()=>{
        setToken('');
        setTokenInput('');
        setChats([]);
        setSelectedChat(null);
        setSelectedChatId('');
        setContacts([]);
        setActiveTab('chats');
        window.localStorage.removeItem('babyplanner_admin_token');
    };
    const sendReply = async (event)=>{
        event.preventDefault();
        const trimmed = reply.trim();
        if (!trimmed || !selectedChatId) return;
        setIsLoading(true);
        try {
            const response = await fetch(`${(0, $b9b0c25068e74815$export$c3ee1e672e1e24e7)}/api/admin/chats/${selectedChatId}/reply`, {
                method: 'POST',
                headers: (0, $bf4fb21d2ea31b30$export$71511d61b312f219)((0, $a5bc2f0ca9d10fc9$export$71511d61b312f219)({}, authHeaders), {
                    'Content-Type': 'application/json'
                }),
                body: JSON.stringify({
                    message: trimmed
                })
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.error || 'No se pudo responder.');
            setSelectedChat(data.chat);
            setReply('');
            loadChats();
            setError('');
        } catch (sendError) {
            setError(sendError.message);
        } finally{
            setIsLoading(false);
        }
    };
    const setAdminMode = async (adminActive)=>{
        if (!selectedChatId) return;
        try {
            const response = await fetch(`${(0, $b9b0c25068e74815$export$c3ee1e672e1e24e7)}/api/admin/chats/${selectedChatId}/mode`, {
                method: 'POST',
                headers: (0, $bf4fb21d2ea31b30$export$71511d61b312f219)((0, $a5bc2f0ca9d10fc9$export$71511d61b312f219)({}, authHeaders), {
                    'Content-Type': 'application/json'
                }),
                body: JSON.stringify({
                    adminActive: adminActive
                })
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.error || 'No se pudo cambiar el modo.');
            setSelectedChat(data.chat);
            loadChats();
            setError('');
        } catch (modeError) {
            setError(modeError.message);
        }
    };
    if (!token) return /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("main", {
        className: "page-shell admin-page",
        children: /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("section", {
            className: "admin-login-card",
            children: [
                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("p", {
                    className: "eyebrow",
                    children: "Chat admin"
                }),
                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("h2", {
                    children: "Ingresar al panel"
                }),
                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("p", {
                    className: "section-lede",
                    children: [
                        "Usa el token definido en ",
                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("code", {
                            children: "ADMIN_CHAT_TOKEN"
                        }),
                        " en el env del backend."
                    ]
                }),
                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("form", {
                    className: "form-grid",
                    onSubmit: handleLogin,
                    children: [
                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("div", {
                            className: "form-field",
                            children: [
                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("label", {
                                    htmlFor: "admin-token",
                                    children: "Token"
                                }),
                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("input", {
                                    id: "admin-token",
                                    type: "password",
                                    value: tokenInput,
                                    onChange: (event)=>setTokenInput(event.target.value),
                                    autoComplete: "current-password",
                                    required: true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("button", {
                            type: "submit",
                            className: "button button-primary",
                            children: "Entrar"
                        })
                    ]
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("main", {
        className: "page-shell admin-page",
        children: /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("section", {
            className: "admin-shell",
            children: [
                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("header", {
                    className: "admin-topbar",
                    children: [
                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("p", {
                                    className: "eyebrow",
                                    children: "Chat admin"
                                }),
                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("h2", {
                                    children: activeTab === 'chats' ? 'Conversaciones' : 'Contactos'
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("div", {
                            className: "site-admin-top-actions",
                            children: [
                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("a", {
                                    className: "button button-secondary",
                                    href: "/#/site-admin",
                                    children: "Contenido del sitio"
                                }),
                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("button", {
                                    type: "button",
                                    className: "button button-secondary",
                                    onClick: handleLogout,
                                    children: "Salir"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("nav", {
                    className: "admin-tabs",
                    "aria-label": "Secciones del panel",
                    children: [
                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("button", {
                            type: "button",
                            className: activeTab === 'chats' ? 'is-active' : '',
                            onClick: ()=>setActiveTab('chats'),
                            children: [
                                "Conversaciones",
                                chats.length > 0 && /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("span", {
                                    children: chats.length
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("button", {
                            type: "button",
                            className: activeTab === 'contacts' ? 'is-active' : '',
                            onClick: ()=>setActiveTab('contacts'),
                            children: [
                                "Contactos",
                                contacts.length > 0 && /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("span", {
                                    children: contacts.length
                                })
                            ]
                        })
                    ]
                }),
                error && /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("p", {
                    className: "admin-error",
                    children: error
                }),
                activeTab === 'chats' && /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("div", {
                    className: "admin-layout",
                    children: [
                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("aside", {
                            className: "admin-chat-list",
                            "aria-label": "Lista de chats",
                            children: [
                                chats.length === 0 && /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("p", {
                                    className: "admin-empty",
                                    children: "Todav\xeda no hay chats."
                                }),
                                chats.map((chat)=>{
                                    var _chat_lastMessage;
                                    return /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("button", {
                                        type: "button",
                                        className: `admin-chat-item ${chat.id === selectedChatId ? 'is-selected' : ''} ${chat.isRead ? '' : 'is-unread'} ${chat.isStarred ? 'is-starred' : ''}`,
                                        onClick: ()=>setSelectedChatId(chat.id),
                                        children: [
                                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("strong", {
                                                children: chat.id.slice(0, 18)
                                            }),
                                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("span", {
                                                children: ((_chat_lastMessage = chat.lastMessage) === null || _chat_lastMessage === void 0 ? void 0 : _chat_lastMessage.text) || 'Sin mensajes'
                                            }),
                                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("small", {
                                                children: $a9d931c52809af12$var$formatTime(chat.updatedAt)
                                            }),
                                            chat.isStarred && /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("b", {
                                                className: "admin-chat-star",
                                                children: "Destacado"
                                            }),
                                            !chat.isRead && /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("em", {
                                                children: chat.unreadUserMessages || 1
                                            })
                                        ]
                                    }, chat.id);
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("section", {
                            className: "admin-chat-detail",
                            children: [
                                !selectedChat && /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("p", {
                                    className: "admin-empty",
                                    children: "Selecciona un chat para verlo."
                                }),
                                selectedChat && /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)((0, $8c08c62dc09ea562$exports.Fragment), {
                                    children: [
                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("div", {
                                            className: "admin-chat-toolbar",
                                            children: [
                                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("strong", {
                                                            children: (selectedSummary === null || selectedSummary === void 0 ? void 0 : selectedSummary.id) || selectedChat.id
                                                        }),
                                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("span", {
                                                            children: selectedChat.adminActive ? 'Modo admin activo' : 'Responde el LLM'
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("div", {
                                                    className: "admin-chat-toolbar-actions",
                                                    children: [
                                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("button", {
                                                            type: "button",
                                                            className: "button button-secondary",
                                                            onClick: ()=>setAdminMode(!selectedChat.adminActive),
                                                            children: selectedChat.adminActive ? 'Devolver al LLM' : 'Tomar chat'
                                                        }),
                                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("button", {
                                                            type: "button",
                                                            className: "button button-secondary",
                                                            onClick: ()=>updateChatStatus(selectedChat.id, {
                                                                    isRead: !selectedChat.isRead
                                                                }),
                                                            disabled: chatActionId === selectedChat.id,
                                                            children: selectedChat.isRead ? "Marcar no le\xeddo" : "Marcar le\xeddo"
                                                        }),
                                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("button", {
                                                            type: "button",
                                                            className: `button button-secondary ${selectedChat.isStarred ? 'is-active' : ''}`,
                                                            onClick: ()=>updateChatStatus(selectedChat.id, {
                                                                    isStarred: !selectedChat.isStarred
                                                                }),
                                                            disabled: chatActionId === selectedChat.id,
                                                            "aria-pressed": selectedChat.isStarred,
                                                            children: selectedChat.isStarred ? 'Quitar destacado' : 'Destacar'
                                                        }),
                                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("button", {
                                                            type: "button",
                                                            className: "button admin-danger-button",
                                                            onClick: ()=>deleteChat(selectedChat),
                                                            disabled: chatActionId === selectedChat.id,
                                                            children: "Eliminar"
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("div", {
                                            className: "admin-messages",
                                            children: selectedChat.messages.map((message)=>/*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("div", {
                                                    className: `admin-message ${message.sender}`,
                                                    children: [
                                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("span", {
                                                            children: message.sender === 'user' ? 'Usuario' : message.sender === 'admin' ? message.displayName || adminName : 'LLM'
                                                        }),
                                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("p", {
                                                            children: message.text
                                                        }),
                                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("small", {
                                                            children: $a9d931c52809af12$var$formatTime(message.createdAt)
                                                        })
                                                    ]
                                                }, message.id))
                                        }),
                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("form", {
                                            className: "admin-reply-form",
                                            onSubmit: sendReply,
                                            children: [
                                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("textarea", {
                                                    value: reply,
                                                    onChange: (event)=>setReply(event.target.value),
                                                    placeholder: "Escribe una respuesta como admin...",
                                                    rows: "4"
                                                }),
                                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("button", {
                                                    type: "submit",
                                                    className: "button button-primary",
                                                    disabled: isLoading || !reply.trim(),
                                                    children: isLoading ? 'Enviando...' : 'Responder como ' + adminName
                                                })
                                            ]
                                        })
                                    ]
                                })
                            ]
                        })
                    ]
                }),
                activeTab === 'contacts' && /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("section", {
                    className: "admin-contacts",
                    "aria-label": "Contactos recibidos",
                    children: [
                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("header", {
                            className: "admin-contacts-header",
                            children: [
                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("div", {
                                    children: [
                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("strong", {
                                            children: [
                                                contacts.length,
                                                " ",
                                                contacts.length === 1 ? 'contacto' : 'contactos'
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("span", {
                                            children: "Mensajes enviados desde el formulario del sitio."
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("button", {
                                    type: "button",
                                    className: "button button-secondary",
                                    onClick: loadContacts,
                                    disabled: contactsLoading,
                                    children: contactsLoading ? "Actualizando\u2026" : 'Actualizar'
                                })
                            ]
                        }),
                        contacts.length === 0 && !contactsLoading && /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("p", {
                            className: "admin-empty",
                            children: "Todav\xeda no hay contactos enviados desde el formulario."
                        }),
                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("div", {
                            className: "admin-contact-grid",
                            children: contacts.map((contact)=>/*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("article", {
                                    className: `admin-contact-card ${contact.isRead ? '' : 'is-unread'} ${contact.isStarred ? 'is-starred' : ''}`,
                                    children: [
                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("header", {
                                            children: [
                                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("div", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("h3", {
                                                            children: contact.name
                                                        }),
                                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("a", {
                                                            href: `mailto:${contact.email}`,
                                                            children: contact.email
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("div", {
                                                    className: "admin-contact-badges",
                                                    children: [
                                                        contact.isStarred && /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("span", {
                                                            className: "contact-starred",
                                                            children: "Destacado"
                                                        }),
                                                        !contact.isRead && /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("span", {
                                                            className: "contact-unread",
                                                            children: "Nuevo"
                                                        }),
                                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("span", {
                                                            className: contact.emailSent ? 'email-sent' : 'email-pending',
                                                            children: contact.emailSent ? 'Correo enviado' : 'Guardado'
                                                        })
                                                    ]
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("p", {
                                            children: contact.message
                                        }),
                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("footer", {
                                            children: [
                                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("time", {
                                                    dateTime: contact.createdAt,
                                                    children: $a9d931c52809af12$var$formatTime(contact.createdAt)
                                                }),
                                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("div", {
                                                    className: "admin-contact-actions",
                                                    children: [
                                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("button", {
                                                            type: "button",
                                                            onClick: ()=>updateContactStatus(contact.id, {
                                                                    isRead: !contact.isRead
                                                                }),
                                                            disabled: contactActionId === contact.id,
                                                            children: contact.isRead ? "Marcar no le\xeddo" : "Marcar le\xeddo"
                                                        }),
                                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("button", {
                                                            type: "button",
                                                            className: contact.isStarred ? 'is-active' : '',
                                                            onClick: ()=>updateContactStatus(contact.id, {
                                                                    isStarred: !contact.isStarred
                                                                }),
                                                            disabled: contactActionId === contact.id,
                                                            "aria-pressed": contact.isStarred,
                                                            children: contact.isStarred ? 'Quitar destacado' : 'Destacar'
                                                        }),
                                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("a", {
                                                            href: `mailto:${contact.email}?subject=Respuesta de Babyplanner Vero`,
                                                            children: "Responder por email"
                                                        }),
                                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("button", {
                                                            type: "button",
                                                            className: "is-danger",
                                                            onClick: ()=>deleteContact(contact),
                                                            disabled: contactActionId === contact.id,
                                                            children: "Eliminar"
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }, contact.id))
                        })
                    ]
                })
            ]
        })
    });
}
var $a9d931c52809af12$export$2e2bcd8739ae039 = $a9d931c52809af12$var$ChatAdmin;






var $6SWiB = parcelRequire("6SWiB");


function $0b2f47f7211526b7$var$resolveImageSource(src) {
    if (!src || /^(https?:|data:|blob:)/.test(src)) return src;
    return `${0, $b9b0c25068e74815$export$c3ee1e672e1e24e7}${src.startsWith('/') ? '' : '/'}${src}`;
}
function $0b2f47f7211526b7$var$blobToDataUrl(blob) {
    return new Promise((resolve, reject)=>{
        const reader = new FileReader();
        reader.onload = ()=>resolve(reader.result);
        reader.onerror = ()=>reject(new Error("No se pudo incorporar una imagen al m\xf3dulo."));
        reader.readAsDataURL(blob);
    });
}
async function $0b2f47f7211526b7$var$portableImageSource(src) {
    if (!src || src.startsWith('data:')) return src;
    const response = await fetch($0b2f47f7211526b7$var$resolveImageSource(src), {
        cache: 'no-store'
    });
    if (!response.ok) throw new Error(`No se pudo descargar la imagen (${response.status}).`);
    return $0b2f47f7211526b7$var$blobToDataUrl(await response.blob());
}
async function $0b2f47f7211526b7$export$dd51eb080b67faf6(content) {
    const portableContent = JSON.parse(JSON.stringify(content));
    const failedSlots = [];
    await Promise.all(Object.entries(portableContent.images || {}).map(async ([slot, image])=>{
        try {
            image.src = await $0b2f47f7211526b7$var$portableImageSource(image.src);
        } catch (error) {
            failedSlots.push(slot);
        }
    }));
    if (failedSlots.length) throw new Error(`No se pudieron incorporar estas fotos: ${failedSlots.join(', ')}. Vuelve a seleccionarlas y exporta nuevamente.`);
    return [
        '// Snapshot generado desde /site-admin.',
        '// Guarda este archivo como src/config/siteContent.snapshot.js y vuelve a desplegar GitHub Pages.',
        `export const siteContentSnapshot = ${JSON.stringify(portableContent, null, 2)};`,
        ''
    ].join('\n');
}
async function $0b2f47f7211526b7$export$1465ee50999a049e(content) {
    const source = await $0b2f47f7211526b7$export$dd51eb080b67faf6(content);
    const url = URL.createObjectURL(new Blob([
        source
    ], {
        type: 'text/javascript;charset=utf-8'
    }));
    const link = document.createElement('a');
    link.href = url;
    link.download = 'siteContent.snapshot.js';
    document.body.appendChild(link);
    link.click();
    link.remove();
    URL.revokeObjectURL(url);
}






var $6SWiB = parcelRequire("6SWiB");

const $f30b20659bd6b188$var$emptyPost = {
    slug: '',
    title: '',
    excerpt: '',
    body: '',
    media: [],
    files: [],
    accessGroups: [],
    accessPlans: [],
    published: false
};
function $f30b20659bd6b188$var$markdownToHtml(markdown) {
    const escapeHtml = (value)=>value.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
    const inline = (value)=>{
        let x = escapeHtml(value);
        x = x.replace(/!\[([^\]]*)\]\((https?:\/\/[^\s)]+)\)/g, (_, alt, url)=>'<img src="' + url + '" alt="' + alt + '" loading="lazy" />');
        x = x.replace(/\[([^\]]+)\]\((https?:\/\/[^\s)]+)\)/g, (_, label, url)=>'<a href="' + url + '" target="_blank" rel="noreferrer">' + label + '</a>');
        x = x.replace(/\[color=(#[0-9a-fA-F]{3,8}|[a-zA-Z]+)\]([\s\S]*?)\[\/color\]/g, (_, color, text)=>'<span style="color:' + color + '">' + text + '</span>');
        return x.replace(/\*\*([^*]+)\*\*/g, (_, text)=>'<strong>' + text + '</strong>').replace(/__([^_]+)__/g, (_, text)=>'<strong>' + text + '</strong>').replace(/\*([^*]+)\*/g, (_, text)=>'<em>' + text + '</em>').replace(/_([^_]+)_/g, (_, text)=>'<em>' + text + '</em>');
    };
    const lines = markdown.split(/\r?\n/);
    let html = '';
    let table = null;
    const closeTable = ()=>{
        if (!table) return;
        html += '<table><thead><tr>' + table.head.map((x)=>'<th>' + inline(x.trim()) + '</th>').join('') + '</tr></thead><tbody>' + table.rows.map((row)=>'<tr>' + row.map((x)=>'<td>' + inline(x.trim()) + '</td>').join('') + '</tr>').join('') + '</tbody></table>';
        table = null;
    };
    lines.forEach((line)=>{
        const t = line.trim();
        if (!t) {
            closeTable();
            return;
        }
        if (t.includes('|')) {
            const cells = t.replace(/^\||\|$/g, '').split('|');
            if (!table) table = {
                head: cells,
                rows: []
            };
            else if (!cells.every((x)=>/^\s*:?-+:?\s*$/.test(x))) table.rows.push(cells);
            return;
        }
        closeTable();
        if (/^### /.test(t)) html += '<h3>' + inline(t.slice(4)) + '</h3>';
        else if (/^## /.test(t)) html += '<h2>' + inline(t.slice(3)) + '</h2>';
        else if (/^# /.test(t)) html += '<h1>' + inline(t.slice(2)) + '</h1>';
        else if (/^- /.test(t)) html += '<ul><li>' + inline(t.slice(2)) + '</li></ul>';
        else if (/^\d+\. /.test(t)) html += '<ol><li>' + inline(t.replace(/^\d+\. /, '')) + '</li></ol>';
        else html += '<p>' + inline(t) + '</p>';
    });
    closeTable();
    return html;
}
function $f30b20659bd6b188$export$2e2bcd8739ae039({ token: token }) {
    const headers = {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json'
    };
    const bodyRef = (0, $6SWiB.useRef)(null);
    const [posts, setPosts] = (0, $6SWiB.useState)([]), [catalogs, setCatalogs] = (0, $6SWiB.useState)({
        groups: [],
        plans: []
    });
    const [post, setPost] = (0, $6SWiB.useState)($f30b20659bd6b188$var$emptyPost), [modal, setModal] = (0, $6SWiB.useState)(null), [status, setStatus] = (0, $6SWiB.useState)('');
    const load = async ()=>{
        try {
            const [p, c] = await Promise.all([
                fetch((0, $b9b0c25068e74815$export$c3ee1e672e1e24e7) + '/api/admin/blog/posts', {
                    headers: headers
                }),
                fetch((0, $b9b0c25068e74815$export$c3ee1e672e1e24e7) + '/api/admin/user-catalogs', {
                    headers: headers
                })
            ]);
            const pd = await p.json().catch(()=>({})), cd = await c.json().catch(()=>({}));
            if (!p.ok) throw new Error(pd.error || "No se pudieron cargar los art\xedculos.");
            if (!c.ok) throw new Error(cd.error || "No se pudieron cargar los cat\xe1logos.");
            setPosts(pd.posts || []);
            setCatalogs({
                groups: cd.groups || [],
                plans: cd.plans || []
            });
        } catch (e) {
            setStatus(e.message);
        }
    };
    (0, $6SWiB.useEffect)(()=>{
        load();
    }, [
        token
    ]);
    const uploadFile = async (event, kind)=>{
        const file = event.target.files[0];
        if (!file) return;
        const form = new FormData();
        form.append('file', file);
        try {
            const response = await fetch((0, $b9b0c25068e74815$export$c3ee1e672e1e24e7) + '/api/admin/blog/uploads', {
                method: 'POST',
                headers: {
                    Authorization: 'Bearer ' + token
                },
                body: form
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.error || 'No se pudo subir el archivo.');
            const item = {
                url: (0, $b9b0c25068e74815$export$c3ee1e672e1e24e7) + data.url,
                type: data.type,
                title: data.name
            };
            setPost((current)=>(0, $bf4fb21d2ea31b30$export$71511d61b312f219)((0, $a5bc2f0ca9d10fc9$export$71511d61b312f219)({}, current), {
                    [kind]: [
                        ...current[kind],
                        item
                    ]
                }));
            setStatus('Archivo subido correctamente.');
        } catch (error) {
            setStatus(error.message);
        }
        event.target.value = '';
    };
    const set = (key, value)=>setPost((current)=>(0, $bf4fb21d2ea31b30$export$71511d61b312f219)((0, $a5bc2f0ca9d10fc9$export$71511d61b312f219)({}, current), {
                [key]: value
            }));
    const insertMarkdown = (before, after = '', placeholder = 'texto')=>{
        const area = bodyRef.current;
        if (!area) return;
        const start = area.selectionStart;
        const end = area.selectionEnd;
        const selected = post.body.slice(start, end) || placeholder;
        const value = post.body.slice(0, start) + before + selected + after + post.body.slice(end);
        set('body', value);
        requestAnimationFrame(()=>{
            area.focus();
            area.setSelectionRange(start + before.length, start + before.length + selected.length);
        });
    };
    const insertBlock = (text)=>{
        const area = bodyRef.current;
        const start = area ? area.selectionStart : post.body.length;
        set('body', post.body.slice(0, start) + (start && post.body[start - 1] !== '\n' ? '\n' : '') + text + '\n' + post.body.slice(start));
        requestAnimationFrame(()=>area && area.focus());
    };
    const save = async (e)=>{
        e.preventDefault();
        const url = (0, $b9b0c25068e74815$export$c3ee1e672e1e24e7) + '/api/admin/blog/posts' + (post.id ? '/' + post.id : '');
        try {
            const r = await fetch(url, {
                method: post.id ? 'PUT' : 'POST',
                headers: headers,
                body: JSON.stringify(post)
            });
            const d = await r.json().catch(()=>({}));
            if (!r.ok) throw new Error(d.error || 'No se pudo guardar.');
            setStatus("Art\xedculo guardado.");
            setModal(null);
            setPost($f30b20659bd6b188$var$emptyPost);
            load();
        } catch (x) {
            setStatus(x.message);
        }
    };
    const remove = async (id)=>{
        if (!window.confirm("\xbfEliminar este art\xedculo? Esta acci\xf3n no se puede deshacer.")) return;
        try {
            const r = await fetch((0, $b9b0c25068e74815$export$c3ee1e672e1e24e7) + '/api/admin/blog/posts/' + id, {
                method: 'DELETE',
                headers: headers
            });
            const d = await r.json().catch(()=>({}));
            if (!r.ok) throw new Error(d.error || 'No se pudo eliminar.');
            setStatus("Art\xedculo eliminado.");
            load();
        } catch (x) {
            setStatus(x.message);
        }
    };
    const toggle = async (item)=>{
        try {
            const r = await fetch((0, $b9b0c25068e74815$export$c3ee1e672e1e24e7) + '/api/admin/blog/posts/' + item.id, {
                method: 'PUT',
                headers: headers,
                body: JSON.stringify((0, $bf4fb21d2ea31b30$export$71511d61b312f219)((0, $a5bc2f0ca9d10fc9$export$71511d61b312f219)({}, item), {
                    published: !item.published
                }))
            });
            const d = await r.json().catch(()=>({}));
            if (!r.ok) throw new Error(d.error || 'No se pudo actualizar.');
            load();
        } catch (x) {
            setStatus(x.message);
        }
    };
    const names = (ids, items)=>(ids === null || ids === void 0 ? void 0 : ids.map((id)=>{
            var _items_find;
            return ((_items_find = items.find((item)=>item.id === id)) === null || _items_find === void 0 ? void 0 : _items_find.name) || id;
        }).join(', ')) || 'Todos';
    return /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("section", {
        className: "blog-admin",
        children: [
            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("div", {
                className: "site-editor-heading",
                children: [
                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("h3", {
                                children: "Blog para usuarios registrados"
                            }),
                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("p", {
                                children: "Gestiona art\xedculos, grupos autorizados y tipos de suscripci\xf3n."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("button", {
                        className: "button button-primary",
                        type: "button",
                        onClick: ()=>{
                            setPost($f30b20659bd6b188$var$emptyPost);
                            setModal('post');
                        },
                        children: "Agregar art\xedculo"
                    })
                ]
            }),
            status && /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("p", {
                className: "site-admin-status warning",
                children: status
            }),
            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("div", {
                className: "blog-post-table-wrap",
                children: [
                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("table", {
                        className: "users-table blog-post-table",
                        children: [
                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("thead", {
                                children: /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("th", {
                                            children: "Art\xedculo"
                                        }),
                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("th", {
                                            children: "Grupos"
                                        }),
                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("th", {
                                            children: "Suscripciones"
                                        }),
                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("th", {
                                            children: "Fecha"
                                        }),
                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("th", {
                                            children: "Activo"
                                        }),
                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("th", {
                                            children: "Acciones"
                                        })
                                    ]
                                })
                            }),
                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("tbody", {
                                children: posts.map((item)=>/*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("td", {
                                                children: [
                                                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("strong", {
                                                        children: item.title
                                                    }),
                                                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("small", {
                                                        children: item.slug
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("td", {
                                                children: names(item.accessGroups, catalogs.groups)
                                            }),
                                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("td", {
                                                children: names(item.accessPlans, catalogs.plans)
                                            }),
                                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("td", {
                                                children: item.createdAt ? new Date(item.createdAt).toLocaleDateString('es-UY') : "\u2014"
                                            }),
                                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("input", {
                                                    type: "checkbox",
                                                    checked: item.published,
                                                    onChange: ()=>toggle(item),
                                                    "aria-label": 'Activar ' + item.title
                                                })
                                            }),
                                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("td", {
                                                children: [
                                                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("button", {
                                                        className: "table-action",
                                                        type: "button",
                                                        onClick: ()=>{
                                                            setPost((0, $a5bc2f0ca9d10fc9$export$71511d61b312f219)({}, $f30b20659bd6b188$var$emptyPost, item));
                                                            setModal('post');
                                                        },
                                                        children: "Editar"
                                                    }),
                                                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("button", {
                                                        className: "table-action danger",
                                                        type: "button",
                                                        onClick: ()=>remove(item.id),
                                                        children: "Eliminar"
                                                    })
                                                ]
                                            })
                                        ]
                                    }, item.id))
                            })
                        ]
                    }),
                    !posts.length && /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("p", {
                        className: "admin-empty",
                        children: "No hay art\xedculos todav\xeda."
                    })
                ]
            }),
            modal === 'post' && /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)($f30b20659bd6b188$var$Modal, {
                title: post.id ? "Editar art\xedculo" : "Agregar art\xedculo",
                close: ()=>setModal(null),
                children: /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("form", {
                    className: "modal-form blog-modal-form",
                    onSubmit: save,
                    children: [
                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("label", {
                            title: "Insertar t\xedtulo",
                            "aria-label": "Insertar t\xedtulo",
                            children: [
                                "\u25B0",
                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("input", {
                                    required: true,
                                    value: post.title,
                                    onChange: (e)=>set('title', e.target.value)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("label", {
                            children: [
                                "Slug",
                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("input", {
                                    required: true,
                                    value: post.slug,
                                    onChange: (e)=>set('slug', e.target.value)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("label", {
                            children: [
                                "Resumen",
                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("textarea", {
                                    rows: "3",
                                    value: post.excerpt,
                                    onChange: (e)=>set('excerpt', e.target.value)
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("div", {
                            className: "markdown-workspace",
                            children: [
                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("label", {
                                    children: [
                                        "Contenido Markdown",
                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("div", {
                                            className: "markdown-toolbar",
                                            role: "toolbar",
                                            "aria-label": "Herramientas de formato",
                                            children: [
                                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("button", {
                                                    type: "button",
                                                    onClick: ()=>insertBlock("# T\xedtulo"),
                                                    children: "T\xedtulo"
                                                }),
                                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("button", {
                                                    type: "button",
                                                    onClick: ()=>insertMarkdown("**", "**", "negrita"),
                                                    title: "Negrita",
                                                    "aria-label": "Negrita",
                                                    children: "B"
                                                }),
                                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("button", {
                                                    type: "button",
                                                    onClick: ()=>insertMarkdown("*", "*", "cursiva"),
                                                    title: "Cursiva",
                                                    "aria-label": "Cursiva",
                                                    children: "\uD835\uDE10"
                                                }),
                                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("button", {
                                                    type: "button",
                                                    onClick: ()=>insertBlock("- Elemento"),
                                                    title: "Lista con vi\xf1etas",
                                                    "aria-label": "Lista con vi\xf1etas",
                                                    children: "\u2637"
                                                }),
                                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("button", {
                                                    type: "button",
                                                    onClick: ()=>insertBlock("1. Elemento"),
                                                    title: "Lista numerada",
                                                    "aria-label": "Lista numerada",
                                                    children: "\u2263"
                                                }),
                                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("button", {
                                                    type: "button",
                                                    onClick: ()=>insertMarkdown("[", "](https://ejemplo.com)", "enlace"),
                                                    title: "Insertar enlace",
                                                    "aria-label": "Insertar enlace",
                                                    children: "\uD83D\uDD17"
                                                }),
                                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("button", {
                                                    type: "button",
                                                    onClick: ()=>insertMarkdown("![", "](https://ejemplo.com/imagen.jpg)", "imagen"),
                                                    title: "Insertar imagen",
                                                    "aria-label": "Insertar imagen",
                                                    children: "\u25A7"
                                                }),
                                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("button", {
                                                    type: "button",
                                                    onClick: ()=>insertBlock("| Columna | Valor |\n|---|---|\n| Dato | Dato |"),
                                                    title: "Insertar tabla",
                                                    "aria-label": "Insertar tabla",
                                                    children: "\u25A6"
                                                }),
                                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("button", {
                                                    type: "button",
                                                    onClick: ()=>insertMarkdown("[color=#9b5c4e]", "[/color]", "color"),
                                                    title: "Texto con color",
                                                    "aria-label": "Texto con color",
                                                    children: "A\u0332"
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("textarea", {
                                            ref: bodyRef,
                                            rows: "18",
                                            required: true,
                                            value: post.body,
                                            onChange: (e)=>set('body', e.target.value),
                                            placeholder: "# T\xedtulo\\n\\n**Texto** y [enlaces](https://ejemplo.com)"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("div", {
                                    className: "markdown-preview",
                                    children: [
                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("strong", {
                                            children: "Vista previa HTML"
                                        }),
                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("article", {
                                            dangerouslySetInnerHTML: {
                                                __html: $f30b20659bd6b188$var$markdownToHtml(post.body)
                                            }
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("label", {
                            children: [
                                "Videos/fotos (URLs, una por l\xednea)",
                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("textarea", {
                                    value: post.media.map((x)=>x.url || '').join('\n'),
                                    onChange: (e)=>set('media', e.target.value.split('\n').filter(Boolean).map((url)=>({
                                                url: url,
                                                type: url.match(/\.(jpg|jpeg|png|webp|gif)$/i) ? 'image' : 'video'
                                            })))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("label", {
                            className: "file-upload-label",
                            children: [
                                "Subir fotos o videos",
                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("input", {
                                    type: "file",
                                    accept: "image/*,video/mp4,video/webm,video/quicktime",
                                    onChange: (e)=>uploadFile(e, 'media')
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("label", {
                            children: [
                                "Documentos (URLs, una por l\xednea)",
                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("textarea", {
                                    value: post.files.map((x)=>x.url || '').join('\n'),
                                    onChange: (e)=>set('files', e.target.value.split('\n').filter(Boolean).map((url)=>({
                                                url: url,
                                                type: 'document'
                                            })))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("label", {
                            className: "file-upload-label",
                            children: [
                                "Subir PDF o documento",
                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("input", {
                                    type: "file",
                                    accept: "application/pdf,.doc,.docx",
                                    onChange: (e)=>uploadFile(e, 'files')
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("fieldset", {
                            className: "blog-access",
                            children: [
                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("legend", {
                                    children: "Acceso"
                                }),
                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("p", {
                                    children: "Sin selecci\xf3n significa todos los usuarios autenticados."
                                }),
                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("strong", {
                                    children: "Grupos"
                                }),
                                catalogs.groups.map((x)=>/*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("label", {
                                        className: "checkbox-field",
                                        children: [
                                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("input", {
                                                type: "checkbox",
                                                checked: post.accessGroups.includes(x.id),
                                                onChange: (e)=>set('accessGroups', e.target.checked ? [
                                                        ...post.accessGroups,
                                                        x.id
                                                    ] : post.accessGroups.filter((id)=>id !== x.id))
                                            }),
                                            " ",
                                            x.name
                                        ]
                                    }, x.id)),
                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("strong", {
                                    children: "Suscripciones"
                                }),
                                catalogs.plans.map((x)=>/*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("label", {
                                        className: "checkbox-field",
                                        children: [
                                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("input", {
                                                type: "checkbox",
                                                checked: post.accessPlans.includes(x.id),
                                                onChange: (e)=>set('accessPlans', e.target.checked ? [
                                                        ...post.accessPlans,
                                                        x.id
                                                    ] : post.accessPlans.filter((id)=>id !== x.id))
                                            }),
                                            " ",
                                            x.name
                                        ]
                                    }, x.id))
                            ]
                        }),
                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("label", {
                            className: "checkbox-field",
                            children: [
                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("input", {
                                    type: "checkbox",
                                    checked: post.published,
                                    onChange: (e)=>set('published', e.target.checked)
                                }),
                                " Art\xedculo activo"
                            ]
                        }),
                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("button", {
                            className: "button button-primary",
                            type: "submit",
                            children: "Guardar art\xedculo"
                        })
                    ]
                })
            })
        ]
    });
}
function $f30b20659bd6b188$var$Modal({ title: title, close: close, children: children }) {
    return /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("div", {
        className: "modal-backdrop",
        role: "presentation",
        onMouseDown: (e)=>e.target === e.currentTarget && close(),
        children: /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("div", {
            className: "admin-modal",
            role: "dialog",
            "aria-modal": "true",
            children: [
                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("header", {
                    children: [
                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("h3", {
                            children: title
                        }),
                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("button", {
                            type: "button",
                            onClick: close,
                            "aria-label": "Cerrar",
                            children: "\xd7"
                        })
                    ]
                }),
                children
            ]
        })
    });
}






var $6SWiB = parcelRequire("6SWiB");

const $df0b21d55506b9cf$var$blankUser = {
    name: '',
    email: '',
    group_id: '',
    notes: '',
    plan_id: '',
    subscription_status: 'active',
    subscription_end: '',
    is_active: true
};
const $df0b21d55506b9cf$var$blankCatalog = {
    name: '',
    description: '',
    is_active: true
};
function $df0b21d55506b9cf$export$2e2bcd8739ae039({ token: token }) {
    const headers = {
        Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json'
    };
    const [users, setUsers] = (0, $6SWiB.useState)([]), [catalogs, setCatalogs] = (0, $6SWiB.useState)({
        groups: [],
        plans: []
    });
    const [user, setUser] = (0, $6SWiB.useState)($df0b21d55506b9cf$var$blankUser), [catalog, setCatalog] = (0, $6SWiB.useState)($df0b21d55506b9cf$var$blankCatalog);
    const [modal, setModal] = (0, $6SWiB.useState)(null), [catalogType, setCatalogType] = (0, $6SWiB.useState)('groups');
    const [status, setStatus] = (0, $6SWiB.useState)(''), [loading, setLoading] = (0, $6SWiB.useState)(true);
    const load = async ()=>{
        setLoading(true);
        try {
            const [u, c] = await Promise.all([
                fetch((0, $b9b0c25068e74815$export$c3ee1e672e1e24e7) + '/api/admin/users', {
                    headers: headers
                }),
                fetch((0, $b9b0c25068e74815$export$c3ee1e672e1e24e7) + '/api/admin/user-catalogs', {
                    headers: headers
                })
            ]);
            const ud = await u.json().catch(()=>({})), cd = await c.json().catch(()=>({}));
            if (!u.ok) throw new Error(ud.error || 'No se pudieron cargar usuarios.');
            if (!c.ok) throw new Error(cd.error || "No se pudieron cargar cat\xe1logos.");
            setUsers(ud.users || []);
            setCatalogs({
                groups: cd.groups || [],
                plans: cd.plans || []
            });
            setStatus('');
        } catch (e) {
            setStatus(e.message);
        } finally{
            setLoading(false);
        }
    };
    (0, $6SWiB.useEffect)(()=>{
        load();
    }, [
        token
    ]);
    const saveUser = async (e)=>{
        e.preventDefault();
        setStatus("Guardando\u2026");
        const url = (0, $b9b0c25068e74815$export$c3ee1e672e1e24e7) + '/api/admin/users' + (user.id ? '/' + user.id : '');
        try {
            const r = await fetch(url, {
                method: user.id ? 'PUT' : 'POST',
                headers: headers,
                body: JSON.stringify(user)
            });
            const d = await r.json().catch(()=>({}));
            if (!r.ok) throw new Error(d.error || 'No se pudo guardar.');
            setModal(null);
            setUser($df0b21d55506b9cf$var$blankUser);
            setStatus('Usuario guardado.');
            load();
        } catch (x) {
            setStatus(x.message);
        }
    };
    const saveCatalog = async (e)=>{
        e.preventDefault();
        const base = catalogType === 'groups' ? '/api/admin/groups' : '/api/admin/subscription-plans';
        try {
            const r = await fetch((0, $b9b0c25068e74815$export$c3ee1e672e1e24e7) + base, {
                method: 'POST',
                headers: headers,
                body: JSON.stringify(catalog)
            });
            const d = await r.json().catch(()=>({}));
            if (!r.ok) throw new Error(d.error || 'No se pudo guardar.');
            setModal(null);
            setCatalog($df0b21d55506b9cf$var$blankCatalog);
            load();
        } catch (x) {
            setStatus(x.message);
        }
    };
    const remove = async (type, id, label)=>{
        if (!window.confirm("\xbfEliminar " + label + "? Esta acci\xf3n no se puede deshacer.")) return;
        const paths = {
            user: '/api/admin/users/',
            group: '/api/admin/groups/',
            plan: '/api/admin/subscription-plans/'
        };
        try {
            const r = await fetch((0, $b9b0c25068e74815$export$c3ee1e672e1e24e7) + paths[type] + id, {
                method: 'DELETE',
                headers: headers
            });
            const d = await r.json().catch(()=>({}));
            if (!r.ok) throw new Error(d.error || 'No se pudo eliminar.');
            setStatus(label + ' eliminado.');
            load();
        } catch (x) {
            setStatus(x.message);
        }
    };
    return /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("section", {
        className: "users-admin",
        children: [
            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("div", {
                className: "site-editor-heading",
                children: [
                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("h3", {
                                children: "Usuarios y suscripciones"
                            }),
                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("p", {
                                children: "Administra usuarios y cat\xe1logos desde paneles modales."
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("div", {
                        className: "users-actions",
                        children: [
                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("button", {
                                className: "button button-primary",
                                onClick: ()=>{
                                    setUser($df0b21d55506b9cf$var$blankUser);
                                    setModal('user');
                                },
                                children: "Agregar usuario"
                            }),
                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("button", {
                                className: "button button-secondary",
                                onClick: ()=>{
                                    setCatalogType('groups');
                                    setCatalog($df0b21d55506b9cf$var$blankCatalog);
                                    setModal('catalog');
                                },
                                children: "Nuevo grupo"
                            }),
                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("button", {
                                className: "button button-secondary",
                                onClick: ()=>{
                                    setCatalogType('plans');
                                    setCatalog($df0b21d55506b9cf$var$blankCatalog);
                                    setModal('catalog');
                                },
                                children: "Nueva suscripci\xf3n"
                            })
                        ]
                    })
                ]
            }),
            status && /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("p", {
                className: "site-admin-status warning",
                children: status
            }),
            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("div", {
                className: "catalog-list-panel",
                children: [
                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("strong", {
                                children: "Grupos"
                            }),
                            catalogs.groups.map((x)=>/*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("span", {
                                    children: [
                                        x.name,
                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("button", {
                                            type: "button",
                                            "aria-label": 'Eliminar grupo ' + x.name,
                                            onClick: ()=>remove('group', x.id, 'grupo'),
                                            children: "\xd7"
                                        })
                                    ]
                                }, x.id))
                        ]
                    }),
                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("strong", {
                                children: "Tipos de suscripci\xf3n"
                            }),
                            catalogs.plans.map((x)=>/*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("span", {
                                    children: [
                                        x.name,
                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("button", {
                                            type: "button",
                                            "aria-label": "Eliminar suscripci\xf3n " + x.name,
                                            onClick: ()=>remove('plan', x.id, "tipo de suscripci\xf3n"),
                                            children: "\xd7"
                                        })
                                    ]
                                }, x.id))
                        ]
                    })
                ]
            }),
            loading ? /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("p", {
                className: "admin-empty",
                children: "Cargando\u2026"
            }) : /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("div", {
                className: "users-table-wrap",
                children: /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("table", {
                    className: "users-table",
                    children: [
                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("thead", {
                            children: /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("tr", {
                                children: [
                                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("th", {
                                        children: "Nombre"
                                    }),
                                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("th", {
                                        children: "Email"
                                    }),
                                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("th", {
                                        children: "Grupo"
                                    }),
                                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("th", {
                                        children: "Suscripci\xf3n"
                                    }),
                                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("th", {
                                        children: "Vencimiento"
                                    }),
                                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("th", {
                                        children: "Notas"
                                    }),
                                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("th", {
                                        children: "Acciones"
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("tbody", {
                            children: users.map((x)=>{
                                var _x_subscription, _x_subscription1, _x_subscription2, _x_subscription3;
                                return /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("td", {
                                            children: x.name
                                        }),
                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("td", {
                                            children: x.email
                                        }),
                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("td", {
                                            children: x.groupName || x.groupId || "\u2014"
                                        }),
                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("td", {
                                            children: [
                                                ((_x_subscription = x.subscription) === null || _x_subscription === void 0 ? void 0 : _x_subscription.plan) || ((_x_subscription1 = x.subscription) === null || _x_subscription1 === void 0 ? void 0 : _x_subscription1.planId) || "\u2014",
                                                " (",
                                                ((_x_subscription2 = x.subscription) === null || _x_subscription2 === void 0 ? void 0 : _x_subscription2.status) || "\u2014",
                                                ")"
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("td", {
                                            children: ((_x_subscription3 = x.subscription) === null || _x_subscription3 === void 0 ? void 0 : _x_subscription3.currentPeriodEnd) ? new Date(x.subscription.currentPeriodEnd).toLocaleDateString('es-UY') : "\u2014"
                                        }),
                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("td", {
                                            children: x.notes || "\u2014"
                                        }),
                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("td", {
                                            children: [
                                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("button", {
                                                    className: "table-action",
                                                    onClick: ()=>{
                                                        var _x_subscription, _x_subscription1, _x_subscription_currentPeriodEnd, _x_subscription2;
                                                        setUser((0, $bf4fb21d2ea31b30$export$71511d61b312f219)((0, $a5bc2f0ca9d10fc9$export$71511d61b312f219)({}, $df0b21d55506b9cf$var$blankUser, x), {
                                                            group_id: x.groupId || '',
                                                            plan_id: ((_x_subscription = x.subscription) === null || _x_subscription === void 0 ? void 0 : _x_subscription.planId) || '',
                                                            subscription_status: ((_x_subscription1 = x.subscription) === null || _x_subscription1 === void 0 ? void 0 : _x_subscription1.status) || 'active',
                                                            subscription_end: ((_x_subscription2 = x.subscription) === null || _x_subscription2 === void 0 ? void 0 : (_x_subscription_currentPeriodEnd = _x_subscription2.currentPeriodEnd) === null || _x_subscription_currentPeriodEnd === void 0 ? void 0 : _x_subscription_currentPeriodEnd.slice(0, 10)) || ''
                                                        }));
                                                        setModal('user');
                                                    },
                                                    children: "Editar"
                                                }),
                                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("button", {
                                                    className: "table-action danger",
                                                    onClick: ()=>remove('user', x.id, 'usuario'),
                                                    children: "Eliminar"
                                                })
                                            ]
                                        })
                                    ]
                                }, x.id);
                            })
                        })
                    ]
                })
            }),
            modal === 'user' && /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)($df0b21d55506b9cf$var$Modal, {
                title: user.id ? 'Editar usuario' : 'Agregar usuario',
                close: ()=>setModal(null),
                children: /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("form", {
                    className: "modal-form",
                    onSubmit: saveUser,
                    children: [
                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("label", {
                            children: [
                                "Nombre",
                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("input", {
                                    required: true,
                                    value: user.name,
                                    onChange: (e)=>setUser((0, $bf4fb21d2ea31b30$export$71511d61b312f219)((0, $a5bc2f0ca9d10fc9$export$71511d61b312f219)({}, user), {
                                            name: e.target.value
                                        }))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("label", {
                            children: [
                                "Email",
                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("input", {
                                    required: true,
                                    type: "email",
                                    value: user.email,
                                    onChange: (e)=>setUser((0, $bf4fb21d2ea31b30$export$71511d61b312f219)((0, $a5bc2f0ca9d10fc9$export$71511d61b312f219)({}, user), {
                                            email: e.target.value
                                        }))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("label", {
                            children: [
                                "Grupo",
                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("select", {
                                    value: user.group_id,
                                    onChange: (e)=>setUser((0, $bf4fb21d2ea31b30$export$71511d61b312f219)((0, $a5bc2f0ca9d10fc9$export$71511d61b312f219)({}, user), {
                                            group_id: e.target.value
                                        })),
                                    children: [
                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("option", {
                                            value: "",
                                            children: "Sin grupo"
                                        }),
                                        catalogs.groups.map((x)=>/*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("option", {
                                                value: x.id,
                                                children: x.name
                                            }, x.id))
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("label", {
                            children: [
                                "Tipo de suscripci\xf3n",
                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("select", {
                                    value: user.plan_id,
                                    onChange: (e)=>setUser((0, $bf4fb21d2ea31b30$export$71511d61b312f219)((0, $a5bc2f0ca9d10fc9$export$71511d61b312f219)({}, user), {
                                            plan_id: e.target.value
                                        })),
                                    children: [
                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("option", {
                                            value: "",
                                            children: "Sin suscripci\xf3n"
                                        }),
                                        catalogs.plans.map((x)=>/*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("option", {
                                                value: x.id,
                                                children: x.name
                                            }, x.id))
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("label", {
                            children: [
                                "Estado",
                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("select", {
                                    value: user.subscription_status,
                                    onChange: (e)=>setUser((0, $bf4fb21d2ea31b30$export$71511d61b312f219)((0, $a5bc2f0ca9d10fc9$export$71511d61b312f219)({}, user), {
                                            subscription_status: e.target.value
                                        })),
                                    children: [
                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("option", {
                                            value: "active",
                                            children: "Activa"
                                        }),
                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("option", {
                                            value: "pending",
                                            children: "Pendiente"
                                        }),
                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("option", {
                                            value: "cancelled",
                                            children: "Cancelada"
                                        }),
                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("option", {
                                            value: "expired",
                                            children: "Vencida"
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("label", {
                            children: [
                                "Vencimiento",
                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("input", {
                                    type: "date",
                                    value: user.subscription_end || '',
                                    onChange: (e)=>setUser((0, $bf4fb21d2ea31b30$export$71511d61b312f219)((0, $a5bc2f0ca9d10fc9$export$71511d61b312f219)({}, user), {
                                            subscription_end: e.target.value || null
                                        }))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("label", {
                            children: [
                                "Notas",
                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("textarea", {
                                    rows: "4",
                                    value: user.notes,
                                    onChange: (e)=>setUser((0, $bf4fb21d2ea31b30$export$71511d61b312f219)((0, $a5bc2f0ca9d10fc9$export$71511d61b312f219)({}, user), {
                                            notes: e.target.value
                                        }))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("label", {
                            className: "checkbox-field",
                            children: [
                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("input", {
                                    type: "checkbox",
                                    checked: user.is_active,
                                    onChange: (e)=>setUser((0, $bf4fb21d2ea31b30$export$71511d61b312f219)((0, $a5bc2f0ca9d10fc9$export$71511d61b312f219)({}, user), {
                                            is_active: e.target.checked
                                        }))
                                }),
                                " Usuario activo"
                            ]
                        }),
                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("button", {
                            className: "button button-primary",
                            type: "submit",
                            children: "Guardar"
                        })
                    ]
                })
            }),
            modal === 'catalog' && /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)($df0b21d55506b9cf$var$Modal, {
                title: catalogType === 'groups' ? 'Agregar grupo' : "Agregar tipo de suscripci\xf3n",
                close: ()=>setModal(null),
                children: /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("form", {
                    className: "modal-form",
                    onSubmit: saveCatalog,
                    children: [
                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("label", {
                            children: [
                                "Nombre",
                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("input", {
                                    required: true,
                                    value: catalog.name,
                                    onChange: (e)=>setCatalog((0, $bf4fb21d2ea31b30$export$71511d61b312f219)((0, $a5bc2f0ca9d10fc9$export$71511d61b312f219)({}, catalog), {
                                            name: e.target.value
                                        }))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("label", {
                            children: [
                                "Descripci\xf3n",
                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("textarea", {
                                    value: catalog.description,
                                    onChange: (e)=>setCatalog((0, $bf4fb21d2ea31b30$export$71511d61b312f219)((0, $a5bc2f0ca9d10fc9$export$71511d61b312f219)({}, catalog), {
                                            description: e.target.value
                                        }))
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("button", {
                            className: "button button-primary",
                            type: "submit",
                            children: "Guardar"
                        })
                    ]
                })
            })
        ]
    });
}
function $df0b21d55506b9cf$var$Modal({ title: title, close: close, children: children }) {
    return /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("div", {
        className: "modal-backdrop",
        role: "presentation",
        onMouseDown: (e)=>e.target === e.currentTarget && close(),
        children: /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("div", {
            className: "admin-modal",
            role: "dialog",
            "aria-modal": "true",
            "aria-label": title,
            children: [
                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("header", {
                    children: [
                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("h3", {
                            children: title
                        }),
                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("button", {
                            type: "button",
                            onClick: close,
                            "aria-label": "Cerrar",
                            children: "\xd7"
                        })
                    ]
                }),
                children
            ]
        })
    });
}



const $f8b48b1b9646f1a1$var$sectionNames = {
    hero: 'Portada',
    lead: "Introducci\xf3n",
    about: "Sobre m\xed",
    method: "M\xe9todo",
    services: 'Encabezado de servicios',
    callToAction: "Llamado a la acci\xf3n",
    recommendations: 'Recursos',
    testimonials: 'Testimonios',
    contact: 'Contacto'
};
const $f8b48b1b9646f1a1$var$fieldNames = {
    eyebrow: 'Etiqueta',
    title: "T\xedtulo",
    description: "Descripci\xf3n",
    primaryButton: "Bot\xf3n principal",
    secondaryButton: "Bot\xf3n secundario",
    button: "Texto del bot\xf3n",
    paragraphs: "P\xe1rrafos"
};
const $f8b48b1b9646f1a1$var$imageNames = {
    logo: 'Logo',
    hero: 'Portada',
    about: "Sobre m\xed",
    method: "Llamado a la acci\xf3n",
    services: 'Servicios',
    contact: 'Contacto'
};
function $f8b48b1b9646f1a1$var$cloneDefaultContent() {
    return JSON.parse(JSON.stringify((0, $27d7bdbf046acfb1$export$ee693cb47e01ebc6)));
}
function $f8b48b1b9646f1a1$var$SiteAdmin() {
    const [token, setToken] = (0, $6SWiB.useState)(()=>window.localStorage.getItem('babyplanner_admin_token') || '');
    const [tokenInput, setTokenInput] = (0, $6SWiB.useState)(token);
    const [content, setContent] = (0, $6SWiB.useState)($f8b48b1b9646f1a1$var$cloneDefaultContent);
    const [activeTab, setActiveTab] = (0, $6SWiB.useState)('sections');
    const [status, setStatus] = (0, $6SWiB.useState)({
        type: '',
        message: ''
    });
    const [loading, setLoading] = (0, $6SWiB.useState)(Boolean(token));
    const [saving, setSaving] = (0, $6SWiB.useState)(false);
    const [uploading, setUploading] = (0, $6SWiB.useState)('');
    const [exporting, setExporting] = (0, $6SWiB.useState)(false);
    const authHeaders = (0, $6SWiB.useMemo)(()=>({
            Authorization: `Bearer ${token}`
        }), [
        token
    ]);
    (0, $6SWiB.useEffect)(()=>{
        if (!token) return;
        setLoading(true);
        fetch(`${(0, $b9b0c25068e74815$export$c3ee1e672e1e24e7)}/api/admin/site-content`, {
            headers: authHeaders
        }).then(async (response)=>{
            const data = await response.json();
            if (!response.ok) throw new Error(data.error || 'No se pudo cargar el contenido.');
            setContent((0, $27d7bdbf046acfb1$export$8eaa4b3dca4db648)(data.content));
            setStatus({
                type: '',
                message: ''
            });
        }).catch((error)=>setStatus({
                type: 'warning',
                message: error instanceof TypeError ? "El backend no est\xe1 disponible. Est\xe1s editando el snapshot incluido en el sitio; puedes exportarlo para GitHub Pages." : error.message
            })).finally(()=>setLoading(false));
    }, [
        token,
        authHeaders
    ]);
    const updateSection = (sectionKey, field, value)=>{
        setContent((current)=>(0, $bf4fb21d2ea31b30$export$71511d61b312f219)((0, $a5bc2f0ca9d10fc9$export$71511d61b312f219)({}, current), {
                sections: (0, $bf4fb21d2ea31b30$export$71511d61b312f219)((0, $a5bc2f0ca9d10fc9$export$71511d61b312f219)({}, current.sections), {
                    [sectionKey]: (0, $bf4fb21d2ea31b30$export$71511d61b312f219)((0, $a5bc2f0ca9d10fc9$export$71511d61b312f219)({}, current.sections[sectionKey]), {
                        [field]: value
                    })
                })
            }));
    };
    const updateListItem = (list, index, field, value)=>{
        setContent((current)=>(0, $bf4fb21d2ea31b30$export$71511d61b312f219)((0, $a5bc2f0ca9d10fc9$export$71511d61b312f219)({}, current), {
                [list]: current[list].map((item, itemIndex)=>itemIndex === index ? (0, $bf4fb21d2ea31b30$export$71511d61b312f219)((0, $a5bc2f0ca9d10fc9$export$71511d61b312f219)({}, item), {
                        [field]: value
                    }) : item)
            }));
    };
    const removeListItem = (list, index)=>{
        setContent((current)=>(0, $bf4fb21d2ea31b30$export$71511d61b312f219)((0, $a5bc2f0ca9d10fc9$export$71511d61b312f219)({}, current), {
                [list]: current[list].filter((_, itemIndex)=>itemIndex !== index)
            }));
    };
    const addService = ()=>setContent((current)=>(0, $bf4fb21d2ea31b30$export$71511d61b312f219)((0, $a5bc2f0ca9d10fc9$export$71511d61b312f219)({}, current), {
                services: [
                    ...current.services,
                    {
                        title: 'Nuevo servicio',
                        subtitle: "Subt\xedtulo",
                        description: '',
                        items: []
                    }
                ]
            }));
    const saveContent = async ()=>{
        setSaving(true);
        setStatus({
            type: '',
            message: ''
        });
        try {
            const response = await fetch(`${(0, $b9b0c25068e74815$export$c3ee1e672e1e24e7)}/api/admin/site-content`, {
                method: 'PUT',
                headers: (0, $bf4fb21d2ea31b30$export$71511d61b312f219)((0, $a5bc2f0ca9d10fc9$export$71511d61b312f219)({}, authHeaders), {
                    'Content-Type': 'application/json'
                }),
                body: JSON.stringify({
                    content: content
                })
            });
            const data = await response.json();
            if (!response.ok) throw new Error(data.error || 'No se pudieron guardar los cambios.');
            setContent((0, $27d7bdbf046acfb1$export$8eaa4b3dca4db648)(data.content));
            setStatus({
                type: 'success',
                message: 'Cambios publicados correctamente.'
            });
        } catch (error) {
            setStatus({
                type: 'error',
                message: error.message
            });
        } finally{
            setSaving(false);
        }
    };
    const uploadImage = (slot, file)=>{
        if (!file) return;
        setUploading(slot);
        setStatus({
            type: '',
            message: ''
        });
        const reader = new FileReader();
        reader.onload = async ()=>{
            const localDataUrl = reader.result;
            setContent((current)=>(0, $bf4fb21d2ea31b30$export$71511d61b312f219)((0, $a5bc2f0ca9d10fc9$export$71511d61b312f219)({}, current), {
                    images: (0, $bf4fb21d2ea31b30$export$71511d61b312f219)((0, $a5bc2f0ca9d10fc9$export$71511d61b312f219)({}, current.images), {
                        [slot]: (0, $bf4fb21d2ea31b30$export$71511d61b312f219)((0, $a5bc2f0ca9d10fc9$export$71511d61b312f219)({}, current.images[slot]), {
                            src: localDataUrl
                        })
                    })
                }));
            try {
                const response = await fetch(`${(0, $b9b0c25068e74815$export$c3ee1e672e1e24e7)}/api/admin/site-content/images`, {
                    method: 'POST',
                    headers: (0, $bf4fb21d2ea31b30$export$71511d61b312f219)((0, $a5bc2f0ca9d10fc9$export$71511d61b312f219)({}, authHeaders), {
                        'Content-Type': 'application/json'
                    }),
                    body: JSON.stringify({
                        slot: slot,
                        fileName: file.name,
                        dataUrl: localDataUrl
                    })
                });
                const data = await response.json();
                if (!response.ok) throw new Error(data.error || 'No se pudo subir la imagen.');
                setContent((current)=>(0, $bf4fb21d2ea31b30$export$71511d61b312f219)((0, $a5bc2f0ca9d10fc9$export$71511d61b312f219)({}, current), {
                        images: (0, $bf4fb21d2ea31b30$export$71511d61b312f219)((0, $a5bc2f0ca9d10fc9$export$71511d61b312f219)({}, current.images), {
                            [slot]: (0, $bf4fb21d2ea31b30$export$71511d61b312f219)((0, $a5bc2f0ca9d10fc9$export$71511d61b312f219)({}, current.images[slot]), {
                                src: data.url
                            })
                        })
                    }));
                setStatus({
                    type: 'success',
                    message: 'Imagen cargada. Guarda los cambios para publicarla.'
                });
            } catch (error) {
                setStatus({
                    type: 'warning',
                    message: "El backend no recibi\xf3 la foto, pero qued\xf3 incorporada localmente. Puedes exportar el m\xf3dulo para GitHub Pages."
                });
            } finally{
                setUploading('');
            }
        };
        reader.onerror = ()=>{
            setUploading('');
            setStatus({
                type: 'error',
                message: 'No se pudo leer la imagen.'
            });
        };
        reader.readAsDataURL(file);
    };
    const exportModule = async ()=>{
        setExporting(true);
        setStatus({
            type: '',
            message: ''
        });
        try {
            await (0, $0b2f47f7211526b7$export$1465ee50999a049e)(content);
            setStatus({
                type: 'success',
                message: "M\xf3dulo descargado. Reemplaza src/config/siteContent.snapshot.js con ese archivo y vuelve a desplegar GitHub Pages."
            });
        } catch (error) {
            setStatus({
                type: 'error',
                message: error.message
            });
        } finally{
            setExporting(false);
        }
    };
    const handleLogin = (event)=>{
        event.preventDefault();
        const nextToken = tokenInput.trim();
        window.localStorage.setItem('babyplanner_admin_token', nextToken);
        setToken(nextToken);
    };
    const logout = ()=>{
        window.localStorage.removeItem('babyplanner_admin_token');
        setToken('');
        setTokenInput('');
        setStatus({
            type: '',
            message: ''
        });
    };
    if (!token) return /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("main", {
        className: "page-shell admin-page",
        children: /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("section", {
            className: "admin-login-card",
            children: [
                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("p", {
                    className: "eyebrow",
                    children: "Site admin"
                }),
                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("h2", {
                    children: "Administrar el sitio"
                }),
                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("p", {
                    className: "section-lede",
                    children: "Usa el mismo token del panel de mensajer\xeda."
                }),
                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("form", {
                    className: "form-grid",
                    onSubmit: handleLogin,
                    children: [
                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("div", {
                            className: "form-field",
                            children: [
                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("label", {
                                    htmlFor: "site-admin-token",
                                    children: "Token"
                                }),
                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("input", {
                                    id: "site-admin-token",
                                    type: "password",
                                    value: tokenInput,
                                    onChange: (event)=>setTokenInput(event.target.value),
                                    required: true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("button", {
                            className: "button button-primary",
                            type: "submit",
                            children: "Entrar"
                        })
                    ]
                })
            ]
        })
    });
    return /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("main", {
        className: "page-shell admin-page",
        children: /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("section", {
            className: "admin-shell site-admin-shell",
            children: [
                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("header", {
                    className: "admin-topbar",
                    children: [
                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("p", {
                                    className: "eyebrow",
                                    children: "Site admin"
                                }),
                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("h2", {
                                    children: "Contenido del sitio"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("div", {
                            className: "site-admin-top-actions",
                            children: [
                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("button", {
                                    className: "button button-secondary",
                                    type: "button",
                                    onClick: exportModule,
                                    disabled: exporting,
                                    children: exporting ? "Exportando\u2026" : "Exportar m\xf3dulo"
                                }),
                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("a", {
                                    className: "button button-secondary",
                                    href: "/#/chat-admin",
                                    children: "Mensajer\xeda"
                                }),
                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("a", {
                                    className: "button button-secondary",
                                    href: "/",
                                    target: "_blank",
                                    rel: "noreferrer",
                                    children: "Ver sitio"
                                }),
                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("button", {
                                    className: "button button-secondary",
                                    type: "button",
                                    onClick: logout,
                                    children: "Salir"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("nav", {
                    className: "admin-tabs",
                    "aria-label": "Contenido editable",
                    children: [
                        [
                            'sections',
                            'Secciones'
                        ],
                        [
                            'blog',
                            'Blog de suscriptores'
                        ],
                        [
                            'users',
                            'Usuarios'
                        ],
                        [
                            'services',
                            'Servicios'
                        ],
                        [
                            'images',
                            'Fotos'
                        ],
                        [
                            'extras',
                            'Otros contenidos'
                        ]
                    ].map(([key, label])=>/*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("button", {
                            type: "button",
                            className: activeTab === key ? 'is-active' : '',
                            onClick: ()=>setActiveTab(key),
                            children: label
                        }, key))
                }),
                status.message && /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("p", {
                    className: `site-admin-status ${status.type}`,
                    role: "status",
                    children: status.message
                }),
                loading ? /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("p", {
                    className: "admin-empty site-admin-loading",
                    children: "Cargando contenido\u2026"
                }) : /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("div", {
                    className: "site-admin-content",
                    children: [
                        activeTab === 'blog' && /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)((0, $f30b20659bd6b188$export$2e2bcd8739ae039), {
                            token: token
                        }),
                        activeTab === 'users' && /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)((0, $df0b21d55506b9cf$export$2e2bcd8739ae039), {
                            token: token
                        }),
                        activeTab === 'sections' && /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("div", {
                            className: "site-editor-grid",
                            children: Object.entries(content.sections).map(([sectionKey, fields])=>/*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("fieldset", {
                                    className: "site-editor-card",
                                    children: [
                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("legend", {
                                            children: $f8b48b1b9646f1a1$var$sectionNames[sectionKey] || sectionKey
                                        }),
                                        Object.entries(fields).map(([field, value])=>/*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("label", {
                                                children: [
                                                    $f8b48b1b9646f1a1$var$fieldNames[field] || field,
                                                    Array.isArray(value) ? /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("textarea", {
                                                        rows: "5",
                                                        value: value.join('\n\n'),
                                                        onChange: (event)=>updateSection(sectionKey, field, event.target.value.split(/\n\s*\n/).filter(Boolean))
                                                    }) : String(value).length > 80 || field === 'description' || field === 'title' ? /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("textarea", {
                                                        rows: "3",
                                                        value: value,
                                                        onChange: (event)=>updateSection(sectionKey, field, event.target.value)
                                                    }) : /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("input", {
                                                        value: value,
                                                        onChange: (event)=>updateSection(sectionKey, field, event.target.value)
                                                    })
                                                ]
                                            }, field))
                                    ]
                                }, sectionKey))
                        }),
                        activeTab === 'services' && /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("div", {
                            children: [
                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("div", {
                                    className: "site-editor-heading",
                                    children: [
                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("h3", {
                                                    children: "Servicios"
                                                }),
                                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("p", {
                                                    children: "Edita sus detalles, reordena los puntos o agrega nuevos servicios."
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("button", {
                                            type: "button",
                                            className: "button button-secondary",
                                            onClick: addService,
                                            children: "Agregar servicio"
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("div", {
                                    className: "site-editor-grid",
                                    children: content.services.map((service, index)=>/*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("fieldset", {
                                            className: "site-editor-card",
                                            children: [
                                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("legend", {
                                                    children: [
                                                        "Servicio ",
                                                        index + 1
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("label", {
                                                    children: [
                                                        "T\xedtulo",
                                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("input", {
                                                            value: service.title,
                                                            onChange: (event)=>updateListItem('services', index, 'title', event.target.value)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("label", {
                                                    children: [
                                                        "Subt\xedtulo",
                                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("input", {
                                                            value: service.subtitle,
                                                            onChange: (event)=>updateListItem('services', index, 'subtitle', event.target.value)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("label", {
                                                    children: [
                                                        "Descripci\xf3n",
                                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("textarea", {
                                                            rows: "4",
                                                            value: service.description,
                                                            onChange: (event)=>updateListItem('services', index, 'description', event.target.value)
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("label", {
                                                    children: [
                                                        "Caracter\xedsticas (una por l\xednea)",
                                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("textarea", {
                                                            rows: "5",
                                                            value: service.items.join('\n'),
                                                            onChange: (event)=>updateListItem('services', index, 'items', event.target.value.split('\n').filter(Boolean))
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("button", {
                                                    type: "button",
                                                    className: "site-remove-button",
                                                    onClick: ()=>removeListItem('services', index),
                                                    children: "Eliminar servicio"
                                                })
                                            ]
                                        }, index))
                                })
                            ]
                        }),
                        activeTab === 'images' && /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("div", {
                            className: "site-image-grid",
                            children: Object.entries(content.images).map(([slot, imageData])=>/*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("article", {
                                    className: "site-image-card",
                                    children: [
                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("img", {
                                            src: (0, $27d7bdbf046acfb1$export$1ea66d1b3c07dae9)(imageData.src),
                                            alt: imageData.alt || ''
                                        }),
                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("div", {
                                            children: [
                                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("h3", {
                                                    children: $f8b48b1b9646f1a1$var$imageNames[slot] || slot
                                                }),
                                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("label", {
                                                    children: [
                                                        "Texto alternativo",
                                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("input", {
                                                            value: imageData.alt,
                                                            onChange: (event)=>setContent((current)=>(0, $bf4fb21d2ea31b30$export$71511d61b312f219)((0, $a5bc2f0ca9d10fc9$export$71511d61b312f219)({}, current), {
                                                                        images: (0, $bf4fb21d2ea31b30$export$71511d61b312f219)((0, $a5bc2f0ca9d10fc9$export$71511d61b312f219)({}, current.images), {
                                                                            [slot]: (0, $bf4fb21d2ea31b30$export$71511d61b312f219)((0, $a5bc2f0ca9d10fc9$export$71511d61b312f219)({}, current.images[slot]), {
                                                                                alt: event.target.value
                                                                            })
                                                                        })
                                                                    }))
                                                        })
                                                    ]
                                                }),
                                                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("label", {
                                                    className: "site-file-button",
                                                    children: [
                                                        uploading === slot ? "Subiendo\u2026" : 'Elegir nueva foto',
                                                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("input", {
                                                            type: "file",
                                                            accept: "image/jpeg,image/png,image/webp,image/gif",
                                                            disabled: Boolean(uploading),
                                                            onChange: (event)=>uploadImage(slot, event.target.files[0])
                                                        })
                                                    ]
                                                })
                                            ]
                                        })
                                    ]
                                }, slot))
                        }),
                        activeTab === 'extras' && /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("div", {
                            className: "site-editor-grid",
                            children: [
                                content.methodSteps.map((step, index)=>/*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("fieldset", {
                                        className: "site-editor-card",
                                        children: [
                                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("legend", {
                                                children: [
                                                    "M\xe9todo ",
                                                    index + 1
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("label", {
                                                children: [
                                                    "T\xedtulo",
                                                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("input", {
                                                        value: step.title,
                                                        onChange: (event)=>updateListItem('methodSteps', index, 'title', event.target.value)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("label", {
                                                children: [
                                                    "Detalle",
                                                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("textarea", {
                                                        value: step.copy,
                                                        onChange: (event)=>updateListItem('methodSteps', index, 'copy', event.target.value)
                                                    })
                                                ]
                                            })
                                        ]
                                    }, `method-${index}`)),
                                content.recommendations.map((item, index)=>/*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("fieldset", {
                                        className: "site-editor-card",
                                        children: [
                                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("legend", {
                                                children: [
                                                    "Recurso ",
                                                    index + 1
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("label", {
                                                children: [
                                                    "T\xedtulo",
                                                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("input", {
                                                        value: item.title,
                                                        onChange: (event)=>updateListItem('recommendations', index, 'title', event.target.value)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("label", {
                                                children: [
                                                    "Detalle",
                                                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("textarea", {
                                                        value: item.copy,
                                                        onChange: (event)=>updateListItem('recommendations', index, 'copy', event.target.value)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("label", {
                                                children: [
                                                    "Elementos (uno por l\xednea)",
                                                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("textarea", {
                                                        value: item.items.join('\n'),
                                                        onChange: (event)=>updateListItem('recommendations', index, 'items', event.target.value.split('\n').filter(Boolean))
                                                    })
                                                ]
                                            })
                                        ]
                                    }, `recommendation-${index}`)),
                                content.testimonials.map((item, index)=>/*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("fieldset", {
                                        className: "site-editor-card",
                                        children: [
                                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("legend", {
                                                children: [
                                                    "Testimonio ",
                                                    index + 1
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("label", {
                                                children: [
                                                    "Nombre",
                                                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("input", {
                                                        value: item.name,
                                                        onChange: (event)=>updateListItem('testimonials', index, 'name', event.target.value)
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("label", {
                                                children: [
                                                    "Testimonio",
                                                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("textarea", {
                                                        value: item.quote,
                                                        onChange: (event)=>updateListItem('testimonials', index, 'quote', event.target.value)
                                                    })
                                                ]
                                            })
                                        ]
                                    }, `testimonial-${index}`))
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)("footer", {
                    className: "site-admin-savebar",
                    children: [
                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("span", {
                            children: "Backend: guarda al instante. GitHub Pages: exporta el snapshot y vuelve a desplegar."
                        }),
                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("button", {
                            className: "button button-secondary",
                            type: "button",
                            onClick: exportModule,
                            disabled: exporting,
                            children: exporting ? "Exportando\u2026" : 'Exportar para GitHub Pages'
                        }),
                        /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("button", {
                            className: "button button-primary",
                            type: "button",
                            onClick: saveContent,
                            disabled: saving || loading,
                            children: saving ? "Guardando\u2026" : 'Guardar en backend'
                        })
                    ]
                })
            ]
        })
    });
}
var $f8b48b1b9646f1a1$export$2e2bcd8739ae039 = $f8b48b1b9646f1a1$var$SiteAdmin;




const $600ae59b01ef8ba1$var$BUILD_VERSION = "2026-08-19-2";
function $600ae59b01ef8ba1$var$AppContent() {
    const location = (0, $576e41193d1785e0$export$45d76561a5302f2b)();
    const isAdminRoute = [
        '/chat-admin',
        '/site-admin'
    ].includes(location.pathname);
    return /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)((0, $8c08c62dc09ea562$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)("span", {
                hidden: true,
                "data-build-version": "2026-08-19-2"
            }),
            !isAdminRoute && /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)((0, $cf3024de9b7a6a1b$export$2e2bcd8739ae039), {}),
            /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsxs)((0, $576e41193d1785e0$export$3565eb3d00ca5a74), {
                children: [
                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)((0, $576e41193d1785e0$export$e7b0ac011bb776c6), {
                        path: "/chat-admin",
                        element: /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)((0, $a9d931c52809af12$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)((0, $576e41193d1785e0$export$e7b0ac011bb776c6), {
                        path: "/site-admin",
                        element: /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)((0, $f8b48b1b9646f1a1$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)((0, $576e41193d1785e0$export$e7b0ac011bb776c6), {
                        path: "/blog",
                        element: /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)((0, $f190811c54c48a7e$export$2e2bcd8739ae039), {})
                    }),
                    /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)((0, $576e41193d1785e0$export$e7b0ac011bb776c6), {
                        path: "/",
                        element: /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)((0, $a2bbadb3646a394d$export$2e2bcd8739ae039), {})
                    })
                ]
            }),
            !isAdminRoute && /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)((0, $353fdf8b9828132f$export$2e2bcd8739ae039), {}),
            !isAdminRoute && /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)((0, $78c2c76c73ab90b3$export$2e2bcd8739ae039), {})
        ]
    });
}
function $600ae59b01ef8ba1$var$App() {
    return /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)((0, $012530f2a7d9abca$export$88f24fd8fcfab6ca), {
        children: /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)((0, $27d7bdbf046acfb1$export$c04d0574b227a65d), {
            children: /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)((0, $fd8010543425d4bc$export$7221d69dcfc8e36b), {
                children: /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)($600ae59b01ef8ba1$var$AppContent, {})
            })
        })
    });
}
var $600ae59b01ef8ba1$export$2e2bcd8739ae039 = $600ae59b01ef8ba1$var$App;



const $75a0ea524e803c08$var$root = (0, (/*@__PURE__*/$parcel$interopDefault($582122ffcee3ecd1$exports))).createRoot(document.getElementById('root'));
$75a0ea524e803c08$var$root.render(/*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($6SWiB))).StrictMode, {
    children: /*#__PURE__*/ (0, $8c08c62dc09ea562$exports.jsx)((0, $600ae59b01ef8ba1$export$2e2bcd8739ae039), {})
}));


//# sourceMappingURL=babyplanner_vero.e2c18636.js.map
